import _asyncToGenerator from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/classCallCheck";
import _inherits from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/getPrototypeOf";
import _toConsumableArray from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/toConsumableArray";
import _typeof from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof";
import _slicedToArray from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/slicedToArray";
import _defineProperty from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/objectWithoutProperties";
var _window, _window$document, _Highcharts$AST, _Highcharts$AST2, _Highcharts$AST3, _Highcharts$AST4;
var _excluded = ["id", "className", "children"],
  _excluded2 = ["id", "element", "text", "className"],
  _excluded3 = ["color", "title", "size"],
  _excluded4 = ["id", "aria-labelledby", "title", "viewBox", "className"],
  _excluded5 = ["text", "type", "className"],
  _excluded6 = ["padding", "width", "children"],
  _excluded7 = ["footer", "hasFooterPadding", "children", "clickShield", "error", "id", "padding", "width", "title", "onSubmit", "onLeave"],
  _excluded8 = ["children", "id", "tag"],
  _excluded9 = ["className", "disabled", "required", "readOnly", "cols"],
  _excluded10 = ["className", "autoHeight", "size", "required", "disabled", "readOnly", "onChange"],
  _excluded11 = ["label", "lineCount", "charCount", "onChange", "className"],
  _excluded12 = ["fontSize"],
  _excluded13 = ["element", "addon", "heading", "id", "number", "numbered", "required", "requiredAsterisk", "useDefaultFrontSize"],
  _excluded14 = ["visible"],
  _excluded15 = ["id", "title", "okButton", "error", "errorId", "onLeave", "padding", "width", "children"],
  _excluded16 = ["onChange"],
  _excluded17 = ["children", "name", "value", "defaultValue", "onChange", "disabled", "readOnly"],
  _excluded18 = ["element", "className", "icon", "checked", "defaultChecked", "onClick", "onChange"],
  _excluded19 = ["className"],
  _excluded20 = ["children", "className", "onChange", "checked", "name", "disabled", "readOnly", "inputSize"],
  _excluded21 = ["id", "label", "value", "columnIds", "className", "onChange", "onClick", "onKeyDown", "width"],
  _excluded22 = ["id", "disabled", "readOnly", "choices", "responses", "columnChoices", "onChange", "labelWidth"],
  _excluded23 = ["className"],
  _excluded24 = ["children", "inputSize", "onChange"],
  _excluded25 = ["id", "children", "value", "defaultValue", "maxLength", "onClick", "onKeyDown", "onChange", "checked"],
  _excluded26 = ["id", "required", "readOnly", "disabled", "columnLayout", "choices", "responses", "choiceNoneOfTheAbove", "choiceOther", "choiceComment", "onChange"],
  _excluded27 = ["id", "required", "disabled", "readOnly", "responses", "onChange", "cols", "rows"],
  _excluded28 = ["required", "children", "disabled", "className", "icon"],
  _excluded29 = ["className"],
  _excluded30 = ["id", "label"],
  _excluded31 = ["isOpen", "value", "height", "rtl", "onChange", "open", "close", "onKeyDown", "aria-activedescendant", "aria-autocomplete", "aria-controls", "aria-label", "aria-labelledby", "className"],
  _excluded32 = ["children", "focusedIndex", "tabIndex", "onKeyDown", "onClick", "onChange", "className"],
  _excluded33 = ["children", "disabled", "selected", "value", "className"],
  _excluded34 = ["id", "options", "height", "width", "itemSize", "className", "classes", "filterOnChange", "value", "optionAlign", "filter", "onChange", "rtl", "aria-label", "aria-labelledby"],
  _excluded35 = ["element", "className"],
  _excluded36 = ["year", "month", "firstDayOfWeek"],
  _excluded37 = ["onClose", "visible", "className"],
  _excluded38 = ["onChange", "dateFormat", "defaultValue", "id", "className", "labels"],
  _excluded39 = ["id", "required", "choices", "responses", "showDate", "showTime", "dateFormat", "onChange", "inlineErrors"],
  _excluded40 = ["id", "disabled", "required", "readOnly", "choices", "choiceOther", "choiceComment", "responses", "onChange"],
  _excluded41 = ["className", "type"],
  _excluded42 = ["id", "type", "alt", "label", "src", "className", "checked", "name", "onChange", "onKeyDown", "onClick", "disabled", "aria-disabled", "readOnly", "aria-readonly"],
  _excluded43 = ["id", "readOnly", "required", "disabled", "multiple", "choices", "choiceNoneOfTheAbove", "onChange", "responses"],
  _excluded44 = ["alt", "className"],
  _excluded45 = ["visible"],
  _excluded46 = ["refs"],
  _excluded47 = ["id", "children", "checked", "value", "defaultValue", "lineCount", "charCount", "maxLength", "onClick", "onChange"],
  _excluded48 = ["id", "required", "disabled", "readOnly", "columnLayout", "choices", "choiceNoneOfTheAbove", "choiceOther", "choiceComment", "responses", "onChange"],
  _excluded49 = ["id", "required", "disabled", "readOnly", "choices", "responses", "onChange", "size"],
  _excluded50 = ["id", "className", "children", "component"],
  _excluded51 = ["id", "choices", "className", "title", "rowId", "responses", "required", "onChange"],
  _excluded52 = ["isGridWhenMobile", "children"],
  _excluded53 = ["id", "choices", "columnChoices", "choiceComment", "onChange", "responses", "disabled", "readOnly", "required"],
  _excluded54 = ["qid", "gridCell", "checked", "isMultipleSelectionsPerRow", "className", "onChange", "columnChoices", "isGridWhenMobile"],
  _excluded55 = ["id", "isMultipleSelectionsPerRow", "choices", "columnChoices", "choiceOther", "hideLabel", "choiceNoneOfTheAbove", "required", "requiredType", "choiceComment", "isForcedRanking", "onChange", "responses", "disabled", "readOnly"],
  _excluded56 = ["className", "dragListeners", "dragRef", "ghost", "id", "position", "label", "controls", "onFocus", "ranksVisible"],
  _excluded57 = ["icon", "children", "className", "disabled"],
  _excluded58 = ["id", "labels", "position", "showApplicability", "applicable", "className", "onApplicableChange", "onOrderUp", "onOrderDown", "disableOrderUp", "disableOrderDown"],
  _excluded59 = ["id", "className", "label", "position", "listLength", "applicable", "showApplicability", "onApplicableChange", "onOrderUp", "onOrderDown", "ranksVisible"],
  _excluded60 = ["id", "disabled", "readOnly", "choices", "rankings", "choiceNotApplicable", "responses", "onChange", "hideRanks"],
  _excluded61 = ["id", "required", "disabled", "readOnly", "responses", "onChange", "size"],
  _excluded62 = ["visible"],
  _excluded63 = ["id", "required", "disabled", "readOnly", "responses", "onChange", "size", "answerOptions"],
  _excluded64 = ["value", "onChange", "options"],
  _excluded65 = ["value", "options", "className", "iconComponent"],
  _excluded66 = ["id", "required", "disabled", "readOnly", "responses", "size", "hasCountrySelect", "answerOptions", "countrySubtitle", "countryCode"],
  _excluded67 = ["id", "required", "disabled", "readOnly", "responses", "onChange", "size", "answerOptions"],
  _excluded68 = ["className", "spacingClass"],
  _excluded69 = ["children", "height", "maxHeight", "scrollable", "tabIndex", "flex"],
  _excluded70 = ["className", "spacingClass"],
  _excluded71 = ["id", "required", "disabled", "readOnly", "responses", "onChange", "size", "answerOptions", "showStatesDropdown", "defaultCountry"],
  _excluded72 = ["id", "className", "value", "onClear", "clearVisible", "clearButtonLabelText", "maxLength"],
  _excluded73 = ["id", "responses", "onChange", "scaleOptions", "hideNumericalInput", "disabled", "required", "readOnly"],
  _excluded74 = ["className", "icon"],
  _excluded75 = ["onChange", "selected", "checked", "name", "symbolColor"],
  _excluded76 = ["choices", "choiceNoneOfTheAbove", "choiceComment", "disabled", "required", "id", "rowId", "readOnly", "onChange", "responses", "symbolOptions"],
  _excluded77 = ["id", "readOnly", "disabled", "responses", "instructions", "validation", "onChange", "uploadFile"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import React__default, { useLayoutEffect, useEffect, useRef, useState, useCallback, useMemo, forwardRef, useContext, createContext, useImperativeHandle } from 'react';
import { c as classNames, E as ErrorBoundary, F as FixedSizeList, N as Ne, d as de, Y as Ye, P as Pe, u as useSortable, C as CSS, K as KeyboardCode, a as PointerSensor$1, b as KeyboardSensor$1, e as useSensors, f as useSensor, D as DndContext, g as closestCenter, S as SortableContext, v as verticalListSortingStrategy, h as DragOverlay, i as arrayMove, j as getCountryCallingCode, k as PhoneCountryInput } from './vendor-9b603dcf.js';
import { createUseStyles, useTheme } from 'react-jss';
import { sanitizeString } from '@sm/utils';
import { uniqueId, visuallyHidden as visuallyHidden$1, withSpacing } from '@wds/utils';
import ReactDOM from 'react-dom';
import { defineMessages, t, L10NContext, T } from '@sm/intl';
import getFontWeights from '@sm/webassets/dist/components/SurveyTheme/getFontWeights';
import { c as contrastColor } from './theme-0294b6d5.js';
import isDark from '@sm/webassets/dist/components/SurveyTheme/isDark';
import '@wds/icons';
import '@wds/typography';
import '@wds/box';
import '@wds/button';
import Highcharts from 'highcharts';
import 'react-dom/server';
import '@wds/styles';
import '@wds/modal';
import 'highcharts/modules/wordcloud';
import 'lodash.merge';
var useStyles$16 = createUseStyles({
  rowStyles: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center'
  }
});
function Row(_ref) {
  var id = _ref.id,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useStyles$ = useStyles$16(),
    rowStyles = _useStyles$.rowStyles;
  return React__default.createElement("div", _objectSpread({
    id: id,
    className: classNames(rowStyles, className)
  }, props), children);
}
var useStyles$15 = createUseStyles(function (theme) {
  var _theme$breakpoints$md, _theme$breakpoints, _tooltip;
  return {
    tooltip: (_tooltip = {
      'span[data-tooltip] &': {
        display: 'none'
      }
    }, _defineProperty(_tooltip, "@media (min-width: ".concat((_theme$breakpoints$md = (_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.md.min) !== null && _theme$breakpoints$md !== void 0 ? _theme$breakpoints$md : '769px', ")"), {
      'span[data-tooltip]:hover &, span[data-tooltip]:focus &': {
        display: 'inline-block'
      }
    }), _defineProperty(_tooltip, "position", 'absolute'), _defineProperty(_tooltip, "left", function left(_ref2) {
      var center = _ref2.center;
      return center;
    }), _defineProperty(_tooltip, "bottom", 20), _defineProperty(_tooltip, "width", 275), _defineProperty(_tooltip, "transform", 'translate(-50%, -5px)'), _defineProperty(_tooltip, "textAlign", 'center'), _defineProperty(_tooltip, "zIndex", 12), _defineProperty(_tooltip, "fontSize", 13), _defineProperty(_tooltip, '&:after', {
      position: 'absolute',
      bottom: -4,
      left: '50%',
      width: 10,
      height: 10,
      backgroundColor: 'white',
      content: '""',
      marginLeft: -5,
      transform: 'rotate(45deg)',
      boxShadow: [[3, 5, 5, 'rgb(0 0 0 / 0.07)']],
      zIndex: 13
    }), _tooltip),
    tooltipBody: {
      display: 'inline-block',
      maxWidth: 275,
      color: 'black',
      fontWeight: 300,
      fontFamily: theme.fontFamily,
      fontStyle: 'normal',
      boxShadow: [[0, 2, 10, 0, 'rgb(0 0 0 / 0.14)']],
      background: 'white',
      padding: [[12, 16]],
      lineHeight: 1.4,
      borderRadius: 2,
      textAlign: 'left'
    }
  };
});
var defaultSelectors = ['a[href]', 'button', 'textarea', 'input:not([type="hidden"])', 'select', 'details', '[tabindex]:not([tabindex="-1"])'];
var useFocusTrap = function useFocusTrap() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$selectors = _ref3.selectors,
    selectors = _ref3$selectors === void 0 ? defaultSelectors : _ref3$selectors;
  var focusRef = React__default.useRef(null);
  var _React__default$useSt = React__default.useState([]),
    _React__default$useSt2 = _slicedToArray(_React__default$useSt, 2),
    focusableEls = _React__default$useSt2[0],
    setEls = _React__default$useSt2[1];
  React__default.useEffect(function () {
    if (focusRef.current) {
      var els = Array.from(focusRef.current.querySelectorAll(selectors.join(',')));
      setEls(els);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusRef]);
  function handleFocus(e) {
    if (focusRef.current) {
      var focusableElements = focusableEls;
      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else if (document.activeElement === lastElement) {
        firstElement.focus();
        e.preventDefault();
      }
    }
  }
  React__default.useEffect(function () {
    var handleKeyDown = function handleKeyDown(e) {
      if (e.key === 'Tab') {
        handleFocus(e);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      return document.removeEventListener('keydown', handleKeyDown);
    };
  });
  return focusRef;
};
var useStyles$14 = createUseStyles(function (theme) {
  var _theme$questionBody;
  return {
    modalOverlay: {
      zIndex: 999,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end'
    },
    modal: {
      position: 'relative',
      width: '85vw',
      minHeight: '20vw',
      marginBottom: 20,
      background: 'white',
      borderRadius: 2
    },
    closeBtn: {
      position: 'absolute',
      cursor: 'pointer',
      background: 'transparent',
      right: 0,
      border: 0,
      padding: 8,
      marginTop: 0,
      color: 'black',
      zIndex: 105
    },
    tooltipText: {
      color: ((_theme$questionBody = theme.questionBody) === null || _theme$questionBody === void 0 ? void 0 : _theme$questionBody.color) || '#333E48',
      fontFamily: theme.fontFamily,
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '1.4',
      padding: [28, 12, 16]
    }
  };
});
var COPY$h = defineMessages({
  CLOSE_MODAL: {
    id: 'Modal.CloseModal',
    defaultMessage: 'Close tooltip',
    description: '[Type: label][Vis: Med] - close button text'
  }
});
function Modal(_ref4) {
  var tooltip = _ref4.tooltip,
    closeModal = _ref4.closeModal;
  var _useStyles$2 = useStyles$14(),
    modalOverlay = _useStyles$2.modalOverlay,
    closeBtn = _useStyles$2.closeBtn,
    modal = _useStyles$2.modal,
    tooltipText = _useStyles$2.tooltipText;
  var closeRef = React__default.useRef(null);
  var tooltipId = uniqueId('tooltip-modal');
  var focusRef = useFocusTrap();
  var handleClick = function handleClick(e) {
    // click on button or overlay should close modal
    e.stopPropagation();
    if (e.currentTarget === e.target) {
      closeModal();
    }
  };
  React__default.useEffect(function () {
    // listen for ESC to close modal
    var handleKeydown = function handleKeydown(e) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        closeModal();
      }
    };
    document.addEventListener('keydown', handleKeydown);
    return function () {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [closeModal]);
  React__default.useEffect(function () {
    var _closeRef$current;
    (_closeRef$current = closeRef.current) === null || _closeRef$current === void 0 ? void 0 : _closeRef$current.focus();
  }, []);
  return React__default.createElement("div", {
    className: modalOverlay,
    onClick: handleClick,
    "aria-hidden": "true"
  }, React__default.createElement("div", {
    ref: focusRef,
    className: modal,
    role: "dialog",
    "aria-modal": "true",
    "aria-describedby": tooltipId
  }, React__default.createElement("button", {
    type: "button",
    className: closeBtn,
    ref: closeRef,
    onClick: handleClick,
    "aria-label": t(COPY$h.CLOSE_MODAL)
  }, "\xD7"), React__default.createElement("p", {
    id: tooltipId,
    className: tooltipText
  }, tooltip)));
}

/** Displays a tooltip on hover for large screens and a modal on click for small screens */
var Tooltip = function Tooltip(_ref5) {
  var _container$getAttribu;
  var container = _ref5.container,
    className = _ref5.className,
    _ref5$id = _ref5.id,
    id = _ref5$id === void 0 ? '' : _ref5$id;
  /** container center position to display tooltip */
  var center = container.offsetWidth / 2;
  var text = (_container$getAttribu = container.getAttribute('data-tooltip')) !== null && _container$getAttribu !== void 0 ? _container$getAttribu : '';
  var theme = useTheme();
  var _useStyles$3 = useStyles$15({
      center: center
    }),
    tooltip = _useStyles$3.tooltip,
    tooltipBody = _useStyles$3.tooltipBody;
  var _React__default$useSt3 = React__default.useState(false),
    _React__default$useSt4 = _slicedToArray(_React__default$useSt3, 2),
    showModal = _React__default$useSt4[0],
    setShowModal = _React__default$useSt4[1];
  var _React__default$useSt5 = React__default.useState('TOOLTIP'),
    _React__default$useSt6 = _slicedToArray(_React__default$useSt5, 2),
    mode = _React__default$useSt6[0],
    setMode = _React__default$useSt6[1];
  var closeModal = function closeModal() {
    setShowModal(false);
    container.focus();
  };
  React__default.useEffect(function () {
    container.setAttribute('role', 'tooltip');
    // make tooltip anchor focusable
    if (!container.hasAttribute('tabIndex')) {
      container.setAttribute('tabIndex', '0');
    }
    // opens modal if matches small screen breakpoint
    var openModal = function openModal() {
      var _theme$breakpoints$md2, _theme$breakpoints2;
      var mql = window.matchMedia("(max-width: ".concat((_theme$breakpoints$md2 = theme === null || theme === void 0 ? void 0 : (_theme$breakpoints2 = theme.breakpoints) === null || _theme$breakpoints2 === void 0 ? void 0 : _theme$breakpoints2.md.min) !== null && _theme$breakpoints$md2 !== void 0 ? _theme$breakpoints$md2 : '769px', ")"));
      if (mql.matches) {
        setMode('MODAL');
        setShowModal(true);
      } else {
        setMode('TOOLTIP');
      }
    };
    var handleClick = function handleClick() {
      openModal();
    };
    var handleKeydown = function handleKeydown(e) {
      if (e.code === 'Enter' || e.code === 'Space') {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      }
    };
    // listen for click, ENTER or SPACE to open modal
    container.addEventListener('click', handleClick);
    container.addEventListener('keydown', handleKeydown);
    return function () {
      container.removeEventListener('click', handleClick);
      container.removeEventListener('keydown', handleKeydown);
    };
  }, [container, theme]);
  var modalEl = showModal ? React__default.createElement(Modal, {
    tooltip: text,
    closeModal: closeModal
  }) : null;
  var tooltipEl = React__default.createElement("div", {
    className: classNames(tooltip, className)
  }, React__default.createElement("span", {
    id: id,
    className: tooltipBody,
    "aria-hidden": "true"
  }, text));
  var child = mode === 'MODAL' ? modalEl : tooltipEl;
  var containerEl = mode === 'MODAL' ? document.body : container;
  return ReactDOM.createPortal(child, containerEl);
};
var listSpacing = {
  margin: [16, 0],
  padding: [0, 0, 0, 40]
};
var mediaReset = {
  border: 0,
  maxWidth: '100%'
};
var useStyles$13 = createUseStyles({
  richTextContent: {
    // Typography
    '& a': {
      // Links are not themed by default. Users must select a link color in the editor
      color: 'blue',
      textDecoration: 'underline',
      '&:hover': {
        cursor: 'pointer'
      },
      '&:focus': {
        outline: 'currentColor auto 1px'
      }
    },
    '& ol': _objectSpread(_objectSpread({}, listSpacing), {}, {
      listStyleType: 'decimal'
    }),
    '& ul': _objectSpread(_objectSpread({}, listSpacing), {}, {
      listStyle: 'disc outside none',
      '& ul li': {
        listStyle: 'circle'
      }
    }),
    '& p': {
      margin: [13, 0]
    },
    '& b': {
      fontWeight: 'bold'
    },
    '& strong': {
      fontWeight: 'bold'
    },
    '& em': {
      fontStyle: 'italic'
    },
    '& i': {
      fontStyle: 'italic'
    },
    '& big': {
      fontSize: 'larger'
    },
    '& small': {
      fontSize: 'smaller'
    },
    '& sup': {
      fontSize: '75%',
      lineHeight: 0,
      position: 'relative',
      top: '-0.5em',
      verticalAlign: 'baseline'
    },
    // Media embeds
    '& iframe': mediaReset,
    '& img': _objectSpread(_objectSpread({}, mediaReset), {}, {
      height: 'auto',
      '-ms-interpolation-mode': 'bicubic'
    }),
    '& span[data-tooltip]': {
      position: 'relative',
      display: 'inline',
      borderBottom: [[1, 'dashed']],
      textDecoration: 'inherit',
      cursor: 'pointer'
    }
  }
});

// Support iframe video embeds and their matching attributes
var sanitizeOptions = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['target', 'allow', 'allowfullscreen', 'frameborder', 'sandbox', 'scrolling']
};
function RichText(_ref6) {
  var elementId = _ref6.id,
    _ref6$element = _ref6.element,
    Element = _ref6$element === void 0 ? 'div' : _ref6$element,
    text = _ref6.text,
    className = _ref6.className,
    containerProps = _objectWithoutProperties(_ref6, _excluded2);
  var _useStyles$4 = useStyles$13(),
    richTextContent = _useStyles$4.richTextContent;
  var _React__default$useSt7 = React__default.useState([]),
    _React__default$useSt8 = _slicedToArray(_React__default$useSt7, 2),
    tooltipNodes = _React__default$useSt8[0],
    setTooltipNodes = _React__default$useSt8[1];
  var tooltipRef = React__default.useRef(null);
  React__default.useEffect(function () {
    if (tooltipRef !== null && tooltipRef !== void 0 && tooltipRef.current) {
      var el = tooltipRef === null || tooltipRef === void 0 ? void 0 : tooltipRef.current;
      setTooltipNodes(Array.from(el.querySelectorAll('[data-tooltip]')));
    }
  }, []);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Element, _objectSpread({
    id: elementId,
    className: classNames(richTextContent, className),
    dangerouslySetInnerHTML: {
      __html: sanitizeString(text, sanitizeOptions)
    },
    ref: tooltipRef,
    translate: "no"
  }, containerProps)), tooltipNodes.map(function (container) {
    var id = uniqueId('rich-text-tooltip');
    container.setAttribute('aria-describedby', id);
    return React__default.createElement(Tooltip, {
      key: id,
      container: container,
      id: id
    });
  }));
}
var useStyles$12 = createUseStyles(function (theme) {
  return {
    wdsIcons: function wdsIcons(_ref7) {
      var _theme$palette, _theme$palette2, _theme$palette2$color;
      var color = _ref7.color,
        size = _ref7.size;
      var fontSize = size ? {
        fontSize: theme.iconSize[size]
      } : {
        fontSize: 'inherit'
      };
      var chosenColor =
      // @ts-expect-error Fallback styles are acceptable
      ((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette.text[color]) || ((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$color = _theme$palette2[color]) === null || _theme$palette2$color === void 0 ? void 0 : _theme$palette2$color.main) || 'currentColor';
      return _objectSpread(_objectSpread({}, fontSize), {}, {
        width: '1em',
        height: '1em',
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'center',
        fill: chosenColor
      });
    }
  };
});

// https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};
function withIcon(Component) {
  function WithIcon(_ref8) {
    var color = _ref8.color,
      title = _ref8.title,
      size = _ref8.size,
      rest = _objectWithoutProperties(_ref8, _excluded3);
    var classes = useStyles$12({
      color: color,
      size: size
    });
    return React__default.createElement("svg", _objectSpread({
      className: classes.wdsIcons,
      viewBox: "0 0 16 16",
      preserveAspectRatio: "xMidYMid",
      "aria-label": title,
      role: title ? 'img' : 'presentation'
    }, rest), React__default.createElement(Component, null));
  }
  WithIcon.displayName = "WithIcon(".concat(getDisplayName(Component), ")");
  WithIcon.getOriginalComponent = function () {
    return Component;
  };
  return WithIcon;
}
var useSurveyIconStyles = createUseStyles({
  svgContainer: {
    display: 'inline-block',
    width: '1em',
    height: '1em'
  }
});
var instance = 0;
function withSvgIcon(Component) {
  var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SvgElement';
  function SvgIcon(_ref9) {
    var id = _ref9.id,
      ariaLabelledBy = _ref9['aria-labelledby'],
      title = _ref9.title,
      _ref9$viewBox = _ref9.viewBox,
      viewBox = _ref9$viewBox === void 0 ? '0 0 16 16' : _ref9$viewBox,
      className = _ref9.className,
      props = _objectWithoutProperties(_ref9, _excluded4);
    instance += 1;
    var styles = useSurveyIconStyles();
    var hasTitle = !!title && !ariaLabelledBy;
    var iconTitleId = id ? "".concat(id, "-icon-title") : "icon-title-".concat(instance);
    return React__default.createElement("svg", _objectSpread(_objectSpread({
      className: classNames(styles.svgContainer, className),
      viewBox: viewBox,
      preserveAspectRatio: "xMidYMid",
      "aria-hidden": hasTitle ? undefined : true,
      "aria-labelledby": hasTitle ? iconTitleId : ariaLabelledBy,
      role: hasTitle ? 'img' : undefined,
      focusable: "false"
    }, props), {}, {
      "data-testid": displayName
    }), hasTitle && React__default.createElement("title", {
      id: iconTitleId
    }, title), React__default.createElement(Component, null));
  }
  SvgIcon.displayName = displayName;
  return SvgIcon;
}
function DocumentXIconPath() {
  return React__default.createElement("path", {
    d: "m5.94.005 8.012.012C14.53.018 15 .487 15 1.067V14.95c0 .58-.47 1.05-1.05 1.05H2.05C1.47 16 1 15.53 1 14.95V4.94L5.94.004zM7 1.505V4.95c0 .541-.41.987-.936 1.044L5.95 6H2.5v8.5h11V1.514L7 1.505zM6.557 7.53 8 8.973 9.443 7.53a.765.765 0 0 1 1.083 1.082l-1.444 1.443 1.444 1.444a.765.765 0 0 1-1.083 1.082L8 11.138 6.557 12.58A.765.765 0 1 1 5.474 11.5l1.444-1.444-1.444-1.443A.765.765 0 1 1 6.557 7.53zM5.5 2.563 3.561 4.5H5.5V2.562z"
  });
}
var IconDocumentX = withIcon(DocumentXIconPath);
var useStyles$11 = createUseStyles(function (theme) {
  var _theme$questionBody$f, _theme$questionBody2;
  return {
    fallbackComponent: {
      fontFamily: (_theme$questionBody$f = (_theme$questionBody2 = theme.questionBody) === null || _theme$questionBody2 === void 0 ? void 0 : _theme$questionBody2.fontFamily) !== null && _theme$questionBody$f !== void 0 ? _theme$questionBody$f : {},
      color: theme.questionColor,
      border: "1px solid ".concat(theme.questionColor),
      borderRadius: '5px',
      width: '100%',
      height: '100%',
      minHeight: '220px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        fill: theme.questionColor
      }
    },
    errorMessage: {
      marginLeft: "8px" // equivalent to wrench theme.spacing[2]
    }
  };
});

var COPY$g = defineMessages({
  ERROR: {
    id: 'FallbackComponent.ERROR',
    defaultMessage: 'Error loading question',
    description: '[Type: label][Vis: high] - error message indicating a question could not be loaded'
  }
});
function FallbackComponent() {
  var _useStyles$5 = useStyles$11(),
    fallbackComponent = _useStyles$5.fallbackComponent,
    errorMessage = _useStyles$5.errorMessage;
  return React__default.createElement("div", {
    className: fallbackComponent
  }, React__default.createElement(IconDocumentX, null), React__default.createElement("p", {
    className: errorMessage
  }, t(COPY$g.ERROR)));
}
var withErrorBoundary = function withErrorBoundary(Component) {
  var displayName = Component.displayName || Component.name || 'Component';
  function ComponentWithErrorBoundary(props) {
    return React__default.createElement(ErrorBoundary, {
      FallbackComponent: FallbackComponent
    }, React__default.createElement(Component, _objectSpread({}, props)));
  }
  ComponentWithErrorBoundary.displayName = "withErrorBoundary(".concat(displayName, ")");
  return ComponentWithErrorBoundary;
};
var createFieldId = function createFieldId(questionId) {
  return "question-field-".concat(questionId);
};
var createLegendId = function createLegendId(questionId) {
  return "question-title-legend-".concat(questionId);
};
var createErrorRowId = function createErrorRowId(questionId) {
  return "error-row-".concat(questionId);
};
var createErrorId = function createErrorId(questionId) {
  return "".concat(questionId, "-validation-message");
};
var stripHTML = function stripHTML(str) {
  var ref = document.createElement('div');
  ref.innerHTML = str;
  return ref.textContent || ref.innerText || '';
};

/**
 * Hook to split question-choices by type and filter for visibility
 */
function useQuestionChoices() {
  var choices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = choices.filter(function (c) {
    return !!c && c.visible;
  });
  var columnOptions = columns.filter(function (c) {
    return !!c && c.visible;
  });
  return {
    options: options,
    /** Standard column options (Matrix) */
    columnOptions: columnOptions,
    /** Standard answer options */
    sortableOptions: options.filter(function (c) {
      return !c.type;
    }),
    /** None-Of-The-Above (NOTA) option  */
    notaOption: options.find(function (c) {
      return c.type === 'NOTA';
    }),
    /** Other answer option */
    otherOption: options.find(function (c) {
      return c.type === 'ANSWER';
    }),
    /** Other comment option - One comment for the question */
    commentOption: options.find(function (c) {
      return c.type === 'COMMENT';
    }),
    /** Other comment option - One comment per row (e.g. for Matrix) */
    commentColumnOption: options.find(function (c) {
      return c.type === 'COMMENT_COLUMN';
    })
  };
}
var useStyles$10 = createUseStyles(function (theme) {
  var _theme$questionBody$f2;
  return {
    button: {
      color: theme.nextButton.color,
      backgroundColor: theme.nextButton.backgroundColor,
      fontFamily: (_theme$questionBody$f2 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f2 !== void 0 ? _theme$questionBody$f2 : {},
      fontSize: 15,
      border: [1, 'solid', 'transparent'],
      borderRadius: 2,
      padding: [1, 6],
      maxWidth: '100%',
      minWidth: 60,
      minHeight: 40,
      cursor: 'pointer',
      overflowWrap: 'break-word',
      transition: "all .2s linear",
      '&:focus, &:hover': {
        outlineOffset: 5,
        outline: "1px solid ".concat(theme.answerColor),
        // Safari seems to have an outline bug, may not render without boxshadow
        boxShadow: '0 0 4px transparent'
      }
    }
  };
});
var COPY$f = defineMessages({
  OK_LABEL: {
    id: 'Button.OK_LABEL',
    defaultMessage: 'OK',
    description: '[Type: button][Vis: high] - question ok label'
  }
});
// This might need to be a prop later once confirmed
var MAX_LENGTH = 20;
function Button(_ref10) {
  var _ref10$text = _ref10.text,
    text = _ref10$text === void 0 ? t(COPY$f.OK_LABEL) : _ref10$text,
    _ref10$type = _ref10.type,
    type = _ref10$type === void 0 ? 'button' : _ref10$type,
    className = _ref10.className,
    props = _objectWithoutProperties(_ref10, _excluded5);
  var _useStyles$6 = useStyles$10(),
    button = _useStyles$6.button;
  var slicedText = text.length <= MAX_LENGTH ? text : text.slice(0, MAX_LENGTH);
  return (
    // eslint-disable-next-line react/button-has-type
    React__default.createElement("button", _objectSpread({
      className: classNames(button, className),
      type: type
    }, props), slicedText)
  );
}

/*eslint spaced-comment: ["error", "never", { "exceptions": ["NOSONAR"] }] */
/**
 * SSR Safe version of useLayoutEffect
 * @see https://code.corp.surveymonkey.com/webplatform/smweb/blob/master/apps/contentweb/src/app/pages/MRX/helpers/useIsomorphicLayoutEffect.js
 *
 * Note: `NOSONAR` is used to bypass a `minor:code-smell` error that states `createElement` is deprecated.
 * The eslint rule above disables the spaced comments to use NOSONAR as stated in the docs.
 */
var useSSRSafeLayoutEffect = typeof window !== 'undefined' && typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window$document = _window.document) === null || _window$document === void 0 ? void 0 : _window$document.createElement) !== 'undefined' //NOSONAR
? useLayoutEffect : useEffect;

/** Referentially stable empty function
 *
 * e.g. as default or placeholder */
// eslint-disable-next-line @typescript-eslint/no-empty-function
var EmptyFn = function EmptyFn() {};

/* eslint-disable no-param-reassign, no-plusplus */
/**
 * @name EasingFunctions- Useful easing equations
 * @comment only considering the t value for the range [0, 1] => [0, 1]
 */
var easingFunctions = {
  /** @comment linear - no easing, no acceleration */
  linear: function linear(t) {
    return t;
  },
  /** @comment easeInQuad - accelerating from zero velocity */
  easeInQuad: function easeInQuad(t) {
    return t * t;
  },
  /** @comment easeOutQuad - decelerating to zero velocity */
  easeOutQuad: function easeOutQuad(t) {
    return t * (2 - t);
  },
  /** @comment easeInOutQuad - acceleration until halfway, then deceleration */
  easeInOutQuad: function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  /** @comment easeInCubic - accelerating from zero velocity */
  easeInCubic: function easeInCubic(t) {
    return t * t * t;
  },
  /** @comment easeOutCubic - decelerating to zero velocity */
  easeOutCubic: function easeOutCubic(t) {
    return --t * t * t + 1;
  },
  /** @comment easeInOutCubic - acceleration until halfway, then deceleration */
  easeInOutCubic: function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  /** @comment easeInQuart - accelerating from zero velocity */
  easeInQuart: function easeInQuart(t) {
    return t * t * t * t;
  },
  /** @comment easeOutQuart - decelerating to zero velocity */
  easeOutQuart: function easeOutQuart(t) {
    return 1 - --t * t * t * t;
  },
  /** @comment easeInOutQuart - acceleration until halfway, then deceleration */
  easeInOutQuart: function easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
  },
  /** @comment easeInQuint - accelerating from zero velocity */
  easeInQuint: function easeInQuint(t) {
    return t * t * t * t * t;
  },
  /** @comment easeOutQuint - decelerating to zero velocity */
  easeOutQuint: function easeOutQuint(t) {
    return 1 + --t * t * t * t * t;
  },
  /** @comment easeInOutQuint - acceleration until halfway, then deceleration */
  easeInOutQuint: function easeInOutQuint(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
  }
};
/**
 * Given a start/end point of a scroll and time elapsed, calculate the scroll position we should be at
 */
function getValue(start, end, elapsed, duration) {
  var easingType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'linear';
  if (elapsed > duration) {
    return end;
  }
  var easing = typeof easingType === 'string' ? easingFunctions[easingType] : easingType;
  return start + (end - start) * easing(elapsed / duration);
}
/**
 * Smoothly animate between two values
 */
function animate(_ref11) {
  var fromValue = _ref11.fromValue,
    toValue = _ref11.toValue,
    onStart = _ref11.onStart,
    onUpdate = _ref11.onUpdate,
    onComplete = _ref11.onComplete,
    _ref11$duration = _ref11.duration,
    duration = _ref11$duration === void 0 ? 600 : _ref11$duration,
    _ref11$delay = _ref11.delay,
    delay = _ref11$delay === void 0 ? 0 : _ref11$delay,
    _ref11$easingType = _ref11.easingType,
    easingType = _ref11$easingType === void 0 ? 'easeOutQuart' : _ref11$easingType;
  var startTime = performance.now() + delay;
  var tick = function tick() {
    var elapsed = performance.now() - startTime;
    var time = getValue(fromValue, toValue, elapsed, duration, easingType);
    var callback = elapsed <= duration ? tick : onComplete !== null && onComplete !== void 0 ? onComplete : EmptyFn;
    var updateAnimation = function updateAnimation() {
      onUpdate(time, callback);
    };
    window.requestAnimationFrame(updateAnimation);
  };
  onStart === null || onStart === void 0 ? void 0 : onStart();
  if (delay > 0) {
    setTimeout(function () {
      tick();
    }, delay);
  } else {
    tick();
  }
}
var useStyles$$ = createUseStyles({
  paddingBox: function paddingBox(_ref12) {
    var padding = _ref12.padding,
      width = _ref12.width;
    return {
      paddingTop: (padding === null || padding === void 0 ? void 0 : padding.top) || 0,
      paddingBottom: (padding === null || padding === void 0 ? void 0 : padding.bottom) || 0,
      paddingLeft: (padding === null || padding === void 0 ? void 0 : padding.left) || 0,
      paddingRight: (padding === null || padding === void 0 ? void 0 : padding.right) || 0,
      width: width ? "".concat(width.width).concat(width.format === 'PERCENT' ? '%' : 'px') : '100%',
      maxWidth: '100%'
    };
  }
});
function QuestionSpacing(_ref13) {
  var padding = _ref13.padding,
    width = _ref13.width,
    children = _ref13.children,
    props = _objectWithoutProperties(_ref13, _excluded6);
  var _useStyles$$ = useStyles$$({
      padding: padding,
      width: width
    }),
    paddingBox = _useStyles$$.paddingBox;
  return React__default.createElement("div", _objectSpread({
    className: paddingBox,
    "data-testid": "QuestionSpacing__paddingBox"
  }, props), children);
}

/**
 * Hook that calls the provided callback function when the ref element is blurred,
 * only if the next focus is outside the ref element
 *
 * @example
 * const ref = useRef<HTMLDivElement>(null);
 * useOnFocusLeave(ref, ()=> onLeaveQuestion());
 * <div rf={ref}><input /></div>
 */
function useOnFocusLeave(ref, focusCallback) {
  useEffect(function () {
    var ele = ref === null || ref === void 0 ? void 0 : ref.current;
    function handleFocus(e) {
      if (!(ele !== null && ele !== void 0 && ele.contains(e.relatedTarget))) {
        focusCallback(ref);
      }
    }
    ele === null || ele === void 0 ? void 0 : ele.addEventListener('focusout', handleFocus);
    return function () {
      ele === null || ele === void 0 ? void 0 : ele.removeEventListener('focusout', handleFocus);
    };
  }, [ref, focusCallback]);
}
var useStyles$_ = createUseStyles({
  footerRow: function footerRow(_ref14) {
    var hasFooterPadding = _ref14.hasFooterPadding;
    return {
      paddingTop: hasFooterPadding ? 20 : 0
    };
  },
  containerStyles: {
    position: 'relative',
    transition: 'opacity 500ms ease-out'
  },
  errorRow: {
    overflow: 'hidden'
  },
  formReset: {
    border: 0,
    minWidth: 0
  },
  headerRow: {
    marginBottom: 24,
    width: '100%'
  }
});
function QuestionFieldLayoutTemplate(_ref15) {
  var footer = _ref15.footer,
    hasFooterPadding = _ref15.hasFooterPadding,
    children = _ref15.children,
    clickShield = _ref15.clickShield,
    error = _ref15.error,
    id = _ref15.id,
    padding = _ref15.padding,
    _ref15$width = _ref15.width,
    width = _ref15$width === void 0 ? {
      width: 100,
      format: 'PERCENT'
    } : _ref15$width,
    title = _ref15.title,
    onSubmit = _ref15.onSubmit,
    _ref15$onLeave = _ref15.onLeave,
    onLeave = _ref15$onLeave === void 0 ? function () {} : _ref15$onLeave,
    props = _objectWithoutProperties(_ref15, _excluded7);
  var _useStyles$_ = useStyles$_({
      hasFooterPadding: hasFooterPadding,
      clickShield: clickShield
    }),
    footerRow = _useStyles$_.footerRow,
    containerStyles = _useStyles$_.containerStyles,
    formReset = _useStyles$_.formReset,
    errorRow = _useStyles$_.errorRow,
    headerRow = _useStyles$_.headerRow;
  var containerRef = useRef(null);
  var errorRef = useRef(null);
  /** Keep track of last error to enable error-hiding animation */
  var _useState = useState(error),
    _useState2 = _slicedToArray(_useState, 2),
    lastShownError = _useState2[0],
    setLastShownError = _useState2[1];
  var handleKeydown = useCallback(function (event) {
    if (event.key === 'Enter') {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    }
  }, [onSubmit]);
  /**
   * resolves double height animate issue with RAWR-1240
   */
  var isAnimating = useRef(false);
  useSSRSafeLayoutEffect(function () {
    var el = errorRef.current;
    if (!el || isAnimating.current) {
      return;
    }
    var hasError = !!error;
    var initialHeight = el.offsetHeight;
    el.style.height = 'auto'; // remove height to measure full size
    var offsetHeight = el.offsetHeight;
    var fromValue = hasError ? 0 : offsetHeight;
    var toValue = hasError ? offsetHeight : 0;
    // don't animate if value is already correct (e.g. at initial load)
    if (initialHeight === toValue) {
      el.style.height = "".concat(initialHeight, "px");
      return;
    }
    el.style.height = "".concat(initialHeight, "px");
    animate({
      fromValue: fromValue,
      toValue: toValue,
      duration: 300,
      delay: 200,
      onUpdate: function onUpdate(height, next) {
        el.style.height = "".concat(height, "px");
        next();
      },
      onStart: function onStart() {
        isAnimating.current = true;
      },
      onComplete: function onComplete() {
        setLastShownError(error);
        isAnimating.current = false;
      }
    });
  }, [error]);
  var fieldsetRef = useRef(null);
  useOnFocusLeave(fieldsetRef, onLeave);
  useEffect(function () {
    var container = containerRef.current;
    container === null || container === void 0 ? void 0 : container.addEventListener('keydown', handleKeydown);
    return function () {
      return container === null || container === void 0 ? void 0 : container.removeEventListener('keydown', handleKeydown);
    };
  }, [containerRef, handleKeydown]);
  /**
   * This id is queried in RespWeb to calculate the offset for scroll-to-error animations in classic mode
   * ref: https://code.corp.surveymonkey.com/webplatform/smweb/pull/10725
   */
  var errorRowId;
  /** used in RespWeb for OQAATView */
  var fieldId;
  /** used in RespWeb for OQAATView */
  var questionTitleId;
  if (id) {
    errorRowId = createErrorRowId(id);
    fieldId = createFieldId(id);
    questionTitleId = createLegendId(id);
  }
  return React__default.createElement("div", _objectSpread(_objectSpread({
    ref: containerRef,
    id: fieldId
  }, props), {}, {
    className: containerStyles
  }), React__default.createElement(QuestionSpacing, {
    padding: padding,
    width: width
  }, React__default.createElement("div", {
    ref: errorRef,
    id: errorRowId,
    className: errorRow
  }, error || lastShownError), React__default.createElement("fieldset", {
    ref: fieldsetRef,
    className: formReset
  }, React__default.createElement("legend", {
    id: questionTitleId,
    className: headerRow,
    tabIndex: -1
  }, title), children), footer && React__default.createElement("div", {
    className: footerRow
  }, footer)));
}

/**
 * Calculate the max number of children each column can be filled in the layout
 * @param columns number of columns
 * @param total total child count
 * @description Based on the current implementation in production (as of Jan 20, 2021),
 * - if columns = 1, the max number of children per column = total (render all children vertically)
 * - if columns > 1, the max number of children per column = (total / columns) + 1
 */
var calculateMaxNumOfChildrenPerColumn = function calculateMaxNumOfChildrenPerColumn(columns, total) {
  if (columns === 1) {
    return total;
  }
  var childrenPerColumn = total / columns;
  if (childrenPerColumn % 1 === 0) {
    return childrenPerColumn;
  }
  return Math.floor(childrenPerColumn) + 1;
};
/**
 * Divide the children array into slices for rendering
 * @param childrenArr - children array
 * @param maxCellsPerCol - maximum number of children per slice
 * @param totalColumns - number of columns
 * @example
 * childrenArr = [option1, option2, option3, option4, option5, option6, option7]
 * childrenPerSlice = 2
 * totalColumns = 3
 * output: [[option1, option2, option3], [option4, option5], [option6, option7]]
 */
var sliceChildren = function sliceChildren(childrenArr, maxCellsPerCol, totalColumns) {
  var index = 0;
  var result = [];
  var partialColumnsCount = totalColumns * maxCellsPerCol - childrenArr.length;
  // Calculate the number of fullColumns, to conditionally push slice with the correct # of cells
  var fullColumnsCount = totalColumns - partialColumnsCount;
  while (index < childrenArr.length) {
    if (fullColumnsCount > 0) {
      result.push(childrenArr.slice(index, index + maxCellsPerCol));
      index += maxCellsPerCol;
    } else {
      result.push(childrenArr.slice(index, index + maxCellsPerCol - 1));
      index += maxCellsPerCol - 1;
    }
    fullColumnsCount -= 1;
  }
  return result;
};
var useStyles$Z = createUseStyles(function (theme) {
  var _ref18;
  return _ref18 = {
    containerVertical: {
      display: 'initial'
    },
    containerHorizontal: {
      display: 'block'
    },
    /** shared between horizontal and vertical columns */
    column: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },
    columnHorizontal: {},
    /** Horizontal Column that adjust width to content width */
    columnHorizontalAutoAdjust: {
      width: 'auto'
    }
  }, _defineProperty(_ref18, "@media (min-width: ".concat(theme.breakpoints.xs.min, ")"), {
    containerVertical: {
      display: 'flex'
    },
    containerHorizontal: {
      display: 'flex',
      flexWrap: 'wrap'
    }
  }), _defineProperty(_ref18, "@media only screen and (min-width: ".concat(theme.breakpoints.lg.min, ")"), {
    columnHorizontal: {
      width: '19%'
    }
  }), _defineProperty(_ref18, "@media (min-width: ".concat(theme.breakpoints.sm.min, ") and (max-width: ").concat(theme.breakpoints.md.max, ")"), {
    columnHorizontal: {
      width: '24%'
    }
  }), _defineProperty(_ref18, "@media only screen and (max-width: ".concat(theme.breakpoints.xxs.max, ")"), {
    columnHorizontal: {
      width: '100%',
      display: 'block'
    },
    columnHorizontalAutoAdjust: {
      width: '100%',
      display: 'block'
    }
  }), _defineProperty(_ref18, "answerLayoutCell", function answerLayoutCell(_ref16) {
    var _ref16$gridCellMargin = _ref16.gridCellMargin,
      gridCellMargin = _ref16$gridCellMargin === void 0 ? '0' : _ref16$gridCellMargin;
    return {
      margin: gridCellMargin,
      flex: [0, 0, 'auto'],
      wordBreak: 'normal',
      overflowWrap: 'anywhere'
    };
  }), _defineProperty(_ref18, "otherLayoutCell", function otherLayoutCell(_ref17) {
    var _ref17$otherCellMargi = _ref17.otherCellMargin,
      otherCellMargin = _ref17$otherCellMargi === void 0 ? '0' : _ref17$otherCellMargi;
    return {
      margin: otherCellMargin
    };
  }), _ref18;
});
function QuestionAnswerLayoutTemplate(_ref19) {
  var children = _ref19.children,
    _ref19$columns = _ref19.columns,
    columns = _ref19$columns === void 0 ? 1 : _ref19$columns,
    other = _ref19.other,
    noneOfTheAbove = _ref19.noneOfTheAbove,
    _ref19$adjustToConten = _ref19.adjustToContent,
    adjustToContent = _ref19$adjustToConten === void 0 ? false : _ref19$adjustToConten,
    gridCellMargin = _ref19.gridCellMargin,
    otherCellMargin = _ref19.otherCellMargin;
  var _useStyles$Z = useStyles$Z({
      columns: columns,
      adjustToContent: adjustToContent,
      gridCellMargin: gridCellMargin,
      otherCellMargin: otherCellMargin
    }),
    containerVertical = _useStyles$Z.containerVertical,
    containerHorizontal = _useStyles$Z.containerHorizontal,
    column = _useStyles$Z.column,
    columnHorizontal = _useStyles$Z.columnHorizontal,
    columnHorizontalAutoAdjust = _useStyles$Z.columnHorizontalAutoAdjust,
    answerLayoutCell = _useStyles$Z.answerLayoutCell,
    otherLayoutCell = _useStyles$Z.otherLayoutCell;
  var isHorizontal = columns === 'horizontal';
  /* Based on the columns config, divide the question answers
    (children of this component) into column groups for rendering.
       The reason we need to do this is when there are multiple columns,
    the answers are listed vertically instead of horizontally.
    For example:
    If there are 3 answers and 2 columns,
    Then the ordering will be:
    Answer 1    Answer 3
    Answer 2
       NOT:
    Answer 1    Answer 2
    Answer 3
    * though `horizontal` uses this
    
  */
  var columnGroups = useMemo(function () {
    var totalChildren = React__default.Children.count(children);
    var totalColumns = columns === 'horizontal' ? totalChildren : columns;
    var childrenArray = React__default.Children.toArray(children);
    if (!other && !!noneOfTheAbove && columns !== 'horizontal') {
      childrenArray.push(noneOfTheAbove);
    }
    var answersPerColumn = columns === 'horizontal' ? 1 : calculateMaxNumOfChildrenPerColumn(totalColumns, totalChildren + (!other && !!noneOfTheAbove ? 1 : 0));
    return sliceChildren(childrenArray, answersPerColumn, totalColumns);
  }, [children, columns, noneOfTheAbove, other]);
  var columnClassNames = isHorizontal ? [column, adjustToContent ? columnHorizontalAutoAdjust : columnHorizontal] : column;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: isHorizontal ? containerHorizontal : containerVertical
  }, columnGroups.map(function (col, columnIndex) {
    return React__default.createElement("div", {
      key: "col-".concat(columnIndex + 1),
      className: classNames(columnClassNames),
      "data-testid": "answer-layout-column"
    }, col.map(function (cell, cellIndex) {
      return React__default.createElement("div", {
        key: "cell-".concat(cellIndex + 1),
        "data-testid": "answer-layout-cell",
        className: answerLayoutCell
      }, cell);
    }));
  })), other && React__default.createElement("div", {
    className: otherLayoutCell
  }, other), (other && noneOfTheAbove || columns === 'horizontal') && React__default.createElement("div", {
    className: otherLayoutCell,
    "data-testid": "Other-NOTA"
  }, noneOfTheAbove));
}
function WarningIcon() {
  return React__default.createElement("g", {
    className: "warning-icon"
  }, React__default.createElement("path", {
    className: "background",
    transform: "translate(0 .49999)",
    d: "M8.49642,0.635797c.1494.086885.27371.210979.36079.360173L15.8621,12.9978c.2782.4766.1169,1.0883-.3602,1.3662-.1529.0891-.3267.136-.5037.136L1,14.5c-.552285,0-1-.4473-1-.999c0-.1766.046846-.35.135766-.5026L7.1291,0.996589c.27785-.476838.89002-.63837,1.36732-.360792Z",
    clipRule: "evenodd",
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none"
  }), React__default.createElement("path", {
    className: "foreground",
    transform: "translate(.000815 .49999)",
    d: "M8,11.2546c-.3797,0-.69349.2794-.74315.6419L7.25,11.9973v.26l.00685.1008C7.30651,12.7206,7.6203,13,8,13s.69349-.2794.74315-.6419L8.75,12.2573v-.26l-.00685-.1008C8.69349,11.534,8.3797,11.2546,8,11.2546ZM8,4c-.3797,0-.69349.2794-.74315.6419L7.25,4.74268v4.54393l.00685.10078c.04966.3625.36345.64191.74315.64191s.69349-.27941.74315-.64191L8.75,9.28661v-4.54393L8.74315,4.6419C8.69349,4.2794,8.3797,4,8,4Z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "none"
  }));
}
var WarningIcon$1 = withSvgIcon(WarningIcon, 'WarningIcon');
var useStyles$Y = createUseStyles(function (theme) {
  var _theme$breakpoints3;
  return {
    icon: {
      color: '#F05B24',
      fontSize: theme.fontSize.body,
      alignSelf: 'flex-start',
      marginTop: 2,
      flexShrink: 0
    },
    validationMessage: _defineProperty({
      fontFamily: theme.fontFamily,
      lineHeight: 1.5,
      color: '#333e48',
      fontWeight: 400,
      fontSize: 16,
      padding: theme.isDark ? 8 : [4, 0],
      backgroundColor: theme.isDark ? 'rgba(255, 255, 255, 0.9)' : '',
      borderRadius: 2,
      display: 'inline-flex',
      gap: 5,
      alignItems: 'center',
      marginBottom: 8
    }, "@media only screen and (max-width: ".concat((_theme$breakpoints3 = theme.breakpoints) === null || _theme$breakpoints3 === void 0 ? void 0 : _theme$breakpoints3.xxs.max, ")"), {
      width: '100%',
      padding: theme.isDark ? 4 : [4, 0]
    })
  };
});
function ValidationMessage(_ref20) {
  var children = _ref20.children,
    id = _ref20.id,
    _ref20$tag = _ref20.tag,
    Wrapper = _ref20$tag === void 0 ? 'span' : _ref20$tag,
    props = _objectWithoutProperties(_ref20, _excluded8);
  var _useStyles$Y = useStyles$Y(),
    icon = _useStyles$Y.icon,
    validationMessage = _useStyles$Y.validationMessage;
  return React__default.createElement(Wrapper, _objectSpread({
    className: validationMessage,
    "aria-live": "polite",
    id: id
  }, props), React__default.createElement(WarningIcon$1, {
    className: icon
  }), React__default.createElement("span", {
    translate: "no"
  }, children));
}
var useStyles$X = createUseStyles(function (theme) {
  var _theme$questionBody$f3, _inputArea;
  var breakpointMedium = "@media only screen and (max-width: ".concat(theme.breakpoints.md.max, ")");
  var breakpointXsMin = "@media only screen and (min-width: ".concat(theme.breakpoints.xs.min, ")");
  var fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
  return {
    inputArea: (_inputArea = {
      fontFamily: (_theme$questionBody$f3 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f3 !== void 0 ? _theme$questionBody$f3 : {},
      fontWeight: fontWeightOptions.medium,
      fontSize: '18px'
    }, _defineProperty(_inputArea, breakpointMedium, {
      fontSize: '16px'
    }), _defineProperty(_inputArea, "lineHeight", '1.15em'), _defineProperty(_inputArea, "padding", '6px 60px 6px 6px'), _defineProperty(_inputArea, "maxWidth", '100%'), _defineProperty(_inputArea, breakpointXsMin, {
      // extra 66px to account for the padding
      width: function width(_ref21) {
        var cols = _ref21.cols;
        return "calc(".concat(cols, "ch + 66px)");
      }
    }), _defineProperty(_inputArea, "width", '100%'), _defineProperty(_inputArea, "border", "1px solid ".concat(theme.answerColor)), _defineProperty(_inputArea, "borderRadius", '0px'), _defineProperty(_inputArea, "backgroundColor", '#fff'), _defineProperty(_inputArea, "color", '#000'), _defineProperty(_inputArea, "transition", 'all 0.1s linear'), _defineProperty(_inputArea, "verticalAlign", 'top'), _defineProperty(_inputArea, "textSizeAdjust", 'auto'), _defineProperty(_inputArea, '&:focus, &:hover', {
      outline: "2px solid ".concat(theme.primaryAccentColor)
    }), _defineProperty(_inputArea, '&:read-only:not(:disabled)', {
      borderColor: 'transparent',
      backgroundColor: theme.input.bgColor,
      color: theme.isDark ? '#fff' : '#000',
      opacity: 0.5
    }), _defineProperty(_inputArea, '&:disabled', {
      opacity: 0.4
    }), _inputArea)
  };
});
function TextArea(_ref22, forwardedRef) {
  var className = _ref22.className,
    _ref22$disabled = _ref22.disabled,
    disabled = _ref22$disabled === void 0 ? false : _ref22$disabled,
    _ref22$required = _ref22.required,
    required = _ref22$required === void 0 ? false : _ref22$required,
    _ref22$readOnly = _ref22.readOnly,
    readOnly = _ref22$readOnly === void 0 ? false : _ref22$readOnly,
    _ref22$cols = _ref22.cols,
    cols = _ref22$cols === void 0 ? 50 : _ref22$cols,
    props = _objectWithoutProperties(_ref22, _excluded9);
  var _useStyles$X = useStyles$X({
      cols: cols
    }),
    inputArea = _useStyles$X.inputArea;
  return React__default.createElement("textarea", _objectSpread({
    className: classNames(inputArea, className),
    disabled: disabled,
    "aria-disabled": disabled,
    required: required,
    "aria-required": required,
    readOnly: readOnly,
    "aria-readonly": readOnly,
    spellCheck: true,
    ref: forwardedRef
  }, props));
}
var TextArea$1 = forwardRef(TextArea);
var useStyles$W = createUseStyles(function (theme) {
  var _theme$questionBody$f4, _inputField;
  var breakpointMedium = "@media only screen and (max-width: ".concat(theme.breakpoints.md.max, ")");
  var breakpointXsMin = "@media only screen and (min-width: ".concat(theme.breakpoints.xs.min, ")");
  var fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
  return {
    inputField: (_inputField = {
      fontFamily: (_theme$questionBody$f4 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f4 !== void 0 ? _theme$questionBody$f4 : {},
      fontSize: '18px'
    }, _defineProperty(_inputField, breakpointMedium, {
      fontSize: '16px'
    }), _defineProperty(_inputField, "fontWeight", fontWeightOptions.medium), _defineProperty(_inputField, "lineHeight", '1.5em'), _defineProperty(_inputField, "height", function height(_ref23) {
      var autoHeight = _ref23.autoHeight;
      return autoHeight ? {} : '50px';
    }), _defineProperty(_inputField, "maxWidth", '100%'), _defineProperty(_inputField, "width", '100%'), _defineProperty(_inputField, breakpointXsMin, {
      // extra 12px to account for the padding
      width: function width(_ref24) {
        var size = _ref24.size;
        return "calc(".concat(size, "ch + 12px)");
      }
    }), _defineProperty(_inputField, "padding", '6px'), _defineProperty(_inputField, "border", "1px solid ".concat(theme.answerColor)), _defineProperty(_inputField, "borderRadius", '0px'), _defineProperty(_inputField, "backgroundColor", '#fff'), _defineProperty(_inputField, "color", '#000'), _defineProperty(_inputField, "transition", 'all 0.1s linear'), _defineProperty(_inputField, '&:focus, &:hover', {
      outline: "2px solid ".concat(theme.primaryAccentColor)
    }), _defineProperty(_inputField, '&:read-only:not(:disabled)', {
      borderColor: 'transparent',
      backgroundColor: theme.input.bgColor,
      color: theme.isDark ? '#fff' : '#000',
      opacity: 0.5
    }), _defineProperty(_inputField, '&:disabled', {
      opacity: 0.4
    }), _inputField)
  };
});
function TextInput(_ref25, forwardedRef) {
  var className = _ref25.className,
    _ref25$autoHeight = _ref25.autoHeight,
    autoHeight = _ref25$autoHeight === void 0 ? false : _ref25$autoHeight,
    _ref25$size = _ref25.size,
    size = _ref25$size === void 0 ? 50 : _ref25$size,
    _ref25$required = _ref25.required,
    required = _ref25$required === void 0 ? false : _ref25$required,
    _ref25$disabled = _ref25.disabled,
    disabled = _ref25$disabled === void 0 ? false : _ref25$disabled,
    _ref25$readOnly = _ref25.readOnly,
    readOnly = _ref25$readOnly === void 0 ? false : _ref25$readOnly,
    handleChange = _ref25.onChange,
    props = _objectWithoutProperties(_ref25, _excluded10);
  var _useStyles$W = useStyles$W({
      autoHeight: autoHeight,
      size: size
    }),
    inputField = _useStyles$W.inputField;
  return React__default.createElement("input", _objectSpread(_objectSpread({
    type: "text",
    className: classNames(inputField, className),
    disabled: disabled,
    "aria-disabled": disabled,
    required: required,
    "aria-required": required,
    readOnly: readOnly,
    "aria-readonly": readOnly,
    spellCheck: true,
    onChange: handleChange
  }, props), {}, {
    ref: forwardedRef
  }));
}
var TextInput$1 = forwardRef(TextInput);
var useStyles$V = createUseStyles(function (theme) {
  return {
    commentLabelText: _objectSpread(_objectSpread({}, theme.questionBody), {}, {
      marginBottom: 5,
      lineHeight: 1.25
    }),
    commentLabel: {
      display: 'block'
    }
  };
});
function CommentChoice(_ref26) {
  var label = _ref26.label,
    _ref26$lineCount = _ref26.lineCount,
    lineCount = _ref26$lineCount === void 0 ? 3 : _ref26$lineCount,
    _ref26$charCount = _ref26.charCount,
    charCount = _ref26$charCount === void 0 ? 50 : _ref26$charCount,
    onChange = _ref26.onChange,
    className = _ref26.className,
    props = _objectWithoutProperties(_ref26, _excluded11);
  var handleChange = function handleChange(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  var _useStyles$V = useStyles$V(),
    commentLabel = _useStyles$V.commentLabel,
    commentLabelText = _useStyles$V.commentLabelText;
  var multipleTextLines = lineCount > 1;
  return React__default.createElement("div", {
    className: className
  }, React__default.createElement("label", {
    id: "".concat(props.id, "-label"),
    htmlFor: props.id,
    className: commentLabel,
    tabIndex: -1
  }, React__default.createElement("div", {
    className: commentLabelText
  }, label), multipleTextLines ? React__default.createElement(TextArea$1, _objectSpread({
    onChange: handleChange,
    rows: lineCount,
    cols: charCount
  }, props)) : React__default.createElement(TextInput$1, _objectSpread({
    autoHeight: true,
    onChange: handleChange,
    size: charCount
  }, props))));
}

/**
 * Visually Hidden CSS properties
 * @description common css-properties to visually hide text and available for screen-readers.
 * There may be times where the css-specificity may not be high enough for the class to be invoked,
 * Ergo, the use of `!important` which will help ensure the properties are applied at any specificity.
 * @example
 * // usage with `react-jss`
 * import visuallyHiddenProperties from './utils/visuallyHidden';
 *
 * const useStyles = createUseStyles({
 *   srOnly: {...visuallyHiddenProperties}
 * })
 */
var visuallyHidden = {
  border: [[0], '!important'],
  /**
   * @desc for backwards compatibility
   * @deprecated
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip
   * @see https://caniuse.com/mdn-css_properties_clip
   */
  clip: ['rect(1px, 1px, 1px, 1px)', '!important'],
  /**
   * @desc future-proof version
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip-path
   * @see https://caniuse.com/css-clip-path
   */
  clipPath: ['inset(50%)', '!important'],
  height: ['1px', '!important'],
  margin: ['-1px', '!important'],
  overflow: ['hidden', '!important'],
  padding: [[0], '!important'],
  position: ['absolute', '!important'],
  width: ['1px', '!important'],
  /**
   * @desc preventing text to be condensed
   * @see https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
   */
  whiteSpace: ['nowrap', '!important']
};
var textReset = {
  margin: 0
};
var useStyles$U = createUseStyles(function (theme) {
  var _theme$questionTitle = theme.questionTitle,
    fontSize = _theme$questionTitle.fontSize,
    questionTitleFormatting = _objectWithoutProperties(_theme$questionTitle, _excluded12);
  var questionTitleFontSize = fontSize !== null && fontSize !== void 0 ? fontSize : {};
  return {
    srOnly: _objectSpread({}, visuallyHidden),
    addonContainer: {
      display: 'inline-block',
      margin: [0, 5],
      verticalAlign: 'text-bottom'
    },
    container: {
      position: 'relative',
      display: 'flex'
    },
    questionNumber: function questionNumber(_ref27) {
      var isRTL = _ref27.isRTL;
      return {
        margin: isRTL ? '0 0 0 0.25em' : '0 0.25em 0 0',
        flex: [0, 0]
      };
    },
    questionTitle: function questionTitle(_ref28) {
      var _theme$questionTitle2;
      var useDefaultFrontSize = _ref28.useDefaultFrontSize;
      return _objectSpread(_objectSpread(_objectSpread({}, textReset), questionTitleFormatting), {}, {
        color: ((_theme$questionTitle2 = theme.questionTitle) === null || _theme$questionTitle2 === void 0 ? void 0 : _theme$questionTitle2.color) || theme.questionColor,
        fontSize: useDefaultFrontSize && !theme.isAccessible ? theme.fontSize.body : questionTitleFontSize,
        lineHeight: 1.25,
        whiteSpace: 'normal',
        wordWrap: 'break-word'
      });
    },
    requiredAsterisk: function requiredAsterisk(_ref29) {
      var isRTL = _ref29.isRTL;
      return {
        display: 'inline-block',
        margin: isRTL ? '0 0 0 0.25em' : '0 0.25em 0 0'
      };
    },
    richText: {
      flex: [1, 0]
    }
  };
});
var COPY$e = defineMessages({
  REQUIRED: {
    id: 'RespondentQuestionTitle.REQUIRED',
    defaultMessage: '(Required.)',
    description: '[Type: label][Vis: medium] - visualy hidden required text'
  }
});
function RespondentQuestionTitle(_ref30) {
  var _ref30$element = _ref30.element,
    Element = _ref30$element === void 0 ? 'div' : _ref30$element,
    addon = _ref30.addon,
    heading = _ref30.heading,
    id = _ref30.id,
    number = _ref30.number,
    numbered = _ref30.numbered,
    required = _ref30.required,
    showAsterisk = _ref30.requiredAsterisk,
    _ref30$useDefaultFron = _ref30.useDefaultFrontSize,
    useDefaultFrontSize = _ref30$useDefaultFron === void 0 ? false : _ref30$useDefaultFron,
    props = _objectWithoutProperties(_ref30, _excluded13);
  var _useContext = useContext(L10NContext),
    isRTL = _useContext.isRTL;
  var _useStyles$U = useStyles$U({
      useDefaultFrontSize: useDefaultFrontSize,
      isRTL: isRTL
    }),
    addonContainer = _useStyles$U.addonContainer,
    container = _useStyles$U.container,
    questionNumber = _useStyles$U.questionNumber,
    questionTitle = _useStyles$U.questionTitle,
    requiredAsterisk = _useStyles$U.requiredAsterisk,
    richText = _useStyles$U.richText,
    srOnly = _useStyles$U.srOnly;
  return React__default.createElement(Element, _objectSpread({
    id: id,
    className: classNames(container, questionTitle),
    translate: "no"
  }, props), required && showAsterisk && React__default.createElement("span", {
    "aria-hidden": true,
    className: requiredAsterisk
  }, "*"), numbered && React__default.createElement("span", {
    className: questionNumber
  }, number, "."), React__default.createElement(RichText, {
    element: "span",
    text: heading,
    className: richText
  }), required && React__default.createElement("span", {
    className: srOnly
  }, React__default.createElement(T, {
    desc: COPY$e.REQUIRED
  })), addon && React__default.createElement("span", {
    className: addonContainer
  }, addon));
}

// default text to be added as a translation to a specific version of Button directly.
var defaultOKConfig = {
  text: 'OK',
  visible: false
};
function QuestionField(_ref31) {
  var id = _ref31.id,
    titleProps = _ref31.title,
    _ref31$okButton = _ref31.okButton;
  _ref31$okButton = _ref31$okButton === void 0 ? defaultOKConfig : _ref31$okButton;
  var showButton = _ref31$okButton.visible,
    okButtonProps = _objectWithoutProperties(_ref31$okButton, _excluded14),
    error = _ref31.error,
    errorIdProp = _ref31.errorId,
    onLeave = _ref31.onLeave,
    _ref31$padding = _ref31.padding,
    padding = _ref31$padding === void 0 ? {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    } : _ref31$padding,
    width = _ref31.width,
    children = _ref31.children,
    props = _objectWithoutProperties(_ref31, _excluded15);
  var errorId = errorIdProp !== null && errorIdProp !== void 0 ? errorIdProp : createErrorId(id);
  return React__default.createElement(QuestionFieldLayoutTemplate, _objectSpread({
    footer: showButton && React__default.createElement(Button, _objectSpread({
      type: "button"
    }, okButtonProps)),
    hasFooterPadding: true,
    clickShield: false,
    error: error && React__default.createElement(ValidationMessage, {
      id: errorId
    }, error),
    onLeave: onLeave,
    id: id,
    padding: padding,
    width: width,
    title: React__default.createElement(RespondentQuestionTitle, _objectSpread({}, titleProps))
  }, props), children);
}
function useInputStyles(_ref32) {
  var _ref33;
  var onChange = _ref32.onChange,
    props = _objectWithoutProperties(_ref32, _excluded16);
  /** extract props without affecting passthrough */
  var isChecked = props.checked,
    isDefaultChecked = props.defaultChecked,
    isDisabled = props.disabled,
    isAriaDisabled = props['aria-disabled'],
    isReadOnly = props.readOnly,
    isAriaReadOnly = props['aria-readonly'];
  /** configure style-props */
  var disabled = isDisabled || isAriaDisabled === 'true';
  var readOnly = isReadOnly || isAriaReadOnly === 'true';
  var _useState3 = useState((_ref33 = isDefaultChecked !== null && isDefaultChecked !== void 0 ? isDefaultChecked : isChecked) !== null && _ref33 !== void 0 ? _ref33 : false),
    _useState4 = _slicedToArray(_useState3, 2),
    checked = _useState4[0],
    setIsChecked = _useState4[1];
  React__default.useEffect(function () {
    setIsChecked(isChecked !== null && isChecked !== void 0 ? isChecked : false);
  }, [isChecked]);
  /** handle change for checked style (controlled/uncontrolled) */
  var handleChange = function handleChange(e) {
    setIsChecked(e.target.checked);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  var styleProps = {
    checked: checked,
    disabled: disabled,
    readOnly: readOnly
  };
  var inputProps = _objectSpread(_objectSpread({}, props), {}, {
    onChange: handleChange
  });
  return {
    styleProps: styleProps,
    inputProps: inputProps
  };
}
var radioGroupContext = createContext(undefined);
function useRadioGroup() {
  return useContext(radioGroupContext);
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, no-console */
function throwControlChangeError(isControlled, controlled, name, state) {
  var conState = ['controlled', 'uncontrolled'];
  var stateStr = isControlled ? conState : [].concat(conState).reverse();
  if (isControlled !== (controlled !== undefined)) {
    console.error(["@sm/question-ui: A component is changing the ".concat(stateStr[0], " ").concat(state, " state of ").concat(name, " to be ").concat(stateStr[1], "."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " element for the lifetime of the component."), "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
  }
}
function throwDefaultStateError(isControlled, defaultValue, defaultProp, name, state) {
  if (!isControlled && defaultValue !== defaultProp) {
    console.error(["@sm/question-ui: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. "), "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
  }
}
function useControlledState(_ref34) {
  var controlled = _ref34.controlled,
    defaultProp = _ref34.default,
    name = _ref34.name,
    _ref34$state = _ref34.state,
    state = _ref34$state === void 0 ? 'value' : _ref34$state;
  // isControlled is ignored in the hook dependency lists as it should never change.
  var _React__default$useRe = React__default.useRef(controlled !== undefined),
    isControlled = _React__default$useRe.current;
  var _React__default$useSt9 = React__default.useState(defaultProp),
    _React__default$useSt10 = _slicedToArray(_React__default$useSt9, 2),
    valueState = _React__default$useSt10[0],
    setValue = _React__default$useSt10[1];
  var value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== 'production') {
    var _React__default$useRe2 = React__default.useRef(defaultProp),
      defaultValue = _React__default$useRe2.current;
    React__default.useEffect(function () {
      throwControlChangeError(isControlled, controlled, name, state);
      throwDefaultStateError(isControlled, defaultValue, defaultProp, name, state);
    }, [state, name, controlled, defaultProp]);
  }
  var setValueIfUncontrolled = React__default.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, [setValue]);
  return [value, setValueIfUncontrolled];
}
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    // eslint-disable-next-line no-param-reassign
    ref.current = value;
  }
}
/**
 * useForkRef
 * Joins refs together and returns a combination of the two as a new ref
 *
 * @param refA
 * @param refB
 */
function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }
    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

/**
 * SMQ Tier 3
 */
function RadioGroup(_ref35) {
  var children = _ref35.children,
    nameProp = _ref35.name,
    valueProp = _ref35.value,
    defaultValue = _ref35.defaultValue,
    onChange = _ref35.onChange,
    _ref35$disabled = _ref35.disabled,
    disabled = _ref35$disabled === void 0 ? false : _ref35$disabled,
    _ref35$readOnly = _ref35.readOnly,
    readOnly = _ref35$readOnly === void 0 ? false : _ref35$readOnly,
    divProps = _objectWithoutProperties(_ref35, _excluded17);
  var _useControlledState = useControlledState({
      controlled: valueProp,
      default: defaultValue,
      name: 'RadioGroup'
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    value = _useControlledState2[0],
    setValueState = _useControlledState2[1];
  var handleChange = function handleChange(e) {
    setValueState(e.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  var name = nameProp;
  return React__default.createElement(radioGroupContext.Provider
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  , {
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    value: {
      name: name,
      onChange: handleChange,
      value: value,
      disabled: disabled,
      readOnly: readOnly
    }
  }, React__default.createElement("div", _objectSpread({
    role: "radiogroup"
  }, divProps), children));
}
var useStyles$T = createUseStyles({
  inputContainer: {
    display: 'inline-flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    width: '1em',
    minWidth: '1em',
    cursor: 'pointer'
  },
  input: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    opacity: 0.00001,
    zIndex: 1,
    margin: 0,
    cursor: function cursor(_ref36) {
      var disabled = _ref36.disabled,
        readOnly = _ref36.readOnly;
      return disabled || readOnly ? 'default' : 'pointer';
    },
    pointerEvents: function pointerEvents(_ref37) {
      var disabled = _ref37.disabled,
        readOnly = _ref37.readOnly;
      return disabled || readOnly ? 'none' : undefined;
    }
  },
  controlIcon: {
    width: '100%',
    height: '100%',
    opacity: function opacity(_ref38) {
      var checked = _ref38.checked;
      return checked ? 1 : 0;
    },
    transition: 'opacity .2s linear'
  }
});
function BaseInput(_ref39, forwardedRef) {
  var _ref39$element = _ref39.element,
    Element = _ref39$element === void 0 ? 'span' : _ref39$element,
    className = _ref39.className,
    icon = _ref39.icon,
    checkedProp = _ref39.checked,
    defaultChecked = _ref39.defaultChecked,
    onClick = _ref39.onClick,
    onChange = _ref39.onChange,
    inputProps = _objectWithoutProperties(_ref39, _excluded18);
  /** extract props without affecting passthrough */
  var disabledProp = inputProps.disabled,
    ariaDisabledProp = inputProps['aria-disabled'],
    readOnlyProp = inputProps.readOnly,
    ariaReadOnlyProp = inputProps['aria-readonly'];
  var disabled = disabledProp || ariaDisabledProp === 'true';
  var readOnly = readOnlyProp || ariaReadOnlyProp === 'true';
  var _useControlledState3 = useControlledState({
      controlled: checkedProp,
      default: defaultChecked,
      state: 'checked',
      name: 'BaseInput'
    }),
    _useControlledState4 = _slicedToArray(_useControlledState3, 2),
    checked = _useControlledState4[0],
    setChecked = _useControlledState4[1];
  var handleChange = function handleChange(e) {
    if (e.nativeEvent.defaultPrevented) {
      return;
    }
    if (disabled || readOnly) {
      e.preventDefault();
      return;
    }
    var newChecked = e.target.checked;
    setChecked(newChecked);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  var handleClick = function handleClick(e) {
    if (disabled || readOnly) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  var _useStyles$T = useStyles$T({
      disabled: disabled,
      readOnly: readOnly,
      checked: checked
    }),
    inputContainer = _useStyles$T.inputContainer,
    input = _useStyles$T.input,
    controlIcon = _useStyles$T.controlIcon;
  return React__default.createElement(Element, {
    className: classNames(inputContainer, className)
  }, React__default.createElement("input", _objectSpread(_objectSpread({
    className: input,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    onChange: handleChange,
    onClick: handleClick
  }, inputProps), {}, {
    ref: forwardedRef
  })), React__default.cloneElement(icon, {
    className: controlIcon
  }));
}
var BaseInput$1 = forwardRef(BaseInput);
function RadioIcon() {
  return React__default.createElement("g", {
    className: "radio-icon"
  }, React__default.createElement("ellipse", {
    fill: "currentColor",
    className: "background",
    transform: "translate(8 8)",
    rx: "8",
    ry: "8"
  }), React__default.createElement("path", {
    fill: "#fff",
    className: "checkmark",
    transform: "matrix(.91924 .91924 -.91924 .91924 -.72152 -9.5796)",
    d: "m14.521 0h1.4788v8h-5.0216l-0.002914-1.4404h3.5456l-1e-6 -6.5596z"
  }));
}
var RadioIcon$1 = withSvgIcon(RadioIcon, 'RadioIcon');
var useStyles$S = createUseStyles(function (theme) {
  return {
    radioInput: {
      color: theme.isDark ? '#fff' : '#000',
      backgroundColor: function backgroundColor(_ref40) {
        var checked = _ref40.checked;
        if (checked) {
          return theme.isDark ? '#fff' : '#000';
        }
        return '#fff';
      },
      border: "1px solid ".concat(theme.answerColor),
      borderRadius: '100%',
      '& .checkmark': {
        fill: theme.isDark ? '#000' : '#fff'
      },
      '&:focus-within': {
        boxShadow: "0 0 0 1px ".concat(theme.primaryAccentColor),
        borderColor: '#fff'
      },
      '& input': {
        cursor: 'pointer'
      }
    }
  };
});
function RadioInput(_ref41, forwardedRef) {
  var className = _ref41.className,
    props = _objectWithoutProperties(_ref41, _excluded19);
  var _useInputStyles = useInputStyles(props),
    inputProps = _useInputStyles.inputProps,
    styleProps = _useInputStyles.styleProps;
  var styles = useStyles$S(styleProps);
  return React__default.createElement(BaseInput$1, _objectSpread({
    type: "radio",
    className: classNames(styles.radioInput, className),
    icon: React__default.createElement(RadioIcon$1, null),
    ref: forwardedRef
  }, inputProps));
}
var RadioInput$1 = forwardRef(RadioInput);

// get the margin top by taking the font size and the line height and divide by 2 to get the margin top
var marginTopHelper$1 = function marginTopHelper$1() {
  var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var lineHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Math.max(0, (height * lineHeight - height) / 2); // no negative margins
};

var useStyles$R = createUseStyles(function (theme) {
  var _theme$questionBody3;
  return {
    controlLabel: function controlLabel(_ref42) {
      var _theme$questionBody$f5;
      var checked = _ref42.checked,
        disabled = _ref42.disabled;
      var borderStyle = checked ? 'solid' : 'dashed';
      var borderColor = disabled && !checked ? 'transparent' : theme.questionColor;
      var fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
      return _objectSpread(_objectSpread({
        display: 'flex',
        alignItems: 'start',
        cursor: 'pointer',
        padding: [5, 8, 7, 8],
        gap: 8,
        borderRadius: 4,
        border: [1, 'solid', checked ? theme.questionColor : 'transparent'],
        backgroundColor: checked ? theme.correctAnswerHighlightColor : 'transparent'
      }, theme.questionBody), {}, {
        lineHeight: 1.5,
        fontWeight: checked ? fontWeightOptions.medium : (_theme$questionBody$f5 = theme.questionBody.fontWeight) !== null && _theme$questionBody$f5 !== void 0 ? _theme$questionBody$f5 : fontWeightOptions.light,
        '&:hover': {
          border: [1, borderStyle, borderColor]
        },
        '&:focus-within': {
          background: theme.correctAnswerHighlightColor
        }
      });
    },
    icon: {
      flexShrink: 0,
      fontSize: function fontSize(_ref43) {
        var inputSize = _ref43.inputSize;
        return inputSize !== null && inputSize !== void 0 ? inputSize : '1em';
      },
      marginTop: marginTopHelper$1((_theme$questionBody3 = theme.questionBody) === null || _theme$questionBody3 === void 0 ? void 0 : _theme$questionBody3.fontSize, 1.5),
      // The following selector singles out Safari and Chrome on iOS14 to
      // implement a workaround for the lack of flex gap.
      '@supports (-webkit-touch-callout: none) and (not (translate: none))': {
        marginRight: 8
      }
    }
  };
});
function Radio(_ref44, forwardedRef) {
  var _radioGroup$disabled, _radioGroup$readOnly;
  var _ref44$children = _ref44.children,
    label = _ref44$children === void 0 ? '' : _ref44$children,
    className = _ref44.className,
    onChange = _ref44.onChange,
    checkedProp = _ref44.checked,
    nameProp = _ref44.name,
    disabledProp = _ref44.disabled,
    readOnlyProp = _ref44.readOnly,
    inputSize = _ref44.inputSize,
    props = _objectWithoutProperties(_ref44, _excluded20);
  var radioGroup = useRadioGroup();
  var checked = checkedProp;
  var name = nameProp;
  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }
    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }
  var disabled = (_radioGroup$disabled = radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.disabled) !== null && _radioGroup$disabled !== void 0 ? _radioGroup$disabled : disabledProp;
  var readOnly = (_radioGroup$readOnly = radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.readOnly) !== null && _radioGroup$readOnly !== void 0 ? _radioGroup$readOnly : readOnlyProp;
  var handleChange = function handleChange(e) {
    var _e$target = e.target,
      id = _e$target.id,
      isChecked = _e$target.checked,
      value = _e$target.value;
    radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.onChange({
      id: id,
      checked: isChecked,
      value: value
    });
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: id,
      checked: isChecked,
      value: value
    });
  };
  var _useInputStyles2 = useInputStyles(_objectSpread(_objectSpread({}, props), {}, {
      name: name,
      checked: checked,
      disabled: disabled,
      readOnly: readOnly,
      onChange: handleChange
    })),
    inputProps = _useInputStyles2.inputProps,
    styleProps = _useInputStyles2.styleProps;
  var _useStyles$R = useStyles$R(_objectSpread(_objectSpread({}, styleProps), {}, {
      inputSize: inputSize
    })),
    controlLabel = _useStyles$R.controlLabel,
    icon = _useStyles$R.icon;
  return React__default.createElement("label", {
    tabIndex: -1,
    htmlFor: props.id,
    className: classNames(controlLabel, className)
  }, React__default.createElement(RadioInput$1, _objectSpread(_objectSpread({}, inputProps), {}, {
    ref: forwardedRef,
    className: icon
  })), React__default.createElement(RichText, {
    element: "span",
    text: label
  }));
}
var Radio$1 = forwardRef(Radio);
var useStyles$Q = createUseStyles(function (theme) {
  var breakpointSmMax = "@media screen and (max-width: ".concat(theme.breakpoints.sm.max, ")");
  return {
    rowStyles: _objectSpread(_objectSpread({
      borderRadius: '3px',
      textAlign: 'center',
      cursor: 'pointer',
      alignItems: 'center',
      padding: '3px'
    }, theme.questionBody), {}, {
      fontSize: '20px'
    }),
    rowLabel: _defineProperty({
      margin: [0, 2, 0, 2],
      fontSize: '18px',
      padding: '3px',
      width: function width(_ref45) {
        var _ref45$width = _ref45.width,
          _width = _ref45$width === void 0 ? 60 : _ref45$width;
        return "".concat(_width, "%");
      },
      wordWrap: 'wrap',
      flexWrap: 'wrap'
    }, breakpointSmMax, {
      width: ['50%', '!important']
    }),
    rowRadio: _defineProperty({
      justifyContent: 'center',
      gap: 0,
      padding: '3px',
      fontSize: 'inherit',
      width: function width(_ref46) {
        var _ref46$radioWidth = _ref46.radioWidth,
          radioWidth = _ref46$radioWidth === void 0 ? 20 : _ref46$radioWidth;
        return "".concat(radioWidth, "%");
      }
    }, breakpointSmMax, {
      width: ['25%', '!important']
    })
  };
});
function BestWorstRow(_ref47) {
  var rowId = _ref47.id,
    label = _ref47.label,
    _ref47$value = _ref47.value,
    value = _ref47$value === void 0 ? null : _ref47$value,
    _ref47$columnIds = _ref47.columnIds,
    columnIds = _ref47$columnIds === void 0 ? [] : _ref47$columnIds,
    className = _ref47.className,
    onChange = _ref47.onChange,
    onClick = _ref47.onClick,
    onKeyDown = _ref47.onKeyDown,
    width = _ref47.width,
    props = _objectWithoutProperties(_ref47, _excluded21);
  var DEFAULT_RADIO_WIDTH = 20;
  var _columnIds = _slicedToArray(columnIds, 2),
    bestColId = _columnIds[0],
    worstColId = _columnIds[1];
  var bestRadioId = "".concat(rowId, "_").concat(bestColId);
  var worstRadioId = "".concat(rowId, "_").concat(worstColId);
  var labelId = "".concat(rowId, "_label");
  var radioEvents = {
    onClick: onClick,
    onKeyDown: onKeyDown
  };
  var radioWidth = width !== undefined ? (100 - width) / 2 : DEFAULT_RADIO_WIDTH;
  var handleChange = function handleChange(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: rowId,
      value: e.value,
      checked: e.checked
    });
  };
  var _useStyles$Q = useStyles$Q({
      width: width,
      radioWidth: radioWidth
    }),
    rowStyles = _useStyles$Q.rowStyles,
    rowLabel = _useStyles$Q.rowLabel,
    rowRadio = _useStyles$Q.rowRadio;
  return React__default.createElement(Row, _objectSpread({
    className: classNames(rowStyles, className)
  }, props), React__default.createElement(Radio$1, _objectSpread({
    id: bestRadioId,
    className: rowRadio,
    value: bestColId,
    name: rowId,
    checked: value === bestColId,
    "aria-labelledby": "".concat(bestColId, " ").concat(labelId),
    onChange: handleChange
  }, radioEvents)), React__default.createElement("span", {
    className: rowLabel
  }, React__default.createElement(RichText, {
    id: labelId,
    element: "span",
    text: label
  })), React__default.createElement(Radio$1, _objectSpread({
    id: worstRadioId,
    className: rowRadio,
    value: worstColId,
    name: rowId,
    checked: value === worstColId,
    "aria-labelledby": "".concat(worstColId, " ").concat(labelId),
    onChange: handleChange
  }, radioEvents)));
}
var useStyles$P = createUseStyles(function (theme) {
  var breakpointSmMax = "@media screen and (max-width: ".concat(theme.breakpoints.sm.max, ")");
  return {
    rowList: {
      '& > :nth-child(even)': {
        backgroundColor: theme.input.bgColor
      }
    },
    headerColumn: function headerColumn(_ref48) {
      var _ref48$radioWidth = _ref48.radioWidth,
        radioWidth = _ref48$radioWidth === void 0 ? 20 : _ref48$radioWidth;
      return _objectSpread(_objectSpread({
        display: 'table',
        width: "".concat(radioWidth, "%"),
        padding: '5px 8px',
        alignItems: 'center',
        textAlign: 'center'
      }, theme.questionBody), {}, _defineProperty({
        fontSize: '20px',
        fontWeight: 500
      }, breakpointSmMax, {
        width: '25%'
      }));
    },
    labelColumn: function labelColumn(_ref49) {
      var _ref49$labelWidth = _ref49.labelWidth,
        labelWidth = _ref49$labelWidth === void 0 ? 60 : _ref49$labelWidth;
      return _defineProperty({
        display: 'table',
        width: "".concat(labelWidth, "%"),
        margin: [0, 2, 0, 2],
        padding: '3px'
      }, breakpointSmMax, {
        width: '50%'
      });
    }
  };
});
function BestWorst(_ref51) {
  var questionId = _ref51.id,
    _dis = _ref51.disabled,
    _ro = _ref51.readOnly,
    _ref51$choices = _ref51.choices,
    fields = _ref51$choices === void 0 ? [] : _ref51$choices,
    _ref51$responses = _ref51.responses,
    responses = _ref51$responses === void 0 ? [] : _ref51$responses,
    _ref51$columnChoices = _ref51.columnChoices,
    columnChoices = _ref51$columnChoices === void 0 ? [] : _ref51$columnChoices,
    onChange = _ref51.onChange,
    labelWidth = _ref51.labelWidth,
    questionFieldProps = _objectWithoutProperties(_ref51, _excluded22);
  var DEFAULT_RADIO_WIDTH = 20;
  var _useState5 = useState(responses),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedChoices = _useState6[0],
    setSelectedChoices = _useState6[1];
  var _columnChoices = _slicedToArray(columnChoices, 2),
    bestAnswerColumn = _columnChoices[0],
    worstAnswerColumn = _columnChoices[1];
  var columnIds = columnChoices === null || columnChoices === void 0 ? void 0 : columnChoices.map(function (c) {
    return c.id;
  });
  var errorId = createErrorId(questionId);
  var radioWidth = labelWidth !== undefined ? (100 - labelWidth) / 2 : DEFAULT_RADIO_WIDTH;
  /** Filter choices that exist and are visible  */
  var _useQuestionChoices = useQuestionChoices(fields),
    rowFields = _useQuestionChoices.options;
  /** determines whether a radio should be rendered as checked or unchecked */
  var getRadioSelection = function getRadioSelection(id) {
    var _selectedChoices$find, _selectedChoices$find2;
    return (_selectedChoices$find = (_selectedChoices$find2 = selectedChoices.find(function (c) {
      return c.id === id;
    })) === null || _selectedChoices$find2 === void 0 ? void 0 : _selectedChoices$find2.value[0].id) !== null && _selectedChoices$find !== void 0 ? _selectedChoices$find : '';
  };
  /** unChecks selected choice  */
  var unCheckOption = function unCheckOption(radioId) {
    var newChoices = selectedChoices.filter(function (c) {
      return !radioId.match(c.id);
    });
    setSelectedChoices(newChoices);
    onChange === null || onChange === void 0 ? void 0 : onChange(newChoices);
  };
  /** handles adding new checked selection to responses */
  var handleChange = function handleChange(e) {
    var newChoices = [];
    var rowId = e.id;
    var rowValue = e.value;
    /** remove any other checked radio in the same row or column */
    newChoices = selectedChoices.filter(function (row) {
      return !(row.id === rowId || row.value.find(function (col) {
        return col.value === rowValue;
      }));
    });
    newChoices.push({
      id: rowId,
      value: [{
        id: rowValue,
        value: rowValue
      }]
    });
    setSelectedChoices(newChoices);
    onChange === null || onChange === void 0 ? void 0 : onChange(newChoices);
  };
  var handleClick = function handleClick(e) {
    var input = e.target;
    var isSelected = selectedChoices.find(function (c) {
      return input.id.match(c.id);
    });
    if (isSelected && input.checked) {
      unCheckOption(input.id);
    }
  };
  var handleKeyboard = function handleKeyboard(e) {
    var input = e.target;
    var isSelected = selectedChoices.find(function (c) {
      return input.id.match(c.id);
    });
    if (e.code === 'Space' && isSelected) {
      e.preventDefault();
      unCheckOption(input.id);
    }
  };
  var _useStyles$P = useStyles$P({
      labelWidth: labelWidth,
      radioWidth: radioWidth
    }),
    headerColumn = _useStyles$P.headerColumn,
    rowList = _useStyles$P.rowList,
    labelColumn = _useStyles$P.labelColumn;
  return (
    /*
      NOTE: The id has been modified to work in hybrid mode. The id needs to
      be different from the question-field id created in the responseweb.
    */
    React__default.createElement(QuestionField, _objectSpread({
      id: "hybrid-".concat(questionId),
      "data-testid": "BestWorstQuestionType"
    }, questionFieldProps), React__default.createElement("div", {
      className: rowList
    }, React__default.createElement(Row, null, React__default.createElement(RichText, {
      id: bestAnswerColumn === null || bestAnswerColumn === void 0 ? void 0 : bestAnswerColumn.id,
      element: "span",
      text: bestAnswerColumn === null || bestAnswerColumn === void 0 ? void 0 : bestAnswerColumn.label,
      className: classNames(headerColumn)
    }), React__default.createElement("span", {
      className: classNames(headerColumn, labelColumn)
    }), React__default.createElement(RichText, {
      id: worstAnswerColumn === null || worstAnswerColumn === void 0 ? void 0 : worstAnswerColumn.id,
      element: "span",
      text: worstAnswerColumn === null || worstAnswerColumn === void 0 ? void 0 : worstAnswerColumn.label,
      className: classNames(headerColumn)
    })), rowFields === null || rowFields === void 0 ? void 0 : rowFields.map(function (field) {
      var rowId = "".concat(questionId, "_").concat(field.id);
      return React__default.createElement(BestWorstRow, {
        key: rowId,
        id: rowId,
        label: field.label,
        width: labelWidth,
        value: getRadioSelection(rowId),
        columnIds: columnIds,
        onChange: handleChange,
        onClick: handleClick,
        onKeyDown: handleKeyboard,
        "aria-describedby": questionFieldProps.error && errorId || undefined
      });
    })))
  );
}
var BestWorst$1 = withErrorBoundary(BestWorst);
function CheckboxIcon() {
  return React__default.createElement("g", {
    className: "checkbox-icon"
  }, React__default.createElement("rect", {
    fill: "currentColor",
    className: "background",
    width: "16",
    height: "16",
    rx: "2",
    ry: "2"
  }), React__default.createElement("path", {
    fill: "#fff",
    className: "checkmark",
    transform: "matrix(.91924 .91924 -.91924 .91924 -.72152 -9.5796)",
    d: "m14.521 0h1.4788v8h-5.0216l-0.002914-1.4404h3.5456l-1e-6 -6.5596z"
  }));
}
var CheckboxIcon$1 = withSvgIcon(CheckboxIcon, 'CheckboxIcon');
function SelectIcon() {
  return React__default.createElement("g", {
    className: "select-icon"
  }, React__default.createElement("polygon", {
    className: "select-arrow select-arrow-top",
    transform: "matrix(1.4619 0 0 1.4619 5.8783 5.4791)",
    points: "1.4514 -3.0633 5.5556 1.0409 -2.6529 1.0409",
    fill: "currentColor",
    stroke: "transparent",
    strokeLinejoin: "round",
    strokeWidth: ".5"
  }), React__default.createElement("polygon", {
    className: "select-arrow select-arrow-bottom",
    transform: "matrix(-1.4619 0 0 -1.4619 10.122 10.522)",
    points: "1.4514 -3.0633 5.5556 1.0409 -2.6529 1.0409",
    fill: "currentColor",
    stroke: "transparent",
    strokeLinejoin: "round",
    strokeWidth: ".5"
  }));
}
var SelectIcon$1 = withSvgIcon(SelectIcon, 'SelectIcon');
function CaretDown() {
  return React__default.createElement("g", {
    className: "caret-down-icon"
  }, React__default.createElement("path", {
    d: "M13.254 4c.19.001.38.088.526.26.267.316.29.81.073 1.158l-.073.1L8.53 11.74l-.084.086a.66.66 0 0 1-.901-.007l-.076-.08L2.22 5.523l-.073-.1a1.024 1.024 0 0 1 0-1.058l.073-.1.084-.085a.674.674 0 0 1 .446-.175V4h10.504z",
    fill: "currentColor"
  }));
}
var CaretDownIcon = withSvgIcon(CaretDown, 'CaretDownIcon');
function CaretDownOutline() {
  return React__default.createElement("g", {
    className: "caret-down-icon"
  }, React__default.createElement("path", {
    d: "m922.74 642.16l-415.95-416.06c-18.533-18.538-48.507-18.538-67.04 0l-415.85 416.06c-18.533 18.538-18.533 48.519 0 67.057l33.473 33.481c18.533 18.538 48.507 18.538 67.04 0l348.91-349 348.91 349c18.533 18.538 48.507 18.538 67.04 0l33.473-33.481c18.533-18.538 18.533-48.519 0-67.057z",
    transform: "matrix(-.016568 0 0 -.016568 15.842 16.026)",
    fill: "currentcolor"
  }));
}
var CaretDownOutlineIcon = withSvgIcon(CaretDownOutline, 'CaretDownOutlineIcon');
function CaretUpOutline() {
  return React__default.createElement("g", {
    className: "caret-up-icon"
  }, React__default.createElement("path", {
    d: "m922.74 642.16-415.95-416.06c-18.533-18.538-48.507-18.538-67.04 0l-415.85 416.06c-18.533 18.538-18.533 48.519 0 67.057l33.473 33.481c18.533 18.538 48.507 18.538 67.04 0l348.91-349 348.91 349c18.533 18.538 48.507 18.538 67.04 0l33.473-33.481c18.533-18.538 18.533-48.519 0-67.057z",
    transform: "matrix(.016568 0 0 .016568 .15803 -.025552)",
    fill: "currentcolor"
  }));
}
var CaretUpOutlineIcon = withSvgIcon(CaretUpOutline, 'CaretUpOutlineIcon');
function CaretLeftOutline() {
  return React__default.createElement("g", {
    className: "caret-left-icon"
  }, React__default.createElement("path", {
    transform: "matrix(0 -.016568 .016568 0 -.025552 15.842)",
    d: "m922.74 642.16-415.95-416.06c-18.533-18.538-48.507-18.538-67.04 0l-415.85 416.06c-18.533 18.538-18.533 48.519 0 67.057l33.473 33.481c18.533 18.538 48.507 18.538 67.04 0l348.91-349 348.91 349c18.533 18.538 48.507 18.538 67.04 0l33.473-33.481c18.533-18.538 18.533-48.519 0-67.057z",
    fill: "currentcolor"
  }));
}
var CaretLeftOutlineIcon = withSvgIcon(CaretLeftOutline, 'CaretLeftOutlineIcon');
function CaretRightOutline() {
  return React__default.createElement("g", {
    className: "caret-right-icon"
  }, React__default.createElement("path", {
    transform: "matrix(0 .016568 -.016568 0 16.026 .15803)",
    d: "m922.74 642.16-415.95-416.06c-18.533-18.538-48.507-18.538-67.04 0l-415.85 416.06c-18.533 18.538-18.533 48.519 0 67.057l33.473 33.481c18.533 18.538 48.507 18.538 67.04 0l348.91-349 348.91 349c18.533 18.538 48.507 18.538 67.04 0l33.473-33.481c18.533-18.538 18.533-48.519 0-67.057z",
    fill: "currentcolor"
  }));
}
var CaretRightOutlineIcon = withSvgIcon(CaretRightOutline, 'CaretRightOutlineIcon');
function DragHandleIcon() {
  return React__default.createElement("g", {
    className: "drag-handle-icon"
  }, React__default.createElement("rect", {
    transform: "matrix(1 0 0 1.4 1 2)",
    width: "14",
    height: "1.4286",
    rx: ".71",
    ry: ".71",
    strokeWidth: "0",
    fill: "currentColor"
  }), React__default.createElement("rect", {
    transform: "matrix(1 0 0 1.4 1 5.3333)",
    width: "14",
    height: "1.4286",
    rx: ".71",
    ry: ".71",
    strokeWidth: "0",
    fill: "currentColor"
  }), React__default.createElement("rect", {
    transform: "matrix(1 0 0 1.4 1 8.6667)",
    width: "14",
    height: "1.4286",
    rx: ".71",
    ry: ".71",
    strokeWidth: "0",
    fill: "currentColor"
  }), React__default.createElement("rect", {
    transform: "matrix(1 0 0 1.4 1 12)",
    width: "14",
    height: "1.4286",
    rx: ".71",
    ry: ".71",
    strokeWidth: "0",
    fill: "currentColor"
  }));
}
var DragHandleIcon$1 = withSvgIcon(DragHandleIcon, 'DragHandleIcon');
function Calendar() {
  return React__default.createElement("g", {
    fill: "currentcolor",
    transform: "matrix(.031614 0 0 .031614 .33438 .33438)"
  }, React__default.createElement("path", {
    d: "m405.17 363.15h-55.727c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4h55.727c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4z"
  }), React__default.createElement("path", {
    d: "m314.23 363.15h-55.727c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4h55.727c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4z"
  }), React__default.createElement("path", {
    d: "m223.28 363.15h-55.726c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4h55.726c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4z"
  }), React__default.createElement("path", {
    d: "m132.34 363.15h-55.725c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4h55.726c2.209 0 4-1.791 4-4v-48.256c-1e-3 -2.209-1.792-4-4.001-4z"
  }), React__default.createElement("path", {
    d: "m349.44 340.41h55.727c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4h-55.727c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m258.5 340.41h55.726c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4h-55.726c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m167.56 340.41h55.726c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4h-55.726c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m76.611 340.41h55.726c2.209 0 4-1.791 4-4v-48.256c0-2.209-1.791-4-4-4h-55.726c-2.209 0-4 1.791-4 4v48.256c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m349.44 261.41h55.727c2.209 0 4-1.791 4-4v-48.255c0-2.209-1.791-4-4-4h-55.727c-2.209 0-4 1.791-4 4v48.255c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m258.5 261.41h55.727c2.209 0 4-1.791 4-4v-48.255c0-2.209-1.791-4-4-4h-55.727c-2.209 0-4 1.791-4 4v48.255c0 2.209 1.791 4 4 4z"
  }), React__default.createElement("path", {
    d: "m363.37 114.86h6.938c10.543 0 19.09-8.549 19.09-19.091v-72.39c0-10.54-8.547-19.089-19.09-19.089h-6.938c-10.545 0-19.092 8.549-19.092 19.089v72.389c2e-3 10.543 8.549 19.092 19.092 19.092z"
  }), React__default.createElement("path", {
    d: "m118.5 115.33h6.938c10.544 0 19.091-8.55 19.091-19.091v-72.389c0-10.541-8.547-19.09-19.091-19.09h-6.938c-10.543 0-19.09 8.549-19.09 19.09v72.389c0 10.541 8.547 19.091 19.09 19.091z"
  }), React__default.createElement("path", {
    d: "M453.916,43.558h-48.996v57.209c0,19.084-15.525,29.61-34.607,29.61h-6.938c-19.084,0-34.609-15.526-34.609-34.61v-52.209h-168.713v52.682c0,19.084-15.525,34.61-34.609,34.61h-6.938c-19.083,0-34.608-15.526-34.608-34.61v-52.682h-52.862C13.923,43.558,0,57.481,0,74.595v375.03c0,17.114,13.923,31.037,31.036,31.037h422.88c17.113,0,31.035-13.923,31.035-31.037v-375.03c.002-17.113-13.922-31.037-31.035-31.037Zm0,406.067h-422.879l-.001-283.213h422.886l.016,283.212c-.002,0-.008.001-.022.001Z"
  }));
}
var CalendarIcon = withSvgIcon(Calendar, 'CalendarIcon');
function CheckOutlineIcon() {
  return React__default.createElement("g", {
    className: "checkoutline-icon"
  }, React__default.createElement("path", {
    fill: "currentcolor",
    transform: "matrix(.8 0 0 0.8-1.6-1.6)",
    d: "M10.6,13.8L8.45,11.65q-.275-.275-.7-.275t-.7.275-.275.7.275.7L9.9,15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7-.7-.275-.7.275L10.6,13.8ZM12,22q-2.075,0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175t-.788-3.9q0-2.075.788-3.9t2.137-3.175Q6.275,3.575,8.1,2.788t3.9-.788q2.075,0,3.9.788t3.175,2.137q1.35,1.35,2.138,3.175t.787,3.9q0,2.075-.788,3.9t-2.137,3.175q-1.35,1.35-3.175,2.138t-3.9.787Zm0-2q3.35,0,5.675-2.325t2.325-5.675-2.325-5.675-5.675-2.325-5.675,2.325Q4,8.65,4,12t2.325,5.675t5.675,2.325Zm0-8"
  }));
}
var CheckOutlineIcon$1 = withSvgIcon(CheckOutlineIcon, 'CheckOutlineIcon');
function CloseOutlineIcon() {
  return React__default.createElement("g", {
    className: "closeoutline-icon",
    fill: "currentColor"
  }, React__default.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm6.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0zm-3.318-3.182a.75.75 0 0 1 0 1.06L9.061 8l2.121 2.121a.75.75 0 0 1-1.06 1.061L8 9.061l-2.121 2.121a.75.75 0 0 1-1.061-1.06L6.939 8 4.818 5.879a.75.75 0 0 1 1.06-1.061L8 6.939l2.121-2.121a.75.75 0 0 1 1.061 0z"
  }));
}
var CloseOutlineIcon$1 = withSvgIcon(CloseOutlineIcon, 'CloseOutlineIcon');
function CloudArrowUpIcon() {
  return React__default.createElement("g", {
    className: "cloudarrowup-icon",
    fill: "currentColor"
  }, React__default.createElement("path", {
    d: "m8.446 6.397.084.073 2.5 2.5a.75.75 0 0 1-.976 1.133l-.084-.073-1.22-1.219v5.439a.75.75 0 0 1-1.493.102l-.007-.102V8.811l-1.22 1.22a.75.75 0 0 1-.976.072l-.084-.073a.75.75 0 0 1-.073-.976l.073-.084 2.5-2.5a.75.75 0 0 1 .976-.073zM9.5 1a4.75 4.75 0 0 1 4.677 5.586l-.057.271-.013.046.113.06a3.499 3.499 0 0 1 1.757 2.64l.018.213.005.193a3.491 3.491 0 0 1-3.3 3.486l-.191.005H10.75a.75.75 0 1 1 0-1.5h1.759c1.05 0 1.91-.812 1.986-1.843l.005-.148c0-.922-.63-1.717-1.511-1.936a.75.75 0 0 1-.507-1.027 3.25 3.25 0 1 0-6.1-2.213.75.75 0 0 1-1.07.453l-.217-.136a1.25 1.25 0 0 0-1.716 1.654l.12.212a.75.75 0 0 1-.494 1.048 1.998 1.998 0 0 0 .346 3.93L3.5 12h1.75a.75.75 0 1 1 0 1.5H3.5a3.5 3.5 0 0 1-3.495-3.308L0 10c0-1.217.626-2.308 1.597-2.936l.175-.107.063-.034-.02-.08-.036-.195-.022-.198-.007-.2a2.75 2.75 0 0 1 3.18-2.717l.209.042.12.033.094-.177a4.753 4.753 0 0 1 3.692-2.41l.236-.016L9.5 1z"
  }));
}
var CloudArrowUpIcon$1 = withSvgIcon(CloudArrowUpIcon, 'CloudArrowUpIcon');
function HeartIcon() {
  return React__default.createElement("g", {
    className: "heart-icon"
  }, React__default.createElement("path", {
    d: "m14.78 2.259c-0.77098-0.8019-1.8346-1.2563-2.947-1.259-1.1121 0.002982-2.1753 0.45735-2.946 1.259l-0.887 0.915-0.889-0.915c-0.76906-0.80332-1.8329-1.2576-2.945-1.2576s-2.1759 0.4543-2.945 1.2576c-1.628 1.677-1.628 4.396 0 6.074l6.243 6.438c0.13979 0.14616 0.33325 0.22883 0.5355 0.22883s0.39571-0.082668 0.5355-0.22883l6.244-6.438c0.7858-0.81546 1.2237-1.9046 1.221-3.037 0-1.14-0.44-2.232-1.22-3.037z",
    fill: "currentColor"
  }));
}
var HeartIcon$1 = withSvgIcon(HeartIcon, 'HeartIcon');
function StarIcon() {
  return React__default.createElement("g", {
    className: "star-icon"
  }, React__default.createElement("path", {
    d: "M5.738,5.528l-4.999.008-.103.007c-.634.085-.878.933-.34,1.345l4.06,3.105-1.548,5.028-.023.094c-.12.65.623,1.149,1.17.732L8,12.772l4.044,3.075.08.053c.564.332,1.272-.215,1.068-.879l-1.55-5.028l4.062-3.105.078-.069c.457-.454.152-1.282-.521-1.283l-5-.008L8.704,0.525c-.093271-.310889-.379421-.523792-.704-.523792s-.610729.212903-.704.523792L5.738,5.528Z",
    fill: "currentColor"
  }));
}
var StarIcon$1 = withSvgIcon(StarIcon, 'StarIcon');
function ThumbsUpIcon() {
  return React__default.createElement("g", {
    className: "thumbs-up-icon"
  }, React__default.createElement("path", {
    d: "M10,2.509c.125.598.06,1.217-.048,1.737l-.068.298-.073.269-.166.567c-.02.08-.022.122,0,.122h5.105c.462363-.026197.901269.205584,1.140346.602205s.239077.892969,0,1.28959-.677983.628402-1.140346.602205h-.5c.462363-.026197.901269.205584,1.140346.602205s.239077.892969,0,1.28959-.677983.628402-1.140346.602205l-.5.001c.462363-.026197.901269.205584,1.140346.602205s.239077.892969,0,1.28959-.677983.628402-1.140346.602205h-.75c.364265-.011529.705904.176222.891446.489903s.185543.703512,0,1.017194-.527181.501432-.891446.489903L8.078,15l-1.526-.013-.13-.005c-.378-.023-.8-.155-1.263-.397-.097921-.05214-.159074-.154063-.159-.265v-8.148c-.000163-.095485.045138-.185345.122-.242c1.113-.812,1.834-1.54,2.162-2.182.15-.303.245-.653.328-1l.12-.51c.148-.606.32-1.117.769-1.226.33-.08,1.23.205,1.5,1.497ZM2.8,6.001c.386209,0,.699448.312791.7.699v7.084c-.000552.386209-.313791.699-.7.699h-2.1c-.386209,0-.699448-.312791-.7-.699L0,6.7c0-.185652.07375-.363699.205025-.494975s.309323-.205025.494975-.205025h2.1Z",
    fill: "currentColor"
  }));
}
var ThumbsUpIcon$1 = withSvgIcon(ThumbsUpIcon, 'ThumbsUpIcon');
function SmileyIcon() {
  return React__default.createElement("g", {
    className: "smiley-icon"
  }, React__default.createElement("path", {
    d: "m8 0c4.4183 0 8 3.5817 8 8s-3.5817 8-8 8-8-3.5817-8-8 3.5817-8 8-8zm3.738 8.815c-0.1822-0.079843-0.38866-0.08403-0.57395-0.01164s-0.33423 0.21543-0.41405 0.39764c-0.4769 1.0938-1.5567 1.801-2.75 1.801s-2.2731-0.7072-2.75-1.801c-0.16624-0.37942-0.60858-0.55224-0.988-0.386s-0.55224 0.60858-0.386 0.988c0.71589 1.6395 2.335 2.6993 4.124 2.6993s3.4081-1.0597 4.124-2.6993c0.079843-0.1822 0.08403-0.38866 0.01164-0.57395s-0.21543-0.33423-0.39764-0.41405zm-7.238-3.315c-0.55228 0-1 0.44772-1 1s0.44772 1 1 1 1-0.44772 1-1-0.44772-1-1-1zm7 0c-0.55228 0-1 0.44772-1 1s0.44772 1 1 1 1-0.44772 1-1-0.44772-1-1-1z",
    fill: "currentColor"
  }));
}
var SmileyIcon$1 = withSvgIcon(SmileyIcon, 'SmileyIcon');
function InfoIcon() {
  return React__default.createElement("g", {
    className: "info-icon"
  }, React__default.createElement("path", {
    fill: "currentcolor",
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm.775 6.632c-.081-.613-.868-.877-1.302-.39L5.94 7.963l-.067.088a.746.746 0 0 0 .13.967l.088.067c.305.2.72.15.969-.13l.224-.252.001 4.498.007.106c.082.613.868.877 1.302.39l1.567-1.756.068-.088a.746.746 0 0 0-.129-.967l-.088-.067a.75.75 0 0 0-.97.128l-.26.29.001-4.5zm-.742-4.181a.748.748 0 0 0-.749.747v1.05l.007.102a.749.749 0 0 0 1.491-.101V3.198l-.007-.101a.749.749 0 0 0-.742-.646z"
  }));
}
var InfoIcon$1 = withSvgIcon(InfoIcon, 'InfoIcon');
var useStyles$O = createUseStyles(function (theme) {
  return {
    checkboxInput: function checkboxInput(_ref52) {
      var checked = _ref52.checked,
        disabled = _ref52.disabled,
        readOnly = _ref52.readOnly;
      var checkBgColor = checked ? theme.questionColor : '#fff';
      var backgroundColor = disabled || readOnly ? '#aaa' : checkBgColor;
      return {
        color: disabled || readOnly ? '#aaa' : theme.questionColor,
        borderRadius: 2,
        backgroundColor: backgroundColor,
        border: "1px solid ".concat(disabled || readOnly ? '#aaa' : theme.questionColor),
        '& .checkmark': {
          fill: theme.isDark ? '#000' : '#fff'
        },
        '&:focus-within': {
          boxShadow: "0 0 0 1px ".concat(theme.primaryAccentColor),
          borderColor: '#fff'
        },
        '& input': {
          cursor: 'pointer'
        }
      };
    }
  };
});
function CheckboxInput(_ref53, ref) {
  var className = _ref53.className,
    props = _objectWithoutProperties(_ref53, _excluded23);
  var _useInputStyles3 = useInputStyles(props),
    inputProps = _useInputStyles3.inputProps,
    styleProps = _useInputStyles3.styleProps;
  var _useStyles$O = useStyles$O(styleProps),
    checkboxInput = _useStyles$O.checkboxInput;
  return React__default.createElement(BaseInput$1, _objectSpread({
    ref: ref,
    type: "checkbox",
    className: classNames(checkboxInput, className),
    icon: React__default.createElement(CheckboxIcon$1, null)
  }, inputProps));
}
var CheckboxInput$1 = React__default.forwardRef(CheckboxInput);

// get the margin top by taking the font size and the line height and divide by 2 to get the margin top
var marginTopHelper = function marginTopHelper() {
  var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var lineHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Math.max(0, (height * lineHeight - height) / 2); // no negative margins
};

var useStyles$N = createUseStyles(function (theme) {
  var _theme$questionBody4;
  return {
    checkboxContainer: function checkboxContainer(_ref54) {
      var _theme$questionBody$f6;
      var checked = _ref54.checked,
        disabled = _ref54.disabled;
      var borderStyle = checked ? 'solid' : 'dashed';
      var borderColor = disabled && !checked ? 'transparent' : theme.questionColor;
      var fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
      return _objectSpread(_objectSpread({
        display: 'flex',
        alignItems: 'start',
        cursor: 'pointer',
        padding: [5, 8, 7, 8],
        gap: 8,
        borderRadius: 4,
        border: [1, 'solid', checked ? theme.questionColor : 'transparent'],
        backgroundColor: checked ? theme.input.bgColor : 'inherit'
      }, theme.questionBody), {}, {
        lineHeight: 1.5,
        fontWeight: checked ? fontWeightOptions.medium : (_theme$questionBody$f6 = theme.questionBody.fontWeight) !== null && _theme$questionBody$f6 !== void 0 ? _theme$questionBody$f6 : fontWeightOptions.light,
        '&:hover': {
          border: [1, borderStyle, borderColor]
        },
        '&:focus-within': {
          background: theme.input.bgColor
        }
      });
    },
    icon: {
      flexShrink: 0,
      fontSize: function fontSize(_ref55) {
        var inputSize = _ref55.inputSize;
        return inputSize !== null && inputSize !== void 0 ? inputSize : '1em';
      },
      marginTop: marginTopHelper((_theme$questionBody4 = theme.questionBody) === null || _theme$questionBody4 === void 0 ? void 0 : _theme$questionBody4.fontSize, 1.5),
      // The following selector singles out Safari and Chrome on iOS14 to
      // implement a workaround for the lack of flex gap.
      '@supports (-webkit-touch-callout: none) and (not (translate: none))': {
        marginRight: 8
      }
    }
  };
});
function Checkbox$2(_ref56, ref) {
  var _ref56$children = _ref56.children,
    label = _ref56$children === void 0 ? '' : _ref56$children,
    inputSize = _ref56.inputSize,
    onChange = _ref56.onChange,
    props = _objectWithoutProperties(_ref56, _excluded24);
  var handleChange = function handleChange(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: e.target.id,
      checked: e.target.checked,
      value: e.target.value
    });
  };
  var _useInputStyles4 = useInputStyles(_objectSpread(_objectSpread({}, props), {}, {
      onChange: handleChange
    })),
    inputProps = _useInputStyles4.inputProps,
    styleProps = _useInputStyles4.styleProps;
  var _useStyles$N = useStyles$N(_objectSpread(_objectSpread({}, styleProps), {}, {
      inputSize: inputSize
    })),
    checkboxContainer = _useStyles$N.checkboxContainer,
    icon = _useStyles$N.icon;
  return React__default.createElement("label", {
    htmlFor: inputProps.id,
    className: checkboxContainer,
    tabIndex: -1
  }, React__default.createElement(CheckboxInput$1, _objectSpread(_objectSpread({
    ref: ref
  }, inputProps), {}, {
    className: icon
  })), React__default.createElement(RichText, {
    element: "span",
    text: label
  }));
}
var Checkbox$3 = forwardRef(Checkbox$2);
var useStyles$M = createUseStyles(function (theme) {
  var _textInput;
  return {
    checkbox: {
      '& label': {
        alignItems: 'baseline'
      }
    },
    labelContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    textInput: (_textInput = {
      opacity: function opacity(_ref57) {
        var isChecked = _ref57.isChecked;
        return isChecked ? 1 : 0.5;
      },
      marginTop: 5,
      marginLeft: 32,
      maxWidth: 'calc(100% - 32px)'
    }, _defineProperty(_textInput, "@media (max-width: ".concat(theme.breakpoints.xxs.max, ")"), {
      marginLeft: 0,
      maxWidth: '100%'
    }), _defineProperty(_textInput, "fontSize", theme.questionBody.fontSize), _defineProperty(_textInput, "lineHeight", 'normal'), _textInput),
    checkHover: {
      '&:hover': {
        outline: 'none',
        cursor: 'pointer'
      }
    }
  };
});
function CheckboxTextfield(props) {
  var id = props.id,
    label = props.children,
    _props$value = props.value,
    inputValue = _props$value === void 0 ? '' : _props$value,
    defaultValue = props.defaultValue,
    maxLength = props.maxLength,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    onChange = props.onChange,
    _props$checked = props.checked,
    checkedProp = _props$checked === void 0 ? false : _props$checked,
    checkboxProps = _objectWithoutProperties(props, _excluded25);
  var _useState7 = useState(checkedProp),
    _useState8 = _slicedToArray(_useState7, 2),
    isChecked = _useState8[0],
    setIsChecked = _useState8[1];
  var _React__default$useSt11 = React__default.useState(defaultValue || inputValue),
    _React__default$useSt12 = _slicedToArray(_React__default$useSt11, 2),
    value = _React__default$useSt12[0],
    setValue = _React__default$useSt12[1];
  var _useStyles$M = useStyles$M({
      isChecked: isChecked
    }),
    checkbox = _useStyles$M.checkbox,
    textInput = _useStyles$M.textInput,
    checkHover = _useStyles$M.checkHover;
  var handleValueChange = function handleValueChange(e) {
    setValue(e.value);
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: id,
      value: e.value,
      checked: e.checked
    });
  };
  var handleInputChange = function handleInputChange(e) {
    if (!isChecked) {
      setIsChecked(true);
    }
    handleValueChange({
      id: id,
      value: e.target.value,
      checked: true
    });
  };
  var inputRef = React__default.useRef(null);
  var handleCheckboxClick = function handleCheckboxClick(e) {
    if (!isChecked && e.clientX !== 0 && e.clientY !== 0) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
    setIsChecked(!isChecked);
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  var handleTextboxClick = function handleTextboxClick() {
    if (!isChecked) {
      setIsChecked(true);
    }
    handleValueChange({
      id: id,
      value: value,
      checked: true
    });
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.code === 'Space') {
      e.preventDefault();
      setIsChecked(!isChecked);
      handleValueChange({
        id: id,
        value: value,
        checked: !isChecked
      });
      return;
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  };
  React__default.useEffect(function () {
    setIsChecked(checkedProp);
  }, [checkedProp]);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Checkbox$3, _objectSpread({
    id: "checkbox-input-".concat(id),
    checked: isChecked,
    onKeyDown: handleKeyDown,
    onClick: handleCheckboxClick,
    onChange: handleValueChange,
    className: checkbox,
    value: value,
    maxLength: maxLength
  }, checkboxProps), label), React__default.createElement(TextInput$1, {
    id: "checkbox-field-".concat(id),
    onChange: handleInputChange,
    onClick: handleTextboxClick,
    className: classNames(textInput, _defineProperty({}, checkHover, !isChecked)),
    defaultValue: defaultValue,
    autoHeight: true,
    maxLength: maxLength,
    tabIndex: isChecked ? 0 : -1,
    ref: inputRef
  }));
}

/**
 * Maximum input characters is 20,000
 * Resolves: RAWR-1186
 */
var TEXT_INPUT_MAX_CHARS = 20000;
var US_STATES = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
// CODES
var COUNTRY_CODES = ['AF', 'AX', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AG', 'AR', 'AM', 'AW', 'AC', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BQ', 'BA', 'BW', 'BR', 'IO', 'BN', 'BG', 'BF', 'BI', 'KH', 'CM', 'CA', 'CV', 'KY', 'CF', 'TD', 'CL', 'CN', 'CX', 'CC', 'CO', 'KM', 'CG', 'CD', 'CK', 'CR', 'CI', 'HR',
// 'CU',
'CW', 'CY', 'CZ', 'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'ET', 'FK', 'FO', 'FM', 'FJ', 'FI', 'FR', 'GF', 'PF', 'GA', 'GM', 'GE', 'DE', 'GH', 'GI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY', 'HT', 'VA', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID', 'IQ', 'IE', 'IM', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KI', 'XK', 'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MX', 'MD', 'MC', 'MN', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP', 'NL', 'NC', 'NZ', 'NI', 'NE', 'NG', 'NU', 'NF', 'KP', 'MK', 'MP', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE', 'PH', 'PL', 'PT', 'PR', 'QA', 'RE', 'RO', 'RW', 'BL', 'SH', 'KN', 'LC', 'MF', 'PM', 'VC', 'WS', 'SM', 'ST', 'SA', 'SN', 'SC', 'SL', 'SG', 'SX', 'SK', 'SI', 'SB', 'SO', 'ZA', 'KR', 'SS', 'ES', 'LK', 'SR', 'SJ', 'SZ', 'SE', 'CH', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT', 'TA', 'TN', 'TR', 'TM', 'TC', 'TV', 'UG', 'UA', 'AE', 'GB', 'US', 'UY', 'UZ', 'VU', 'VE', 'VN', 'VG', 'VI', 'WF', 'EH', 'YE', 'ZM', 'ZW'];
// SPAGE-8747: list excludes sanctioned countries (Syria, Cuba, Iran, Sudan, Russia, Belarus, Crimea)
var COUNTRIES = {
  af: 'Afghanistan',
  ax: 'Åland Islands',
  al: 'Albania',
  dz: 'Algeria',
  ad: 'Andorra',
  ao: 'Angola',
  ai: 'Anguilla',
  aq: 'Antarctica',
  ag: 'Antigua and Barbuda',
  ar: 'Argentina',
  am: 'Armenia',
  aw: 'Aruba',
  au: 'Australia',
  at: 'Austria',
  az: 'Azerbaijan',
  bs: 'Bahamas',
  bh: 'Bahrain',
  bd: 'Bangladesh',
  bb: 'Barbados',
  be: 'Belgium',
  bz: 'Belize',
  bj: 'Benin',
  bm: 'Bermuda',
  bt: 'Bhutan',
  bo: 'Bolivia, Plurinational State of',
  bq: 'Bonaire, Sint Eustatius and Saba',
  ba: 'Bosnia and Herzegovina',
  bw: 'Botswana',
  bv: 'Bouvet Island',
  br: 'Brazil',
  io: 'British Indian Ocean Territory',
  bn: 'Brunei Darussalam',
  bg: 'Bulgaria',
  bf: 'Burkina Faso',
  bi: 'Burundi',
  kh: 'Cambodia',
  cm: 'Cameroon',
  ca: 'Canada',
  cv: 'Cape Verde',
  ky: 'Cayman Islands',
  cf: 'Central African Republic',
  td: 'Chad',
  cl: 'Chile',
  cn: 'China',
  cx: 'Christmas Island',
  cc: 'Cocos (Keeling) Islands',
  co: 'Colombia',
  km: 'Comoros',
  cg: 'Congo',
  cd: 'Congo, The Democratic Republic of the',
  ck: 'Cook Islands',
  cr: 'Costa Rica',
  ci: "Côte d'Ivoire",
  hr: 'Croatia',
  cw: 'Curaçao',
  cy: 'Cyprus',
  cz: 'Czech Republic',
  dk: 'Denmark',
  dj: 'Djibouti',
  dm: 'Dominica',
  do: 'Dominican Republic',
  ec: 'Ecuador',
  eg: 'Egypt',
  sv: 'El Salvador',
  gq: 'Equatorial Guinea',
  er: 'Eritrea',
  ee: 'Estonia',
  et: 'Ethiopia',
  fk: 'Falkland Islands (Malvinas)',
  fo: 'Faroe Islands',
  fj: 'Fiji',
  fi: 'Finland',
  fr: 'France',
  gf: 'French Guiana',
  pf: 'French Polynesia',
  tf: 'French Southern Territories',
  ga: 'Gabon',
  gm: 'Gambia',
  ge: 'Georgia',
  de: 'Germany',
  gh: 'Ghana',
  gi: 'Gibraltar',
  gr: 'Greece',
  gl: 'Greenland',
  gd: 'Grenada',
  gp: 'Guadeloupe',
  gt: 'Guatemala',
  gg: 'Guernsey',
  gn: 'Guinea',
  gw: 'Guinea-Bissau',
  gy: 'Guyana',
  ht: 'Haiti',
  hm: 'Heard Island and McDonald Islands',
  va: 'Holy See (Vatican City State)',
  hn: 'Honduras',
  hk: 'Hong Kong',
  hu: 'Hungary',
  is: 'Iceland',
  in: 'India',
  id: 'Indonesia',
  iq: 'Iraq',
  ie: 'Ireland',
  im: 'Isle of Man',
  il: 'Israel',
  it: 'Italy',
  jm: 'Jamaica',
  jp: 'Japan',
  je: 'Jersey',
  jo: 'Jordan',
  kz: 'Kazakhstan',
  ke: 'Kenya',
  ki: 'Kiribati',
  kr: 'Korea, Republic of',
  kw: 'Kuwait',
  kg: 'Kyrgyzstan',
  la: "Lao People's Democratic Republic",
  lv: 'Latvia',
  lb: 'Lebanon',
  ls: 'Lesotho',
  lr: 'Liberia',
  ly: 'Libya',
  li: 'Liechtenstein',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  mo: 'Macao',
  mk: 'Macedonia, Republic of',
  mg: 'Madagascar',
  mw: 'Malawi',
  my: 'Malaysia',
  mv: 'Maldives',
  ml: 'Mali',
  mt: 'Malta',
  mh: 'Marshall Islands',
  mq: 'Martinique',
  mr: 'Mauritania',
  mu: 'Mauritius',
  yt: 'Mayotte',
  mx: 'Mexico',
  fm: 'Micronesia, Federated States of',
  md: 'Moldova, Republic of',
  mc: 'Monaco',
  mn: 'Mongolia',
  me: 'Montenegro',
  ms: 'Montserrat',
  ma: 'Morocco',
  mz: 'Mozambique',
  mm: 'Myanmar',
  na: 'Namibia',
  nr: 'Nauru',
  np: 'Nepal',
  nl: 'Netherlands',
  nc: 'New Caledonia',
  nz: 'New Zealand',
  ni: 'Nicaragua',
  ne: 'Niger',
  ng: 'Nigeria',
  nu: 'Niue',
  nf: 'Norfolk Island',
  no: 'Norway',
  om: 'Oman',
  pk: 'Pakistan',
  pw: 'Palau',
  ps: 'Palestine, State of',
  pa: 'Panama',
  pg: 'Papua New Guinea',
  py: 'Paraguay',
  pe: 'Peru',
  ph: 'Philippines',
  pn: 'Pitcairn',
  pl: 'Poland',
  pt: 'Portugal',
  qa: 'Qatar',
  re: 'Réunion',
  ro: 'Romania',
  rw: 'Rwanda',
  bl: 'Saint Barthélemy',
  sh: 'Saint Helena,Ascension and Tristan da Cunha',
  kn: 'Saint Kitts and Nevis',
  lc: 'Saint Lucia',
  mf: 'Saint Martin (French part)',
  pm: 'Saint Pierre and Miquelon',
  vc: 'Saint Vincent and the Grenadines',
  ws: 'Samoa',
  sm: 'San Marino',
  st: 'Sao Tome and Principe',
  sa: 'Saudi Arabia',
  sn: 'Senegal',
  rs: 'Serbia',
  sc: 'Seychelles',
  sl: 'Sierra Leone',
  sg: 'Singapore',
  sx: 'Sint Maarten (Dutch part)',
  sk: 'Slovakia',
  si: 'Slovenia',
  sb: 'Solomon Islands',
  so: 'Somalia',
  za: 'South Africa',
  gs: 'South Georgia and the South Sandwich Islands',
  ss: 'South Sudan',
  es: 'Spain',
  lk: 'Sri Lanka',
  sr: 'Suriname',
  sj: 'Svalbard and Jan Mayen',
  sz: 'Swaziland',
  se: 'Sweden',
  ch: 'Switzerland',
  tw: 'Taiwan, Province of China',
  tj: 'Tajikistan',
  tz: 'Tanzania, United Republic of',
  th: 'Thailand',
  tl: 'Timor-Leste',
  tg: 'Togo',
  tk: 'Tokelau',
  to: 'Tonga',
  tt: 'Trinidad and Tobago',
  tn: 'Tunisia',
  tr: 'Turkey',
  tm: 'Turkmenistan',
  tc: 'Turks and Caicos Islands',
  tv: 'Tuvalu',
  ug: 'Uganda',
  ua: 'Ukraine',
  ae: 'United Arab Emirates',
  gb: 'United Kingdom',
  us: 'United States',
  um: 'United States Minor Outlying Islands',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  vu: 'Vanuatu',
  ve: 'Venezuela, Bolivarian Republic of',
  vn: 'Vietnam',
  vg: 'Virgin Islands, British',
  wf: 'Wallis and Futuna',
  eh: 'Western Sahara',
  ye: 'Yemen',
  zm: 'Zambia',
  zw: 'Zimbabwe'
};
var useStyles$L = createUseStyles({
  commentChoiceContainer: {
    marginTop: '10px'
  }
});
var INPUT_SIZE$2 = 20;
function Checkbox(_ref58) {
  var questionId = _ref58.id,
    _req = _ref58.required,
    _ro = _ref58.readOnly,
    disabled = _ref58.disabled,
    columnLayout = _ref58.columnLayout,
    _ref58$choices = _ref58.choices,
    choices = _ref58$choices === void 0 ? [] : _ref58$choices,
    _ref58$responses = _ref58.responses,
    responses = _ref58$responses === void 0 ? [] : _ref58$responses,
    choiceNoneOfTheAbove = _ref58.choiceNoneOfTheAbove,
    choiceOther = _ref58.choiceOther,
    choiceComment = _ref58.choiceComment,
    onChange = _ref58.onChange,
    questionFieldProps = _objectWithoutProperties(_ref58, _excluded26);
  var _useState9 = useState(responses),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedChoices = _useState10[0],
    setSelectedChoices = _useState10[1];
  var errorId = createErrorId(questionId);
  /**
   * Default value by id
   * used for text-input based choices
   */
  var getDefaultValueById = function getDefaultValueById(id) {
    var _responses$find;
    return (_responses$find = responses.find(function (c) {
      return c.id === id;
    })) === null || _responses$find === void 0 ? void 0 : _responses$find.value;
  };
  var handleDefault = function handleDefault(id) {
    var _responses$find2;
    return (_responses$find2 = responses.find(function (c) {
      return c.id === id;
    })) === null || _responses$find2 === void 0 ? void 0 : _responses$find2.value;
  };
  var isChecked = function isChecked(id) {
    return !!selectedChoices.find(function (item) {
      return item.id === id;
    });
  };
  var handleChange = function handleChange(e) {
    // 1. remove NOTA from array
    var newState = selectedChoices.filter(function (c) {
      return c.id !== e.id && c.type !== 'NOTA';
    });
    // 2. if e.target.checked remove item from array
    if (e.checked) {
      newState.push({
        id: e.id,
        value: e.value
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var handleNAChange = function handleNAChange(e) {
    var newState = selectedChoices.filter(function (c) {
      return c.type === 'COMMENT';
    });
    // 2. if e.target.checked remove item from array
    if (e.checked) {
      newState.push({
        id: e.id,
        value: e.value,
        type: 'NOTA'
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var handleOtherChange = function handleOtherChange(e) {
    var newState = selectedChoices.filter(function (c) {
      return c.id !== e.id && c.type !== 'NOTA';
    });
    // 2. if e.target.checked remove item from array
    if (e.checked) {
      newState.push({
        id: e.id,
        value: e.value,
        type: 'ANSWER'
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var handleCommentChange = function handleCommentChange(e) {
    var newState = selectedChoices.filter(function (c) {
      return c.type !== 'COMMENT';
    });
    if (newState && !!e.target.value) {
      newState.push({
        id: e.target.id,
        value: e.target.value,
        type: 'COMMENT'
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var _useStyles$L = useStyles$L(),
    commentChoiceContainer = _useStyles$L.commentChoiceContainer;
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    "data-testid": "CheckboxQuestionType"
  }, questionFieldProps), React__default.createElement(QuestionAnswerLayoutTemplate, {
    gridCellMargin: [0, 2, 5, 2],
    otherCellMargin: [0, 2, 5, 2],
    noneOfTheAbove: choiceNoneOfTheAbove && (choiceNoneOfTheAbove === null || choiceNoneOfTheAbove === void 0 ? void 0 : choiceNoneOfTheAbove.visible) && React__default.createElement(Checkbox$3, {
      id: choiceNoneOfTheAbove.id,
      value: choiceNoneOfTheAbove.id,
      onChange: handleNAChange,
      checked: isChecked(choiceNoneOfTheAbove.id),
      disabled: disabled,
      readOnly: _ro,
      "aria-describedby": questionFieldProps.error && errorId || undefined,
      inputSize: INPUT_SIZE$2
    }, choiceNoneOfTheAbove.label),
    other: (choiceOther === null || choiceOther === void 0 ? void 0 : choiceOther.type) === 'ANSWER' && (choiceOther === null || choiceOther === void 0 ? void 0 : choiceOther.visible) && React__default.createElement(CheckboxTextfield, {
      id: choiceOther.id,
      defaultValue: handleDefault(choiceOther.id),
      onChange: handleOtherChange,
      checked: isChecked(choiceOther.id),
      maxLength: TEXT_INPUT_MAX_CHARS,
      disabled: disabled,
      readOnly: _ro,
      "aria-describedby": questionFieldProps.error && errorId || undefined,
      inputSize: INPUT_SIZE$2
    }, choiceOther.label),
    columns: columnLayout
  }, choices === null || choices === void 0 ? void 0 : choices.map(function (choice) {
    return React__default.createElement(Checkbox$3, {
      key: choice.id,
      id: choice.id,
      onChange: handleChange,
      checked: isChecked(choice.id),
      value: choice.id,
      disabled: disabled,
      readOnly: _ro,
      "aria-describedby": questionFieldProps.error && errorId || undefined,
      inputSize: INPUT_SIZE$2
    }, choice.label);
  })), choiceComment && React__default.createElement(CommentChoice, {
    id: choiceComment.id,
    label: choiceComment.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(choiceComment.id),
    lineCount: choiceComment.linesCount,
    charCount: choiceComment.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    "aria-describedby": questionFieldProps.error && errorId || undefined,
    className: commentChoiceContainer
  }));
}
var Checkbox$1 = withErrorBoundary(Checkbox);
function CommentBox(_ref59) {
  var questionId = _ref59.id,
    _req = _ref59.required,
    disabled = _ref59.disabled,
    readOnly = _ref59.readOnly,
    _ref59$responses = _ref59.responses,
    defaultResponses = _ref59$responses === void 0 ? [] : _ref59$responses,
    onChange = _ref59.onChange,
    _ref59$cols = _ref59.cols,
    cols = _ref59$cols === void 0 ? 50 : _ref59$cols,
    _ref59$rows = _ref59.rows,
    rows = _ref59$rows === void 0 ? 3 : _ref59$rows,
    fieldProps = _objectWithoutProperties(_ref59, _excluded27);
  var error = fieldProps.error,
    _fieldProps$errorId = fieldProps.errorId,
    errorId = _fieldProps$errorId === void 0 ? createErrorId(questionId) : _fieldProps$errorId,
    titleId = fieldProps.title.id;
  var defaultValue = useMemo(function () {
    var _defaultResponses$fin, _defaultResponses$fin2;
    return (_defaultResponses$fin = (_defaultResponses$fin2 = defaultResponses.find(function (r) {
      return !!r.value;
    })) === null || _defaultResponses$fin2 === void 0 ? void 0 : _defaultResponses$fin2.value) !== null && _defaultResponses$fin !== void 0 ? _defaultResponses$fin : '';
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var handleChange = function handleChange(e) {
    var responses = e.target.value ? [{
      id: questionId,
      value: e.target.value
    }] : [];
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId,
    "data-testid": "CommentBoxQuestionType"
  }, fieldProps), React__default.createElement(TextArea$1, {
    name: questionId,
    defaultValue: defaultValue,
    disabled: disabled,
    readOnly: readOnly,
    cols: cols,
    rows: rows,
    onChange: handleChange,
    "aria-invalid": !!error,
    "aria-describedby": error && errorId,
    "aria-labelledby": titleId,
    maxLength: TEXT_INPUT_MAX_CHARS
  }));
}
var CommentBox$1 = withErrorBoundary(CommentBox);
var useStyles$K = createUseStyles(function (theme) {
  var _theme$questionBody5 = theme.questionBody,
    color = _theme$questionBody5.color,
    fontSize = _theme$questionBody5.fontSize,
    fontFamily = _theme$questionBody5.fontFamily,
    fontWeight = _theme$questionBody5.fontWeight;
  return {
    selectContainerStyles: {
      maxWidth: '100%',
      position: 'relative',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      overflow: 'hidden',
      transition: 'all 0.1s linear',
      borderRadius: "4px",
      border: "2px solid transparent",
      outline: "1px solid transparent",
      '&:focus-within, &:hover': {
        border: "2px solid ".concat(theme.primaryAccentColor),
        outline: "1px solid #fff"
      },
      color: '#000'
    },
    selectStyles: {
      position: 'relative',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      overflow: 'hidden',
      fontSize: fontSize,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      lineHeight: 'normal',
      outline: 'none',
      backgroundColor: '#fff',
      color: 'inherit',
      maxWidth: '100%',
      padding: function padding(_ref60) {
        var _ref60$isRTL = _ref60.isRTL,
          isRTL = _ref60$isRTL === void 0 ? false : _ref60$isRTL;
        return isRTL ? '6px 6px 6px 1.75em' : '6px 1.75em 6px 6px';
      },
      verticalAlign: 'bottom',
      textSizeAdjust: 'auto',
      // Prevent de fault chevron from showing
      mozAppearance: 'none',
      webkitAppearance: 'none',
      appearance: 'none',
      transition: 'border 0.1s linear',
      border: "1px solid ".concat(color),
      '&:focus-within, &:hover': {
        border: "1px solid transparent"
      }
    },
    selectIconStyles: {
      position: 'absolute',
      width: '1em',
      height: '1em',
      display: 'block',
      margin: '0 .5em',
      right: function right(_ref61) {
        var _ref61$isRTL = _ref61.isRTL,
          isRTL = _ref61$isRTL === void 0 ? false : _ref61$isRTL;
        return isRTL ? 'auto' : 0;
      },
      left: function left(_ref62) {
        var _ref62$isRTL = _ref62.isRTL,
          isRTL = _ref62$isRTL === void 0 ? false : _ref62$isRTL;
        return isRTL ? 0 : 'auto';
      },
      zIndex: 2,
      pointerEvents: 'none'
    },
    disabledStyles: {
      opacity: 0.4
    }
  };
});
function NativeSelect(_ref63) {
  var required = _ref63.required,
    children = _ref63.children,
    disabled = _ref63.disabled,
    className = _ref63.className,
    _ref63$icon = _ref63.icon,
    icon = _ref63$icon === void 0 ? React__default.createElement(SelectIcon$1, null) : _ref63$icon,
    props = _objectWithoutProperties(_ref63, _excluded28);
  var _useContext2 = useContext(L10NContext),
    isRTL = _useContext2.isRTL;
  var _useStyles$K = useStyles$K({
      isRTL: isRTL
    }),
    selectStyles = _useStyles$K.selectStyles,
    selectContainerStyles = _useStyles$K.selectContainerStyles,
    selectIconStyles = _useStyles$K.selectIconStyles,
    disabledStyles = _useStyles$K.disabledStyles;
  var _icon$props = icon.props,
    iconClasses = _icon$props.className,
    iconProps = _objectWithoutProperties(_icon$props, _excluded29);
  return React__default.createElement("div", {
    className: classNames(selectContainerStyles, disabled ? disabledStyles : {}, className)
  }, React__default.cloneElement(icon, _objectSpread({
    // this will apply our placement styles, along with any other supplied classes
    className: classNames(selectIconStyles, iconClasses)
  }, iconProps)), React__default.createElement("select", _objectSpread({
    className: selectStyles,
    required: required,
    "aria-required": required,
    "data-testid": "select",
    disabled: disabled
  }, props), children));
}
var useStyles$J = createUseStyles(function (_ref64) {
  var _ref64$questionBody = _ref64.questionBody,
    fontFamily = _ref64$questionBody.fontFamily,
    fontSize = _ref64$questionBody.fontSize,
    fontWeight = _ref64$questionBody.fontWeight;
  return {
    selectOption: {
      fontFamily: fontFamily,
      fontSize: fontSize,
      fontWeight: fontWeight
    }
  };
});
function SelectAnswerOption(_ref65) {
  var id = _ref65.id,
    label = _ref65.label,
    props = _objectWithoutProperties(_ref65, _excluded30);
  var _useStyles$J = useStyles$J(),
    selectOption = _useStyles$J.selectOption;
  return React__default.createElement("option", _objectSpread({
    id: id,
    "data-testid": "select-answer-option",
    className: selectOption
  }, props), label);
}
var useStyles$I = createUseStyles(function (theme) {
  var _theme$questionBody6 = theme.questionBody,
    color = _theme$questionBody6.color,
    fontSize = _theme$questionBody6.fontSize,
    fontFamily = _theme$questionBody6.fontFamily,
    fontWeight = _theme$questionBody6.fontWeight;
  return {
    inputGroup: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: function flexDirection(_ref66) {
        var rtl = _ref66.rtl;
        return rtl ? 'row-reverse' : 'row';
      },
      transition: 'all 0.1s linear',
      border: "1px solid ".concat(color),
      '&:focus-within, &:hover': {
        border: "1px solid transparent"
      }
    },
    input: {
      border: 'none',
      textAlign: function textAlign(_ref67) {
        var rtl = _ref67.rtl;
        return rtl ? 'right' : 'left';
      },
      height: function height(_ref68) {
        var _height = _ref68.height;
        return _height || 'auto';
      },
      width: 'calc(100% - 30px)',
      outline: 'currentColor none medium',
      backgroundColor: '#FFF',
      padding: '6px 0 6px 10px',
      fontSize: fontSize,
      fontFamily: fontFamily,
      fontWeight: fontWeight
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      height: function height(_ref69) {
        var _height2 = _ref69.height;
        return _height2 || 'auto';
      },
      width: 30,
      backgroundColor: '#FFF',
      border: 'none'
    },
    buttonIcon: {
      transform: function transform(_ref70) {
        var isOpen = _ref70.isOpen;
        return isOpen ? 'rotate(180deg)' : 'rotate(0)';
      }
    }
  };
});
var ComboBoxInputGroup = React__default.forwardRef(function (_ref71, ref) {
  var isOpen = _ref71.isOpen,
    value = _ref71.value,
    height = _ref71.height,
    _ref71$rtl = _ref71.rtl,
    rtl = _ref71$rtl === void 0 ? false : _ref71$rtl,
    onChange = _ref71.onChange,
    open = _ref71.open,
    close = _ref71.close,
    onKeyDown = _ref71.onKeyDown,
    ariaActiveDescendant = _ref71['aria-activedescendant'],
    ariaAutocomplete = _ref71['aria-autocomplete'],
    ariaControls = _ref71['aria-controls'],
    ariaLabel = _ref71['aria-label'],
    ariaLabelledBy = _ref71['aria-labelledby'],
    className = _ref71.className,
    rest = _objectWithoutProperties(_ref71, _excluded31);
  var inputRef = useRef(null);
  useImperativeHandle(ref, function () {
    return inputRef.current;
  });
  var _useStyles$I = useStyles$I({
      isOpen: isOpen,
      height: height,
      rtl: rtl
    }),
    inputGroup = _useStyles$I.inputGroup,
    input = _useStyles$I.input,
    button = _useStyles$I.button,
    buttonIcon = _useStyles$I.buttonIcon;
  return React__default.createElement("div", _objectSpread({
    className: classNames(inputGroup, className)
  }, rest), React__default.createElement("input", {
    className: input,
    type: "text",
    role: "combobox",
    "aria-autocomplete": ariaAutocomplete,
    "aria-expanded": isOpen,
    "aria-controls": ariaControls,
    "aria-activedescendant": ariaActiveDescendant,
    value: value,
    onChange: onChange,
    onClick: open,
    onKeyDown: onKeyDown,
    ref: inputRef
  }), React__default.createElement("button", {
    className: button,
    type: "button",
    tabIndex: -1,
    "aria-expanded": isOpen,
    "aria-controls": ariaControls,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    onClick: function onClick() {
      var _inputRef$current2;
      if (isOpen) {
        close();
      } else {
        open();
      }
      (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    }
  }, React__default.createElement(CaretDownIcon, {
    className: buttonIcon
  })));
});
var useStyles$H = createUseStyles({
  listBox: {
    listStyle: 'none',
    width: 'fit-content',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&:focus-visible': {
      outline: '#005fcc auto 1px',
      outlineOffset: 1
    }
  }
});

/**
 * Scroll to the item at the specified index if it is fully or partially obscured
 * */
var scrollToItem = function scrollToItem(itemRect, containerRef) {
  var _containerRef$current;
  var ulRect = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect();
  if (!ulRect || !containerRef.current) {
    return;
  }
  if (itemRect.top < ulRect.top) {
    // eslint-disable-next-line no-param-reassign
    containerRef.current.scrollTop -= ulRect.top - itemRect.top;
  } else if (itemRect.bottom > ulRect.bottom) {
    // eslint-disable-next-line no-param-reassign
    containerRef.current.scrollTop += itemRect.bottom - ulRect.bottom;
  }
};
/**
 * Returns the number of items visible inside the listbox given its current dimensions
 * note: if height is 0, it will return 10 as a default to satisfy tests
 * */
var numItemsVisible = function numItemsVisible(containerHeight) {
  var itemHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 48;
  return !containerHeight ? 10 : Math.round(containerHeight / itemHeight);
};

/**
 * Focus another item in the listBox depending on which key is pressed
 * @param key The key that was pressed
 * @param focusedIndex The index of the currently focused item
 * @param itemCount The number of items in the listBox
 * @param visibleItemCount The number of items visible in the listBox
 * @param focusItem Function which updates the the currently focused item
 */
var focusNext = function focusNext(key, focusedIndex, itemCount, visibleItemCount, focusItem) {
  var lastIndex = itemCount - 1;
  if (key === 'End') {
    focusItem(lastIndex);
    return;
  }
  if (focusedIndex === null) {
    focusItem(0);
    return;
  }
  switch (key) {
    case 'Down':
    case 'ArrowDown':
      if (focusedIndex < lastIndex) {
        focusItem(focusedIndex + 1);
      } else {
        focusItem(0);
      }
      break;
    case 'Up':
    case 'ArrowUp':
      if (focusedIndex > 0) {
        focusItem(focusedIndex - 1);
      } else {
        focusItem(lastIndex);
      }
      break;
    case 'PageDown':
      if (focusedIndex < lastIndex - visibleItemCount) {
        focusItem(focusedIndex + visibleItemCount);
      } else {
        focusItem(lastIndex);
      }
      break;
    case 'PageUp':
      if (focusedIndex > visibleItemCount) {
        focusItem(focusedIndex - visibleItemCount);
      } else {
        focusItem(0);
      }
      break;
    case 'Home':
      focusItem(0);
      break;
  }
};
React__default.forwardRef(function (_ref72, ref) {
  var children = _ref72.children,
    externalFocusedIndex = _ref72.focusedIndex,
    tabIndex = _ref72.tabIndex,
    onKeyDown = _ref72.onKeyDown,
    onClick = _ref72.onClick,
    onChange = _ref72.onChange,
    className = _ref72.className,
    rest = _objectWithoutProperties(_ref72, _excluded32);
  var _useStyles$H = useStyles$H(),
    listBox = _useStyles$H.listBox;
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    focusedIndex = _useState12[0],
    setFocusedIndex = _useState12[1];
  // override internal focusedIndex with external state if provided
  useEffect(function () {
    if (externalFocusedIndex !== undefined) {
      setFocusedIndex(externalFocusedIndex);
    }
  }, [externalFocusedIndex]);
  var itemsRef = useRef([]);
  var ulRef = useRef(null);
  var focusItem = function focusItem(index) {
    setFocusedIndex(index);
  };
  useImperativeHandle(ref, function () {
    return ulRef.current;
  });
  useEffect(function () {
    var _itemsRef$current, _itemsRef$current$foc;
    if (focusedIndex === null) {
      return;
    }
    // Scroll to the currently focused item anytime the focused index changes
    scrollToItem((_itemsRef$current = itemsRef.current) === null || _itemsRef$current === void 0 ? void 0 : _itemsRef$current[focusedIndex].getBoundingClientRect(), ulRef);
    // call the onChange callback if the focused index changes
    onChange === null || onChange === void 0 ? void 0 : onChange({
      target: itemsRef.current[focusedIndex],
      value: (_itemsRef$current$foc = itemsRef.current[focusedIndex].dataset.value) !== null && _itemsRef$current$foc !== void 0 ? _itemsRef$current$foc : ''
    });
  }, [focusedIndex]);
  var handleKeyDown = function handleKeyDown(e) {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    if (!(e.target instanceof HTMLUListElement)) {
      return;
    }
    if (['Down', 'Up', 'ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'End', 'Home'].includes(e.key)) {
      var _ulRef$current;
      e.preventDefault();
      // Focus another item in the listBox depending on which key is pressed
      focusNext(e.key, focusedIndex, itemsRef.current.length, numItemsVisible((_ulRef$current = ulRef.current) === null || _ulRef$current === void 0 ? void 0 : _ulRef$current.getBoundingClientRect().height), focusItem);
    }
  };
  var handleClick = function handleClick(e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
    if (e.target instanceof HTMLLIElement) {
      setFocusedIndex(itemsRef.current.indexOf(e.target));
    }
  };
  var interactiveProps = {
    tabIndex: tabIndex,
    'aria-activedescendant': tabIndex !== undefined && focusedIndex !== null ? "ListBoxItem-".concat(focusedIndex) : undefined
  };
  return React__default.createElement("ul", _objectSpread(_objectSpread({
    ref: ulRef,
    className: classNames(listBox, className),
    role: "listbox",
    onKeyDown: handleKeyDown,
    onClick: handleClick
  }, interactiveProps), rest), React__default.Children.map(children, function (child, index) {
    var _child$props$id;
    return React__default.isValidElement(child) && React__default.cloneElement(child, {
      key: child.props.value,
      id: (_child$props$id = child.props.id) !== null && _child$props$id !== void 0 ? _child$props$id : "ListBoxItem-".concat(index),
      selected: index === focusedIndex,
      ref: function ref(el) {
        itemsRef.current[index] = el;
      }
    });
  }));
});
var useStyles$G = createUseStyles({
  listBoxItem: function listBoxItem(_ref73) {
    var selected = _ref73.selected,
      disabled = _ref73.disabled;
    return _objectSpread(_objectSpread({
      display: 'flex',
      alignItems: 'center',
      maxWidth: '100%',
      backgroundColor: '#FFF',
      cursor: 'pointer'
    }, selected && {
      backgroundColor: 'rgb(237, 238, 238)'
    }), {}, {
      '&:hover, &:focus': {
        backgroundColor: 'rgb(237, 238, 238)'
      },
      '&:active': {
        backgroundColor: 'rgb(224, 226, 226)'
      }
    }, disabled && {
      opacity: 0.5,
      pointerEvents: 'none'
    });
  }
});
var ListBoxItem = React__default.forwardRef(function (_ref74, ref) {
  var children = _ref74.children,
    disabled = _ref74.disabled,
    selected = _ref74.selected,
    value = _ref74.value,
    className = _ref74.className,
    rest = _objectWithoutProperties(_ref74, _excluded33);
  var _useStyles$G = useStyles$G({
      disabled: disabled,
      selected: selected
    }),
    listBoxItem = _useStyles$G.listBoxItem;
  return React__default.createElement("li", _objectSpread({
    ref: ref,
    "data-value": value,
    className: classNames(listBoxItem, className),
    role: "option",
    "aria-selected": selected ? true : undefined
  }, rest), children);
});
var useStyles$F = createUseStyles({
  listBoxContainer: {
    // TODO: Possible to utilize focus-visible to show only on keyboard interaction? (with child)
    '&:focus-within': {
      outline: '#005fcc auto 1px',
      outlineOffset: 1
    }
  },
  listBox: {
    listStyle: 'none',
    width: 'fit-content',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: 0
  }
});
var ARIA_ACTIVEDESCENDANT = 'aria-activedescendant';
/**
 * A virtualized version of the List component, using `react-window` to render large datasets. This component should only be used when the number of items would cause performance issues with the standard List component (most likely >500 items).
 */
var VirtualizedListBox = React__default.forwardRef(function (_ref75, ref) {
  var _ref75$height = _ref75.height,
    height = _ref75$height === void 0 ? 325 : _ref75$height,
    _ref75$width = _ref75.width,
    width = _ref75$width === void 0 ? 175 : _ref75$width,
    itemSize = _ref75.itemSize,
    ariaLabel = _ref75['aria-label'],
    ariaLabelledBy = _ref75['aria-labelledby'],
    ariaActiveDescendant = _ref75[ARIA_ACTIVEDESCENDANT],
    tabIndex = _ref75.tabIndex,
    itemCount = _ref75.itemCount,
    externalFocusedIndex = _ref75.focusedIndex,
    onChange = _ref75.onChange,
    onKeyDown = _ref75.onKeyDown,
    onClick = _ref75.onClick,
    className = _ref75.className,
    children = _ref75.children,
    rest = _objectWithoutProperties(_ref75, ["height", "width", "itemSize", "aria-label", "aria-labelledby", ARIA_ACTIVEDESCENDANT, "tabIndex", "itemCount", "focusedIndex", "onChange", "onKeyDown", "onClick", "className", "children"].map(_toPropertyKey));
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    focusedIndex = _useState14[0],
    setFocusedIndex = _useState14[1];
  var listRef = useRef(null);
  var innerRef = useRef(null);
  var outerRef = useRef(null);
  var itemsRef = useRef([]);
  // override internal focusedIndex with external state if provided
  useEffect(function () {
    if (externalFocusedIndex !== undefined) {
      if (externalFocusedIndex !== null) {
        var _listRef$current;
        (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollToItem(externalFocusedIndex);
      }
      setFocusedIndex(externalFocusedIndex);
    }
  }, [externalFocusedIndex]);
  var _useStyles$F = useStyles$F(),
    listBoxContainer = _useStyles$F.listBoxContainer,
    listBox = _useStyles$F.listBox;
  var handleChange = function handleChange(item) {
    var _item$dataset$value;
    onChange === null || onChange === void 0 ? void 0 : onChange({
      target: item,
      value: (_item$dataset$value = item.dataset.value) !== null && _item$dataset$value !== void 0 ? _item$dataset$value : ''
    });
  };
  /**
   * Scroll to and focus the item at the specified index
   */
  var focusItem = function focusItem(index) {
    var _listRef$current2;
    (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.scrollToItem(index);
    setFocusedIndex(index);
    handleChange(itemsRef.current[index]);
  };
  useImperativeHandle(ref, function () {
    return {
      listRef: listRef,
      innerRef: innerRef,
      outerRef: outerRef,
      itemsRef: itemsRef
    };
  });
  var handleKeyDown = useCallback(function (e) {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    if (!(e.target instanceof HTMLUListElement)) {
      return;
    }
    if (['Down', 'Up', 'ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'End', 'Home'].includes(e.key)) {
      var _outerRef$current;
      e.preventDefault();
      // Focus another item in the listBox depending on which key is pressed
      focusNext(e.key, focusedIndex, itemCount, numItemsVisible((_outerRef$current = outerRef.current) === null || _outerRef$current === void 0 ? void 0 : _outerRef$current.getBoundingClientRect().height), focusItem);
    }
  }, [focusedIndex, itemCount, onKeyDown]);
  var handleClick = useCallback(function (e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
    if (e.target instanceof HTMLLIElement) {
      setFocusedIndex(itemsRef.current.indexOf(e.target));
      handleChange(e.target);
    }
  }, [onClick]);
  useSSRSafeLayoutEffect(function () {
    var _outerRef$current2;
    var listElement = innerRef.current;
    (_outerRef$current2 = outerRef.current) === null || _outerRef$current2 === void 0 ? void 0 : _outerRef$current2.removeAttribute('tabindex');
    if (listElement) {
      listElement.className = listBox;
      listElement.setAttribute('role', 'listbox');
      listElement.addEventListener('keydown', handleKeyDown);
      listElement.addEventListener('click', handleClick);
      if (tabIndex === undefined) {
        listElement.removeAttribute('tabindex');
      } else {
        listElement.setAttribute('tabindex', tabIndex === null || tabIndex === void 0 ? void 0 : tabIndex.toString());
      }
      if (ariaLabel) {
        listElement.setAttribute('aria-label', ariaLabel);
      }
      if (ariaLabelledBy) {
        listElement.setAttribute('aria-labelledby', ariaLabelledBy);
      }
    }
    return function () {
      if (listElement) {
        listElement.removeEventListener('keydown', handleKeyDown);
        listElement.removeEventListener('click', handleClick);
      }
    };
  }, [ariaLabel, ariaLabelledBy, handleClick, handleKeyDown, listBox, tabIndex]);
  useSSRSafeLayoutEffect(function () {
    var listElement = innerRef.current;
    if (ariaActiveDescendant || tabIndex !== undefined && focusedIndex !== null) {
      listElement === null || listElement === void 0 ? void 0 : listElement.setAttribute(ARIA_ACTIVEDESCENDANT, ariaActiveDescendant !== null && ariaActiveDescendant !== void 0 ? ariaActiveDescendant : "ListBoxItem-".concat(focusedIndex));
    } else {
      listElement === null || listElement === void 0 ? void 0 : listElement.removeAttribute(ARIA_ACTIVEDESCENDANT);
    }
  }, [ariaActiveDescendant, focusedIndex, tabIndex]);
  return React__default.createElement(FixedSizeList, _objectSpread({
    className: classNames(listBoxContainer, className),
    itemSize: itemSize,
    height: Math.min(height, itemCount * itemSize),
    width: width,
    innerElementType: "ul",
    innerRef: innerRef,
    outerRef: outerRef,
    overscanCount: 10,
    itemCount: itemCount,
    ref: listRef
  }, rest), function (props) {
    var _children$props$id;
    return React__default.cloneElement(children(props), {
      id: (_children$props$id = children(props).props.id) !== null && _children$props$id !== void 0 ? _children$props$id : "ListBoxItem-".concat(props.index),
      selected: props.index === focusedIndex,
      ref: function ref(el) {
        itemsRef.current[props.index] = el;
      }
    });
  });
});
var useStyles$E = createUseStyles(function (theme) {
  return {
    comboBox: {
      display: 'inline-block',
      width: function width(_ref76) {
        var _width2 = _ref76.width;
        return _width2;
      },
      borderRadius: "4px",
      border: "2px solid transparent",
      outline: "1px solid transparent",
      '&:focus-within, &:hover': {
        border: "2px solid ".concat(theme.primaryAccentColor),
        outline: "1px solid #fff"
      }
    },
    listBox: {
      display: function display(_ref77) {
        var isOpen = _ref77.isOpen;
        return isOpen ? 'block' : 'none';
      },
      '&:focus-within': {
        outline: 'none'
      },
      border: '1px solid rgb(204, 204, 204)'
    },
    listBoxItem: {
      direction: function direction(_ref78) {
        var rtl = _ref78.rtl;
        return rtl ? 'rtl' : 'ltr';
      },
      paddingLeft: '10px'
    }
  };
});
function ComboBox(_ref79) {
  var _comboBoxRef$current;
  var id = _ref79.id,
    options = _ref79.options,
    height = _ref79.height,
    _ref79$width = _ref79.width,
    width = _ref79$width === void 0 ? '100%' : _ref79$width,
    _ref79$itemSize = _ref79.itemSize,
    itemSize = _ref79$itemSize === void 0 ? 48 : _ref79$itemSize,
    className = _ref79.className,
    classes = _ref79.classes,
    _ref79$filterOnChange = _ref79.filterOnChange,
    filterOnChange = _ref79$filterOnChange === void 0 ? false : _ref79$filterOnChange,
    _ref79$value = _ref79.value,
    outsideValue = _ref79$value === void 0 ? '' : _ref79$value,
    _ref79$optionAlign = _ref79.optionAlign,
    optionAlign = _ref79$optionAlign === void 0 ? 'center' : _ref79$optionAlign,
    filter = _ref79.filter,
    onChange = _ref79.onChange,
    _ref79$rtl = _ref79.rtl,
    rtl = _ref79$rtl === void 0 ? false : _ref79$rtl,
    ariaLabel = _ref79['aria-label'],
    ariaLabelledBy = _ref79['aria-labelledby'],
    rest = _objectWithoutProperties(_ref79, _excluded34);
  var comboBoxRef = useRef(null);
  var inputRef = useRef(null);
  var listBoxRef = useRef(null);
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isOpen = _useState16[0],
    setIsOpen = _useState16[1];
  var _useState17 = useState(outsideValue),
    _useState18 = _slicedToArray(_useState17, 2),
    value = _useState18[0],
    setValue = _useState18[1];
  var _useState19 = useState(options),
    _useState20 = _slicedToArray(_useState19, 2),
    currentOptions = _useState20[0],
    setCurrentOptions = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    focusedIndex = _useState22[0],
    setFocusedIndex = _useState22[1];
  var _useState23 = useState(!filterOnChange),
    _useState24 = _slicedToArray(_useState23, 2),
    filterActive = _useState24[0],
    setFilterActive = _useState24[1];
  // the initial value of the input field when the listbox is opened (used to control whether the filter is active or not)
  var _useState25 = useState(outsideValue),
    _useState26 = _slicedToArray(_useState25, 2),
    valueOnOpen = _useState26[0],
    setValueOnOpen = _useState26[1];
  /** For preventing onChange being called on first render */
  var firstRender = useRef(true);
  var _useStyles$E = useStyles$E({
      isOpen: isOpen,
      width: width,
      rtl: rtl
    }),
    comboBox = _useStyles$E.comboBox,
    listBox = _useStyles$E.listBox,
    listBoxItem = _useStyles$E.listBoxItem;
  var closeListBox = function closeListBox() {
    if (isOpen) {
      setIsOpen(false);
    }
  };
  var openListBox = function openListBox() {
    if (!isOpen) {
      setValueOnOpen(value);
      setIsOpen(true);
    }
  };
  // close the listbox when the user clicks outside of it
  useOnFocusLeave(comboBoxRef, function () {
    closeListBox();
    setFocusedIndex(null);
  });
  var focusItem = function focusItem(index) {
    setFocusedIndex(index);
  };
  // call onChange when value changes
  useEffect(function () {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        value: value,
        target: inputRef.current
      });
    }
  }, [value]);
  // filter the current options if a filter is provided and filtering is active. If filtering is inactive, reset the current options to the original options
  useEffect(function () {
    if (filter && filterActive) {
      setCurrentOptions(options.filter(function (option) {
        return filter(option, value);
      }));
    } else if (!filterActive) {
      setCurrentOptions(options);
    }
  }, [options, value, filter, filterActive]);
  // if filterOnChange is true, activate filtering if the value has changed since the listbox was opened, otherwise deactivate filtering
  useEffect(function () {
    if (filterOnChange) {
      setFilterActive(value !== valueOnOpen);
    }
  }, [filterOnChange, value, valueOnOpen]);
  // if the current value matches an option when the list opens, focus it and center it in the list
  useEffect(function () {
    if (isOpen) {
      var matchingOption = currentOptions.find(function (option) {
        return option.label === value;
      });
      if (matchingOption) {
        var _listBoxRef$current, _listBoxRef$current$l;
        (_listBoxRef$current = listBoxRef.current) === null || _listBoxRef$current === void 0 ? void 0 : (_listBoxRef$current$l = _listBoxRef$current.listRef.current) === null || _listBoxRef$current$l === void 0 ? void 0 : _listBoxRef$current$l.scrollToItem(currentOptions.indexOf(matchingOption), optionAlign // position the option in the list according to the alignment (default is `center`)
        );

        setFocusedIndex(currentOptions.indexOf(matchingOption));
      }
    }
  }, [isOpen, currentOptions, value, optionAlign]);
  useEffect(function () {
    setValue(outsideValue);
  }, [outsideValue]);
  var handleKeyDown = function handleKeyDown(e) {
    switch (e.key) {
      case 'ArrowDown':
      case 'Down':
      case 'ArrowUp':
      case 'Up':
      case 'PageDown':
      case 'PageUp':
        e.preventDefault();
        openListBox();
        if (!e.altKey) {
          var _listBoxRef$current2, _listBoxRef$current2$;
          focusNext(e.key, focusedIndex, currentOptions.length, numItemsVisible((_listBoxRef$current2 = listBoxRef.current) === null || _listBoxRef$current2 === void 0 ? void 0 : (_listBoxRef$current2$ = _listBoxRef$current2.outerRef.current) === null || _listBoxRef$current2$ === void 0 ? void 0 : _listBoxRef$current2$.getBoundingClientRect().height, itemSize), focusItem);
        }
        break;
      case 'Escape':
        if (isOpen) {
          closeListBox();
          setFocusedIndex(null);
        } else {
          setValue('');
        }
        break;
      case 'Enter':
        e.preventDefault();
        if (isOpen) {
          if (focusedIndex !== null) {
            var _listBoxRef$current$i, _listBoxRef$current3, _listBoxRef$current3$;
            setValue((_listBoxRef$current$i = (_listBoxRef$current3 = listBoxRef.current) === null || _listBoxRef$current3 === void 0 ? void 0 : (_listBoxRef$current3$ = _listBoxRef$current3.itemsRef.current) === null || _listBoxRef$current3$ === void 0 ? void 0 : _listBoxRef$current3$[focusedIndex].textContent) !== null && _listBoxRef$current$i !== void 0 ? _listBoxRef$current$i : '');
          }
          closeListBox();
          setFocusedIndex(null);
        }
        break;
    }
  };
  var handleListBoxClick = function handleListBoxClick() {
    var _inputRef$current3;
    (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.focus();
    closeListBox();
  };
  var activeDescendant = focusedIndex !== null && currentOptions[focusedIndex] ? "".concat(id, "-").concat(currentOptions[focusedIndex].value) : undefined;
  return React__default.createElement("div", _objectSpread({
    className: classNames(comboBox, classes === null || classes === void 0 ? void 0 : classes.comboBox, className),
    ref: comboBoxRef
  }, rest), React__default.createElement(ComboBoxInputGroup, {
    ref: inputRef,
    className: classes === null || classes === void 0 ? void 0 : classes.inputGroup,
    height: height,
    rtl: rtl,
    value: value,
    isOpen: isOpen,
    "aria-controls": "".concat(id, "-listbox"),
    "aria-autocomplete": filter ? 'list' : 'none',
    "aria-activedescendant": activeDescendant,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    open: openListBox,
    close: closeListBox,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    onKeyDown: handleKeyDown
  }), React__default.createElement(VirtualizedListBox, {
    ref: listBoxRef,
    itemSize: itemSize,
    itemCount: currentOptions.length,
    className: classNames(listBox, classes === null || classes === void 0 ? void 0 : classes.listBox),
    focusedIndex: focusedIndex,
    width: (_comboBoxRef$current = comboBoxRef.current) === null || _comboBoxRef$current === void 0 ? void 0 : _comboBoxRef$current.clientWidth,
    onChange: function onChange(e) {
      var _e$target$textContent, _e$target2;
      return setValue((_e$target$textContent = (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.textContent) !== null && _e$target$textContent !== void 0 ? _e$target$textContent : '');
    },
    onClick: handleListBoxClick,
    tabIndex: -1,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-activedescendant": activeDescendant,
    /**
     * adding inline style to overwrite react-window inline styles as per their docs
     * https://github.com/bvaughn/react-window
     */
    style: {
      position: 'absolute'
    }
  }, function (_ref80) {
    var index = _ref80.index,
      style = _ref80.style;
    return React__default.createElement(ListBoxItem, {
      className: classNames(listBoxItem, classes === null || classes === void 0 ? void 0 : classes.listBoxItem),
      style: style,
      value: currentOptions[index].value,
      id: "".concat(id, "-").concat(currentOptions[index].value),
      key: "".concat(id, "-").concat(currentOptions[index].value)
    }, currentOptions[index].label);
  }));
}
var useStyles$D = createUseStyles({
  srOnly: visuallyHidden
});

/** default element for the visually hidden component */
var DEFAULT_ELEMENT = 'span';
/**
 * A component to have visually hidden text still available to Assistive
 * Technologies, such as screen-readers.
 * All HTML properties are available on the selected `element` tag used.
 */
function VisuallyHidden(_ref81) {
  var _ref81$element = _ref81.element,
    Tag = _ref81$element === void 0 ? DEFAULT_ELEMENT : _ref81$element,
    className = _ref81.className,
    props = _objectWithoutProperties(_ref81, _excluded35);
  var _useStyles$D = useStyles$D(),
    srOnly = _useStyles$D.srOnly;
  return React__default.createElement(Tag, _objectSpread({
    className: classNames(srOnly, className)
  }, props));
}
var useCalendarStyles = createUseStyles({
  calendarPickerWrapper: {
    width: function width(_ref82) {
      var _width3 = _ref82.width;
      return _width3;
    },
    height: function height(_ref83) {
      var _height3 = _ref83.height;
      return _height3;
    },
    border: '1px solid #CCCCCC',
    padding: '10px',
    background: '#FFFFFF',
    color: '#333333'
  },
  calendarControls: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px'
  },
  button: {
    border: 'none',
    borderRadius: 0,
    background: 'transparent',
    width: '60px',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#05467E',
      color: '#FFFFFF'
    }
  },
  comboboxWrapper: {
    display: 'flex',
    flexGrow: 1,
    '& > div': {
      width: '50%'
    }
  },
  monthWrapper: {
    display: 'grid',
    margin: '32px 0 0',
    gridTemplateColumns: "repeat(1, 100%)",
    gridGap: '0 64px'
  }
});
var useMonthStyles = createUseStyles({
  weekdayLabel: {
    textAlign: 'center',
    marginBottom: '10px',
    fontSize: '10px'
  },
  weekGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    justifyContent: 'center'
  }
});
var useDayStyles = createUseStyles({
  dayDefault: {
    padding: '8px',
    border: '1px solid #CCCCCC',
    borderRadius: '0',
    color: '#001217',
    backgroundColor: '#FFFFFF',
    '&:hover': {
      color: '#FFFFFF',
      backgroundColor: '#05467E',
      borderColor: '#05467E'
    }
  },
  daySelected: {
    color: '#FFFFFF',
    backgroundColor: '#71c9ed'
  },
  daySelectedFirstOrLast: {
    color: '#FFFFFF',
    backgroundColor: '#000000',
    borderColor: '#000000'
  },
  dayDisabled: {
    color: '#808285',
    backgroundColor: '#FFFFFF'
  }
});
var COPY$d = defineMessages({
  DAY_OF_MONTH: {
    id: 'Day.dayOfMonth',
    defaultMessage: '{dayInCalendar, date, full}',
    description: '[Type: label][Vis: high] - label for the full date'
  }
});
function Day(_ref84) {
  var _classNames2;
  var dayLabel = _ref84.dayLabel,
    date = _ref84.date,
    focusedDate = _ref84.focusedDate,
    isDateSelected = _ref84.isDateSelected,
    isDateFocused = _ref84.isDateFocused,
    isDateHovered = _ref84.isDateHovered,
    onDateHover = _ref84.onDateHover,
    onDateSelect = _ref84.onDateSelect,
    onDateFocus = _ref84.onDateFocus,
    isFirstOrLastSelectedDate = _ref84.isFirstOrLastSelectedDate;
  var dayRef = useRef(null);
  var fn = function fn() {
    return false;
  };
  var _Ne = Ne({
      date: date,
      focusedDate: focusedDate,
      isDateFocused: isDateFocused,
      isDateSelected: isDateSelected,
      isDateHovered: isDateHovered,
      isDateBlocked: fn,
      isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
      onDateFocus: onDateFocus,
      onDateSelect: onDateSelect,
      onDateHover: onDateHover,
      dayRef: dayRef
    }),
    isSelected = _Ne.isSelected,
    isSelectedStartOrEnd = _Ne.isSelectedStartOrEnd,
    isWithinHoverRange = _Ne.isWithinHoverRange,
    disabledDate = _Ne.disabledDate,
    onClick = _Ne.onClick,
    onKeyDown = _Ne.onKeyDown,
    onMouseEnter = _Ne.onMouseEnter,
    tabIndex = _Ne.tabIndex;
  useEffect(function () {
    if (dayRef && dayRef.current && isDateFocused(date)) {
      dayRef.current.focus();
    }
  }, [dayRef, date, isDateFocused]);
  var _useDayStyles = useDayStyles(),
    dayDefault = _useDayStyles.dayDefault,
    daySelected = _useDayStyles.daySelected,
    daySelectedFirstOrLast = _useDayStyles.daySelectedFirstOrLast,
    dayDisabled = _useDayStyles.dayDisabled;
  if (!dayLabel) {
    return React__default.createElement("div", null);
  }
  return React__default.createElement("button", {
    onClick: onClick,
    onKeyDown: onKeyDown,
    onMouseEnter: onMouseEnter,
    tabIndex: tabIndex,
    type: "button",
    ref: dayRef,
    "aria-label": t(COPY$d.DAY_OF_MONTH, {
      dayInCalendar: date
    }),
    className: classNames(dayDefault, (_classNames2 = {}, _defineProperty(_classNames2, daySelected, isSelected || isWithinHoverRange), _defineProperty(_classNames2, daySelectedFirstOrLast, isSelectedStartOrEnd), _defineProperty(_classNames2, dayDisabled, disabledDate), _classNames2))
  }, dayLabel);
}
var COPY$c = defineMessages({
  DAY_OF_WEEK_LEGEND_SHORT: {
    id: 'Month.dayOfWeekLegendShort',
    defaultMessage: '{dayOfTheWeek, select, Mo {Mo} Tu {Tu} We {We} Th {Th} Fr {Fr} Sa {Sa} Su {Su}}',
    description: '[Type: label][Vis: high] - label for the day of the week in shorthand'
  },
  DAY_OF_WEEK_LEGEND_FULL: {
    id: 'Month.dayOfWeekLegendLong',
    defaultMessage: '{dayOfTheWeek, select, Mo {Monday} Tu {Tuesday} We {Wednesday} Th {Thursday} Fr {Friday} Sa {Saturday} Su {Sunday}}',
    description: '[Type: label][Vis: high] - label for the day of the week'
  }
});
function Month(_ref85) {
  var year = _ref85.year,
    month = _ref85.month,
    firstDayOfWeek = _ref85.firstDayOfWeek,
    dayProps = _objectWithoutProperties(_ref85, _excluded36);
  var _de = de({
      year: year,
      month: month,
      firstDayOfWeek: firstDayOfWeek
    }),
    days = _de.days,
    weekdayLabels = _de.weekdayLabels;
  var _useMonthStyles = useMonthStyles(),
    weekdayLabel = _useMonthStyles.weekdayLabel,
    weekGrid = _useMonthStyles.weekGrid;
  return React__default.createElement("div", null, React__default.createElement("div", {
    className: weekGrid,
    role: "grid"
  }, weekdayLabels.map(function (dayLabel) {
    return React__default.createElement("div", {
      className: weekdayLabel,
      key: dayLabel,
      role: "columnheader"
    }, React__default.createElement("span", {
      role: "presentation"
    }, React__default.createElement(T, {
      desc: COPY$c.DAY_OF_WEEK_LEGEND_SHORT,
      values: {
        dayOfTheWeek: dayLabel
      }
    })), React__default.createElement(VisuallyHidden, null, React__default.createElement(T, {
      desc: COPY$c.DAY_OF_WEEK_LEGEND_FULL,
      values: {
        dayOfTheWeek: dayLabel
      }
    })));
  }), days.map(function (day, index) {
    if (_typeof(day) === 'object') {
      return React__default.createElement(Day, _objectSpread({
        date: day.date,
        key: day.dayLabel,
        dayLabel: day.dayLabel
      }, dayProps));
    }
    var emptyDayKey = "empty-day-".concat(index);
    return React__default.createElement("div", {
      key: emptyDayKey
    });
  })));
}
var COPY$b = defineMessages({
  PREVIOUS_MONTH: {
    id: 'CalendarPicker.previousMonth',
    defaultMessage: 'Previous Month',
    description: '[Type: button][Vis: high] - button label to go to previous month'
  },
  NEXT_MONTH: {
    id: 'CalendarPicker.nextMonth',
    defaultMessage: 'Next Month',
    description: '[Type: button][Vis: high] - button label to go to next month'
  },
  MONTH_SELECT: {
    id: 'CalendarPicker.month',
    defaultMessage: 'Select a month',
    description: '[Type: label][Vis: high] - label for month selection combo box'
  },
  YEAR_SELECT: {
    id: 'CalendarPicker.year',
    defaultMessage: 'Select a year',
    description: '[Type: label][Vis: high] - label for year selection combo box'
  },
  MONTHS: {
    id: 'CalendarPicker.months',
    defaultMessage: '{months, select, January {January} February {February} March {March} April {April} May {May} June {June} July {July} August {August} September {September} October {October} November {November} December {December}}',
    description: '[Type: label][Vis: high] - label for the months'
  }
});
var startingYear = new Date().getFullYear() - 200;
var yearOptions = _toConsumableArray(Array(251)).map(function (_, year) {
  return {
    label: "".concat(startingYear + year),
    value: "".concat(startingYear + year)
  };
});
function getPreviousMonth(currentMonth) {
  var newDate;
  if (currentMonth.getMonth() - 1 < 0) {
    newDate = new Date(currentMonth.getFullYear() - 1, 11, currentMonth.getDate());
  } else {
    var prevMonthLastDay = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 0).getDate();
    if (currentMonth.getDate() > prevMonthLastDay) {
      newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, prevMonthLastDay);
    } else {
      newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, currentMonth.getDate());
    }
  }
  return newDate;
}
function getNextMonth(currentMonth) {
  var newDate;
  if (currentMonth.getMonth() + 1 > 11) {
    newDate = new Date(currentMonth.getFullYear() + 1, 0, currentMonth.getDate());
  } else {
    var nextMonthLastDay = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 2, 0).getDate();
    if (currentMonth.getDate() > nextMonthLastDay) {
      newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, nextMonthLastDay);
    } else {
      newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, currentMonth.getDate());
    }
  }
  return newDate;
}
var comboBoxSeedId = 'calendar-picker-combobox';
function CalendarPicker(_ref86) {
  var onDaySelect = _ref86.onDaySelect,
    onDateChange = _ref86.onDateChange,
    selectedDate = _ref86.selectedDate,
    _ref86$width = _ref86.width,
    width = _ref86$width === void 0 ? '300px' : _ref86$width,
    _ref86$height = _ref86.height,
    height = _ref86$height === void 0 ? 'auto' : _ref86$height,
    _ref86$startingDayOfW = _ref86.startingDayOfWeek,
    startingDayOfWeek = _ref86$startingDayOfW === void 0 ? 0 : _ref86$startingDayOfW;
  var focusTrapRef = useFocusTrap({
    selectors: ['button:not([tabindex="-1"])', 'input']
  });
  var comboboxId = useMemo(function () {
    return uniqueId(comboBoxSeedId);
  }, []);
  var selectId = useMemo(function () {
    return uniqueId('calendar-picker-select');
  }, []);
  var _useState27 = useState(selectedDate),
    _useState28 = _slicedToArray(_useState27, 2),
    state = _useState28[0],
    setState = _useState28[1];
  var handleDateChange = function handleDateChange(_ref87) {
    var startDate = _ref87.startDate;
    var d = startDate !== null && startDate !== void 0 ? startDate : new Date();
    setState(d);
    onDaySelect === null || onDaySelect === void 0 ? void 0 : onDaySelect(d);
  };
  var _Ye = Ye({
      startDate: selectedDate,
      endDate: null,
      focusedInput: Pe,
      onDatesChange: handleDateChange,
      numberOfMonths: 1,
      /*
       * minBookingDays and exactBookingDays are used to remove the date range feature
       * see: https://github.com/tomgreenwood1/react-datepicker/tree/f2b1969cb4808c68d578428c4c5e6ed98c96461e/packages/hooks#exactminbookingdays-boolean--undefined-default-false
       */
      minBookingDays: 1,
      exactMinBookingDays: true,
      /*
       * firstDayofWeek is used to set the first day of the week. 0 = Sunday, 1 = Monday, etc.
       */
      firstDayOfWeek: startingDayOfWeek
    }),
    firstDayOfWeek = _Ye.firstDayOfWeek,
    activeMonths = _Ye.activeMonths,
    isDateSelected = _Ye.isDateSelected,
    isDateHovered = _Ye.isDateHovered,
    isFirstOrLastSelectedDate = _Ye.isFirstOrLastSelectedDate,
    isDateFocused = _Ye.isDateFocused,
    focusedDate = _Ye.focusedDate,
    onDateHover = _Ye.onDateHover,
    onDateSelect = _Ye.onDateSelect,
    onDateFocus = _Ye.onDateFocus,
    goToDate = _Ye.goToDate;
  useEffect(function () {
    goToDate(selectedDate);
  }, [selectedDate, goToDate]);
  var currentMonth = activeMonths[0];
  var _useCalendarStyles = useCalendarStyles({
      height: height,
      width: width
    }),
    comboboxWrapper = _useCalendarStyles.comboboxWrapper,
    calendarControls = _useCalendarStyles.calendarControls,
    calendarPickerWrapper = _useCalendarStyles.calendarPickerWrapper,
    button = _useCalendarStyles.button,
    monthWrapper = _useCalendarStyles.monthWrapper;
  // populate monthOptions array
  var monthNames = [t(COPY$b.MONTHS, {
    months: 'January'
  }), t(COPY$b.MONTHS, {
    months: 'February'
  }), t(COPY$b.MONTHS, {
    months: 'March'
  }), t(COPY$b.MONTHS, {
    months: 'April'
  }), t(COPY$b.MONTHS, {
    months: 'May'
  }), t(COPY$b.MONTHS, {
    months: 'June'
  }), t(COPY$b.MONTHS, {
    months: 'July'
  }), t(COPY$b.MONTHS, {
    months: 'August'
  }), t(COPY$b.MONTHS, {
    months: 'September'
  }), t(COPY$b.MONTHS, {
    months: 'October'
  }), t(COPY$b.MONTHS, {
    months: 'November'
  }), t(COPY$b.MONTHS, {
    months: 'December'
  })];
  var monthOptions = monthNames.map(function (name) {
    return {
      label: name,
      value: name
    };
  });
  var getMonthLabel = function getMonthLabel(monthNamesIndex) {
    return monthNames[monthNamesIndex];
  };
  var handleMonthChange = function handleMonthChange(e) {
    var monthIndex = monthOptions.findIndex(function (i) {
      return i.value === e.target.value;
    });
    var newDate = new Date(currentMonth.year, monthIndex, state.getDate());
    if (monthIndex !== -1) {
      goToDate(newDate);
      setState(newDate);
      onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
    }
  };
  var handleYearChange = function handleYearChange(e) {
    if (e.value.length >= 4) {
      var newDate = new Date(parseInt(e.value, 10), currentMonth.month, state.getDate());
      goToDate(newDate);
      setState(newDate);
      onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
    }
  };
  var handleGoToPreviousMonths = function handleGoToPreviousMonths() {
    var newDate = getPreviousMonth(state);
    setState(newDate);
    goToDate(newDate);
    onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
  };
  var handleGoToNextMonths = function handleGoToNextMonths() {
    var newDate = getNextMonth(state);
    setState(newDate);
    goToDate(newDate);
    onDateChange === null || onDateChange === void 0 ? void 0 : onDateChange(newDate);
  };
  return React__default.createElement("div", {
    className: calendarPickerWrapper,
    "data-testid": "CalendarPicker",
    ref: focusTrapRef
  }, React__default.createElement("div", {
    className: calendarControls
  }, React__default.createElement("button", {
    type: "button",
    onClick: handleGoToPreviousMonths,
    className: button,
    "aria-label": t(COPY$b.PREVIOUS_MONTH),
    "data-testid": "previous-month-button"
  }, React__default.createElement(CaretLeftOutlineIcon, null)), React__default.createElement("div", {
    className: comboboxWrapper
  }, React__default.createElement("div", null, React__default.createElement(NativeSelect, {
    id: selectId,
    value: getMonthLabel(currentMonth.month),
    onChange: handleMonthChange
  }, monthOptions.map(function (option) {
    return React__default.createElement(SelectAnswerOption, {
      value: option.value,
      label: option.value,
      key: option.value
    });
  }))), React__default.createElement("div", null, React__default.createElement(ComboBox, {
    id: comboboxId,
    "aria-label": t(COPY$b.YEAR_SELECT),
    options: yearOptions,
    value: currentMonth.year.toString(),
    onChange: handleYearChange
  }))), React__default.createElement("button", {
    type: "button",
    onClick: handleGoToNextMonths,
    className: button,
    "aria-label": t(COPY$b.NEXT_MONTH),
    "data-testid": "next-month-button"
  }, React__default.createElement(CaretRightOutlineIcon, null))), React__default.createElement("div", {
    className: monthWrapper
  }, React__default.createElement(Month, {
    year: currentMonth.year,
    month: currentMonth.month,
    firstDayOfWeek: firstDayOfWeek,
    onChange: goToDate,
    focusedDate: focusedDate,
    isDateSelected: isDateSelected,
    isDateFocused: isDateFocused,
    isDateHovered: isDateHovered,
    onDateHover: onDateHover,
    onDateSelect: onDateSelect,
    onDateFocus: onDateFocus,
    isFirstOrLastSelectedDate: isFirstOrLastSelectedDate
  })));
}
var useStyles$C = createUseStyles({
  container: {
    visibility: function visibility(_ref88) {
      var calendarVisibility = _ref88.calendarVisibility;
      return calendarVisibility ? 'visible' : 'hidden';
    }
  }
});
var DisclosureContainer = forwardRef(function DisclosureContainer(_ref89, ref) {
  var onClose = _ref89.onClose,
    _ref89$visible = _ref89.visible,
    visible = _ref89$visible === void 0 ? false : _ref89$visible,
    className = _ref89.className,
    props = _objectWithoutProperties(_ref89, _excluded37);
  var focusTrapRef = useFocusTrap({
    selectors: ['button:not([tabindex="-1"])', 'input']
  });
  var disclosureRef = useForkRef(focusTrapRef, ref);
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(e) {
      if (e.key === 'Escape') {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    };
    var handleClick = function handleClick(e) {
      var _focusTrapRef$current;
      var target = e.target;
      var clickedOutside = !((_focusTrapRef$current = focusTrapRef.current) !== null && _focusTrapRef$current !== void 0 && _focusTrapRef$current.contains(target));
      var comboBoxOptionClicked = !target.id.startsWith(comboBoxSeedId);
      if (visible && clickedOutside && comboBoxOptionClicked) {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    };
    if (visible) {
      /*
       * RAWR-1437
       * Delay setting up the EventListener to after the current render, otherwise the handleClick triggers
       * when the calendar first opens and closes the calendar right away.
       */
      setTimeout(function () {
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('click', handleClick);
      }, 0);
    } else {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('click', handleClick);
    }
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('click', handleClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  var _useStyles$C = useStyles$C({
      calendarVisibility: visible
    }),
    container = _useStyles$C.container;
  return React__default.createElement("div", _objectSpread({
    ref: disclosureRef,
    className: classNames(container, className)
  }, props));
});

// constants.ts
var US_DATE_FORMAT = 'MM/DD/YYYY';
var EURO_DATE_FORMAT = 'DD/MM/YYYY';
var DATE_DELIMITER = /[/.-]/g;
var validDateStringCheck = function validDateStringCheck(dateString) {
  var badValues = ['0', ' '];
  var isValid = dateString.every(function (value) {
    // eslint-disable-next-line no-restricted-globals
    return badValues.indexOf(value) === -1 && !isNaN(parseInt(value, 10));
  });
  return dateString.length === 3 && isValid;
};
var toDateString = function toDateString(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : US_DATE_FORMAT;
  if (!date) {
    return '';
  }
  var segments = date.toISOString().split('T')[0].split(DATE_DELIMITER);
  var _segments$map = segments.map(function (s) {
      return s;
    }),
    _segments$map2 = _slicedToArray(_segments$map, 3),
    y = _segments$map2[0],
    m = _segments$map2[1],
    d = _segments$map2[2];
  if (format === US_DATE_FORMAT) {
    return "".concat(m, "/").concat(d, "/").concat(y);
  }
  return "".concat(d, "/").concat(m, "/").concat(y);
};
var isValidDate = function isValidDate(year, month, day) {
  var date = new Date("".concat(year, "-").concat(month, "-").concat(day, "T00:00:00"));
  return date.getFullYear() === Number(year) && date.getMonth() === Number(month) - 1 && date.getDate() === Number(day);
};
var stringToDate = function stringToDate(dateString) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : US_DATE_FORMAT;
  if (!dateString) {
    return new Date();
  }
  if (!validDateStringCheck(dateString.split(DATE_DELIMITER))) {
    return new Date();
  }
  if (format === EURO_DATE_FORMAT) {
    var _dateString$split = dateString.split(DATE_DELIMITER),
      _dateString$split2 = _slicedToArray(_dateString$split, 3),
      _d = _dateString$split2[0],
      _m = _dateString$split2[1],
      _y = _dateString$split2[2];
    if (isValidDate(_y, _m, _d)) {
      return new Date("".concat(_y.padStart(4, '0'), "-").concat(_m.padStart(2, '0'), "-").concat(_d.padStart(2, '0'), "T00:00:00"));
    }
  }
  var _dateString$split3 = dateString.split(DATE_DELIMITER),
    _dateString$split4 = _slicedToArray(_dateString$split3, 3),
    m = _dateString$split4[0],
    d = _dateString$split4[1],
    y = _dateString$split4[2];
  if (isValidDate(y, m, d)) {
    return new Date("".concat(y.padStart(4, '0'), "-").concat(m.padStart(2, '0'), "-").concat(d.padStart(2, '0'), "T00:00:00"));
  }
  return new Date();
};
var useStyles$B = createUseStyles(function (theme) {
  return {
    container: {
      position: 'relative'
    },
    dateInputWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    dateInput: {
      maxWidth: '175px',
      maxHeight: '36px',
      padding: function padding(_ref90) {
        var _ref90$isRTL = _ref90.isRTL,
          isRTL = _ref90$isRTL === void 0 ? false : _ref90$isRTL;
        return isRTL ? '6px 6px 6px 36px' : '6px 36px 6px 6px';
      }
    },
    calendarButton: {
      borderRadius: 'none',
      border: 'none',
      margin: function margin(_ref91) {
        var _ref91$isRTL = _ref91.isRTL,
          isRTL = _ref91$isRTL === void 0 ? false : _ref91$isRTL;
        return isRTL ? '0 -37px 0 0' : '0 0 0 -37px';
      },
      height: '34px',
      width: '36px',
      fontSize: '15px',
      color: '#404040',
      backgroundColor: '#EFEFEF',
      '&:focus, &:hover': {
        cursor: 'pointer',
        outline: "2px solid ".concat(theme.primaryAccentColor),
        background: 'linear-gradient(0deg, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.2) 30%, #EFEFEF 100%)'
      },
      '&:focus': {
        borderRadius: '3px'
      },
      '&:active': {
        background: 'linear-gradient(0deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.4) 30%, #EFEFEF 100%)'
      },
      '&:disabled': {
        opacity: '.5'
      }
    },
    calendarWrapper: {
      position: 'absolute',
      bottom: function bottom(_ref92) {
        var calendarPosition = _ref92.calendarPosition;
        return calendarPosition;
      },
      zIndex: 100
    },
    commentLabel: {
      fontWeight: theme.questionBody.fontWeight,
      fontFamily: theme.questionBody.fontFamily,
      marginBottom: 5,
      display: 'block',
      fontSize: '14px'
    }
  };
});
var defaultLabels$1 = {
  dateInputLabel: 'Date',
  iconButton: 'Open Calendar',
  usDateFormat: 'MM/DD/YYYY',
  intlDateFormat: 'DD/MM/YYYY'
};
function DateInput(_ref93, ref) {
  var onChange = _ref93.onChange,
    _ref93$dateFormat = _ref93.dateFormat,
    dateFormat = _ref93$dateFormat === void 0 ? US_DATE_FORMAT : _ref93$dateFormat,
    _ref93$defaultValue = _ref93.defaultValue,
    defaultValue = _ref93$defaultValue === void 0 ? '' : _ref93$defaultValue,
    id = _ref93.id,
    className = _ref93.className,
    _ref93$labels = _ref93.labels,
    labels = _ref93$labels === void 0 ? defaultLabels$1 : _ref93$labels,
    props = _objectWithoutProperties(_ref93, _excluded38);
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    calendarVisibility = _useState30[0],
    setCalendarVisibility = _useState30[1];
  var dateInputID = useMemo(function () {
    return uniqueId('date-input-');
  }, []);
  var internalInputRef = useRef(null);
  var inputRef = useForkRef(ref, internalInputRef);
  var calendarButtonRef = useRef(null);
  var disclosureRef = useRef(null);
  var dateValueRef = useRef(defaultValue);
  var calendarPosition = useRef('100%');
  useSSRSafeLayoutEffect(function () {
    if (internalInputRef.current && disclosureRef.current) {
      var inputBound = internalInputRef.current.getBoundingClientRect();
      var disclosureBound = disclosureRef.current.getBoundingClientRect();
      if (inputBound.top < disclosureBound.height) {
        // not enough space
        calendarPosition.current = 'auto';
      } else {
        calendarPosition.current = '100%';
      }
    }
  }, [calendarVisibility]);
  var dateInputLabel = labels.dateInputLabel,
    iconButton = labels.iconButton,
    usDateFormat = labels.usDateFormat,
    intlDateFormat = labels.intlDateFormat;
  var handleCalendarVisibility = function handleCalendarVisibility() {
    setCalendarVisibility(function (s) {
      return !s;
    });
  };
  var handleDisclosureClose = function handleDisclosureClose() {
    var _calendarButtonRef$cu;
    (_calendarButtonRef$cu = calendarButtonRef.current) === null || _calendarButtonRef$cu === void 0 ? void 0 : _calendarButtonRef$cu.focus();
    setCalendarVisibility(false);
  };
  var handleDaySelect = function handleDaySelect(date) {
    var _internalInputRef$cur;
    var dateString = toDateString(date, dateFormat);
    dateValueRef.current = dateString;
    (_internalInputRef$cur = internalInputRef.current) === null || _internalInputRef$cur === void 0 ? void 0 : _internalInputRef$cur.setAttribute('value', dateString);
    onChange === null || onChange === void 0 ? void 0 : onChange(dateString);
    handleDisclosureClose();
  };
  var handleInputChange = function handleInputChange(e) {
    dateValueRef.current = e.target.value;
    onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
  };
  var _useContext3 = useContext(L10NContext),
    isRTL = _useContext3.isRTL;
  var _useStyles$B = useStyles$B({
      isRTL: isRTL,
      calendarPosition: calendarPosition.current
    }),
    dateInput = _useStyles$B.dateInput,
    calendarButton = _useStyles$B.calendarButton,
    calendarWrapper = _useStyles$B.calendarWrapper,
    commentLabel = _useStyles$B.commentLabel,
    dateInputWrapper = _useStyles$B.dateInputWrapper,
    container = _useStyles$B.container;
  return React__default.createElement("div", {
    className: classNames(container, className),
    id: id
  }, React__default.createElement("label", {
    htmlFor: dateInputID,
    className: commentLabel
  }, dateInputLabel), React__default.createElement("div", {
    className: dateInputWrapper
  }, React__default.createElement(TextInput$1, _objectSpread({
    "data-testid": "DateInput",
    className: dateInput,
    maxLength: 10,
    onChange: handleInputChange,
    defaultValue: dateValueRef.current,
    ref: inputRef,
    placeholder: dateFormat === 'DD/MM/YYYY' ? intlDateFormat : usDateFormat,
    id: dateInputID
  }, props)), React__default.createElement("button", {
    type: "button",
    ref: calendarButtonRef,
    className: calendarButton,
    onClick: handleCalendarVisibility,
    "aria-expanded": calendarVisibility,
    "aria-label": iconButton
  }, React__default.createElement(CalendarIcon, null))), React__default.createElement(DisclosureContainer, {
    className: calendarWrapper,
    onClose: handleDisclosureClose,
    ref: disclosureRef,
    visible: calendarVisibility,
    "data-testid": "DisclosureContainer"
  }, React__default.createElement(CalendarPicker
  /** date coming out */, {
    /** date coming out */
    onDaySelect: handleDaySelect,
    /** date going in */
    selectedDate: stringToDate(dateValueRef.current, dateFormat)
  })));
}
var DateInput$1 = forwardRef(DateInput);
var COPY$a = defineMessages({
  DATE_LABEL: {
    id: 'DateInputWrapper.dateLabel',
    defaultMessage: 'Date',
    description: '[Type: label][Vis: high] - label for date input'
  },
  DATE_BUTTON_LABEL: {
    id: 'DateInputWrapper.dateButton',
    defaultMessage: 'Open calendar',
    description: '[Type: button][Vis: high] - aria text for opening the calendar picker'
  },
  US_DATE_FORMAT: {
    id: 'DateInputWrapper.dateFormatUs',
    defaultMessage: 'MM/DD/YYYY',
    description: '[Type: label][Vis: high] - ISO 8601 US date character format notation. No localized delimiter translation. Must be uppercase.'
  },
  INTL_DATE_FORMAT: {
    id: 'DateInputWrapper.dateFormatIntl',
    defaultMessage: 'DD/MM/YYYY',
    description: '[Type: label][Vis: high] - ISO 8601 International date character format notation. Must be uppercase.'
  }
});
function DateInputWrapper(props, ref) {
  // translates and defines the label dictionary
  var l10n = {
    dateInputLabel: t(COPY$a.DATE_LABEL),
    iconButton: t(COPY$a.DATE_BUTTON_LABEL),
    usDateFormat: t(COPY$a.US_DATE_FORMAT),
    intlDateFormat: t(COPY$a.INTL_DATE_FORMAT)
  };
  return React__default.createElement(DateInput$1, _objectSpread(_objectSpread({
    labels: l10n
  }, props), {}, {
    ref: ref
  }));
}
var DateInputWrapper$1 = forwardRef(DateInputWrapper);
var useStyles$A = createUseStyles(function (theme) {
  return {
    container: {
      display: 'flex'
    },
    verticalContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    horizontalContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      /**
       * including specific margin value to match production
       */
      marginRight: 35
    },
    label: {
      fontSize: '14px',
      fontWeight: theme.questionBody.fontWeight,
      fontFamily: theme.questionBody.fontFamily,
      width: '100%',
      display: 'block',
      marginBottom: '5px'
    },
    input: {
      /**
       * including specific height and width values to match production
       */
      maxWidth: '50px',
      maxHeight: '36px',
      textAlign: 'center'
    },
    separator: {
      width: '20px',
      height: '36px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    srOnly: _objectSpread({}, visuallyHidden)
  };
});
var defaultLabels = {
  timeLabel: 'Time',
  hour: 'Hour',
  minutes: 'Minutes',
  daytimeLabel: 'AM/PM',
  am: 'AM',
  pm: 'PM',
  hourPlaceholder: 'hh',
  minutesPlaceholder: 'mm'
};
function TimeInput(_ref94) {
  var onChange = _ref94.onChange,
    _ref94$defaultValue = _ref94.defaultValue,
    defaultValue = _ref94$defaultValue === void 0 ? {
      hour: '',
      minute: '',
      period: 'AM'
    } : _ref94$defaultValue,
    _ref94$id = _ref94.id,
    id = _ref94$id === void 0 ? uniqueId('TimeInput-') : _ref94$id,
    className = _ref94.className,
    required = _ref94.required,
    ariaDescribedBy = _ref94['aria-describedby'],
    _ref94$labels = _ref94.labels,
    labels = _ref94$labels === void 0 ? defaultLabels : _ref94$labels;
  var _useState31 = useState(defaultValue),
    _useState32 = _slicedToArray(_useState31, 2),
    state = _useState32[0],
    setState = _useState32[1];
  var timeLabelID = "".concat(id, "-time-label");
  var hourLabelID = "".concat(id, "-hour-label");
  var hourInputID = "".concat(id, "-hour-input");
  var minuteLabelID = "".concat(id, "-minute-label");
  var minuteInputID = "".concat(id, "-minute-input");
  var periodLabelID = "".concat(id, "-period-label");
  var periodSelectID = "".concat(id, "-period-input");
  var handleHourChange = function handleHourChange(e) {
    var newState = _objectSpread(_objectSpread({}, state), {}, {
      hour: e.target.value
    });
    // if hour is > 12, set daytime period to PM
    if (!Number.isNaN(parseInt(newState.hour, 10)) && parseInt(newState.hour, 10) > 12) {
      newState.period = 'PM';
    }
    if (!newState.period) {
      newState.period = 'AM';
    }
    setState(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var handleHourOnBlur = function handleHourOnBlur(e) {
    var newState = _objectSpread({}, state);
    // if hour is > 12, subtract 12 from the hour value to maintain 12 hour time
    if (!Number.isNaN(parseInt(e.target.value, 10)) && parseInt(e.target.value, 10) > 12) {
      newState.hour = String(parseInt(e.target.value, 10) - 12);
      setState(newState);
      onChange === null || onChange === void 0 ? void 0 : onChange(newState);
    }
  };
  var handleMinuteChange = function handleMinuteChange(e) {
    var newState = _objectSpread(_objectSpread({}, state), {}, {
      minute: e.target.value
    });
    setState(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var handleSelectChange = function handleSelectChange(e) {
    var newState = _objectSpread(_objectSpread({}, state), {}, {
      period: e.target.value
    });
    setState(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var _useStyles$A = useStyles$A(),
    container = _useStyles$A.container,
    verticalContainer = _useStyles$A.verticalContainer,
    horizontalContainer = _useStyles$A.horizontalContainer,
    input = _useStyles$A.input,
    label = _useStyles$A.label,
    separator = _useStyles$A.separator,
    srOnly = _useStyles$A.srOnly;
  return React__default.createElement("div", {
    className: classNames(container, className),
    id: id,
    "data-testid": "TimeInput"
  }, React__default.createElement("div", {
    className: verticalContainer
  }, React__default.createElement("label", {
    htmlFor: hourInputID,
    id: hourLabelID,
    "aria-labelledby": "".concat(timeLabelID, " ").concat(hourLabelID),
    className: srOnly
  }, labels.hour), React__default.createElement("div", {
    className: horizontalContainer
  }, React__default.createElement("div", {
    className: verticalContainer
  }, React__default.createElement("div", {
    className: label,
    id: timeLabelID
  }, labels.timeLabel), React__default.createElement(TextInput$1, {
    className: input,
    maxLength: 2,
    onChange: handleHourChange,
    onBlur: handleHourOnBlur,
    value: state.hour,
    placeholder: labels.hourPlaceholder,
    id: hourInputID,
    required: required,
    "aria-describedby": ariaDescribedBy
  })), React__default.createElement("span", {
    className: separator
  }, ":"), React__default.createElement("div", {
    className: verticalContainer
  }, React__default.createElement("label", {
    htmlFor: minuteInputID,
    id: minuteLabelID,
    "aria-labelledby": "".concat(timeLabelID, " ").concat(minuteLabelID),
    className: srOnly
  }, labels.minutes), React__default.createElement(TextInput$1, {
    className: input,
    maxLength: 2,
    onChange: handleMinuteChange,
    value: state.minute,
    placeholder: labels.minutesPlaceholder,
    id: minuteInputID,
    "aria-labelledby": "".concat(timeLabelID, " ").concat(minuteLabelID),
    required: required,
    "aria-describedby": ariaDescribedBy
  })))), React__default.createElement("div", {
    className: verticalContainer
  }, React__default.createElement("label", {
    id: periodLabelID,
    htmlFor: periodSelectID,
    className: label
  }, labels.daytimeLabel), React__default.createElement(NativeSelect, {
    id: periodSelectID,
    value: state.period,
    onChange: handleSelectChange,
    required: required
  }, React__default.createElement(SelectAnswerOption, {
    value: "AM",
    label: labels.am
  }), React__default.createElement(SelectAnswerOption, {
    value: "PM",
    label: labels.pm
  }))));
}
var COPY$9 = defineMessages({
  TIME_LABEL: {
    id: 'TimeInputWrapper.timeLabel',
    defaultMessage: 'Time',
    description: '[Type: label][Vis: high] - label for time input'
  },
  HOUR_LABEL: {
    id: 'TimeInputWrapper.hour',
    defaultMessage: 'Hour',
    description: '[Type: label][Vis: high] - label for hour input'
  },
  MINUTES_LABEL: {
    id: 'TimeInputWrapper.minutes',
    defaultMessage: 'Minutes',
    description: '[Type: label][Vis: high] - label for minutes input'
  },
  DAYTIME_LABEL: {
    id: 'TimeInputWrapper.daytimeLabel',
    defaultMessage: 'AM/PM',
    description: '[Type: label][Vis: high] - label for daytime AM/PM select'
  },
  AM: {
    id: 'TimeInputWrapper.am',
    defaultMessage: 'AM',
    description: '[Type: label][Vis: high] - label for ante meridiem'
  },
  PM: {
    id: 'TimeInputWrapper.pm',
    defaultMessage: 'PM',
    description: '[Type: label][Vis: high] - label for post meridiem'
  },
  HOUR_PLACEHOLDER: {
    id: 'TimeInputWrapper.hhPlaceholder',
    defaultMessage: 'hh',
    description: '[Type: placeholder][Vis: high] - placeholder text for hour input'
  },
  MINUTE_PLACEHOLDER: {
    id: 'TimeInputWrapper.mmPlaceholder',
    defaultMessage: 'mm',
    description: '[Type: placeholder][Vis: high] - placeholder text for minutes input'
  }
});
function TimeInputWrapper(props) {
  // translates and defines the label dictionary
  var l10n = {
    timeLabel: t(COPY$9.TIME_LABEL),
    hour: t(COPY$9.HOUR_LABEL),
    minutes: t(COPY$9.MINUTES_LABEL),
    daytimeLabel: t(COPY$9.DAYTIME_LABEL),
    am: t(COPY$9.AM),
    pm: t(COPY$9.PM),
    hourPlaceholder: t(COPY$9.HOUR_PLACEHOLDER),
    minutesPlaceholder: t(COPY$9.MINUTE_PLACEHOLDER)
  };
  return React__default.createElement(TimeInput, _objectSpread({
    labels: l10n
  }, props));
}
var useStyles$z = createUseStyles(function (theme) {
  var _theme$questionBody7 = theme.questionBody,
    fontSize = _theme$questionBody7.fontSize,
    fontFamily = _theme$questionBody7.fontFamily,
    fontWeight = _theme$questionBody7.fontWeight;
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: '7px',
      color: theme.answerColor
    },
    label: {
      fontSize: fontSize,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      color: theme.questionColor,
      marginBottom: '14px'
    },
    inputContainer: _defineProperty({
      display: 'flex',
      flexWrap: 'wrap',
      gap: '35px'
    }, "@media (max-width: ".concat(theme.breakpoints.sm.min, ")"), {
      flexDirection: 'column',
      gap: '5px'
    }),
    inlineErrorContainer: {
      padding: '10px 0',
      fontSize: '16px',
      fontWeight: theme.questionBody.fontWeight,
      fontFamily: theme.questionBody.fontFamily,
      '& ul': {
        padding: 0,
        margin: 0
      },
      '& ul li': {
        paddingBottom: '0.2rem',
        listStyle: 'none',
        '&:before': {
          content: '"*"',
          marginRight: '5px'
        }
      }
    }
  };
});
var COPY$8 = defineMessages({
  DATE_INTL_FORMAT_ERROR: {
    id: 'DateTime.formatErrorDateIntl',
    defaultMessage: 'Please provide date in DD/MM/YYYY format.',
    description: '[Type: label][Vis: high] - label for incorrect or missing date error (using ISO 8601 US date character format notation)'
  },
  DATE_US_FORMAT_ERROR: {
    id: 'DateTime.formatErrorDateUs',
    defaultMessage: 'Please provide date in MM/DD/YYYY format.',
    description: '[Type: label][Vis: high] - label for incorrect or missing date error (using ISO 8601 international date character format notation)'
  },
  ERROR_ENTER_HOURS: {
    id: 'DateTime.errorEnterHours',
    defaultMessage: 'Please enter hours from 0 to 12.',
    description: '[Type: label][Vis: high] - label for incorrect or missing hour input'
  },
  ERROR_ENTER_MINUTES: {
    id: 'DateTime.errorEnterMinutes',
    defaultMessage: 'Please enter minutes from 0 to 59.',
    description: '[Type: label][Vis: high] - label for incorrect or missing minute input'
  },
  ERROR_SELECT_PERIOD: {
    id: 'DateTime.errorSelectPeriod',
    defaultMessage: 'Please select AM/PM.',
    description: '[Type: label][Vis: high] - label for incorrect or missing period selection'
  }
});
function DateTime(_ref95) {
  var questionId = _ref95.id,
    required = _ref95.required,
    _ref95$choices = _ref95.choices,
    choices = _ref95$choices === void 0 ? [] : _ref95$choices,
    _ref95$responses = _ref95.responses,
    responses = _ref95$responses === void 0 ? [] : _ref95$responses,
    _ref95$showDate = _ref95.showDate,
    showDate = _ref95$showDate === void 0 ? true : _ref95$showDate,
    _ref95$showTime = _ref95.showTime,
    showTime = _ref95$showTime === void 0 ? true : _ref95$showTime,
    dateFormat = _ref95.dateFormat,
    onChange = _ref95.onChange,
    _ref95$inlineErrors = _ref95.inlineErrors,
    inlineErrors = _ref95$inlineErrors === void 0 ? [] : _ref95$inlineErrors,
    questionFieldProps = _objectWithoutProperties(_ref95, _excluded39);
  var _useState33 = useState(responses),
    _useState34 = _slicedToArray(_useState33, 2),
    responseValues = _useState34[0],
    setResponseValues = _useState34[1];
  var errorId = createErrorId(questionId);
  var dateInputRef = useRef(null);
  /** Translation keys may change so this separates the key from the message */
  var errorMessage = useMemo(function () {
    return {
      ERROR_PROVIDE_DATE_INTL_FORMAT: t(COPY$8.DATE_INTL_FORMAT_ERROR),
      ERROR_PROVIDE_DATE_US_FORMAT: t(COPY$8.DATE_US_FORMAT_ERROR),
      ERROR_ENTER_HOURS: t(COPY$8.ERROR_ENTER_HOURS),
      ERROR_ENTER_MINUTES: t(COPY$8.ERROR_ENTER_MINUTES),
      ERROR_SELECT_PERIOD: t(COPY$8.ERROR_SELECT_PERIOD)
    };
  }, []);
  var getDateValueById = function getDateValueById(id) {
    var choice = responseValues.find(function (item) {
      return item.id === id;
    });
    return choice === null || choice === void 0 ? void 0 : choice.value.date;
  };
  var getTimeValueById = function getTimeValueById(id) {
    var choice = responseValues.find(function (item) {
      return item.id === id;
    });
    return choice !== null && choice !== void 0 && choice.value ? {
      hour: choice === null || choice === void 0 ? void 0 : choice.value.hour,
      minute: choice === null || choice === void 0 ? void 0 : choice.value.minute,
      period: choice === null || choice === void 0 ? void 0 : choice.value.period
    } : undefined;
  };
  var handleDateOrTimeChange = function handleDateOrTimeChange(_ref96) {
    var _responseValues$find, _newResponse$value, _newResponse$value2, _newResponse$value3;
    var id = _ref96.id,
      date = _ref96.date,
      time = _ref96.time;
    var newState = responseValues.filter(function (r) {
      return r.id !== id;
    });
    var prevState = (_responseValues$find = responseValues.find(function (r) {
      return r.id === id;
    })) !== null && _responseValues$find !== void 0 ? _responseValues$find : {
      id: id,
      value: {
        date: '',
        hour: '',
        minute: '',
        period: 'AM'
      }
    };
    var newDateOrTime = time !== null && time !== void 0 ? time : {
      date: date
    };
    var newResponse = {
      id: id,
      value: _objectSpread(_objectSpread({}, prevState.value), newDateOrTime)
    };
    if ((_newResponse$value = newResponse.value) !== null && _newResponse$value !== void 0 && _newResponse$value.date || (_newResponse$value2 = newResponse.value) !== null && _newResponse$value2 !== void 0 && _newResponse$value2.hour || (_newResponse$value3 = newResponse.value) !== null && _newResponse$value3 !== void 0 && _newResponse$value3.minute) {
      newState.push(newResponse);
    }
    setResponseValues(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var _useStyles$z = useStyles$z(),
    container = _useStyles$z.container,
    label = _useStyles$z.label,
    inputContainer = _useStyles$z.inputContainer,
    inlineErrorContainer = _useStyles$z.inlineErrorContainer;
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    "data-testid": "DateTimeQuestionType"
  }, questionFieldProps), choices === null || choices === void 0 ? void 0 : choices.map(function (choice) {
    return React__default.createElement("div", {
      className: container,
      key: choice.id,
      id: choice.id
    }, React__default.createElement(RichText, {
      element: "div",
      text: choice.label,
      className: label
    }), React__default.createElement("div", {
      className: inputContainer
    }, showDate && React__default.createElement(DateInputWrapper$1, {
      ref: dateInputRef,
      onChange: function onChange(date) {
        return handleDateOrTimeChange({
          id: choice.id,
          date: date
        });
      },
      defaultValue: getDateValueById(choice.id),
      dateFormat: dateFormat,
      required: required,
      "aria-describedby": questionFieldProps.error && errorId || undefined
    }), showTime && React__default.createElement(TimeInputWrapper, {
      onChange: function onChange(time) {
        return handleDateOrTimeChange({
          id: choice.id,
          time: time
        });
      },
      defaultValue: getTimeValueById(choice.id),
      required: required
    })), inlineErrors.length > 0 && React__default.createElement("div", {
      className: inlineErrorContainer
    }, React__default.createElement("ul", null, inlineErrors.filter(function (e) {
      return e.fieldId === choice.id;
    }).map(function (error) {
      return React__default.createElement("li", {
        key: "".concat(error.fieldId, "-").concat(error.detail)
      }, errorMessage[error.detail]);
    }))));
  }));
}
var DateTime$1 = withErrorBoundary(DateTime);
var useStyles$y = createUseStyles(function (theme) {
  var _theme$questionBody8;
  var defaultFontSize = theme.fontSize.body;
  var _ref97 = (_theme$questionBody8 = theme.questionBody) !== null && _theme$questionBody8 !== void 0 ? _theme$questionBody8 : {},
    _ref97$fontFamily = _ref97.fontFamily,
    fontFamily = _ref97$fontFamily === void 0 ? 'inherit' : _ref97$fontFamily,
    _ref97$fontWeight = _ref97.fontWeight,
    fontWeight = _ref97$fontWeight === void 0 ? 'inherit' : _ref97$fontWeight,
    _ref97$fontStyle = _ref97.fontStyle,
    fontStyle = _ref97$fontStyle === void 0 ? 'inherit' : _ref97$fontStyle,
    _ref97$textDecoration = _ref97.textDecoration,
    textDecoration = _ref97$textDecoration === void 0 ? 'inherit' : _ref97$textDecoration,
    _ref97$highlightColor = _ref97.highlightColor,
    highlightColor = _ref97$highlightColor === void 0 ? 'inherit' : _ref97$highlightColor,
    _ref97$color = _ref97.color,
    color = _ref97$color === void 0 ? 'inherit' : _ref97$color;
  return {
    otherStyles: {
      marginTop: '5px',
      display: 'block'
    },
    hiddenInput: {
      display: 'none'
    },
    commentChoice: {
      marginTop: 10
    },
    label: {
      display: 'block',
      marginTop: '10px',
      position: 'relative',
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontStyle: fontStyle,
      textDecoration: textDecoration,
      highlightColor: highlightColor,
      color: color,
      fontSize: defaultFontSize
    }
  };
});

/**
 * MultipleChoice Question Type (Tier 2)
 */
function Dropdown(_ref98) {
  var questionId = _ref98.id,
    disabled = _ref98.disabled,
    _required = _ref98.required,
    _readOnly = _ref98.readOnly,
    _ref98$choices = _ref98.choices,
    choices = _ref98$choices === void 0 ? [] : _ref98$choices,
    choiceOther = _ref98.choiceOther,
    choiceComment = _ref98.choiceComment,
    _ref98$responses = _ref98.responses,
    defaultResponses = _ref98$responses === void 0 ? [] : _ref98$responses,
    onChange = _ref98.onChange,
    fieldProps = _objectWithoutProperties(_ref98, _excluded40);
  var errorId = createErrorId(questionId);
  /** Filter choices that exist and are visible  */
  var _useQuestionChoices2 = useQuestionChoices([].concat(_toConsumableArray(choices), [choiceOther, choiceComment])),
    options = _useQuestionChoices2.options,
    sortableOptions = _useQuestionChoices2.sortableOptions,
    otherOption = _useQuestionChoices2.otherOption,
    commentOption = _useQuestionChoices2.commentOption;
  var _useState35 = useState(defaultResponses),
    _useState36 = _slicedToArray(_useState35, 2),
    responseValue = _useState36[0],
    setResponseValue = _useState36[1];
  var _useStyles$y = useStyles$y(),
    otherStyles = _useStyles$y.otherStyles,
    hiddenInput = _useStyles$y.hiddenInput,
    commentChoice = _useStyles$y.commentChoice;
  /**
   * Default value by id
   * used for text-input based choices
   */
  var getDefaultValueById = function getDefaultValueById(id) {
    var defaultChoice = defaultResponses.find(function (c) {
      return c.id === id;
    });
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  /**
   * Default value for the choices
   */
  var defaultValue = useMemo(function () {
    var _defaultResponses$fin3;
    return (_defaultResponses$fin3 = defaultResponses.find(function (c) {
      return c.type !== 'COMMENT';
    })) === null || _defaultResponses$fin3 === void 0 ? void 0 : _defaultResponses$fin3.id;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /**
   * Other Answer Textfield state
   */
  var _useState37 = useState(otherOption && getDefaultValueById(otherOption.id) || ''),
    _useState38 = _slicedToArray(_useState37, 2),
    otherText = _useState38[0],
    setOtherText = _useState38[1];
  var handleSelectChange = function handleSelectChange(e) {
    var choiceData = options.find(function (c) {
      return c.id === e.target.value;
    });
    var responses = responseValue.filter(function (c) {
      return c.type === 'COMMENT';
    });
    if (choiceData) {
      var id = choiceData.id,
        type = choiceData.type;
      if (type === 'ANSWER') {
        /** Want to update the value with the value of the TextField texts, when otherAnswer is selected */
        responses.push({
          id: id,
          type: type,
          value: otherText
        });
      } else {
        responses.push({
          id: id,
          type: type,
          value: e.target.value
        });
      }
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  /**
   * Other Answer Textfield Change
   */
  var handleTextChange = function handleTextChange(e) {
    var choiceData = options.find(function (c) {
      return c.type === 'ANSWER';
    });
    var responses = responseValue.filter(function (c) {
      return c.type === 'COMMENT';
    });
    if (choiceData) {
      var id = choiceData.id,
        type = choiceData.type;
      responses.push({
        id: id,
        type: type,
        value: e.target.value
      });
      setOtherText(e.target.value);
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var handleCommentChange = function handleCommentChange(e) {
    var choiceData = options.find(function (c) {
      return c.id === e.target.id;
    });
    var responses = responseValue.filter(function (c) {
      return c.type !== 'COMMENT';
    });
    if (choiceData && !!e.target.value) {
      var id = choiceData.id,
        type = choiceData.type;
      responses.push({
        id: id,
        type: type,
        value: e.target.value
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var isOtherAnswerSelected = !!responseValue.find(function (c) {
    return c.type === 'ANSWER';
  });
  var multipleTextLines = otherOption && (otherOption === null || otherOption === void 0 ? void 0 : otherOption.linesCount) > 1;
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId,
    "data-testid": "DropdownQuestionType"
  }, fieldProps), React__default.createElement(NativeSelect, {
    defaultValue: defaultValue,
    disabled: disabled,
    onChange: handleSelectChange
  }, React__default.createElement(SelectAnswerOption, {
    value: undefined
  }), " ", sortableOptions === null || sortableOptions === void 0 ? void 0 : sortableOptions.map(function (choice) {
    return React__default.createElement(SelectAnswerOption, {
      key: choice.id,
      id: choice.id,
      label: choice.label,
      value: choice.id
    });
  }), otherOption && React__default.createElement(SelectAnswerOption, {
    key: otherOption.id,
    id: otherOption.id,
    label: otherOption.label,
    value: otherOption.id
  })), otherOption && (multipleTextLines ? React__default.createElement(TextArea$1, {
    defaultValue: getDefaultValueById(otherOption.id),
    autoFocus: false,
    rows: otherOption.linesCount,
    cols: otherOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    onChange: handleTextChange,
    className: classNames(otherStyles, _defineProperty({}, hiddenInput, !isOtherAnswerSelected)),
    tabIndex: isOtherAnswerSelected ? 0 : -1
  }) : React__default.createElement(TextInput$1, {
    defaultValue: getDefaultValueById(otherOption.id),
    autoFocus: false,
    autoHeight: true,
    size: otherOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    onChange: handleTextChange,
    className: classNames(otherStyles, _defineProperty({}, hiddenInput, !isOtherAnswerSelected)),
    tabIndex: isOtherAnswerSelected ? 0 : -1
  })), commentOption && React__default.createElement(CommentChoice, {
    id: commentOption.id,
    label: commentOption.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(commentOption.id),
    lineCount: commentOption.linesCount,
    charCount: commentOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    "aria-describedby": fieldProps.error && errorId,
    className: commentChoice
  }));
}
var Dropdown$1 = withErrorBoundary(Dropdown);
var useStyles$x = createUseStyles(function (theme) {
  return {
    imageChoice: {
      display: 'flex',
      position: 'relative'
    },
    labelContainer: function labelContainer(_ref99) {
      var _theme$questionBody$h;
      var checked = _ref99.checked,
        disabled = _ref99.disabled;
      var borderColor = disabled && !checked ? 'transparent' : theme.primaryAccentColor;
      return _objectSpread(_objectSpread({
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        cursor: 'pointer',
        width: '100%',
        border: [1, 'solid', checked ? theme.questionColor : (_theme$questionBody$h = theme.questionBody.highlightColor) !== null && _theme$questionBody$h !== void 0 ? _theme$questionBody$h : 'rgb(208, 210, 211)'],
        borderRadius: 2,
        backgroundColor: checked ? theme.input.bgColor : 'inherit'
      }, theme.questionBody), {}, {
        '&:hover': {
          border: [1, 'solid', borderColor]
        },
        '&:focus-within': {
          border: [1, 'solid', borderColor]
        }
      });
    },
    controlImage: {
      position: 'absolute',
      right: '-1',
      top: '-1',
      width: '26px',
      height: '26px',
      transitionDuration: '0.3s',
      border: 'none',
      borderRadius: 2,
      zIndex: 10,
      transform: function transform(_ref100) {
        var checked = _ref100.checked;
        return checked ? 'scale(1)' : 'scale(0)';
      }
    },
    optionLabel: function optionLabel(_ref101) {
      var _theme$questionBody$h2;
      var checked = _ref101.checked;
      return {
        padding: '9px 7px',
        width: '100%',
        wordWrap: 'break-word',
        fontWeight: checked ? 'bold' : 'normal',
        '&:focus-within': {
          background: (_theme$questionBody$h2 = theme.questionBody.highlightColor) !== null && _theme$questionBody$h2 !== void 0 ? _theme$questionBody$h2 : 'rgb(208, 210, 211)'
        }
      };
    },
    imageContainer: {
      paddingTop: '75%',
      width: '100%',
      position: 'relative',
      '& > img': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain'
      }
    },
    inputContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      backgroundColor: '#EFEFEF'
    }
  };
});
var useStyles$w = createUseStyles(function (theme) {
  return {
    imageInput: function imageInput(_ref102) {
      var checked = _ref102.checked,
        disabled = _ref102.disabled,
        readOnly = _ref102.readOnly;
      var checkBgColor = checked ? theme.questionColor : 'transparent';
      var backgroundColor = disabled || readOnly ? '#aaa' : checkBgColor;
      return {
        color: disabled || readOnly ? '#aaa' : theme.input.activeColor,
        border: 'none',
        borderRadius: 4,
        backgroundColor: backgroundColor,
        '& .checkmark': {
          fill: contrastColor(theme.input.activeColor)
        },
        '& input': {
          cursor: 'pointer'
        }
      };
    }
  };
});
function ImageInput(_ref103, ref) {
  var className = _ref103.className,
    type = _ref103.type,
    props = _objectWithoutProperties(_ref103, _excluded41);
  var _useInputStyles5 = useInputStyles(props),
    inputProps = _useInputStyles5.inputProps,
    styleProps = _useInputStyles5.styleProps;
  var _useStyles$w = useStyles$w(styleProps),
    imageInput = _useStyles$w.imageInput;
  return React__default.createElement(BaseInput$1, _objectSpread({
    ref: ref,
    type: type,
    className: classNames(imageInput, className),
    icon: React__default.createElement(CheckboxIcon$1, null)
  }, inputProps));
}
var ImageInput$1 = React__default.forwardRef(ImageInput);
function ImageChoice$2(_ref104, ref) {
  var id = _ref104.id,
    type = _ref104.type,
    _ref104$alt = _ref104.alt,
    alt = _ref104$alt === void 0 ? '' : _ref104$alt,
    label = _ref104.label,
    imageSrc = _ref104.src,
    className = _ref104.className,
    checked = _ref104.checked,
    name = _ref104.name,
    onChange = _ref104.onChange,
    onKeyDown = _ref104.onKeyDown,
    onClick = _ref104.onClick,
    disabledProp = _ref104.disabled,
    ariaDisabledProp = _ref104['aria-disabled'],
    readOnlyProp = _ref104.readOnly,
    ariaReadOnlyProp = _ref104['aria-readonly'],
    inputProps = _objectWithoutProperties(_ref104, _excluded42);
  var handleChange = function handleChange(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: e.target.id,
      checked: e.target.checked,
      value: e.target.value
    });
  };
  var handleClick = function handleClick(e) {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
    if (e.isDefaultPrevented()) {
      return;
    }
    var target = e.target;
    var checkVal = true;
    if (!inputProps.required && checked) {
      checkVal = false;
    }
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: target.id,
      checked: checkVal,
      value: target.value
    });
  };
  var handleKeyboard = function handleKeyboard(e) {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    if (e.isDefaultPrevented()) {
      return;
    }
    var target = e.target;
    if (!inputProps.required && checked && e.code === 'Space') {
      e.preventDefault();
      onChange === null || onChange === void 0 ? void 0 : onChange({
        id: target.id,
        checked: false,
        value: target.value
      });
    }
  };
  var disabled = disabledProp || ariaDisabledProp === 'true';
  var readOnly = readOnlyProp || ariaReadOnlyProp === 'true';
  var _useStyles$x = useStyles$x({
      disabled: disabled,
      readOnly: readOnly,
      checked: checked
    }),
    imageChoice = _useStyles$x.imageChoice,
    controlImage = _useStyles$x.controlImage,
    inputContainer = _useStyles$x.inputContainer,
    labelContainer = _useStyles$x.labelContainer,
    optionLabel = _useStyles$x.optionLabel,
    imageContainer = _useStyles$x.imageContainer;
  var imageId = "".concat(id, "-image");
  var labelId = "".concat(id, "-label");
  var ariaDescribeId = alt ? imageId : undefined;
  var imageInputEvents = type === 'radio' ? {
    onClick: handleClick,
    onKeyDown: handleKeyboard,
    onChange: handleChange
  } : {
    onChange: handleChange
  };
  return React__default.createElement("div", {
    className: imageChoice
  }, React__default.createElement("label", {
    htmlFor: id,
    className: classNames(labelContainer, className),
    tabIndex: -1
  }, React__default.createElement("div", {
    className: inputContainer
  }, React__default.createElement(ImageInput$1, _objectSpread(_objectSpread({
    "aria-labelledby": labelId,
    "aria-describedby": ariaDescribeId,
    ref: ref,
    checked: checked,
    className: controlImage,
    id: id,
    type: type,
    value: id,
    name: name
  }, inputProps), imageInputEvents)), React__default.createElement("div", {
    className: imageContainer
  }, React__default.createElement("img", {
    id: imageId,
    src: imageSrc,
    alt: alt
  }))), label && React__default.createElement("span", {
    id: labelId,
    className: optionLabel
  }, label)));
}
var ImageChoiceOption = forwardRef(ImageChoice$2);
var useStyles$v = createUseStyles(function (theme) {
  var _theme$breakpoints4, _theme$breakpoints5, _theme$breakpoints6, _imageChoiceContainer;
  var isFull = theme.layout.includes('CENTER') || theme.layout.includes('BANNER');
  var isThird = theme.layout.includes('THIRD');
  var isHalf = theme.layout.includes('HALF') || theme.layout.includes('FULL') && !theme.layout.includes('CENTER');
  var cols3 = 'repeat(3, minmax(0, 1fr))';
  var cols2 = 'repeat(2, minmax(0, 1fr))';
  var cols1 = 'minmax(0, 1fr)';
  return {
    imageChoiceContainer: (_imageChoiceContainer = {
      display: 'grid',
      flexWrap: 'wrap',
      gap: '25px',
      width: '100%',
      gridTemplateColumns: 'minmax(0, 1fr)'
    }, _defineProperty(_imageChoiceContainer, "@media (min-width: ".concat((_theme$breakpoints4 = theme.breakpoints) === null || _theme$breakpoints4 === void 0 ? void 0 : _theme$breakpoints4.md.min, ")"), {
      gridTemplateColumns: isFull || isThird ? cols2 : cols1
    }), _defineProperty(_imageChoiceContainer, "@media (min-width: ".concat((_theme$breakpoints5 = theme.breakpoints) === null || _theme$breakpoints5 === void 0 ? void 0 : _theme$breakpoints5.lg.min, ")"), {
      gridTemplateColumns: function gridTemplateColumns() {
        if (isFull || isThird) {
          return cols3;
        }
        if (isHalf) {
          return cols2;
        }
        return cols1;
      }
    }), _defineProperty(_imageChoiceContainer, "@media (min-width: ".concat((_theme$breakpoints6 = theme.breakpoints) === null || _theme$breakpoints6 === void 0 ? void 0 : _theme$breakpoints6.xl.min, ")"), {
      gridTemplateColumns: isHalf ? cols2 : cols3
    }), _imageChoiceContainer),
    imageChoice: {
      width: '100%'
    },
    noneOfTheAboveContainer: {
      marginTop: '15px'
    }
  };
});
var INPUT_SIZE$1 = 20;
function ImageChoice(_ref105) {
  var questionId = _ref105.id,
    readOnly = _ref105.readOnly,
    required = _ref105.required,
    disabled = _ref105.disabled,
    _ref105$multiple = _ref105.multiple,
    multiple = _ref105$multiple === void 0 ? false : _ref105$multiple,
    _ref105$choices = _ref105.choices,
    choices = _ref105$choices === void 0 ? [] : _ref105$choices,
    choiceNoneOfTheAbove = _ref105.choiceNoneOfTheAbove,
    onChange = _ref105.onChange,
    _ref105$responses = _ref105.responses,
    responses = _ref105$responses === void 0 ? [] : _ref105$responses,
    questionFieldProps = _objectWithoutProperties(_ref105, _excluded43);
  var imageChoiceType = multiple ? 'checkbox' : 'radio';
  var groupName = !multiple ? "".concat(questionId, "-imageChoice") : undefined;
  var errorId = createErrorId(questionId);
  var _useState39 = useState(responses),
    _useState40 = _slicedToArray(_useState39, 2),
    selectedChoices = _useState40[0],
    setSelectedChoices = _useState40[1];
  var handleChange = function handleChange(e) {
    var newState = !multiple ? [] : selectedChoices.filter(function (c) {
      return c.id !== e.id && c.type !== 'NOTA';
    });
    if (e.checked) {
      newState.push({
        id: e.id,
        value: e.value
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var handleNAChange = function handleNAChange(e) {
    var newState = [];
    if (e.checked) {
      newState.push({
        id: e.id,
        value: e.value,
        type: 'NOTA'
      });
    }
    setSelectedChoices(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var isChecked = function isChecked(id) {
    return !!selectedChoices.find(function (item) {
      return item.id === id;
    });
  };
  var _useStyles$v = useStyles$v(),
    imageChoiceContainer = _useStyles$v.imageChoiceContainer,
    imageChoice = _useStyles$v.imageChoice,
    noneOfTheAboveContainer = _useStyles$v.noneOfTheAboveContainer;
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    "data-testid": "ImageChoiceQuestionType",
    errorId: errorId
  }, questionFieldProps), React__default.createElement("div", {
    className: imageChoiceContainer
  }, choices === null || choices === void 0 ? void 0 : choices.map(function (choice) {
    return React__default.createElement(ImageChoiceOption, {
      key: choice.id,
      id: choice.id,
      disabled: disabled,
      required: required,
      readOnly: readOnly,
      label: choice.label,
      onChange: handleChange,
      className: imageChoice,
      value: choice.id,
      src: choice.image.url,
      alt: choice.image.altText || '',
      name: groupName,
      type: imageChoiceType,
      "aria-describedby": questionFieldProps.error && errorId || undefined,
      checked: isChecked(choice.id)
    });
  })), choiceNoneOfTheAbove && (choiceNoneOfTheAbove === null || choiceNoneOfTheAbove === void 0 ? void 0 : choiceNoneOfTheAbove.visible) && React__default.createElement("div", {
    className: noneOfTheAboveContainer
  }, React__default.createElement(Checkbox$3, {
    id: choiceNoneOfTheAbove.id,
    value: choiceNoneOfTheAbove.id,
    onChange: handleNAChange,
    checked: isChecked(choiceNoneOfTheAbove.id),
    disabled: disabled,
    readOnly: readOnly,
    "aria-describedby": questionFieldProps.error && errorId || undefined,
    inputSize: INPUT_SIZE$1
  }, choiceNoneOfTheAbove.label)));
}
var ImageChoice$1 = withErrorBoundary(ImageChoice);
var useStyles$u = createUseStyles({
  imageStyles: {
    maxWidth: '100%',
    display: 'block'
  }
});
function Image(_ref106) {
  var _ref106$alt = _ref106.alt,
    alt = _ref106$alt === void 0 ? '' : _ref106$alt,
    className = _ref106.className,
    props = _objectWithoutProperties(_ref106, _excluded44);
  var _useStyles$u = useStyles$u(),
    imageStyles = _useStyles$u.imageStyles;
  return React__default.createElement("img", _objectSpread({
    className: classNames(imageStyles, className),
    "data-testid": "image",
    alt: alt
  }, props));
}
var useStyles$t = createUseStyles(function (theme) {
  var _theme$questionTitle$, _theme$questionTitle$2, _theme$questionTitle$3, _theme$questionTitle$4;
  return {
    presentationalTitleStyles: {
      fontFamily: (_theme$questionTitle$ = theme.questionTitle.fontFamily) !== null && _theme$questionTitle$ !== void 0 ? _theme$questionTitle$ : 'inherit',
      fontSize: (_theme$questionTitle$2 = theme.questionTitle.fontSize) !== null && _theme$questionTitle$2 !== void 0 ? _theme$questionTitle$2 : '16px',
      fontWeight: (_theme$questionTitle$3 = theme.questionTitle.fontWeight) !== null && _theme$questionTitle$3 !== void 0 ? _theme$questionTitle$3 : theme.isAccessible ? 500 : 300,
      marginBottom: '24px',
      textDecoration: (_theme$questionTitle$4 = theme.questionTitle.textDecoration) !== null && _theme$questionTitle$4 !== void 0 ? _theme$questionTitle$4 : 'inherit'
    },
    buttonStyles: {
      marginTop: '20px'
    }
  };
});
function ImagePresentational(_ref107) {
  var text = _ref107.text,
    image = _ref107.image,
    _ref107$padding = _ref107.padding,
    padding = _ref107$padding === void 0 ? {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    } : _ref107$padding,
    id = _ref107.id,
    _ref107$okButton = _ref107.okButton,
    okButton = _ref107$okButton === void 0 ? {
      visible: false
    } : _ref107$okButton;
  var richTextId = "text-presentational-header-".concat(id);
  var _useStyles$t = useStyles$t(),
    presentationalTitleStyles = _useStyles$t.presentationalTitleStyles,
    buttonStyles = _useStyles$t.buttonStyles;
  var showButton = okButton.visible,
    buttonProps = _objectWithoutProperties(okButton, _excluded45);
  return React__default.createElement(QuestionSpacing, {
    padding: padding,
    "data-testid": "ImagePresentational"
  }, text && React__default.createElement(RichText, {
    id: richTextId,
    element: "div",
    text: text,
    className: presentationalTitleStyles
  }), React__default.createElement(Image, _objectSpread({}, image)), showButton && React__default.createElement(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
    className: buttonStyles
  })));
}
var ImagePresentational$1 = withErrorBoundary(ImagePresentational);
var useStyles$s = createUseStyles(function (theme) {
  var _textInput2;
  return {
    radioInput: {
      '& label': {
        alignItems: 'baseline'
      }
    },
    labelContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    textInput: (_textInput2 = {
      opacity: function opacity(_ref108) {
        var checked = _ref108.checked;
        return checked ? 1 : 0.5;
      },
      cursor: function cursor(_ref109) {
        var checked = _ref109.checked;
        return checked ? 'inherit' : 'pointer';
      },
      marginTop: 5,
      marginLeft: 32,
      maxWidth: 'calc(100% - 32px)'
    }, _defineProperty(_textInput2, "@media (max-width: ".concat(theme.breakpoints.xxs.max, ")"), {
      marginLeft: 0,
      maxWidth: '100%'
    }), _defineProperty(_textInput2, "fontSize", theme.questionBody.fontSize), _defineProperty(_textInput2, "lineHeight", 'normal'), _textInput2),
    checkHover: {
      '&:hover': {
        outline: 'none'
      }
    }
  };
});
function RadioTextfield(_ref110) {
  var refs = _ref110.refs,
    props = _objectWithoutProperties(_ref110, _excluded46);
  var id = props.id,
    label = props.children,
    _props$checked2 = props.checked,
    checkedProp = _props$checked2 === void 0 ? false : _props$checked2,
    valueProp = props.value,
    defaultValue = props.defaultValue,
    _props$lineCount = props.lineCount,
    lineCount = _props$lineCount === void 0 ? 1 : _props$lineCount,
    _props$charCount = props.charCount,
    charCount = _props$charCount === void 0 ? 50 : _props$charCount,
    maxLength = props.maxLength,
    onClick = props.onClick,
    onChange = props.onChange,
    radioProps = _objectWithoutProperties(props, _excluded47);
  var radioGroup = useRadioGroup();
  var _useState41 = useState(checkedProp),
    _useState42 = _slicedToArray(_useState41, 2),
    checked = _useState42[0],
    setChecked = _useState42[1];
  var _useState43 = useState(defaultValue || valueProp),
    _useState44 = _slicedToArray(_useState43, 2),
    value = _useState44[0],
    setValue = _useState44[1];
  var radioInputRef = useRef(null);
  var radioRef = useForkRef(radioInputRef, refs === null || refs === void 0 ? void 0 : refs.radio);
  var textInputRef = useRef(null);
  var inputRef = useForkRef(textInputRef, refs === null || refs === void 0 ? void 0 : refs.text);
  var multipleTextLines = lineCount > 1;
  var handleValueChange = function handleValueChange(e) {
    radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.onChange(e);
    setValue(e.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };
  var handleInputChange = function handleInputChange(e) {
    handleValueChange({
      id: id,
      value: e.target.value,
      checked: checked
    });
  };
  var handleFocusChange = function handleFocusChange(e) {
    handleValueChange({
      id: id,
      value: e.target.value,
      checked: checked
    });
  };
  var handleClick = function handleClick(e) {
    /**
     * Selection via keyboard calls onClick event - check for
     * mouse-position to ensure we were called by a pointing device.
     */
    if (!checked && e.clientX !== 0 && e.clientY !== 0) {
      var _textInputRef$current;
      textInputRef === null || textInputRef === void 0 ? void 0 : (_textInputRef$current = textInputRef.current) === null || _textInputRef$current === void 0 ? void 0 : _textInputRef$current.focus();
    }
    setChecked(true);
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  useEffect(function () {
    setChecked(checkedProp);
  }, [checkedProp]);
  useEffect(function () {
    if ((radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.value) !== value) {
      setChecked(false);
    }
  }, [radioGroup, value]);
  var _useStyles$s = useStyles$s({
      checked: checked
    }),
    radioInput = _useStyles$s.radioInput,
    textInput = _useStyles$s.textInput,
    checkHover = _useStyles$s.checkHover;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Radio$1, _objectSpread({
    id: "radio-input-".concat(id),
    checked: checked,
    value: value,
    onClick: handleClick,
    onChange: handleValueChange,
    className: radioInput,
    ref: radioRef
  }, radioProps), label), multipleTextLines ? React__default.createElement(TextArea$1, {
    id: "radio-field-".concat(id),
    defaultValue: defaultValue,
    autoFocus: false,
    rows: lineCount,
    cols: charCount,
    maxLength: maxLength,
    onClick: handleClick,
    onChange: handleInputChange,
    onBlur: handleFocusChange,
    onFocus: handleFocusChange,
    className: classNames(textInput, _defineProperty({}, checkHover, !checked)),
    ref: inputRef,
    tabIndex: checked ? 0 : -1
  }) : React__default.createElement(TextInput$1, {
    id: "radio-field-".concat(id),
    defaultValue: defaultValue,
    autoFocus: false,
    autoHeight: true,
    size: charCount,
    maxLength: maxLength,
    onClick: handleClick,
    onChange: handleInputChange,
    onBlur: handleFocusChange,
    onFocus: handleFocusChange,
    className: classNames(textInput, _defineProperty({}, checkHover, !checked)),
    ref: inputRef,
    tabIndex: checked ? 0 : -1
  }));
}
var useStyles$r = createUseStyles({
  commentChoiceContainer: {
    marginTop: '10px'
  }
});
var INPUT_SIZE = 20;
/**
 * MultipleChoice Question Type (Tier 2)
 */
function MultipleChoice(_ref111) {
  var questionId = _ref111.id,
    required = _ref111.required,
    disabled = _ref111.disabled,
    readOnly = _ref111.readOnly,
    _ref111$columnLayout = _ref111.columnLayout,
    columnLayout = _ref111$columnLayout === void 0 ? 1 : _ref111$columnLayout,
    _ref111$choices = _ref111.choices,
    choices = _ref111$choices === void 0 ? [] : _ref111$choices,
    choiceNoneOfTheAbove = _ref111.choiceNoneOfTheAbove,
    choiceOther = _ref111.choiceOther,
    choiceComment = _ref111.choiceComment,
    _ref111$responses = _ref111.responses,
    defaultResponses = _ref111$responses === void 0 ? [] : _ref111$responses,
    onChange = _ref111.onChange,
    fieldProps = _objectWithoutProperties(_ref111, _excluded48);
  var groupId = createFieldId(questionId);
  var errorId = createErrorId(questionId);
  /** Filter choices that exist and are visible  */
  var _useQuestionChoices3 = useQuestionChoices([].concat(_toConsumableArray(choices), [choiceNoneOfTheAbove, choiceOther, choiceComment])),
    options = _useQuestionChoices3.options,
    sortableOptions = _useQuestionChoices3.sortableOptions,
    notaOption = _useQuestionChoices3.notaOption,
    otherOption = _useQuestionChoices3.otherOption,
    commentOption = _useQuestionChoices3.commentOption;
  var _useState45 = useState(defaultResponses),
    _useState46 = _slicedToArray(_useState45, 2),
    responseValue = _useState46[0],
    setResponseValue = _useState46[1];
  /**
   * Default value by id
   * used for text-input based choices
   */
  var getDefaultValueById = function getDefaultValueById(id) {
    var defaultChoice = defaultResponses.find(function (c) {
      return c.id === id;
    });
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  /**
   * Default value for the group
   */
  var defaultValue = useMemo(function () {
    var _defaultResponses$fin4;
    return (_defaultResponses$fin4 = defaultResponses.find(function (c) {
      return c.type !== 'COMMENT';
    })) === null || _defaultResponses$fin4 === void 0 ? void 0 : _defaultResponses$fin4.value;
  },
  // defaultValues should not be changed post render (breaks rules of controlled components)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  /**
   * Determine if choice is selected
   * @return TRUE if the choice.id exists in responses
   */
  var isChecked = function isChecked(id) {
    return !!responseValue.find(function (c) {
      return c.id === id;
    });
  };
  var handleRadioChange = function handleRadioChange(e) {
    var choiceData = options.find(function (c) {
      return e.id.match(c.id);
    });
    var responses = responseValue.filter(function (c) {
      return c.type === 'COMMENT';
    });
    if (choiceData) {
      var id = choiceData.id,
        type = choiceData.type;
      responses.push({
        id: id,
        type: type,
        value: e.value
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var handleCommentChange = function handleCommentChange(e) {
    var choiceData = options.find(function (c) {
      return c.id === e.target.id;
    });
    var responses = responseValue.filter(function (c) {
      return c.type !== 'COMMENT';
    });
    if (choiceData && !!e.target.value) {
      var id = choiceData.id,
        type = choiceData.type;
      responses.push({
        id: id,
        type: type,
        value: e.target.value
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  /**
   * deselect choice if the question is not required
   */
  var unCheckOption = function unCheckOption() {
    if (required) {
      return;
    }
    var responses = responseValue.filter(function (c) {
      return c.type === 'COMMENT';
    });
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var handleClick = function handleClick(e) {
    // match is used since RadioTextfield applies a prefix
    // to maintain unique ID's'
    var input = e.target;
    var isSelected = responseValue.find(function (c) {
      return input.id.match(c.id);
    });
    if (isSelected && input.checked) {
      e.preventDefault();
      unCheckOption();
    }
  };
  var handleKeyboard = function handleKeyboard(e) {
    var isSelected = responseValue.find(function (c) {
      return e.target.id.match(c.id);
    });
    if (isSelected && e.code === 'Space') {
      e.preventDefault();
      unCheckOption();
    }
  };
  var radioEvents = {
    onClick: handleClick,
    onKeyDown: handleKeyboard
  };
  var radioGroupProps = {
    disabled: disabled,
    readOnly: readOnly,
    name: groupId,
    defaultValue: defaultValue,
    onChange: handleRadioChange
  };
  var _useStyles$r = useStyles$r(),
    commentChoiceContainer = _useStyles$r.commentChoiceContainer;
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId,
    "data-testid": "MultipleChoiceQuestionType"
  }, fieldProps), React__default.createElement(RadioGroup, _objectSpread({}, radioGroupProps), React__default.createElement(QuestionAnswerLayoutTemplate, {
    gridCellMargin: [0, 2, 5, 2],
    otherCellMargin: [0, 2, 5, 2],
    columns: columnLayout,
    other: otherOption && React__default.createElement(RadioTextfield, _objectSpread({
      id: otherOption.id,
      checked: isChecked(otherOption.id),
      defaultValue: getDefaultValueById(otherOption.id),
      lineCount: otherOption.linesCount,
      charCount: otherOption.charsCount,
      maxLength: TEXT_INPUT_MAX_CHARS,
      "aria-describedby": fieldProps.error && errorId,
      inputSize: INPUT_SIZE
    }, radioEvents), otherOption.label),
    noneOfTheAbove: notaOption && React__default.createElement(Radio$1, _objectSpread({
      id: notaOption.id,
      value: notaOption.id,
      checked: isChecked(notaOption.id),
      "aria-describedby": fieldProps.error && errorId,
      inputSize: INPUT_SIZE
    }, radioEvents), notaOption.label)
  }, sortableOptions.map(function (choice) {
    return React__default.createElement(Radio$1, _objectSpread({
      id: choice.id,
      key: choice.id,
      value: choice.id,
      checked: isChecked(choice.id),
      "aria-describedby": fieldProps.error && errorId,
      inputSize: INPUT_SIZE
    }, radioEvents), choice.label);
  })), commentOption && React__default.createElement(CommentChoice, {
    id: commentOption.id,
    label: commentOption.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(commentOption.id),
    lineCount: commentOption.linesCount,
    charCount: commentOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    "aria-describedby": fieldProps.error && errorId,
    className: commentChoiceContainer
  })));
}
var useStyles$q = createUseStyles(function (theme) {
  var _theme$questionBody9 = theme.questionBody,
    fontSize = _theme$questionBody9.fontSize,
    fontFamily = _theme$questionBody9.fontFamily,
    fontWeight = _theme$questionBody9.fontWeight;
  return {
    container: _defineProperty({
      display: 'flex',
      flexDirection: 'row',
      wordBreak: 'break-word',
      marginBottom: '7px'
    }, "@media (max-width: ".concat(theme.breakpoints.sm.min, ")"), {
      flexWrap: 'wrap'
    }),
    label: _defineProperty({
      fontSize: fontSize,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      color: theme.questionColor,
      flex: '0 0 20%',
      marginRight: '7px'
    }, "@media (max-width: ".concat(theme.breakpoints.sm.min, ")"), {
      flex: '0 0 100%',
      margin: '0 2px 2px 0'
    }),
    input: {
      marginTop: 'auto',
      flex: 'auto'
    }
  };
});
function MultipleTextbox(_ref112) {
  var questionId = _ref112.id,
    _req = _ref112.required,
    disabled = _ref112.disabled,
    readOnly = _ref112.readOnly,
    _ref112$choices = _ref112.choices,
    choices = _ref112$choices === void 0 ? [] : _ref112$choices,
    _ref112$responses = _ref112.responses,
    responses = _ref112$responses === void 0 ? [] : _ref112$responses,
    onChange = _ref112.onChange,
    size = _ref112.size,
    fieldProps = _objectWithoutProperties(_ref112, _excluded49);
  var _useState47 = useState(responses),
    _useState48 = _slicedToArray(_useState47, 2),
    responseValues = _useState48[0],
    setResponseValues = _useState48[1];
  var error = fieldProps.error,
    _fieldProps$errorId2 = fieldProps.errorId,
    errorId = _fieldProps$errorId2 === void 0 ? createErrorId(questionId) : _fieldProps$errorId2;
  var getDefaultValueById = function getDefaultValueById(id) {
    var defaultChoice = responseValues.find(function (item) {
      return item.id === id;
    });
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  var handleChange = function handleChange(e) {
    var newState = responseValues.filter(function (response) {
      return response.id !== e.target.id;
    });
    if (e.target.value) {
      var newResponse = {
        id: e.target.id,
        value: e.target.value
      };
      newState.push(newResponse);
    }
    setResponseValues(newState);
    onChange === null || onChange === void 0 ? void 0 : onChange(newState);
  };
  var _useStyles$q = useStyles$q(),
    container = _useStyles$q.container,
    label = _useStyles$q.label,
    input = _useStyles$q.input;
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId,
    "data-testid": "MultipleTextbox"
  }, fieldProps), choices === null || choices === void 0 ? void 0 : choices.map(function (choice) {
    var labelId = "".concat(choice.id, "-label");
    return React__default.createElement("div", {
      className: container,
      key: choice.id
    }, React__default.createElement("label", {
      className: label,
      id: labelId,
      htmlFor: choice.id
    }, React__default.createElement(RichText, {
      element: "span",
      text: choice.label
    })), React__default.createElement(TextInput$1, {
      id: choice.id,
      defaultValue: getDefaultValueById(choice.id),
      disabled: disabled,
      readOnly: readOnly,
      size: size,
      onChange: handleChange,
      "aria-invalid": !!error,
      "aria-describedby": error && errorId,
      maxLength: TEXT_INPUT_MAX_CHARS,
      className: input
    }));
  }));
}
var useStyles$p = createUseStyles(function (theme) {
  var fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
  return {
    npsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minWidth: 230
    },
    npsLabel: {
      color: theme.questionColor,
      fontFamily: theme.questionBody.fontFamily,
      fontSize: 14,
      fontWeight: fontWeightOptions.light,
      lineHeight: 1.25
    },
    npsRatingButtonList: {
      margin: 0,
      padding: 0,
      display: 'inline-flex',
      listStyleType: 'none',
      border: [1, 'solid', theme.primaryAccentColor],
      borderRadius: 4,
      overflow: 'hidden',
      outline: [2, 'solid', 'transparent'],
      outlineOffset: 2,
      width: '100%'
    },
    npsRatingButton: function npsRatingButton(_ref113) {
      var isRTL = _ref113.isRTL;
      return {
        padding: 0,
        minWidth: 20,
        flex: '1 1 9.09%',
        '& + $npsRatingButton': {
          borderLeft: isRTL ? 0 : [2, 'solid', theme.primaryAccentColor],
          borderRight: isRTL ? [2, 'solid', theme.primaryAccentColor] : 0
        }
      };
    },
    minLabel: function minLabel(_ref114) {
      var isRTL = _ref114.isRTL;
      return {
        margin: isRTL ? [0, 4, 2, 0] : [0, 0, 2, 4]
      };
    },
    maxLabel: function maxLabel(_ref115) {
      var isRTL = _ref115.isRTL;
      return {
        margin: isRTL ? [0, 0, 2, 4] : [0, 4, 2, 0]
      };
    },
    srOnly: visuallyHidden$1
  };
});
var useStyles$o = createUseStyles(function (theme) {
  // theme.correctAnswerHighlightColor is the correct color, but not an accurate token.
  var focusBackgroundColor = theme.correctAnswerHighlightColor;
  return {
    container: {
      position: 'relative',
      display: 'flex',
      cursor: 'pointer'
    },
    radio: {
      appearance: 'none',
      outline: 'none',
      position: 'absolute',
      width: '100%',
      height: '100%',
      '&:focus + $label, &:hover + $label': {
        border: [2, 'solid', theme.primaryAccentColor],
        backgroundColor: focusBackgroundColor
      },
      '&:checked + $label': {
        backgroundColor: theme.questionColor,
        color: theme.primaryBackgroundColor,
        fontWeight: 'bold',
        transition: 'background 200ms ease'
      }
    },
    label: {
      position: 'relative',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      border: [2, 'solid', 'transparent'],
      backgroundColor: theme.primaryBackgroundColor,
      color: theme.questionColor,
      fontFamily: theme.fontFamily,
      fontSize: 15,
      fontWeight: 700,
      padding: [10, 0],
      width: '100%'
    }
  };
});
function NpsRatingButton(_ref116) {
  var id = _ref116.id,
    className = _ref116.className,
    label = _ref116.children,
    _ref116$component = _ref116.component,
    Tag = _ref116$component === void 0 ? 'div' : _ref116$component,
    props = _objectWithoutProperties(_ref116, _excluded50);
  var styles = useStyles$o();
  return React__default.createElement(Tag, {
    className: classNames(styles.container, className)
  }, React__default.createElement("input", _objectSpread({
    id: id,
    type: "radio",
    className: styles.radio
  }, props)), React__default.createElement("label", {
    className: classNames(styles.label),
    htmlFor: id
  }, label));
}
var COPY$7 = defineMessages({
  NPS_QUESTION_TITLE: {
    id: 'Nps.QUESTION_TITLE',
    defaultMessage: '<div class="{srOnlyClass}">On a scale of {minValue} to {maxValue}, </div>{heading}<div id="{instructionsId}" class="{srOnlyClass}"> {minValue} for {minLabelText}, {maxValue} for {maxLabelText}</div>',
    description: '[Type: header][Vis: high] - question title'
  }
});
/** Unicode dash characters, in addition to standard delimiters (forward/back-slash, pipe, hyphen) */
var LABEL_SEPERATOR = /\s(?:[\u2010-\u2015\u2043/\-|])\s/gi;
function Nps(_ref117) {
  var _choices$0$label, _choices$, _choices$slice$0$labe, _choices$slice$;
  var questionId = _ref117.id,
    _ref117$choices = _ref117.choices,
    choices = _ref117$choices === void 0 ? [] : _ref117$choices,
    className = _ref117.className,
    title = _ref117.title,
    rowId = _ref117.rowId,
    _ref117$responses = _ref117.responses,
    defaultResponses = _ref117$responses === void 0 ? [] : _ref117$responses,
    required = _ref117.required,
    onChange = _ref117.onChange,
    fieldProps = _objectWithoutProperties(_ref117, _excluded51);
  var _useState49 = useState(defaultResponses),
    _useState50 = _slicedToArray(_useState49, 2),
    responseValue = _useState50[0],
    setResponseValue = _useState50[1];
  var defaultValue = useMemo(function () {
    var _defaultResponses$fin5, _defaultResponses$fin6;
    return (_defaultResponses$fin5 = (_defaultResponses$fin6 = defaultResponses.find(function (r) {
      return !!r.value;
    })) === null || _defaultResponses$fin6 === void 0 ? void 0 : _defaultResponses$fin6.value) !== null && _defaultResponses$fin5 !== void 0 ? _defaultResponses$fin5 : '';
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var ratingChanged = function ratingChanged(e) {
    var value = e.target.value;
    var response = value ? [{
      id: rowId,
      value: value
    }] : [];
    /**
     * FIXES: RAWR-1628
     * Safari doesn't apply focus by default; an inelegant solution for an inelegant browser.
     * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#clicking_and_focus
     */
    e.target.focus();
    setResponseValue(response);
    onChange === null || onChange === void 0 ? void 0 : onChange(response);
  };
  var unCheckOption = function unCheckOption(input) {
    if (required) {
      return;
    }
    // eslint-disable-next-line no-param-reassign
    input.checked = false;
    setResponseValue([]);
    onChange === null || onChange === void 0 ? void 0 : onChange([]);
  };
  var buttonClicked = function buttonClicked(e) {
    var _responseValue$;
    var input = e.target;
    var isSelected = ((_responseValue$ = responseValue[0]) === null || _responseValue$ === void 0 ? void 0 : _responseValue$.value) === input.value;
    if (isSelected && input.checked) {
      unCheckOption(input);
    }
  };
  var handleKeyboard = function handleKeyboard(e) {
    var _responseValue$2;
    var input = e.target;
    var isSelected = ((_responseValue$2 = responseValue[0]) === null || _responseValue$2 === void 0 ? void 0 : _responseValue$2.value) === input.value;
    if (isSelected && e.code === 'Space') {
      e.preventDefault();
      unCheckOption(input);
    }
  };
  var getLabel = function getLabel(str) {
    var parts = str.split(LABEL_SEPERATOR);
    // the direction of the label is not always written reverse,
    // and is not based on RTL. (i.e. Russian)
    if (Number.isNaN(Number(parts[0]))) {
      parts = parts.reverse();
    }
    var _parts = parts,
      _parts2 = _slicedToArray(_parts, 2),
      numLabel = _parts2[0],
      textLabel = _parts2[1];
    return [numLabel, textLabel !== null && textLabel !== void 0 ? textLabel : numLabel];
  };
  var _useContext4 = useContext(L10NContext),
    isRTL = _useContext4.isRTL;
  var errorId = createErrorId(questionId);
  var _useStyles$p = useStyles$p({
      isRTL: isRTL
    }),
    npsContainer = _useStyles$p.npsContainer,
    npsLabel = _useStyles$p.npsLabel,
    minLabel = _useStyles$p.minLabel,
    maxLabel = _useStyles$p.maxLabel,
    srOnly = _useStyles$p.srOnly,
    npsRatingButtonList = _useStyles$p.npsRatingButtonList,
    npsRatingButton = _useStyles$p.npsRatingButton;
  var heading = title.heading;
  var minFullLabel = (_choices$0$label = (_choices$ = choices[0]) === null || _choices$ === void 0 ? void 0 : _choices$.label) !== null && _choices$0$label !== void 0 ? _choices$0$label : '';
  var maxFullLabel = (_choices$slice$0$labe = (_choices$slice$ = choices.slice(-1)[0]) === null || _choices$slice$ === void 0 ? void 0 : _choices$slice$.label) !== null && _choices$slice$0$labe !== void 0 ? _choices$slice$0$labe : '';
  var _getLabel = getLabel(minFullLabel),
    _getLabel2 = _slicedToArray(_getLabel, 2),
    minValue = _getLabel2[0],
    minLabelText = _getLabel2[1];
  var _getLabel3 = getLabel(maxFullLabel),
    _getLabel4 = _slicedToArray(_getLabel3, 2),
    maxValue = _getLabel4[0],
    maxLabelText = _getLabel4[1];
  var instructionsId = "".concat(questionId, "-instructions");
  var accessibleHeading = t(COPY$7.NPS_QUESTION_TITLE, {
    minValue: minValue,
    maxValue: maxValue,
    minLabelText: minLabelText,
    maxLabelText: maxLabelText,
    heading: heading,
    instructionsId: instructionsId,
    srOnlyClass: classNames(srOnly)
  });
  var accessibleTitle = _objectSpread(_objectSpread({}, title), {}, {
    heading: accessibleHeading
  });
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId,
    "data-testid": "NpsQuestionType",
    title: accessibleTitle
  }, fieldProps), React__default.createElement("div", {
    className: classNames(npsContainer, className)
  }, React__default.createElement("span", {
    className: classNames(npsLabel, minLabel),
    role: "presentation"
  }, minLabelText), React__default.createElement("span", {
    className: classNames(npsLabel, maxLabel),
    role: "presentation"
  }, maxLabelText), React__default.createElement("div", {
    className: classNames(npsRatingButtonList)
  }, choices.map(function (c) {
    return React__default.createElement(NpsRatingButton, {
      id: "".concat(questionId, "-").concat(c.id),
      key: "".concat(questionId, "-").concat(c.id),
      name: "".concat(questionId, "-rating"),
      value: c.id,
      className: classNames(npsRatingButton),
      onChange: ratingChanged,
      onClick: buttonClicked,
      onKeyDown: handleKeyboard,
      defaultChecked: defaultValue === c.id
    }, getLabel(c.label)[0]);
  }))));
}
var useStyles$n = createUseStyles(function (theme) {
  var _theme$breakpoints7;
  return {
    gridCell: {
      display: 'flex',
      flex: '1 auto',
      position: 'relative',
      padding: 3
    },
    gridCellMobile: _defineProperty({}, "@media (max-width: ".concat((_theme$breakpoints7 = theme.breakpoints) === null || _theme$breakpoints7 === void 0 ? void 0 : _theme$breakpoints7.xs.max, ")"), {
      justifyContent: 'flex-start',
      background: theme.correctAnswerHighlightColor,
      marginTop: '5px',
      marginBottom: '5px'
    })
  };
});
function GridCell(_ref118) {
  var isGridWhenMobile = _ref118.isGridWhenMobile,
    children = _ref118.children,
    props = _objectWithoutProperties(_ref118, _excluded52);
  var _useStyles$n = useStyles$n(),
    gridCell = _useStyles$n.gridCell,
    gridCellMobile = _useStyles$n.gridCellMobile;
  return React__default.createElement("div", _objectSpread({
    className: classNames(gridCell, _defineProperty({}, gridCellMobile, !isGridWhenMobile)),
    role: "gridcell"
  }, props), children);
}
var useStyles$m = createUseStyles(function (theme) {
  var _theme$questionBody$f7, _theme$questionBody$f8, _theme$questionBody$f9, _theme$breakpoints8, _theme$breakpoints9, _labelVisibleBase, _theme$breakpoints10, _theme$breakpoints11, _theme$breakpoints12;
  return {
    labelVisibleBase: (_labelVisibleBase = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      textAlign: 'left',
      padding: [3, 3, 3, 7],
      fontWeight: (_theme$questionBody$f7 = theme.questionBody.fontWeight) !== null && _theme$questionBody$f7 !== void 0 ? _theme$questionBody$f7 : null,
      fontFamily: (_theme$questionBody$f8 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f8 !== void 0 ? _theme$questionBody$f8 : null,
      fontSize: (_theme$questionBody$f9 = theme.questionBody.fontSize) !== null && _theme$questionBody$f9 !== void 0 ? _theme$questionBody$f9 : null,
      width: 150
    }, _defineProperty(_labelVisibleBase, "@media (max-width: ".concat((_theme$breakpoints8 = theme.breakpoints) === null || _theme$breakpoints8 === void 0 ? void 0 : _theme$breakpoints8.sm.max, ")"), {
      width: 100
    }), _defineProperty(_labelVisibleBase, "@media (max-width: ".concat((_theme$breakpoints9 = theme.breakpoints) === null || _theme$breakpoints9 === void 0 ? void 0 : _theme$breakpoints9.xs.max, ")"), {
      width: 75
    }), _labelVisibleBase),
    labelVisibleMobile: _defineProperty({}, "@media (max-width: ".concat((_theme$breakpoints10 = theme.breakpoints) === null || _theme$breakpoints10 === void 0 ? void 0 : _theme$breakpoints10.xs.max, ")"), {
      width: '100%'
    }),
    labelHidden: {
      display: 'none'
    },
    rowBaseStyles: _defineProperty({
      display: 'flex',
      width: '100%',
      color: theme.answerColor,
      border: 'none',
      background: theme.correctAnswerHighlightColor
    }, "@media (max-width: ".concat((_theme$breakpoints11 = theme.breakpoints) === null || _theme$breakpoints11 === void 0 ? void 0 : _theme$breakpoints11.xs.max, ")"), {
      marginTop: '5px',
      marginBottom: '5px'
    }),
    rowAsColumnStyles: _defineProperty({}, "@media (max-width: ".concat((_theme$breakpoints12 = theme.breakpoints) === null || _theme$breakpoints12 === void 0 ? void 0 : _theme$breakpoints12.xs.max, ")"), {
      flexDirection: 'column'
    })
  };
});
function GridRow(_ref119) {
  var rowId = _ref119.id,
    rowIndex = _ref119.row,
    label = _ref119.label,
    columnDataArray = _ref119.columnDataArray,
    hideLabel = _ref119.hideLabel,
    className = _ref119.className,
    gridComponent = _ref119.gridComponent,
    isGridWhenMobile = _ref119.isGridWhenMobile;
  var _useStyles$m = useStyles$m(),
    rowBaseStyles = _useStyles$m.rowBaseStyles,
    rowAsColumnStyles = _useStyles$m.rowAsColumnStyles,
    labelHidden = _useStyles$m.labelHidden,
    labelVisibleBase = _useStyles$m.labelVisibleBase,
    labelVisibleMobile = _useStyles$m.labelVisibleMobile;
  var labelVisibleClass = isGridWhenMobile ? labelVisibleBase : classNames(labelVisibleBase, labelVisibleMobile);
  var labelClass = hideLabel ? labelHidden : labelVisibleClass;
  return React__default.createElement("div", {
    id: rowId,
    role: "row",
    className: classNames(rowBaseStyles, className, _defineProperty({}, rowAsColumnStyles, !isGridWhenMobile))
  }, React__default.createElement("div", {
    id: "".concat(rowId, "-header"),
    role: "rowheader",
    className: labelClass
  }, React__default.createElement(RichText, {
    element: "span",
    text: label
  })), columnDataArray.map(function (_ref120, colIndex) {
    var colId = _ref120.id;
    var cellId = "".concat(rowId, "-").concat(colId, "-cell");
    var props = {
      rowId: rowId,
      rowIndex: rowIndex,
      colId: colId,
      colIndex: colIndex,
      label: label,
      'aria-labelledby': "".concat(rowId, "-header ").concat(colId, "-header")
    };
    return React__default.createElement(GridCell, {
      id: cellId,
      key: cellId,
      "data-row": rowIndex,
      "data-col": colIndex,
      isGridWhenMobile: isGridWhenMobile
    }, gridComponent === null || gridComponent === void 0 ? void 0 : gridComponent(_objectSpread({}, props)));
  }));
}
var useStyles$l = createUseStyles(function (theme) {
  var _theme$breakpoints13, _theme$breakpoints14, _theme$breakpoints15, _theme$questionBody$f10, _theme$questionBody$f11, _theme$breakpoints16, _theme$breakpoints17, _bufferVisible;
  return {
    gridContainer: {
      width: '100%',
      // grid keeps the grid rows all the same length, and therefore the grid columns in alignment
      display: 'grid'
    },
    gridStyles: {
      display: 'flex',
      flexWrap: 'wrap',
      color: theme.answerColor,
      border: 'none'
    },
    stripeBasic: {
      '& [role="row"]:nth-child(even)': {
        background: 'transparent'
      }
    },
    stripeBasicMobile: _defineProperty({}, "@media (max-width: ".concat((_theme$breakpoints13 = theme.breakpoints) === null || _theme$breakpoints13 === void 0 ? void 0 : _theme$breakpoints13.xs.max, ")"), {
      '& [role="row"]': {
        background: 'transparent'
      }
    }),
    stripeOther: {
      '& [role="row"]': {
        background: 'transparent',
        width: '100%',
        '& [data-other]': {
          textAlign: 'left'
        }
      },
      // alternating elements 2 at a time (1+2, 5+6, 9+10) with n starting at 0
      '& [role="row"]:nth-child(4n+1), & [role="row"]:nth-child(4n+2)': {
        background: theme.correctAnswerHighlightColor
      }
    },
    stripeOtherMobile: _defineProperty({}, "@media (max-width: ".concat((_theme$breakpoints14 = theme.breakpoints) === null || _theme$breakpoints14 === void 0 ? void 0 : _theme$breakpoints14.xs.max, ")"), {
      '& [role="row"]:nth-child(4n+1), & [role="row"]:nth-child(4n+2)': {
        background: 'transparent'
      }
    }),
    columnContainerBase: {
      display: 'flex',
      width: '100%'
    },
    columnContainerMobile: _defineProperty({}, "@media (max-width: ".concat((_theme$breakpoints15 = theme.breakpoints) === null || _theme$breakpoints15 === void 0 ? void 0 : _theme$breakpoints15.xs.max, ")"), {
      display: 'none'
    }),
    columnHeader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      flex: 1,
      padding: 3,
      color: theme.answerColor,
      fontWeight: (_theme$questionBody$f10 = theme.questionBody.fontWeight) !== null && _theme$questionBody$f10 !== void 0 ? _theme$questionBody$f10 : null,
      fontFamily: (_theme$questionBody$f11 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f11 !== void 0 ? _theme$questionBody$f11 : null,
      fontSize: 14,
      textAlign: 'center'
    },
    bufferVisible: (_bufferVisible = {
      width: 150
    }, _defineProperty(_bufferVisible, "@media (max-width: ".concat((_theme$breakpoints16 = theme.breakpoints) === null || _theme$breakpoints16 === void 0 ? void 0 : _theme$breakpoints16.sm.max, ")"), {
      width: 100
    }), _defineProperty(_bufferVisible, "@media (max-width: ".concat((_theme$breakpoints17 = theme.breakpoints) === null || _theme$breakpoints17 === void 0 ? void 0 : _theme$breakpoints17.xs.max, ")"), {
      width: 75
    }), _bufferVisible),
    bufferHidden: {
      display: 'none'
    },
    scrollContainer: {
      overflowX: 'auto'
    }
  };
});
function MatrixGrid(_ref121) {
  var id = _ref121.id,
    className = _ref121.className,
    rowDataArray = _ref121.rowDataArray,
    columnDataArray = _ref121.columnDataArray,
    commentColumnOtherOption = _ref121.commentColumnOtherOption,
    hideLabel = _ref121.hideLabel,
    gridComponent = _ref121.gridComponent,
    commentColumnComponent = _ref121.commentColumnComponent,
    isGridWhenMobile = _ref121.isGridWhenMobile;
  var gridRef = useRef(null);
  /**
   * @note This is specific to MatrixRating, logic should be moved there and favour
   * composition over configuration
   */
  /** If true "other" inputs are rendered per-row  */
  var hasCommentColumnOther = (commentColumnOtherOption === null || commentColumnOtherOption === void 0 ? void 0 : commentColumnOtherOption.type) === 'COMMENT_COLUMN' && commentColumnComponent;
  var computedRows;
  if (hasCommentColumnOther) {
    // fill rows with artificial rows for the other column options
    computedRows = rowDataArray.reduce(function (acc, row) {
      return [].concat(_toConsumableArray(acc), [row, _objectSpread(_objectSpread({}, row), {}, {
        id: "".concat(row.id, "-other"),
        associatedId: row.id,
        isOtherRow: true
      })]);
    }, []);
  } else {
    computedRows = rowDataArray;
  }
  var _useStyles$l = useStyles$l(),
    gridStyles = _useStyles$l.gridStyles,
    columnContainerBase = _useStyles$l.columnContainerBase,
    columnContainerMobile = _useStyles$l.columnContainerMobile,
    columnHeader = _useStyles$l.columnHeader,
    bufferHidden = _useStyles$l.bufferHidden,
    bufferVisible = _useStyles$l.bufferVisible,
    stripeBasic = _useStyles$l.stripeBasic,
    stripeBasicMobile = _useStyles$l.stripeBasicMobile,
    stripeOther = _useStyles$l.stripeOther,
    stripeOtherMobile = _useStyles$l.stripeOtherMobile,
    gridContainer = _useStyles$l.gridContainer,
    scrollContainer = _useStyles$l.scrollContainer;
  var columnCount = columnDataArray.length;
  var stripeOtherClass = isGridWhenMobile ? stripeOther : classNames(stripeOther, stripeOtherMobile);
  var stripeBasicClass = isGridWhenMobile ? stripeBasic : classNames(stripeBasic, stripeBasicMobile);
  var renderStripe = commentColumnOtherOption ? stripeOtherClass : stripeBasicClass;
  var bufferClass = hideLabel ? bufferHidden : bufferVisible;
  return React__default.createElement("div", {
    className: scrollContainer
  }, React__default.createElement("div", {
    id: id,
    role: "grid",
    ref: gridRef,
    className: gridContainer
  }, React__default.createElement("div", {
    role: "rowgroup",
    className: "ghead"
  }, React__default.createElement("div", {
    role: "row",
    className: classNames(columnContainerBase, _defineProperty({}, columnContainerMobile, !isGridWhenMobile))
  }, React__default.createElement("div", {
    role: "gridcell",
    className: bufferClass
  }), columnDataArray.map(function (column) {
    return React__default.createElement("div", {
      id: "".concat(column.id, "-header"),
      role: "columnheader",
      key: column.id,
      className: columnHeader
    }, React__default.createElement(RichText, {
      element: "span",
      text: column.label
    }));
  }))), React__default.createElement("div", {
    role: "rowgroup",
    className: classNames('gbody', gridStyles, renderStripe, className)
  }, computedRows.map(function (row, rowIndex) {
    return !row.isOtherRow ? React__default.createElement(GridRow, {
      id: row.id,
      hideLabel: hideLabel,
      key: row.id,
      row: rowIndex,
      label: row.label,
      columnDataArray: columnDataArray,
      gridComponent: gridComponent,
      isGridWhenMobile: isGridWhenMobile
    }) : React__default.createElement("div", {
      role: "row",
      "data-other": true,
      key: row.id
    }, React__default.createElement(GridCell, {
      id: "".concat(rowIndex, "-").concat(columnCount + 1, "-cell"),
      "data-row": rowIndex,
      "data-col": columnCount + 1,
      colSpan: columnCount + 1,
      isGridWhenMobile: isGridWhenMobile
    }, commentColumnComponent === null || commentColumnComponent === void 0 ? void 0 : commentColumnComponent({
      commentColumnOtherOption: commentColumnOtherOption,
      row: row,
      columnCount: columnCount
    })));
  }))));
}
var useStyles$k = createUseStyles({
  cellInputWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  }
});
var UNSELECTED_OPTION = 'unselectedOption';
var COPY$6 = defineMessages({
  SELECT_AN_OPTION: {
    id: 'MatrixDropdown.EmptyTopNativeSelect',
    defaultMessage: 'Select an option',
    description: 'Label for screen readers when the top/default selection is empty'
  }
});
function MatrixDropdown(_ref122) {
  var questionId = _ref122.id,
    _ref122$choices = _ref122.choices,
    rows = _ref122$choices === void 0 ? [] : _ref122$choices,
    _ref122$columnChoices = _ref122.columnChoices,
    columns = _ref122$columnChoices === void 0 ? [] : _ref122$columnChoices,
    choiceComment = _ref122.choiceComment,
    onChange = _ref122.onChange,
    _ref122$responses = _ref122.responses,
    defaultResponses = _ref122$responses === void 0 ? [] : _ref122$responses,
    _disabled = _ref122.disabled,
    _ro = _ref122.readOnly,
    _req = _ref122.required,
    questionFieldProps = _objectWithoutProperties(_ref122, _excluded53);
  var errorId = createErrorId(questionId);
  /** Filter choices that exist and are visible  */
  var _useQuestionChoices4 = useQuestionChoices([].concat(_toConsumableArray(rows), [choiceComment])),
    options = _useQuestionChoices4.options,
    sortableRows = _useQuestionChoices4.sortableOptions,
    commentOption = _useQuestionChoices4.commentOption;
  var _useState51 = useState(defaultResponses),
    _useState52 = _slicedToArray(_useState51, 2),
    responseValue = _useState52[0],
    setResponseValue = _useState52[1];
  /**
   * Default value by id
   * used for text-input based choices (i.e. choiceComment)
   * Matrix provides a 2D Array construct
   */
  var getDefaultValueById = function getDefaultValueById(id) {
    var _defaultChoice$value$;
    var defaultChoice = defaultResponses.find(function (c) {
      return c.id === id;
    });
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : (_defaultChoice$value$ = defaultChoice.value[0]) === null || _defaultChoice$value$ === void 0 ? void 0 : _defaultChoice$value$.value;
  };
  var handleChange = function handleChange(e, gridCell) {
    var rowId = gridCell.rowId,
      colId = gridCell.colId;
    var storedValuesForGrid = responseValue.filter(function (r) {
      return !(r.id === rowId);
    });
    var rowDataContainingChange = responseValue.find(function (r) {
      return r.id === rowId;
    }) || {
      id: rowId,
      value: []
    };
    var prevCellsForChangedRow = rowDataContainingChange.value.filter(function (cell) {
      return cell.id !== colId;
    });
    var newCellData = {
      id: colId,
      value: e.target.value
    };
    // remove old data for the changed cell
    var newCellsForChangedRow = prevCellsForChangedRow.filter(function (cell) {
      return cell.id !== colId;
    });
    if (newCellData.value !== UNSELECTED_OPTION) {
      newCellsForChangedRow.push(newCellData);
    }
    // add the new row if at least one cell has a value other than UNSELECTED_OPTION
    var newRowForGrid = newCellsForChangedRow.length > 0 ? [_objectSpread(_objectSpread({}, rowDataContainingChange), {}, {
      value: newCellsForChangedRow
    })] : [];
    var responses = [].concat(_toConsumableArray(storedValuesForGrid), newRowForGrid);
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var handleCommentChange = function handleCommentChange(e) {
    var choiceData = options.find(function (c) {
      return c.id === e.target.id;
    });
    var responses = responseValue.filter(function (c) {
      return c.type !== 'COMMENT';
    });
    if (choiceData && !!e.target.value) {
      var id = choiceData.id,
        type = choiceData.type;
      var response = {
        id: id,
        type: type,
        value: e.target.value
      };
      // @note: ensure to loop the values when transforming in RespWeb
      responses.push({
        id: id,
        type: type,
        value: [response]
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  /**
   * Default value for the choices
   */
  var getDefaultValue = function getDefaultValue(rowId, colId) {
    var _defaultResponses$fin7, _defaultResponses$fin8, _defaultResponses$fin9;
    return (_defaultResponses$fin7 = defaultResponses.find(function (c) {
      return c.id === rowId;
    })) === null || _defaultResponses$fin7 === void 0 ? void 0 : (_defaultResponses$fin8 = _defaultResponses$fin7.value) === null || _defaultResponses$fin8 === void 0 ? void 0 : (_defaultResponses$fin9 = _defaultResponses$fin8.find(function (c) {
      return c.id === colId;
    })) === null || _defaultResponses$fin9 === void 0 ? void 0 : _defaultResponses$fin9.value;
  };
  var _useStyles$k = useStyles$k(),
    cellInputWrapper = _useStyles$k.cellInputWrapper;
  var selectAnOptionWithDashes = "-- ".concat(t(COPY$6.SELECT_AN_OPTION), " --");
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    "data-testid": "MatrixDropdownQuestionType",
    errorId: errorId
  }, questionFieldProps), React__default.createElement(MatrixGrid, {
    id: questionId,
    columnDataArray: columns,
    rowDataArray: sortableRows,
    isGridWhenMobile: true,
    // eslint-disable-next-line react/no-unstable-nested-components
    gridComponent: function gridComponent(gridCell) {
      var colId = gridCell.colId;
      return React__default.createElement("div", {
        className: cellInputWrapper
      }, React__default.createElement(NativeSelect, {
        onChange: function onChange(e) {
          return handleChange(e, gridCell);
        },
        defaultValue: getDefaultValue(gridCell.rowId, gridCell.colId),
        "aria-labelledby": gridCell['aria-labelledby']
      }, React__default.createElement(SelectAnswerOption, {
        value: UNSELECTED_OPTION,
        label: selectAnOptionWithDashes
      }),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      columns.find(function (col) {
        return col.id === colId;
      }).choices.map(function (choice) {
        return React__default.createElement(SelectAnswerOption, {
          key: choice.id,
          id: choice.id,
          label: choice.label,
          value: choice.id
        });
      })));
    }
  }), commentOption && React__default.createElement(CommentChoice, {
    id: commentOption.id,
    label: commentOption.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(commentOption.id),
    lineCount: commentOption.linesCount,
    charCount: commentOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS
  }));
}
var useStyles$j = createUseStyles(function (theme) {
  var _theme$breakpoints18, _theme$breakpoints19;
  return _defineProperty({
    cellInputWrapperBase: function cellInputWrapperBase(_ref123) {
      var checked = _ref123.checked;
      return {
        display: 'flex',
        width: '100%',
        border: [1, 'solid', checked ? theme.questionColor : 'transparent'],
        '&:hover': {
          border: [1, checked ? 'solid' : 'dashed', theme.questionColor]
        },
        backgroundColor: checked ? theme.input.bgColor : 'transparent',
        '&:focus-within': {
          backgroundColor: theme.input.bgColor
        },
        padding: 5,
        borderRadius: 4,
        cursor: 'pointer'
      };
    },
    cellInputCenterOnly: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    cellInputLeftWhenMobile: _defineProperty({
      justifyContent: 'center',
      alignItems: 'center'
    }, "@media (max-width: ".concat((_theme$breakpoints18 = theme.breakpoints) === null || _theme$breakpoints18 === void 0 ? void 0 : _theme$breakpoints18.xs.max, ")"), {
      justifyContent: 'flex-start',
      alignItems: 'flex-start'
    }),
    labelForMobileView: function labelForMobileView(_ref124) {
      var _theme$questionBody$f12, _theme$questionBody$f13, _theme$questionBody$f14;
      var checked = _ref124.checked;
      return {
        marginLeft: 10,
        marginBottom: 2,
        fontWeight: checked ? 'bold' : (_theme$questionBody$f12 = theme.questionBody.fontWeight) !== null && _theme$questionBody$f12 !== void 0 ? _theme$questionBody$f12 : null,
        fontFamily: (_theme$questionBody$f13 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f13 !== void 0 ? _theme$questionBody$f13 : null,
        fontSize: (_theme$questionBody$f14 = theme.questionBody.fontSize) !== null && _theme$questionBody$f14 !== void 0 ? _theme$questionBody$f14 : null
      };
    }
  }, "@media (min-width: ".concat((_theme$breakpoints19 = theme.breakpoints) === null || _theme$breakpoints19 === void 0 ? void 0 : _theme$breakpoints19.sm.min, ")"), {
    labelForMobileView: {
      display: 'none'
    }
  });
});
function RatingInput(_ref126) {
  var _columnChoices$find;
  var questionId = _ref126.qid,
    gridCell = _ref126.gridCell,
    _ref126$checked = _ref126.checked,
    checked = _ref126$checked === void 0 ? false : _ref126$checked,
    _ref126$isMultipleSel = _ref126.isMultipleSelectionsPerRow,
    isMultipleSelectionsPerRow = _ref126$isMultipleSel === void 0 ? false : _ref126$isMultipleSel,
    className = _ref126.className,
    onChange = _ref126.onChange,
    columnChoices = _ref126.columnChoices,
    _ref126$isGridWhenMob = _ref126.isGridWhenMobile,
    isGridWhenMobile = _ref126$isGridWhenMob === void 0 ? false : _ref126$isGridWhenMob,
    props = _objectWithoutProperties(_ref126, _excluded54);
  var _ref127 = gridCell || {},
    _ref127$rowId = _ref127.rowId,
    rowId = _ref127$rowId === void 0 ? '' : _ref127$rowId,
    _ref127$colId = _ref127.colId,
    colId = _ref127$colId === void 0 ? '' : _ref127$colId,
    ariaLabelledBy = _ref127['aria-labelledby'];
  var CheckboxOrRadio = isMultipleSelectionsPerRow ? CheckboxInput$1 : RadioInput$1;
  var inputId = "".concat(questionId, "-").concat(rowId, "-").concat(colId);
  var handleInputChange = function handleInputChange(e) {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: rowId,
      value: e.target.value,
      checked: e.target.checked
    });
  };
  var _useStyles$j = useStyles$j({
      checked: checked
    }),
    cellInputWrapperBase = _useStyles$j.cellInputWrapperBase,
    cellInputLeftWhenMobile = _useStyles$j.cellInputLeftWhenMobile,
    cellInputCenterOnly = _useStyles$j.cellInputCenterOnly,
    labelForMobileView = _useStyles$j.labelForMobileView;
  var columnLabel = ((_columnChoices$find = columnChoices.find(function (column) {
    return column.id === colId;
  })) === null || _columnChoices$find === void 0 ? void 0 : _columnChoices$find.label) || '';
  return React__default.createElement("label", {
    htmlFor: inputId,
    "aria-labelledby": ariaLabelledBy,
    className: classNames(cellInputWrapperBase, _defineProperty({}, cellInputCenterOnly, isGridWhenMobile), _defineProperty({}, cellInputLeftWhenMobile, !isGridWhenMobile))
  }, React__default.createElement(CheckboxOrRadio, _objectSpread({
    id: inputId,
    value: colId,
    "data-component": true,
    checked: checked,
    onChange: handleInputChange,
    className: className
  }, props)), !isGridWhenMobile && React__default.createElement(RichText, {
    element: "span",
    className: labelForMobileView,
    text: columnLabel
  }));
}
var useStyles$i = createUseStyles({
  gridComponentStyle: {
    display: 'flex',
    flexShrink: 0,
    width: 20,
    height: 20
  },
  commentChoiceContainer: {
    width: '100%'
  },
  commentColumnContainer: {
    margin: '1em'
  }
});
function MatrixRating(_ref128) {
  var questionId = _ref128.id,
    _ref128$isMultipleSel = _ref128.isMultipleSelectionsPerRow,
    isMultipleSelectionsPerRow = _ref128$isMultipleSel === void 0 ? false : _ref128$isMultipleSel,
    _ref128$choices = _ref128.choices,
    choices = _ref128$choices === void 0 ? [] : _ref128$choices,
    _ref128$columnChoices = _ref128.columnChoices,
    columnChoices = _ref128$columnChoices === void 0 ? [] : _ref128$columnChoices,
    choiceOther = _ref128.choiceOther,
    hideLabel = _ref128.hideLabel,
    choiceNoneOfTheAbove = _ref128.choiceNoneOfTheAbove,
    required = _ref128.required,
    requiredType = _ref128.requiredType,
    choiceComment = _ref128.choiceComment,
    isForcedRanking = _ref128.isForcedRanking,
    onChange = _ref128.onChange,
    _ref128$responses = _ref128.responses,
    defaultResponses = _ref128$responses === void 0 ? [] : _ref128$responses,
    _disabled = _ref128.disabled,
    _ro = _ref128.readOnly,
    questionFieldProps = _objectWithoutProperties(_ref128, _excluded55);
  var errorId = createErrorId(questionId);
  /** Filter choices that exist and are visible  */
  var _useQuestionChoices5 = useQuestionChoices([].concat(_toConsumableArray(choices), [choiceNoneOfTheAbove ? _objectSpread(_objectSpread({}, choiceNoneOfTheAbove), {}, {
      type: 'NOTA'
    }) : undefined, choiceOther, choiceComment]), [].concat(_toConsumableArray(columnChoices), [choiceNoneOfTheAbove ? _objectSpread(_objectSpread({}, choiceNoneOfTheAbove), {}, {
      type: 'NOTA'
    }) : undefined])),
    options = _useQuestionChoices5.options,
    sortableOptions = _useQuestionChoices5.sortableOptions,
    commentOption = _useQuestionChoices5.commentOption,
    commentColumnOption = _useQuestionChoices5.commentColumnOption,
    columnOptions = _useQuestionChoices5.columnOptions;
  var _useState53 = useState(defaultResponses),
    _useState54 = _slicedToArray(_useState53, 2),
    responseValue = _useState54[0],
    setResponseValue = _useState54[1];
  /**
   * Default value by id
   * used for text-input based choices (i.e. choiceComment)
   * Matrix provides a 2D Array construct
   */
  var getDefaultValueById = function getDefaultValueById(id) {
    var _defaultChoice$value$2;
    var defaultChoice = defaultResponses.find(function (c) {
      return c.id === id;
    });
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : (_defaultChoice$value$2 = defaultChoice.value[0]) === null || _defaultChoice$value$2 === void 0 ? void 0 : _defaultChoice$value$2.value;
  };
  var isChecked = function isChecked(rowId, colId) {
    return !!responseValue.find(function (r) {
      return r.id === rowId && r.value.find(function (c) {
        return c.id === colId;
      });
    });
  };
  var unCheckOption = function unCheckOption(unSelectOptionID) {
    if (required && requiredType === 'ALL') {
      return;
    }
    var result = responseValue.filter(function (option) {
      return option.id !== unSelectOptionID;
    });
    setResponseValue(result);
    onChange === null || onChange === void 0 ? void 0 : onChange(result);
  };
  var handleClick = function handleClick(e, gridCell) {
    var input = e.target;
    var checkedOption = responseValue.find(function (option) {
      return option.id === gridCell.rowId && option.value[0].id === gridCell.colId;
    });
    if (input.checked && !!checkedOption) {
      e.preventDefault();
      unCheckOption(checkedOption.id);
    }
  };
  var handleKeyboard = function handleKeyboard(e, gridCell) {
    var checkedOption = responseValue.find(function (option) {
      return option.id === gridCell.rowId && option.value[0].id === gridCell.colId;
    });
    if (checkedOption && e.code === 'Space') {
      e.preventDefault();
      unCheckOption(checkedOption.id);
    }
  };
  var handleChange = function handleChange(e, gridCell) {
    var rowId = e.id,
      colId = e.value,
      checked = e.checked;
    var isNa = gridCell.colIndex > columnChoices.length - 1;
    var type = isNa ? 'NOTA' : undefined;
    var prevRows = responseValue.filter(function (r) {
      return r.id !== rowId;
    });
    var currentRow = !isNa && responseValue.find(function (r) {
      return r.id === rowId && r.type !== 'NOTA';
    }) || {
      id: rowId,
      value: [],
      type: type
    };
    var currentCols = isMultipleSelectionsPerRow ? currentRow.value.filter(function (c) {
      return c.value !== colId;
    }) : [];
    if (checked) {
      currentCols.push({
        id: colId,
        value: colId
      });
    }
    var newRows = currentCols.length ? [_objectSpread(_objectSpread({}, currentRow), {}, {
      value: currentCols
    })] : [];
    if (isForcedRanking) {
      var filteredRows = prevRows.find(function (r) {
        return r.value[0].value === currentCols[0].value;
      });
      if (filteredRows && !isNa) {
        var found = prevRows.indexOf(filteredRows);
        prevRows.splice(found, 1);
      }
    }
    var rows = [].concat(_toConsumableArray(prevRows), newRows);
    var responses = rows;
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var handleCommentChange = function handleCommentChange(e) {
    var choiceData = options.find(function (c) {
      return c.id === e.target.id;
    });
    var responses = responseValue.filter(function (c) {
      return c.type !== 'COMMENT';
    });
    if (choiceData && !!e.target.value) {
      var id = choiceData.id,
        type = choiceData.type;
      var response = {
        id: id,
        type: type,
        value: e.target.value
      };
      // @note: ensure to loop the values when transforming in RespWeb
      responses.push({
        id: id,
        type: type,
        value: [response]
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var handleCommentColumnChange = function handleCommentColumnChange(e, associatedRowId) {
    var _currentRowData$value;
    if (!commentColumnOption) {
      return; // mainly here for type-safety
    }

    var currentRowData = responseValue.find(function (_ref129) {
      var id = _ref129.id;
      return id === associatedRowId;
    });
    var allButNewValue = (_currentRowData$value = currentRowData === null || currentRowData === void 0 ? void 0 : currentRowData.value.filter(function (_ref130) {
      var id = _ref130.id;
      return id !== commentColumnOption.id;
    })) !== null && _currentRowData$value !== void 0 ? _currentRowData$value : [];
    var isDelete = !e.target.value && !!currentRowData && allButNewValue.length < (currentRowData === null || currentRowData === void 0 ? void 0 : currentRowData.value.length);
    var newValue = isDelete ? allButNewValue : [].concat(_toConsumableArray(allButNewValue), [{
      id: commentColumnOption.id,
      value: e.target.value,
      type: 'COMMENT_COLUMN'
    }]);
    var responses = responseValue.filter(function (_ref131) {
      var id = _ref131.id;
      return id !== associatedRowId;
    });
    if (newValue.length > 0) {
      responses.push({
        id: associatedRowId,
        value: newValue
      });
    }
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var _useStyles$i = useStyles$i(),
    gridComponentStyle = _useStyles$i.gridComponentStyle,
    commentChoiceContainer = _useStyles$i.commentChoiceContainer,
    commentColumnContainer = _useStyles$i.commentColumnContainer;
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    "data-testid": "MatrixRatingQuestionType",
    errorId: errorId
  }, questionFieldProps), React__default.createElement(MatrixGrid, {
    id: questionId,
    hideLabel: hideLabel,
    columnDataArray: columnOptions,
    rowDataArray: sortableOptions,
    isGridWhenMobile: isForcedRanking,
    // eslint-disable-next-line react/no-unstable-nested-components
    gridComponent: function gridComponent(gridCell) {
      return React__default.createElement(RatingInput, {
        qid: questionId,
        gridCell: gridCell,
        isMultipleSelectionsPerRow: isMultipleSelectionsPerRow,
        checked: isChecked(gridCell.rowId, gridCell.colId),
        onChange: function onChange(e) {
          return handleChange(e, gridCell);
        },
        name: isMultipleSelectionsPerRow ? undefined : "".concat(gridCell.rowId, "-group"),
        onClick: isMultipleSelectionsPerRow ? undefined : function (e) {
          return handleClick(e, gridCell);
        },
        onKeyDown: isMultipleSelectionsPerRow ? undefined : function (e) {
          return handleKeyboard(e, gridCell);
        },
        className: gridComponentStyle,
        isGridWhenMobile: isForcedRanking,
        columnChoices: columnOptions
      });
    },
    commentColumnOtherOption: commentColumnOption,
    commentColumnComponent: commentColumnOption ?
    // eslint-disable-next-line react/no-unstable-nested-components
    function (commentProps) {
      return React__default.createElement(CommentChoice, {
        id: "".concat(commentProps.row.id, "-comment"),
        label: commentColumnOption === null || commentColumnOption === void 0 ? void 0 : commentColumnOption.label,
        onChange: function onChange(e) {
          return commentProps.row.associatedId && handleCommentColumnChange(e, commentProps.row.associatedId);
        },
        lineCount: commentColumnOption.linesCount,
        charCount: commentColumnOption.charsCount,
        maxLength: TEXT_INPUT_MAX_CHARS,
        className: commentColumnContainer,
        "aria-labelledby": "".concat(commentProps.row.associatedId, "-header ").concat(commentProps.row.id, "-comment-label")
      });
    } : undefined
  }), commentOption && React__default.createElement(CommentChoice, {
    id: commentOption.id,
    label: commentOption.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(commentOption.id),
    lineCount: commentOption.linesCount,
    charCount: commentOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS,
    className: commentChoiceContainer
  }));
}
var useStyles$h = createUseStyles(function (theme) {
  var breakpointSmMin = "@media screen and (max-width: ".concat(theme.breakpoints.sm.min, ")");
  var _theme$input = theme.input,
    listItemBackground = _theme$input.bgColor,
    listItemBorderActive = _theme$input.activeColor;
  var flexStart = 'flex-start';
  var lineHeight = 1.25;
  var controlsPadding = 6;
  var controlsFontSize = 'inherit';
  // helps align label-first-line to controls center
  var labelOffset = Math.floor(controlsPadding / lineHeight);
  return {
    listItem: {
      position: 'relative',
      userSelect: 'none',
      lineHeight: 0,
      outline: 'none',
      zIndex: function zIndex(_ref132) {
        var ghost = _ref132.ghost;
        return ghost ? 5 : 'auto';
      },
      '&:active, &:focus, &:focus-within': {
        zIndex: 5
      },
      '&:active $content, &:focus-within $content': {
        outlineWidth: 1,
        outlineStyle: function outlineStyle(_ref133) {
          var ghost = _ref133.ghost;
          return ghost ? 'dashed' : 'solid';
        },
        outlineColor: listItemBorderActive
      },
      '&:active $content, &:focus $content': {
        outlineWidth: 3,
        outlineStyle: function outlineStyle(_ref134) {
          var ghost = _ref134.ghost;
          return ghost ? 'dashed' : 'solid';
        },
        outlineColor: listItemBorderActive
      }
    },
    rankItemContainer: {
      display: 'flex',
      fontSize: theme.questionBody.fontSize,
      lineHeight: lineHeight,
      color: theme.questionBody.color
    },
    orderIndex: {
      padding: '16px 5px 10px 5px',
      visibility: function visibility(_ref135) {
        var ranksVisible = _ref135.ranksVisible;
        return ranksVisible ? 'visible' : 'hidden';
      },
      minWidth: '45px',
      display: 'flex'
    },
    content: _defineProperty({
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: flexStart,
      alignItems: flexStart,
      gap: 10,
      flex: '1 auto',
      borderWidth: 1,
      borderRadius: 4,
      borderStyle: 'solid',
      borderColor: 'transparent',
      background: isDark(theme.questionBody.color || '#fff') ? listItemBackground : 'rgba(255, 255, 255, 0.15)',
      padding: 10,
      cursor: 'move'
    }, breakpointSmMin, {
      flexWrap: 'wrap'
    }),
    dragHandle: {
      outline: 'none',
      visibility: function visibility(_ref136) {
        var ghost = _ref136.ghost;
        return ghost ? 'hidden' : 'visible';
      },
      fontSize: controlsFontSize,
      lineHeight: 0,
      padding: controlsPadding,
      touchAction: 'none',
      '&::after': {
        content: "''",
        position: 'absolute',
        display: 'block',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    },
    label: _defineProperty({
      visibility: function visibility(_ref137) {
        var ghost = _ref137.ghost;
        return ghost ? 'hidden' : 'visible';
      },
      display: 'flex',
      justifyContent: flexStart,
      alignItems: flexStart,
      flex: '1 auto',
      paddingTop: labelOffset,
      '& iframe': {
        position: 'relative'
      },
      overflowWrap: 'anywhere'
    }, breakpointSmMin, {
      order: 3,
      paddingLeft: '6px',
      width: '100%'
    }),
    controls: _defineProperty({
      visibility: function visibility(_ref138) {
        var ghost = _ref138.ghost;
        return ghost ? 'hidden' : 'visible';
      },
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-around',
      gap: 10,
      fontSize: controlsFontSize
    }, breakpointSmMin, {
      order: 2,
      flex: '1 1 auto',
      justifyContent: 'flex-end'
    })
  };
});
function RankingRow(_ref139, ref) {
  var className = _ref139.className,
    dragListeners = _ref139.dragListeners,
    dragRef = _ref139.dragRef,
    ghost = _ref139.ghost,
    id = _ref139.id,
    position = _ref139.position,
    label = _ref139.label,
    controls = _ref139.controls,
    onFocus = _ref139.onFocus,
    _ref139$ranksVisible = _ref139.ranksVisible,
    ranksVisible = _ref139$ranksVisible === void 0 ? true : _ref139$ranksVisible,
    props = _objectWithoutProperties(_ref139, _excluded56);
  var _useStyles$h = useStyles$h({
      ghost: ghost,
      ranksVisible: ranksVisible
    }),
    listItem = _useStyles$h.listItem,
    rankItemContainer = _useStyles$h.rankItemContainer,
    orderIndex = _useStyles$h.orderIndex,
    contentContainer = _useStyles$h.content,
    dragHandleContainer = _useStyles$h.dragHandle,
    labelContainer = _useStyles$h.label,
    controlsContainer = _useStyles$h.controls;
  var labelId = "".concat(id, "-label");
  var index = position !== null && position !== void 0 ? position : -1;
  var indexLabel = index >= 0 ? index + 1 : '';
  return React__default.createElement("li", _objectSpread({
    id: id,
    className: classNames('rankItem', listItem, className),
    ref: ref
  }, props), React__default.createElement("div", {
    className: rankItemContainer
  }, React__default.createElement("span", {
    className: classNames('OrderIndex', orderIndex),
    "data-testid": "RankingRow__OrderIndex",
    "aria-hidden": true
  }, indexLabel), React__default.createElement("div", {
    className: classNames('rankItem__content', contentContainer)
  }, React__default.createElement("div", _objectSpread({
    "data-testid": "RankingRow__DragHandle",
    className: classNames('rankItem__dragHandle', dragHandleContainer),
    onFocus: onFocus,
    "data-pos": index,
    ref: dragRef
  }, dragListeners), React__default.createElement(DragHandleIcon$1, {
    className: "rankItem__dragHandleIcon"
  })), React__default.createElement("div", {
    "data-testid": "RankingRow__Label",
    className: classNames('rankItem__label', labelContainer)
  }, React__default.createElement(RichText, {
    id: labelId,
    element: "div",
    className: "rankItem__richText",
    translate: "no",
    text: label
  })), React__default.createElement("div", {
    "data-no-dnd": "true",
    "data-testid": "RankingRow__Controls",
    className: classNames('rankItem__controls', controlsContainer)
  }, controls))));
}
var RankingRow$1 = forwardRef(RankingRow);

/**
 * OrderButton
 *
 * @todo: replace instances with reusable `Button` component that satisfies
 * all scenarios, variants and themes.
 */
var useStyles$g = createUseStyles(function (theme) {
  return {
    orderButton: {
      color: '#000',
      backgroundColor: '#fff',
      fontSize: 'inherit',
      border: [1, 'solid', '#000'],
      borderRadius: 4,
      padding: [6, 6],
      maxWidth: '100%',
      cursor: 'pointer',
      lineHeight: 0,
      outlineColor: theme.primaryAccentColor,
      '&[aria-disabled]': {
        backgroundColor: 'rgba(255,255,255,.5)',
        borderColor: 'rgba(0,0,0,.5)',
        pointerEvents: 'none',
        cursor: 'default'
      },
      '&[aria-disabled] > svg': {
        opacity: 0.5,
        cursor: 'default'
      },
      '&:focus, &:focus-visible': {
        borderColor: theme.primaryAccentColor,
        outline: "2px solid ".concat(theme.primaryAccentColor)
      }
    },
    '@media (hover: hover) and (pointer: fine)': {
      orderButton: {
        '&:hover': {
          borderColor: theme.primaryAccentColor,
          outline: "2px solid ".concat(theme.primaryAccentColor)
        }
      }
    },
    srOnly: visuallyHidden
  };
});
function OrderButton(_ref140) {
  var icon = _ref140.icon,
    label = _ref140.children,
    className = _ref140.className,
    disabled = _ref140.disabled,
    props = _objectWithoutProperties(_ref140, _excluded57);
  var _useStyles$g = useStyles$g(),
    orderButton = _useStyles$g.orderButton,
    srOnly = _useStyles$g.srOnly;
  return React__default.createElement("button", _objectSpread({
    type: "button",
    "aria-disabled": disabled || undefined,
    className: classNames('order-button', orderButton, className)
  }, props), icon, React__default.createElement("span", {
    className: srOnly
  }, label));
}
var useStyles$f = createUseStyles({
  controlsContainer: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-around',
    gap: 10
  },
  applicableControl: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  }
});
var COPY$5 = defineMessages({
  RANK_NA: {
    id: 'OrderControl.NA',
    defaultMessage: 'N/A',
    description: '[Type: label][Vis: high] - not applicable label'
  },
  ARIA_RANK_NA: {
    id: 'OrderControl.AriaNA',
    defaultMessage: 'Not Applicable',
    description: '[Type: label][Vis: high] - accessible not applicable label'
  }
});
var RANK_DIRECTION_BACKWARD = -1;
var RANK_DIRECTION_FORWARD = 1;
function OrderControl(_ref141) {
  var id = _ref141.id,
    labels = _ref141.labels,
    position = _ref141.position,
    _ref141$showApplicabi = _ref141.showApplicability,
    showApplicability = _ref141$showApplicabi === void 0 ? true : _ref141$showApplicabi,
    _ref141$applicable = _ref141.applicable,
    defaultApplicable = _ref141$applicable === void 0 ? true : _ref141$applicable,
    className = _ref141.className,
    onApplicableChange = _ref141.onApplicableChange,
    onOrderUp = _ref141.onOrderUp,
    onOrderDown = _ref141.onOrderDown,
    _ref141$disableOrderU = _ref141.disableOrderUp,
    disableOrderUp = _ref141$disableOrderU === void 0 ? false : _ref141$disableOrderU,
    _ref141$disableOrderD = _ref141.disableOrderDown,
    disableOrderDown = _ref141$disableOrderD === void 0 ? false : _ref141$disableOrderD,
    props = _objectWithoutProperties(_ref141, _excluded58);
  var _useState55 = useState(defaultApplicable),
    _useState56 = _slicedToArray(_useState55, 2),
    applicable = _useState56[0],
    setApplicable = _useState56[1];
  var currentIndex = position !== null && position !== void 0 ? position : -1;
  var handleOrderUp = function handleOrderUp(_e) {
    onOrderUp === null || onOrderUp === void 0 ? void 0 : onOrderUp({
      id: id,
      value: currentIndex,
      direction: RANK_DIRECTION_BACKWARD
    });
  };
  var handleOrderDown = function handleOrderDown(_e) {
    onOrderDown === null || onOrderDown === void 0 ? void 0 : onOrderDown({
      id: id,
      value: currentIndex,
      direction: RANK_DIRECTION_FORWARD
    });
  };
  var handleApplicableChange = function handleApplicableChange(e) {
    var isApplicable = !e.target.checked;
    onApplicableChange === null || onApplicableChange === void 0 ? void 0 : onApplicableChange({
      id: id,
      applicable: isApplicable
    });
    setApplicable(isApplicable);
  };
  var applicableId = "".concat(id, "-applicable");
  var _useStyles$f = useStyles$f(),
    controlsContainer = _useStyles$f.controlsContainer,
    applicableControl = _useStyles$f.applicableControl;
  return React__default.createElement("div", _objectSpread({
    id: id,
    className: classNames(controlsContainer, className)
  }, props), React__default.createElement(OrderButton, {
    disabled: disableOrderUp || !applicable,
    onClick: handleOrderUp,
    icon: React__default.createElement(CaretUpOutlineIcon, null)
  }, labels.orderUpLabel), React__default.createElement(OrderButton, {
    disabled: disableOrderDown || !applicable,
    onClick: handleOrderDown,
    icon: React__default.createElement(CaretDownOutlineIcon, null)
  }, labels.orderDownLabel), showApplicability && React__default.createElement("label", {
    className: classNames('order-na', applicableControl),
    htmlFor: applicableId,
    "aria-label": t(COPY$5.ARIA_RANK_NA)
  }, React__default.createElement(CheckboxInput$1, {
    id: applicableId,
    checked: !applicable,
    onChange: handleApplicableChange
  }), React__default.createElement(T, {
    desc: COPY$5.RANK_NA
  })));
}
var useStyles$e = createUseStyles({
  item: {},
  itemDisabled: {
    '& .rankItem__dragHandle::after': {
      cursor: 'default'
    },
    '& .rankItem__dragHandle, & .rankItem__label': {
      opacity: 0.5
    }
  }
});
var COPY$4 = defineMessages({
  ARIA_RANK_MOVE_UP: {
    id: 'RankingItem.AriaRankMoveUp',
    defaultMessage: 'Move up {label}',
    description: '[Type: button][Vis: high] - accessible rank move up label'
  },
  ARIA_RANK_MOVE_DOWN: {
    id: 'RankingItem.AriaRankMoveDown',
    defaultMessage: 'Move down {label}',
    description: '[Type: button][Vis: high] - accessible rank move down label'
  }
});
function RankingItem(_ref142) {
  var id = _ref142.id,
    className = _ref142.className,
    label = _ref142.label,
    index = _ref142.position,
    listLength = _ref142.listLength,
    applicable = _ref142.applicable,
    showApplicability = _ref142.showApplicability,
    onApplicableChange = _ref142.onApplicableChange,
    onOrderUp = _ref142.onOrderUp,
    onOrderDown = _ref142.onOrderDown,
    ranksVisible = _ref142.ranksVisible,
    props = _objectWithoutProperties(_ref142, _excluded59);
  var textOnlyLabel = stripHTML(label);
  var controlLabels = {
    orderUpLabel: t(COPY$4.ARIA_RANK_MOVE_UP, {
      label: textOnlyLabel
    }),
    orderDownLabel: t(COPY$4.ARIA_RANK_MOVE_DOWN, {
      label: textOnlyLabel
    })
  };
  var _useSortable = useSortable({
      id: id,
      /*
       * role=listitem is forced to override DnD-kits use of role=button.
       * This re-instates proper a11y announcements of the role
       */
      attributes: {
        role: 'listitem',
        tabIndex: -1
      },
      disabled: !applicable,
      data: {
        id: id,
        position: index,
        label: label,
        applicable: applicable,
        showApplicability: showApplicability
      }
    }),
    attributes = _useSortable.attributes,
    listeners = _useSortable.listeners,
    setNodeRef = _useSortable.setNodeRef,
    transform = _useSortable.transform,
    transition = _useSortable.transition,
    isDragging = _useSortable.isDragging,
    setActivatorNodeRef = _useSortable.setActivatorNodeRef;
  var style = {
    transform: CSS.Transform.toString(transform),
    transition: transition
  };
  var handleOrderUp = function handleOrderUp(e) {
    onOrderUp === null || onOrderUp === void 0 ? void 0 : onOrderUp(_objectSpread(_objectSpread({}, e), {}, {
      id: id
    }));
  };
  var handleOrderDown = function handleOrderDown(e) {
    onOrderDown === null || onOrderDown === void 0 ? void 0 : onOrderDown(_objectSpread(_objectSpread({}, e), {}, {
      id: id
    }));
  };
  var handleApplicableChange = function handleApplicableChange(e) {
    onApplicableChange === null || onApplicableChange === void 0 ? void 0 : onApplicableChange(_objectSpread(_objectSpread({}, e), {}, {
      id: id
    }));
  };
  var _useStyles$e = useStyles$e({
      applicable: applicable
    }),
    item = _useStyles$e.item,
    itemDisabled = _useStyles$e.itemDisabled;
  return React__default.createElement(RankingRow$1, _objectSpread(_objectSpread({
    id: id,
    label: label,
    position: index,
    className: classNames(item, _defineProperty({}, itemDisabled, !applicable), className),
    ref: setNodeRef,
    style: style,
    ghost: isDragging
  }, attributes), {}, {
    dragListeners: listeners,
    dragRef: setActivatorNodeRef,
    ranksVisible: ranksVisible,
    controls: React__default.createElement(OrderControl, {
      id: "".concat(id, "-control"),
      position: index,
      applicable: applicable,
      showApplicability: !!showApplicability,
      onApplicableChange: handleApplicableChange,
      onOrderUp: handleOrderUp,
      onOrderDown: handleOrderDown,
      labels: controlLabels,
      disableOrderUp: index === 0,
      disableOrderDown: index === listLength - 1
    })
  }, props));
}
var useRankingIds = function useRankingIds(_ref143) {
  var rankings = _ref143.rankings,
    choiceNotApplicable = _ref143.choiceNotApplicable;
  return useMemo(function () {
    var order = rankings.filter(function (r) {
      return !!r && r.visible;
    }).sort(function (a, b) {
      return Number(a.label) - Number(b.label);
    }).map(function (r) {
      return r.id;
    });
    if (choiceNotApplicable) {
      order.push(choiceNotApplicable.id);
    }
    return order;
  }, [rankings, choiceNotApplicable]);
};
var useRankingState = function useRankingState(_ref144) {
  var choices = _ref144.choices,
    rankingIds = _ref144.rankingIds,
    _ref144$defaultRespon = _ref144.defaultResponses,
    defaultResponses = _ref144$defaultRespon === void 0 ? [] : _ref144$defaultRespon,
    choiceNotApplicable = _ref144.choiceNotApplicable;
  var findResponseByChoiceId = function findResponseByChoiceId(id) {
    return defaultResponses.find(function (r) {
      return r.id === id;
    });
  };
  var findPositionByRankId = function findPositionByRankId(id) {
    return rankingIds.findIndex(function (rid) {
      return rid === id;
    });
  };
  return useState(function () {
    // Filter choices that exist and are visible, add rankable meta data
    return choices.filter(function (c) {
      return !!c && c.visible;
    }).map(function (_ref145, defaultIndex) {
      var id = _ref145.id,
        label = _ref145.label;
      var _ref146 = findResponseByChoiceId(id) || {},
        _ref146$value = _ref146.value,
        rankId = _ref146$value === void 0 ? rankingIds[defaultIndex] : _ref146$value,
        type = _ref146.type;
      var item = {
        id: id,
        label: label,
        type: type,
        value: rankId,
        applicable: rankId !== (choiceNotApplicable === null || choiceNotApplicable === void 0 ? void 0 : choiceNotApplicable.id),
        index: findPositionByRankId(rankId)
      };
      return item;
    }).sort(function (a, b) {
      return a.index - b.index;
    });
  });
};

/* istanbul ignore file */
function shouldHandleEvent(element) {
  var cur = element;
  while (cur) {
    if (cur.dataset && cur.dataset.noDnd) {
      return false;
    }
    cur = cur.parentElement;
  }
  return true;
}
var defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter]
};
var PointerSensor = /*#__PURE__*/function (_PointerSensor$) {
  _inherits(PointerSensor, _PointerSensor$);
  var _super = _createSuper(PointerSensor);
  function PointerSensor() {
    _classCallCheck(this, PointerSensor);
    return _super.apply(this, arguments);
  }
  return PointerSensor;
}(PointerSensor$1);
PointerSensor.activators = [{
  eventName: 'onPointerDown',
  handler: function handler(_ref147, _ref148) {
    var event = _ref147.nativeEvent;
    var onActivation = _ref148.onActivation;
    if (!shouldHandleEvent(event.target)) {
      return false;
    }
    onActivation === null || onActivation === void 0 ? void 0 : onActivation({
      event: event
    });
    return true;
  }
}];
var KeyboardSensor = /*#__PURE__*/function (_KeyboardSensor$) {
  _inherits(KeyboardSensor, _KeyboardSensor$);
  var _super2 = _createSuper(KeyboardSensor);
  function KeyboardSensor() {
    _classCallCheck(this, KeyboardSensor);
    return _super2.apply(this, arguments);
  }
  return KeyboardSensor;
}(KeyboardSensor$1);
KeyboardSensor.activators = [{
  eventName: 'onKeyDown',
  handler: function handler(_ref149, _ref150, _ref151) {
    var event = _ref149.nativeEvent;
    var _ref150$keyboardCodes = _ref150.keyboardCodes,
      keyboardCodes = _ref150$keyboardCodes === void 0 ? defaultKeyboardCodes : _ref150$keyboardCodes,
      onActivation = _ref150.onActivation;
    var active = _ref151.active;
    var code = event.code;
    if (keyboardCodes.start.includes(code)) {
      var activator = active.activatorNode.current;
      if (activator && event.target !== activator || !shouldHandleEvent(event.target)) {
        return false;
      }
      event.preventDefault();
      onActivation === null || onActivation === void 0 ? void 0 : onActivation({
        event: event
      });
      return true;
    }
    return false;
  }
}];
var useStyles$d = createUseStyles({
  list: {
    '& > *': {
      WebkitUserSelect: 'none',
      WebkitTouchCallout: 'none'
    }
  },
  listItem: {
    marginBottom: 10
  },
  dragOverlay: {
    opacity: 0.5,
    '& .rankItem__orderIndex, & .rankItem__controls': {
      opacity: 0
    }
  },
  srOnly: _objectSpread({}, visuallyHidden)
});
var COPY$3 = defineMessages({
  ARIA_RANK_MOVED_UP: {
    id: 'Ranking.AriaRankMovedUp',
    defaultMessage: '{label} moved up to number {position}',
    description: '[Type: button][Vis: high] - accessible ranking moved up label'
  },
  ARIA_RANK_MOVED_DOWN: {
    id: 'Ranking.AriaRankMovedDown',
    defaultMessage: '{label} moved down to number {position}',
    description: '[Type: button][Vis: high] - accessible ranking moved down label'
  },
  ARIA_RANK_MOVED_TO_TOP: {
    id: 'Ranking.AriaRankAtTop',
    defaultMessage: '{label} moved to the top of the list',
    description: '[Type: button][Vis: high] - accessible ranking at top of list'
  },
  ARIA_RANK_MOVED_TO_BOTTOM: {
    id: 'Ranking.AriaRankAtBottom',
    defaultMessage: '{label} moved to the bottom of the list',
    description: '[Type: button][Vis: high] - accessible ranking at bottom of list'
  }
});
/** Turn off a11y announcements for Drag and Drop in the DnDContext - this is handled by the order buttons */
var emptyStringNoop = function emptyStringNoop() {
  return '';
};
var dndAnnouncements = {
  onDragStart: emptyStringNoop,
  onDragMove: emptyStringNoop,
  onDragOver: emptyStringNoop,
  onDragEnd: emptyStringNoop,
  onDragCancel: emptyStringNoop
};
var dndAccessibility = {
  announcements: dndAnnouncements,
  screenReaderInstructions: {
    draggable: ''
  }
};
function Ranking(_ref152) {
  var _activeItem$data$curr, _activeItem$data$curr2;
  var questionId = _ref152.id,
    _dis = _ref152.disabled,
    _ro = _ref152.readOnly,
    _ref152$choices = _ref152.choices,
    choices = _ref152$choices === void 0 ? /* istanbul ignore next: cannot reach default branch */[] : _ref152$choices,
    _ref152$rankings = _ref152.rankings,
    rankings = _ref152$rankings === void 0 ? /* istanbul ignore next: cannot reach default branch */[] : _ref152$rankings,
    choiceNotApplicable = _ref152.choiceNotApplicable,
    _ref152$responses = _ref152.responses,
    defaultResponses = _ref152$responses === void 0 ? [] : _ref152$responses,
    onChange = _ref152.onChange,
    _ref152$hideRanks = _ref152.hideRanks,
    hideRanks = _ref152$hideRanks === void 0 ? false : _ref152$hideRanks,
    fieldProps = _objectWithoutProperties(_ref152, _excluded60);
  /**
   * @author <Keisha Mukasa>[kmukasa@surveymonkey.com]
   * @description The id has been modified to work in __hybrid__ mode. The `id` needs to
   * be different from the question-field `id` normally created/used.
   * @see https://code.corp.surveymonkey.com/webplatform/smquestions/pull/1204
   * @todo remove prefix 'hybrid-' when no longer required
   */
  var fieldId = "hybrid-".concat(questionId);
  /**
   * @description `createLegendId` is used internally by [QuestionFieldLayoutTemplate](https://code.corp.surveymonkey.com/webplatform/smquestions/blob/master/packages/question-ui/src/capabilities/respondent-survey/components/QuestionFieldLayoutTemplate/QuestionFieldLayoutTemplate.tsx#L157)
   * to create an id.  This `id` cannot be passed down via props.  It is recreated here for `ARIA` referencing.
   */
  var questionTitleId = createLegendId(fieldId);
  var errorId = createErrorId(questionId);
  var sensors = useSensors(useSensor(PointerSensor));
  // toggles display of N/A choice
  var showApplicability = choiceNotApplicable !== undefined;
  // create ranking order (N/A choice is last)
  var rankingIds = useRankingIds({
    rankings: rankings,
    choiceNotApplicable: choiceNotApplicable
  });
  var _useState57 = useState(null),
    _useState58 = _slicedToArray(_useState57, 2),
    setActiveId = _useState58[1];
  var _useState59 = useState(null),
    _useState60 = _slicedToArray(_useState59, 2),
    activeItem = _useState60[0],
    setActiveItem = _useState60[1];
  // for Aria-Live
  var _useState61 = useState(''),
    _useState62 = _slicedToArray(_useState61, 2),
    statusMessage = _useState62[0],
    announceStatus = _useState62[1];
  var setAnnoucement = function setAnnoucement(str) {
    setTimeout(function () {
      return announceStatus('');
    }, 5000);
    announceStatus(str);
  };
  var _useState63 = useState(hideRanks),
    _useState64 = _slicedToArray(_useState63, 2),
    ranksVisible = _useState64[0],
    setRanksVisible = _useState64[1];
  var _useRankingState = useRankingState({
      choices: choices,
      defaultResponses: defaultResponses,
      choiceNotApplicable: choiceNotApplicable,
      rankingIds: rankingIds
    }),
    _useRankingState2 = _slicedToArray(_useRankingState, 2),
    listItems = _useRankingState2[0],
    setListItems = _useRankingState2[1];
  /* istanbul ignore next */
  var getItemIndices = function getItemIndices(items, fromId, toId) {
    var fromIndex = items.findIndex(function (item) {
      return item.id === fromId;
    });
    var toIndex = items.findIndex(function (item) {
      return item.id === toId;
    });
    return {
      fromIndex: fromIndex,
      toIndex: toIndex
    };
  };
  /* istanbul ignore next */
  var moveById = function moveById(items, fromId, toId) {
    var _getItemIndices = getItemIndices(items, fromId, toId),
      fromIndex = _getItemIndices.fromIndex,
      toIndex = _getItemIndices.toIndex;
    return arrayMove(items, fromIndex, toIndex);
  };
  /* istanbul ignore next: cannot test drag-and-drop logic */
  var moveItem = function moveItem(fromId, toId) {
    setListItems(function (items) {
      return moveById(items, fromId, toId);
    });
  };
  var _useStyles$d = useStyles$d(),
    list = _useStyles$d.list,
    listItem = _useStyles$d.listItem,
    dragOverlay = _useStyles$d.dragOverlay,
    srOnly = _useStyles$d.srOnly;
  var orderedListProps = {
    /**
     * role is forced for a11y, so SR's will announce properly,
     * this is somehow lost or manipulated, possibly, by DnD-Kit
     */
    role: 'list',
    className: list,
    'aria-labelledby': questionTitleId
  };
  var updateRankingOrder = function updateRankingOrder(current, next) {
    var nextValue = Math.max(0, Math.min(next, listItems.length - 1));
    var responses = arrayMove(listItems, current, nextValue).map(function (response, index) {
      return _objectSpread(_objectSpread({}, response), {}, {
        index: index,
        value: rankingIds[index]
      });
    });
    setRanksVisible(true);
    setListItems(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var announcePosition = function announcePosition(current, next, label) {
    var nextPos = Math.max(0, Math.min(next, listItems.length - 1));
    if (current === nextPos) return; // no change in position
    var position = nextPos + 1; // announce non-zero base number
    var message = COPY$3.ARIA_RANK_MOVED_DOWN;
    if (nextPos <= 0) {
      // moved to top
      message = COPY$3.ARIA_RANK_MOVED_TO_TOP;
    } else if (nextPos < current) {
      // moved up
      message = COPY$3.ARIA_RANK_MOVED_UP;
    } else if (nextPos >= listItems.length - 1) {
      // moved to bottom
      message = COPY$3.ARIA_RANK_MOVED_TO_BOTTOM;
    }
    setAnnoucement(t(message, {
      label: stripHTML(label),
      position: position
    }));
  };
  var handleOrderUp = function handleOrderUp(e) {
    var rowId = e.id,
      currentPosition = e.value,
      _e$direction = e.direction,
      direction = _e$direction === void 0 ? /* istanbul ignore next: cannot reach default branch */0 : _e$direction;
    var item = listItems.find(function (li) {
      return li.id === rowId;
    });
    var nextPosition = currentPosition + direction;
    updateRankingOrder(currentPosition, nextPosition);
    announcePosition(currentPosition, nextPosition, item.label);
  };
  var handleOrderDown = function handleOrderDown(e) {
    var rowId = e.id,
      currentPosition = e.value,
      _e$direction2 = e.direction,
      direction = _e$direction2 === void 0 ? /* istanbul ignore next: cannot reach default branch */0 : _e$direction2;
    var item = listItems.find(function (li) {
      return li.id === rowId;
    });
    var nextPosition = currentPosition + direction;
    updateRankingOrder(currentPosition, nextPosition);
    announcePosition(currentPosition, nextPosition, item.label);
  };
  var handleApplicableChange = function handleApplicableChange(e) {
    /* istanbul ignore else: should never branch */
    if (showApplicability) {
      var id = e.id,
        applicable = e.applicable;
      var responses = listItems.map(function (item) {
        return _objectSpread(_objectSpread(_objectSpread({}, item), item.id === id ? {
          applicable: applicable
        } : {}), item.id === id && !applicable ? {
          value: choiceNotApplicable.id
        } : {});
      });
      setListItems(responses);
      onChange === null || onChange === void 0 ? void 0 : onChange(responses);
    }
  };
  /* istanbul ignore next: cannot test drag-and-drop logic */
  var handleDragStart = function handleDragStart(_ref153) {
    var active = _ref153.active;
    setActiveId(active.id);
    setActiveItem(active);
  };
  /* istanbul ignore next: cannot test drag-and-drop logic */
  var handleDragEnd = function handleDragEnd(_ref154) {
    var active = _ref154.active,
      over = _ref154.over;
    if (active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
      moveItem(active.id, over === null || over === void 0 ? void 0 : over.id);
    }
    setRanksVisible(true);
    setActiveId(null);
    setActiveItem(null);
  };
  return React__default.createElement(QuestionField, _objectSpread({
    id: "hybrid-".concat(questionId),
    errorId: errorId,
    "data-testid": "RankingQuestionType"
  }, fieldProps), React__default.createElement("div", {
    role: "status",
    "aria-live": "assertive",
    "aria-atomic": "true",
    className: srOnly
  }, statusMessage), React__default.createElement(DndContext, {
    sensors: sensors,
    collisionDetection: closestCenter,
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
    accessibility: dndAccessibility
  }, React__default.createElement(SortableContext, {
    items: listItems,
    strategy: verticalListSortingStrategy
  }, React__default.createElement("ol", _objectSpread({}, orderedListProps), listItems.map(function (_ref155, index) {
    var itemId = _ref155.id,
      label = _ref155.label,
      applicable = _ref155.applicable;
    return React__default.createElement(RankingItem, {
      id: itemId,
      key: itemId,
      label: label,
      position: index,
      listLength: listItems.length,
      applicable: applicable,
      showApplicability: !!showApplicability,
      onApplicableChange: handleApplicableChange,
      onOrderUp: handleOrderUp,
      onOrderDown: handleOrderDown,
      className: listItem,
      ranksVisible: ranksVisible
    });
  })), React__default.createElement(DragOverlay, null, /* istanbul ignore next: cannot test drag-and-drop logic */activeItem ? React__default.createElement(RankingRow$1, {
    id: activeItem.id,
    className: dragOverlay,
    label: (_activeItem$data$curr = activeItem.data.current) === null || _activeItem$data$curr === void 0 ? void 0 : _activeItem$data$curr.label,
    position: (_activeItem$data$curr2 = activeItem.data.current) === null || _activeItem$data$curr2 === void 0 ? void 0 : _activeItem$data$curr2.index,
    ranksVisible: ranksVisible
  }) : null))));
}
function SingleTextbox(_ref156) {
  var questionId = _ref156.id,
    _req = _ref156.required,
    disabled = _ref156.disabled,
    readOnly = _ref156.readOnly,
    _ref156$responses = _ref156.responses,
    defaultResponses = _ref156$responses === void 0 ? [] : _ref156$responses,
    onChange = _ref156.onChange,
    size = _ref156.size,
    fieldProps = _objectWithoutProperties(_ref156, _excluded61);
  var error = fieldProps.error,
    _fieldProps$errorId3 = fieldProps.errorId,
    errorId = _fieldProps$errorId3 === void 0 ? createErrorId(questionId) : _fieldProps$errorId3,
    titleId = fieldProps.title.id;
  var defaultValue = useMemo(function () {
    var _defaultResponses$fin10, _defaultResponses$fin11;
    return (_defaultResponses$fin10 = (_defaultResponses$fin11 = defaultResponses.find(function (r) {
      return !!r.value;
    })) === null || _defaultResponses$fin11 === void 0 ? void 0 : _defaultResponses$fin11.value) !== null && _defaultResponses$fin10 !== void 0 ? _defaultResponses$fin10 : '';
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var handleChange = function handleChange(e) {
    var responses = e.target.value ? [{
      id: questionId,
      value: e.target.value
    }] : [];
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  return React__default.createElement("div", null, React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId,
    "data-testid": "SingleTextboxQuestionType"
  }, fieldProps), React__default.createElement(TextInput$1, {
    name: questionId,
    defaultValue: defaultValue,
    disabled: disabled,
    readOnly: readOnly,
    size: size,
    onChange: handleChange,
    "aria-invalid": !!error,
    "aria-describedby": error && errorId,
    "aria-labelledby": titleId,
    maxLength: TEXT_INPUT_MAX_CHARS
  })));
}
var SingleTextbox$1 = withErrorBoundary(SingleTextbox);
var useStyles$c = createUseStyles(function (theme) {
  var _theme$questionTitle$5, _theme$questionTitle$6, _theme$questionTitle$7, _theme$questionTitle$8, _theme$questionTitle$9, _theme$questionTitle$10;
  return {
    textPresentationalStyles: {
      fontFamily: (_theme$questionTitle$5 = theme.questionTitle.fontFamily) !== null && _theme$questionTitle$5 !== void 0 ? _theme$questionTitle$5 : 'inherit',
      fontSize: (_theme$questionTitle$6 = theme.questionTitle.fontSize) !== null && _theme$questionTitle$6 !== void 0 ? _theme$questionTitle$6 : '16px',
      fontWeight: (_theme$questionTitle$7 = theme.questionTitle.fontWeight) !== null && _theme$questionTitle$7 !== void 0 ? _theme$questionTitle$7 : theme.isAccessible ? 500 : 300,
      textDecoration: (_theme$questionTitle$8 = theme.questionTitle.textDecoration) !== null && _theme$questionTitle$8 !== void 0 ? _theme$questionTitle$8 : 'inherit',
      fontStyle: (_theme$questionTitle$9 = theme.questionTitle.fontStyle) !== null && _theme$questionTitle$9 !== void 0 ? _theme$questionTitle$9 : 'inherit',
      color: (_theme$questionTitle$10 = theme.questionTitle.color) !== null && _theme$questionTitle$10 !== void 0 ? _theme$questionTitle$10 : 'inherit'
    },
    buttonStyles: {
      marginTop: '20px'
    }
  };
});
function TextPresentational(_ref157) {
  var text = _ref157.text,
    _ref157$padding = _ref157.padding,
    padding = _ref157$padding === void 0 ? {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    } : _ref157$padding,
    id = _ref157.id,
    _ref157$okButton = _ref157.okButton,
    okButton = _ref157$okButton === void 0 ? {
      visible: false
    } : _ref157$okButton;
  var richTextId = "text-presentational-".concat(id);
  var _useStyles$c = useStyles$c(),
    textPresentationalStyles = _useStyles$c.textPresentationalStyles,
    buttonStyles = _useStyles$c.buttonStyles;
  var showButton = okButton.visible,
    buttonProps = _objectWithoutProperties(okButton, _excluded62);
  return React__default.createElement(QuestionSpacing, {
    padding: padding,
    "data-testid": "TextPresentational"
  }, React__default.createElement(RichText, {
    id: richTextId,
    element: "div",
    text: text,
    className: textPresentationalStyles
  }), showButton && React__default.createElement(Button, _objectSpread(_objectSpread({}, buttonProps), {}, {
    className: buttonStyles
  })));
}
var TextPresentational$1 = withErrorBoundary(TextPresentational);
var useStyles$b = createUseStyles(function (theme) {
  var _theme$questionBody10, _rowBlock, _nameBlock, _theme$questionBody$f15;
  var _ref158 = (_theme$questionBody10 = theme.questionBody) !== null && _theme$questionBody10 !== void 0 ? _theme$questionBody10 : {},
    _ref158$fontSize = _ref158.fontSize,
    fontSize = _ref158$fontSize === void 0 ? 'inherit' : _ref158$fontSize,
    _ref158$fontFamily = _ref158.fontFamily,
    fontFamily = _ref158$fontFamily === void 0 ? 'inherit' : _ref158$fontFamily,
    _ref158$fontWeight = _ref158.fontWeight,
    fontWeight = _ref158$fontWeight === void 0 ? 'inherit' : _ref158$fontWeight;
  return {
    rowBlock: (_rowBlock = {
      display: 'flex',
      width: '100%'
    }, _defineProperty(_rowBlock, "@media (min-width: ".concat(theme.breakpoints.sm.max, ")"), {
      width: '33.3% !important'
    }), _defineProperty(_rowBlock, "flexDirection", 'column'), _defineProperty(_rowBlock, "float", 'left'), _defineProperty(_rowBlock, "padding", '0px 14px 8px 0px'), _rowBlock),
    nameBlock: (_nameBlock = {
      width: '100%'
    }, _defineProperty(_nameBlock, "@media (min-width: ".concat(theme.breakpoints.sm.max, ")"), {
      width: '33.3% !important',
      marginRight: '66.6%'
    }), _defineProperty(_nameBlock, "display", 'flex'), _defineProperty(_nameBlock, "flexDirection", 'column'), _defineProperty(_nameBlock, "padding", '0px 14px 8px 0px'), _nameBlock),
    nameLabel: {
      paddingBottom: '8px',
      fontFamily: (_theme$questionBody$f15 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f15 !== void 0 ? _theme$questionBody$f15 : {},
      fontSize: '16px'
    },
    nameInput: {
      border: "1px solid ".concat(theme.answerColor),
      height: '40px',
      marginBottom: '8px',
      width: '100%',
      fontSize: fontSize,
      fontFamily: fontFamily,
      fontWeight: fontWeight
    },
    container: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    }
  };
});
function NameField(_ref159) {
  var questionId = _ref159.id,
    required = _ref159.required,
    disabled = _ref159.disabled,
    readOnly = _ref159.readOnly,
    _ref159$responses = _ref159.responses,
    defaultResponses = _ref159$responses === void 0 ? [] : _ref159$responses,
    onChange = _ref159.onChange,
    _ref159$size = _ref159.size,
    size = _ref159$size === void 0 ? 20 : _ref159$size,
    _ref159$answerOptions = _ref159.answerOptions,
    answerOptions = _ref159$answerOptions === void 0 ? [] : _ref159$answerOptions,
    fieldProps = _objectWithoutProperties(_ref159, _excluded63);
  var error = fieldProps.error,
    _fieldProps$errorId4 = fieldProps.errorId,
    errorId = _fieldProps$errorId4 === void 0 ? createErrorId(questionId) : _fieldProps$errorId4,
    titleId = fieldProps.title.id;
  var getDefaultValueById = function getDefaultValueById(id) {
    var defaultChoice = defaultResponses.find(function (c) {
      return c.id === id;
    });
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  var handleChange = function handleChange(e) {
    var responses = e.target.value ? [{
      id: questionId,
      value: e.target.value
    }] : [];
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var _useStyles$b = useStyles$b(),
    nameLabel = _useStyles$b.nameLabel,
    nameInput = _useStyles$b.nameInput,
    nameBlock = _useStyles$b.nameBlock,
    rowBlock = _useStyles$b.rowBlock,
    container = _useStyles$b.container;
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId
  }, fieldProps), React__default.createElement("div", {
    className: container
  }, answerOptions.map(function (option) {
    var _option$placeholder;
    return (option === null || option === void 0 ? void 0 : option.visible) && React__default.createElement("div", {
      key: option.id,
      className: classNames(option.subtype.includes('name') ? rowBlock : nameBlock)
    }, React__default.createElement("label", {
      className: nameLabel,
      htmlFor: "".concat(questionId, "_").concat(option.id)
    }, option.required && React__default.createElement("span", {
      "aria-hidden": true
    }, "* "), React__default.createElement(RichText, {
      element: "span",
      text: option.label
    })), React__default.createElement(TextInput$1, {
      id: "".concat(questionId, "_").concat(option.id),
      className: nameInput,
      name: "".concat(questionId, "_").concat(option.id),
      defaultValue: getDefaultValueById(option.id),
      required: (option === null || option === void 0 ? void 0 : option.required) && required,
      disabled: (option === null || option === void 0 ? void 0 : option.disabled) && disabled,
      readOnly: (option === null || option === void 0 ? void 0 : option.readOnly) && readOnly,
      placeholder: (_option$placeholder = option.placeholder) !== null && _option$placeholder !== void 0 ? _option$placeholder : '',
      size: size,
      onChange: handleChange,
      "aria-invalid": !!error,
      "aria-describedby": error && errorId,
      "aria-labelledby": titleId,
      maxLength: TEXT_INPUT_MAX_CHARS
    }));
  })));
}
var NameField$1 = withErrorBoundary(NameField);
function getSelectedOption(options, value) {
  var selectedOption = {
    divider: false,
    label: '',
    value: ''
  };
  options.forEach(function (option) {
    if (!option.divider && option.value === value) {
      selectedOption = option;
    }
  });
  return selectedOption;
}
var DIVIDER_STYLE = {
  fontSize: '1px',
  backgroundColor: 'currentColor',
  color: 'inherit'
};
function CountrySelect(_ref160) {
  var value = _ref160.value,
    onChange = _ref160.onChange,
    options = _ref160.options,
    rest = _objectWithoutProperties(_ref160, _excluded64);
  var onChangeSelect = useCallback(function (event) {
    var v = event.target.value;
    onChange(v === 'ZZ' ? undefined : v);
  }, [onChange]);
  // "ZZ" means "International".
  // (HTML requires each `<option/>` have some string `value`).
  return React__default.createElement("select", _objectSpread({
    value: value || 'ZZ',
    onChange: onChangeSelect
  }, rest), options.map(function (_ref161) {
    var val = _ref161.value,
      label = _ref161.label,
      divider = _ref161.divider;
    return React__default.createElement("option", {
      key: divider ? '|' : val || 'ZZ',
      value: divider ? '|' : val || 'ZZ',
      style: divider ? DIVIDER_STYLE : undefined,
      "calling-code": getCountryCallingCode(val)
    }, label);
  }));
}
function CountrySelectWithIcon(_ref162) {
  var value = _ref162.value,
    options = _ref162.options,
    className = _ref162.className,
    Icon = _ref162.iconComponent,
    rest = _objectWithoutProperties(_ref162, _excluded65);
  var selectedOption = useMemo(function () {
    return getSelectedOption(options, value);
  }, [options, value]);
  return React__default.createElement("div", {
    className: "PhoneInputCountry"
  }, React__default.createElement(CountrySelect, _objectSpread(_objectSpread({}, rest), {}, {
    value: value,
    options: options,
    className: classNames('PhoneInputCountrySelect', className)
  })), React__default.createElement(Icon, {
    "aria-hidden": true,
    country: value,
    label: selectedOption && selectedOption.label
  }), React__default.createElement("div", {
    className: "PhoneInputCountrySelectArrow"
  }));
}
var useStyles$a = createUseStyles(function (theme) {
  var _theme$questionBody$f16, _PhoneInputInput, _theme$questionBody$f17, _theme$questionBody$f18, _PhoneInputInput2, _phoneTextInput, _theme$questionBody$f19, _theme$questionBody$f20, _theme$questionBody$f21, _theme$questionBody$f22, _theme$questionBody$f23, _placeholder, _extensionFieldClass;
  var breakpointMedium = "@media only screen and (max-width: ".concat(theme.breakpoints.md.max, ")");
  var breakpointXsMin = "@media only screen and (min-width: ".concat(theme.breakpoints.xs.min, ")");
  var fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
  return {
    phoneTextInput: (_phoneTextInput = {
      display: 'flex',
      alignItems: 'center',
      maxWidth: '100%'
    }, _defineProperty(_phoneTextInput, breakpointXsMin, {
      // extra 12px to account for the padding
      width: function width(_ref163) {
        var size = _ref163.size;
        return "calc(".concat(size, "ch + 12px)");
      }
    }), _defineProperty(_phoneTextInput, "transition", 'all 0.1s linear'), _defineProperty(_phoneTextInput, '& .PhoneInputInput', (_PhoneInputInput = {
      flex: 1,
      minWidth: 0,
      backgroundColor: '#fff',
      color: '#000',
      border: "1px solid ".concat(theme.answerColor),
      height: '28px',
      fontFamily: (_theme$questionBody$f16 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f16 !== void 0 ? _theme$questionBody$f16 : {},
      fontSize: '18px'
    }, _defineProperty(_PhoneInputInput, breakpointMedium, {
      fontSize: '16px'
    }), _defineProperty(_PhoneInputInput, "padding", '6px'), _defineProperty(_PhoneInputInput, "lineHeight", '1.5em'), _PhoneInputInput)), _defineProperty(_phoneTextInput, '& .PhoneInputCountry', {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      marginRight: '0.35em',
      border: "1px solid ".concat(theme.answerColor),
      height: '40px',
      width: '100px',
      justifyContent: 'center',
      alignSelf: 'auto',
      lineHeight: '1.5em',
      backgroundColor: '#fff'
    }), _defineProperty(_phoneTextInput, '& .PhoneInputCountrySelect', {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      zIndex: 1,
      border: 0,
      opacity: 0,
      cursor: 'pointer'
    }), _defineProperty(_phoneTextInput, '& .PhoneInputCountrySelectArrow', {
      display: 'block',
      content: '',
      borderStyle: 'solid',
      margin: '0px 8px',
      borderTop: '6px solid black',
      borderRight: '6px solid transparent',
      borderLeft: '6px solid transparent',
      borderBottom: '0px solid transparent',
      borderRadius: '2px'
    }), _defineProperty(_phoneTextInput, '& .PhoneInputCountryIcon', {
      height: '1.5em',
      width: '2.25em',
      border: "1px solid black",
      margin: '0px 8px'
    }), _defineProperty(_phoneTextInput, '& .PhoneInputCountryIconImg', {
      display: 'block',
      height: '100%',
      width: '100%'
    }), _defineProperty(_phoneTextInput, '& .CountryCallingCode', {
      marginRight: '5px',
      marginLeft: '5px',
      fontWeight: fontWeightOptions.medium,
      fontFamily: (_theme$questionBody$f17 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f17 !== void 0 ? _theme$questionBody$f17 : {},
      fontSize: '16px'
    }), _defineProperty(_phoneTextInput, '& .PhoneInputCountry:focus, & .PhoneInputCountry:hover', {
      outline: "2px solid ".concat(theme.primaryAccentColor)
    }), _defineProperty(_phoneTextInput, '& .PhoneInputInput:focus, & .PhoneInputInput:hover', {
      outline: "2px solid ".concat(theme.primaryAccentColor)
    }), _defineProperty(_phoneTextInput, '& .PhoneInputInput::placeholder', (_PhoneInputInput2 = {
      fontWeight: fontWeightOptions.light,
      fontFamily: (_theme$questionBody$f18 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f18 !== void 0 ? _theme$questionBody$f18 : {},
      fontSize: '18px'
    }, _defineProperty(_PhoneInputInput2, breakpointMedium, {
      fontSize: '16px'
    }), _defineProperty(_PhoneInputInput2, "color", '#999'), _PhoneInputInput2)), _defineProperty(_phoneTextInput, '& .PhoneInputInput:read-only:not(:disabled)', {
      borderColor: 'transparent',
      backgroundColor: theme.input.bgColor,
      color: theme.isDark ? '#fff' : '#000',
      opacity: 0.5
    }), _defineProperty(_phoneTextInput, '& .PhoneInputInput:disabled', {
      opacity: 0.4
    }), _phoneTextInput),
    phoneLabelContainer: {
      display: 'flex',
      paddingBottom: '8px'
    },
    phoneLabelClass: {
      fontFamily: (_theme$questionBody$f19 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f19 !== void 0 ? _theme$questionBody$f19 : {},
      fontSize: '16px',
      alignSelf: 'flex-end',
      overflowWrap: 'break-word',
      width: '200px'
    },
    countryLabelClass: {
      fontFamily: (_theme$questionBody$f20 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f20 !== void 0 ? _theme$questionBody$f20 : {},
      fontSize: '16px',
      width: '100px',
      overflowWrap: 'break-word',
      alignSelf: 'flex-end',
      marginRight: '.65em'
    },
    extensionLabelClass: {
      paddingBottom: '8px',
      fontFamily: (_theme$questionBody$f21 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f21 !== void 0 ? _theme$questionBody$f21 : {},
      fontSize: '16px',
      color: 'inherit'
    },
    extensionFieldClass: (_extensionFieldClass = {
      minWidth: 0,
      backgroundColor: '#fff',
      color: '#000',
      border: "1px solid ".concat(theme.answerColor),
      height: '42px',
      width: '85px',
      fontFamily: (_theme$questionBody$f22 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f22 !== void 0 ? _theme$questionBody$f22 : {},
      fontWeight: 'inherit',
      fontSize: '18px'
    }, _defineProperty(_extensionFieldClass, breakpointMedium, {
      fontSize: '16px'
    }), _defineProperty(_extensionFieldClass, "lineHeight", '1.5em'), _defineProperty(_extensionFieldClass, "padding", '6px'), _defineProperty(_extensionFieldClass, '&::placeholder', (_placeholder = {
      fontWeight: fontWeightOptions.light,
      fontFamily: (_theme$questionBody$f23 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f23 !== void 0 ? _theme$questionBody$f23 : {},
      fontSize: '18px'
    }, _defineProperty(_placeholder, breakpointMedium, {
      fontSize: '16px'
    }), _defineProperty(_placeholder, "color", '#999'), _placeholder)), _extensionFieldClass),
    questionContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    },
    fieldContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 14px 8px 0px',
      float: 'left',
      alignSelf: 'flex-end'
    }
  };
});
function PhoneField(_ref164) {
  var questionId = _ref164.id,
    required = _ref164.required,
    disabled = _ref164.disabled,
    readOnly = _ref164.readOnly,
    _ref164$responses = _ref164.responses,
    defaultResponses = _ref164$responses === void 0 ? [] : _ref164$responses,
    size = _ref164.size,
    hasCountrySelect = _ref164.hasCountrySelect,
    answerOptions = _ref164.answerOptions,
    countrySubtitle = _ref164.countrySubtitle,
    countryCode = _ref164.countryCode,
    fieldProps = _objectWithoutProperties(_ref164, _excluded66);
  var error = fieldProps.error,
    _fieldProps$errorId5 = fieldProps.errorId,
    errorId = _fieldProps$errorId5 === void 0 ? createErrorId(questionId) : _fieldProps$errorId5,
    titleId = fieldProps.title.id;
  var getDefaultValueById = function getDefaultValueById(id) {
    var defaultChoice = defaultResponses.find(function (c) {
      return c.id === id;
    });
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  var phoneDefault = '';
  var extDefault = '';
  answerOptions.forEach(function (option) {
    if (option.visible && option.subtype === 'phone_number') {
      var _getDefaultValueById;
      phoneDefault = (_getDefaultValueById = getDefaultValueById(option.id)) !== null && _getDefaultValueById !== void 0 ? _getDefaultValueById : '';
    } else if (option.visible && option.subtype === 'extension') {
      var _getDefaultValueById2;
      extDefault = (_getDefaultValueById2 = getDefaultValueById(option.id)) !== null && _getDefaultValueById2 !== void 0 ? _getDefaultValueById2 : '';
    }
  });
  var _useState65 = useState(phoneDefault),
    _useState66 = _slicedToArray(_useState65, 2),
    phoneValue = _useState66[0],
    setPhoneValue = _useState66[1];
  var handleChangeWithCountry = function handleChangeWithCountry(v) {
    setPhoneValue(v);
  };
  var _useStyles$a = useStyles$a({
      size: 40
    }),
    phoneTextInput = _useStyles$a.phoneTextInput,
    phoneLabelContainer = _useStyles$a.phoneLabelContainer,
    phoneLabelClass = _useStyles$a.phoneLabelClass,
    countryLabelClass = _useStyles$a.countryLabelClass,
    extensionLabelClass = _useStyles$a.extensionLabelClass,
    extensionFieldClass = _useStyles$a.extensionFieldClass,
    questionContainer = _useStyles$a.questionContainer,
    fieldContainer = _useStyles$a.fieldContainer;
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId
  }, fieldProps), React__default.createElement("div", {
    key: questionId,
    className: questionContainer
  }, answerOptions.map(function (option) {
    var _option$placeholder2;
    return (option === null || option === void 0 ? void 0 : option.visible) && React__default.createElement("div", {
      key: option.id,
      className: fieldContainer
    }, option.subtype === 'phone_number' && React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
      className: phoneLabelContainer
    }, hasCountrySelect && React__default.createElement("div", {
      className: countryLabelClass
    }, React__default.createElement(RichText, {
      element: "span",
      text: countrySubtitle
    })), React__default.createElement("div", {
      className: phoneLabelClass
    }, React__default.createElement(RichText, {
      element: "span",
      text: option.label
    }))), React__default.createElement(PhoneCountryInput, {
      id: "".concat(questionId, "_").concat(option.id),
      name: "".concat(questionId, "_").concat(option.id),
      className: classNames(phoneTextInput),
      value: phoneValue,
      required: required,
      disabled: disabled,
      readOnly: readOnly,
      size: size,
      onChange: handleChangeWithCountry,
      "aria-invalid": !!error,
      "aria-describedby": error && errorId,
      "aria-labelledby": titleId,
      maxLength: TEXT_INPUT_MAX_CHARS,
      placeholder: option.placeholder,
      addInternationalOption: false,
      defaultCountry: countryCode,
      countries: COUNTRY_CODES,
      focusInputOnCountrySelection: false,
      countrySelectComponent: CountrySelectWithIcon,
      international: true,
      countryCallingCodeEditable: false
    })), option.subtype === 'extension' && React__default.createElement(React__default.Fragment, null, React__default.createElement("label", {
      className: extensionLabelClass,
      htmlFor: "".concat(questionId, "_").concat(option.id)
    }, required && React__default.createElement("span", {
      "aria-hidden": true
    }, "* "), React__default.createElement(RichText, {
      element: "span",
      text: option.label
    })), React__default.createElement(TextInput$1, {
      id: "".concat(questionId, "_").concat(option.id),
      name: "".concat(questionId, "_").concat(option.id),
      className: extensionFieldClass,
      defaultValue: extDefault,
      required: required,
      disabled: disabled,
      readOnly: readOnly,
      placeholder: (_option$placeholder2 = option.placeholder) !== null && _option$placeholder2 !== void 0 ? _option$placeholder2 : '',
      size: size,
      "aria-invalid": !!error,
      "aria-describedby": error && errorId,
      "aria-labelledby": titleId,
      maxLength: TEXT_INPUT_MAX_CHARS
    })));
  })));
}
var PhoneField$1 = withErrorBoundary(PhoneField);
var useStyles$9 = createUseStyles(function (theme) {
  var _theme$questionBody$f24, _emailInput, _theme$questionBody$f25;
  var breakpointMedium = "@media only screen and (max-width: ".concat(theme.breakpoints.md.max, ")");
  var breakpointXsMin = "@media only screen and (min-width: ".concat(theme.breakpoints.xs.min, ")");
  var fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
  return {
    emailInput: (_emailInput = {
      backgroundColor: '#fff',
      color: '#000',
      border: "1px solid ".concat(theme.answerColor),
      fontFamily: (_theme$questionBody$f24 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f24 !== void 0 ? _theme$questionBody$f24 : {},
      fontSize: '18px'
    }, _defineProperty(_emailInput, breakpointMedium, {
      fontSize: '16px'
    }), _defineProperty(_emailInput, "padding", '6px'), _defineProperty(_emailInput, "lineHeight", '1.5em'), _defineProperty(_emailInput, "height", '40px'), _defineProperty(_emailInput, "maxWidth", '100%'), _defineProperty(_emailInput, "width", '100%'), _defineProperty(_emailInput, breakpointXsMin, {
      // extra 12px to account for the padding
      width: function width(_ref165) {
        var size = _ref165.size;
        return "calc(".concat(size, "ch + 12px)");
      }
    }), _defineProperty(_emailInput, '&::placeholder', _defineProperty({
      fontWeight: fontWeightOptions.light,
      fontSize: '18px'
    }, breakpointMedium, {
      fontSize: '16px'
    })), _emailInput),
    emailSubtitle: {
      display: 'flex',
      paddingBottom: '8px',
      fontFamily: (_theme$questionBody$f25 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f25 !== void 0 ? _theme$questionBody$f25 : {},
      fontSize: '16px'
    }
  };
});
function EmailField(_ref166) {
  var questionId = _ref166.id,
    required = _ref166.required,
    disabled = _ref166.disabled,
    readOnly = _ref166.readOnly,
    _ref166$responses = _ref166.responses,
    defaultResponses = _ref166$responses === void 0 ? [] : _ref166$responses,
    onChange = _ref166.onChange,
    size = _ref166.size,
    answerOptions = _ref166.answerOptions,
    fieldProps = _objectWithoutProperties(_ref166, _excluded67);
  var error = fieldProps.error,
    _fieldProps$errorId6 = fieldProps.errorId,
    errorId = _fieldProps$errorId6 === void 0 ? createErrorId(questionId) : _fieldProps$errorId6,
    titleId = fieldProps.title.id;
  var defaultValue = useMemo(function () {
    var _defaultResponses$fin12, _defaultResponses$fin13;
    return (_defaultResponses$fin12 = (_defaultResponses$fin13 = defaultResponses.find(function (r) {
      return !!r.value;
    })) === null || _defaultResponses$fin13 === void 0 ? void 0 : _defaultResponses$fin13.value) !== null && _defaultResponses$fin12 !== void 0 ? _defaultResponses$fin12 : '';
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var handleChange = function handleChange(e) {
    var responses = e.target.value ? [{
      id: questionId,
      value: e.target.value
    }] : [];
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var _useStyles$7 = useStyles$9({
      size: 40
    }),
    emailInput = _useStyles$7.emailInput,
    emailSubtitle = _useStyles$7.emailSubtitle;
  var optionId = answerOptions.id,
    label = answerOptions.label,
    placeholder = answerOptions.placeholder;
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId
  }, fieldProps), React__default.createElement("div", {
    className: emailSubtitle
  }, React__default.createElement(RichText, {
    element: "span",
    text: label
  })), React__default.createElement(TextInput$1, {
    id: "".concat(questionId, "_").concat(optionId),
    name: "".concat(questionId, "_").concat(optionId),
    className: emailInput,
    defaultValue: defaultValue,
    required: required,
    disabled: disabled,
    readOnly: readOnly,
    size: size,
    onChange: handleChange,
    "aria-invalid": !!error,
    "aria-describedby": error && errorId,
    "aria-labelledby": titleId,
    maxLength: TEXT_INPUT_MAX_CHARS,
    placeholder: placeholder
  }));
}
var EmailField$1 = withErrorBoundary(EmailField);
createUseStyles(function (_ref167) {
  var palette = _ref167.palette,
    radius = _ref167.radius;
  return {
    comment: {
      border: 'none',
      cursor: 'pointer',
      backgroundColor: function backgroundColor(_ref168) {
        var active = _ref168.active;
        return active ? palette.primary.main : palette.text.darkMuted;
      },
      color: palette.primary.contrast,
      fontSize: '13px',
      borderRadius: radius.small,
      height: '26px',
      lineHeight: '26px',
      textDecoration: 'none',
      width: 'auto'
    },
    commentIconContainer: {
      color: palette.primary.contrast,
      fontSize: '16px',
      lineHeight: '26px',
      margin: [0, '6px'],
      cursor: 'pointer'
    }
  };
});
var useStyles$8 = createUseStyles(function (theme) {
  return {
    reset: {
      border: 'none'
    },
    border: {
      borderTop: theme.border.main
    }
  };
});
function Keyline(_ref169) {
  var className = _ref169.className,
    spacingClass = _ref169.spacingClass,
    props = _objectWithoutProperties(_ref169, _excluded68);
  var _useStyles$8 = useStyles$8(),
    reset = _useStyles$8.reset,
    border = _useStyles$8.border;
  return React__default.createElement("hr", _objectSpread({
    className: classNames(reset, className, spacingClass, border)
  }, props));
}
withSpacing(Keyline);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var useStyles$7 = createUseStyles(function (theme) {
  return {
    scrollY: function scrollY(_ref170) {
      var _ref170$height = _ref170.height,
        height = _ref170$height === void 0 ? 'auto' : _ref170$height,
        _ref170$maxHeight = _ref170.maxHeight,
        maxHeight = _ref170$maxHeight === void 0 ? 'none' : _ref170$maxHeight,
        scrollable = _ref170.scrollable,
        flex = _ref170.flex;
      return {
        display: flex ? 'flex' : undefined,
        flexGrow: flex ? 1 : undefined,
        height: !Number.isNaN(height) && typeof height === 'number' ? "".concat(height, "px") : height,
        maxHeight: !Number.isNaN(maxHeight) && typeof maxHeight === 'number' ? "".concat(maxHeight, "px") : maxHeight,
        overflowY: scrollable ? 'auto' : 'hidden',
        '&::-webkit-scrollbar-thumb': {
          // This color is brand color 'stone' which is currently not in WrenchTheme
          backgroundColor: '#9DA5AA',
          borderRadius: '6px'
        },
        '&::-webkit-scrollbar': {
          backgroundColor: 'transparent',
          width: '6px',
          height: '6px'
        }
      };
    }
  };
});
function ScrollableBox(_ref171) {
  var children = _ref171.children,
    height = _ref171.height,
    maxHeight = _ref171.maxHeight,
    scrollable = _ref171.scrollable,
    tabIndex = _ref171.tabIndex,
    flex = _ref171.flex,
    props = _objectWithoutProperties(_ref171, _excluded69);
  var _useStyles$9 = useStyles$7({
      height: height,
      maxHeight: maxHeight,
      scrollable: scrollable,
      flex: flex
    }),
    scrollY = _useStyles$9.scrollY;
  var className = props.className,
    spacingClass = props.spacingClass,
    rest = _objectWithoutProperties(props, _excluded70);
  var scrollableBoxTabIndex = function scrollableBoxTabIndex() {
    if (tabIndex) {
      return tabIndex;
    }
    return height ? 0 : undefined;
  };
  return React__default.createElement("div", _objectSpread({
    // Scrollable elements should be accessible by keyboard users
    tabIndex: scrollableBoxTabIndex(),
    className: classNames(className, spacingClass, scrollY)
  }, rest), children);
}
withSpacing(ScrollableBox);
createUseStyles(function (theme) {
  return {
    slideBoxContainer: {
      width: function width(_ref172) {
        var _ref172$width = _ref172.width,
          _width4 = _ref172$width === void 0 ? '100%' : _ref172$width;
        return _width4;
      },
      height: function height(_ref173) {
        var _ref173$height = _ref173.height,
          _height4 = _ref173$height === void 0 ? '100%' : _ref173$height;
        return _height4;
      },
      /** Artbitrary - Should have some sort of min/max to display content properly */
      /* minWidth: '300px',
      minHeight: '200px', */
      display: 'flex',
      flexDirection: 'column'
    },
    slideBoxViewport: {
      display: 'flex',
      flex: '1 1 auto',
      overflow: 'hidden',
      position: 'relative'
    },
    slideBoxList: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      width: '100%',
      position: 'relative',
      height: '100%',
      transform: function transform(_ref174) {
        var _ref174$position = _ref174.position,
          position = _ref174$position === void 0 ? 0 : _ref174$position;
        return "translateX(".concat(-(position * 100), "%)");
      },
      transition: 'transform .3s ease-out'
    },
    slideBoxListItem: {
      display: 'flex',
      flex: '1 0 auto',
      width: '100%',
      padding: "0 ".concat(theme.spacing[4], "px")
    },
    slideBoxNavContainer: {
      flex: 'none',
      display: 'flex',
      justifyContent: 'stretch',
      alignItems: 'center',
      padding: '15px',
      boxSizing: 'border-box'
    },
    slideBoxNavIndicator: {
      flexGrow: 1
    }
  };
});
defineMessages({
  NEXT_BUTTON: {
    id: 'SlideBoxNavigation.NEXT_BUTTON',
    defaultMessage: 'NEXT',
    description: '[Type: button][Vis: med] - next button of slider'
  },
  PREVIOUS_BUTTON: {
    id: 'SlideBoxNavigation.PREVIOUS_BUTTON',
    defaultMessage: 'PREV',
    description: '[Type: button][Vis: med] - previous button of slider'
  },
  NEXT_SLIDE: {
    id: 'SlideBoxNavigation.NEXT_SLIDE',
    defaultMessage: 'Next slide',
    description: '[Type: label][Vis: low] - next button label of slider'
  },
  PREVIOUS_SLIDE: {
    id: 'SlideBoxNavigation.PREVIOUS_SLIDE',
    defaultMessage: 'Previous slide',
    description: '[Type: label][Vis: low] - previous button label of slider'
  },
  SLIDE_INDICATOR: {
    id: 'SlideBoxNavigation.SLIDE_INDICATOR',
    defaultMessage: '{position, number} of {total, number}',
    description: '[Type: label][Vis: low] - slide pagination'
  }
});
var sentimentColors = {
  unknown: '#9DA5AA',
  neutral: '#F9BE00',
  negative: '#DB4D5C',
  positive: '#00BF6F'
};
function Negative() {
  return React__default.createElement("path", {
    fill: sentimentColors.negative,
    d: "M16.875 10.125a1.874 1.874 0 11-.001-3.749 1.874 1.874 0 01.001 3.749zM6 18.563a6 6 0 0112 0H6zM5.25 8.25a1.874 1.874 0 113.749-.001 1.874 1.874 0 01-3.749.001zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0z",
    fillRule: "evenodd"
  });
}
withIcon(Negative);
function Neutral() {
  return React__default.createElement("path", {
    d: "M4.875 17.813h14.25v-3H4.875v3zm2.25-11.438a1.874 1.874 0 11.001 3.749 1.874 1.874 0 01-.001-3.749zm9.75 0a1.874 1.874 0 11.001 3.749 1.874 1.874 0 01-.001-3.749zM12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0z",
    fill: sentimentColors.neutral,
    fillRule: "evenodd"
  });
}
withIcon(Neutral);
function Positive() {
  return React__default.createElement("path", {
    fill: sentimentColors.positive,
    d: "M16.875 10.125a1.874 1.874 0 11-.001-3.749 1.874 1.874 0 01.001 3.749M12 19.313a6 6 0 01-6-6h12a6 6 0 01-6 6M5.25 8.25a1.874 1.874 0 113.749-.001 1.874 1.874 0 01-3.749.001M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0",
    fillRule: "evenodd"
  });
}
withIcon(Positive);
function Unknown() {
  return React__default.createElement("path", {
    d: "M14.177 11.626c-1.011.874-1.408 1.425-1.427 2.374h-2.42c0-1.5.575-2.202 1.468-3 .773-.702 1.625-1.158 1.625-2.26 0-.892-.634-1.65-1.844-1.65-1.229 0-2.041.872-2.22 2.201L7 8.645C7.338 6.746 8.963 5 11.739 5 14.414 5 16 6.557 16 8.55c0 1.444-.872 2.24-1.823 3.076M11.5 19c-.89 0-1.5-.669-1.5-1.51S10.61 16 11.5 16s1.5.649 1.5 1.49S12.39 19 11.5 19M12 0C5.373 0 0 5.373 0 12c0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12",
    fill: sentimentColors.unknown,
    fillRule: "evenodd"
  });
}
withIcon(Unknown);
defineMessages({
  PERCENT: {
    id: 'copySentiment.PERCENT',
    defaultMessage: "{percentage, number, percent}",
    description: '[Type: label][Vis: med] - percentage rendering'
  },
  SENTIMENT: {
    id: 'copySentiment.SENTIMENT',
    defaultMessage: "{sentiment, select, \n      positive {Positive}\n      negative {Negative}\n      neutral {Neutral}\n      other {Unknown}\n    }",
    description: '[Type: label][Vis: med] - sentiment labels'
  },
  SENTIMENT_WITH_PERCENT: {
    id: 'copySentiment.SENTIMENT_WITH_PERCENT',
    defaultMessage: "{sentiment, select, \n      positive {Positive: {percentage, number, percent}}\n      negative {Negative: {percentage, number, percent}}\n      neutral {Neutral: {percentage, number, percent}}\n      other {Unknown: {percentage, number, percent}}\n    }",
    description: '[Type: label][Vis: med] - sentiment labels with percentage'
  },
  // note this copy uses UNDETECTED instead of UNKNOWN because it is specific for analyze
  FILTER_BY_SENTIMENT: {
    id: 'copySentiment.FILTER_BY_SENTIMENT',
    defaultMessage: "{sentiment, select, \n      positive {Filter by positive sentiment}\n      negative {Filter by negative sentiment}\n      neutral {Filter by neutral sentiment}\n      other {Filter by undetected sentiment}\n    }",
    description: '[Type: title][Vis: med] - filter by sentiment'
  }
});
createUseStyles(function (theme) {
  return {
    chartItem: function chartItem(_ref175) {
      var width = _ref175.width;
      return {
        width: width && "".concat(width, "%")
      };
    },
    chartBar: function chartBar(_ref176) {
      var color = _ref176.color;
      return {
        border: "1px solid ".concat(theme.palette.background.light),
        backgroundColor: color,
        height: '30px'
      };
    }
  };
});

// support additional SVG attributes
(_Highcharts$AST = Highcharts.AST) === null || _Highcharts$AST === void 0 ? void 0 : _Highcharts$AST.allowedAttributes.push('viewBox');
(_Highcharts$AST2 = Highcharts.AST) === null || _Highcharts$AST2 === void 0 ? void 0 : _Highcharts$AST2.allowedAttributes.push('preserveAspectRatio');
(_Highcharts$AST3 = Highcharts.AST) === null || _Highcharts$AST3 === void 0 ? void 0 : _Highcharts$AST3.allowedAttributes.push('fill-rule');
// Highcharts 9 removes some HTML tags and attributes: https://www.highcharts.com/blog/changelog/#highcharts-v9.0.0
(_Highcharts$AST4 = Highcharts.AST) === null || _Highcharts$AST4 === void 0 ? void 0 : _Highcharts$AST4.allowedAttributes.push('data-testid');
var ACCESS_TYPE;
(function (ACCESS_TYPE) {
  ACCESS_TYPE["REQUEST"] = "REQUEST";
  ACCESS_TYPE["UPGRADE"] = "UPGRADE";
  ACCESS_TYPE["FULL"] = "FULL";
  ACCESS_TYPE["NONE"] = "NONE";
})(ACCESS_TYPE || (ACCESS_TYPE = {}));
var STATUS;
(function (STATUS) {
  STATUS["ERROR"] = "error";
  STATUS["SUCCESS"] = "success";
  STATUS["IN_PROGRESS"] = "inProgress";
})(STATUS || (STATUS = {}));
createUseStyles(function (theme) {
  return {
    imageContainer: {
      width: '200px',
      '& > img': {
        width: '200px',
        height: '100%'
      }
    },
    textContainer: {
      marginLeft: theme.spacing[6],
      '& p': {
        marginBottom: theme.spacing[3]
      },
      '& button:first-child': {
        marginRight: theme.spacing[4]
      }
    },
    title: {
      fontWeight: theme.type.fontWeight.medium
    }
  };
});
defineMessages({
  SENTIMENT_UPGRADE_MODAL_ALT_TEXT: {
    id: 'SentimentUpgradeModal.SENTIMENT_UPGRADE_MODAL_ALT_TEXT',
    defaultMessage: "Sentiment upgrade image",
    description: '[Type: Label][Vis: med] - Sentiment Upgrade Modal Image alt text'
  },
  SENTIMENT_UPGRADE_MODAL_TITLE: {
    id: 'SentimentUpgradeModal.SENTIMENT_UPGRADE_MODAL_TITLE',
    defaultMessage: "Sentiment Analysis",
    description: '[Type: Label][Vis: med] - Sentiment Upgrade Modal title'
  },
  SENTIMENT_UPGRADE_MODAL_SECTION_TITLE: {
    id: 'SentimentUpgradeModal.SENTIMENT_UPGRADE_MODAL_SECTION_TITLE',
    defaultMessage: "Know right away how people are feeling",
    description: '[Type: Label][Vis: med] - Sentiment Upgrade Modal section title'
  },
  SENTIMENT_UPGRADE_MODAL_SECTION_DESCRIPTION: {
    id: 'SentimentUpgradeModal.SENTIMENT_UPGRADE_MODAL_SECTION_DESCRIPTION',
    defaultMessage: "Turn on sentiment analysis with just one click. We\u2019ll classify\n    your text responses as positive, neutral, or negative to\n    reveal the emotion behind what people are saying.",
    description: '[Type: Label][Vis: med] - Sentiment Upgrade Modal description'
  },
  SENTIMENT_UPGRADE_BUTTON_TEXT: {
    id: 'SentimentUpgradeModal.SENTIMENT_UPGRADE_BUTTON_TEXT',
    defaultMessage: "Upgrade",
    description: '[Type: Label][Vis: med] - Sentiment Upgrade button text'
  },
  SENTIMENT_REQUEST_BUTTON_TEXT: {
    id: 'SentimentUpgradeModal.SENTIMENT_REQUEST_BUTTON_TEXT',
    defaultMessage: "Request feature",
    description: '[Type: Label][Vis: med] - Sentiment request button text'
  },
  SENTIMENT_CLOSE_BUTTON_TEXT: {
    id: 'SentimentUpgradeModal.SENTIMENT_CLOSE_BUTTON_TEXT',
    defaultMessage: "No thanks",
    description: '[Type: Label][Vis: med] - Sentiment close button text'
  }
});
defineMessages({
  TOOLTIP_TITLE: {
    id: 'WordCloudTooltip.TOOLTIP_TITLE',
    defaultMessage: '#{number} most important word',
    description: '[Type: header][Vis: med] - title of the chart'
  },
  OCCURRENCES: {
    id: 'WordCloudTooltip.TOOLTIP_OCCURRENCES',
    defaultMessage: 'Occurrences: {weight} ',
    description: '[Type: header][Vis: med] - title of the chart'
  }
});
createUseStyles(function (theme) {
  return {
    line: {
      stroke: theme.palette.border.hover,
      strokeWidth: 0.7
    },
    legendText: function legendText(_ref177) {
      var range = _ref177.range;
      return {
        fontSize: "".concat(range, "px"),
        fill: theme.palette.border.hover
      };
    }
  };
});
createUseStyles(function (theme) {
  return {
    legendContainer: function legendContainer(_ref178) {
      var maxWidth = _ref178.maxWidth;
      return {
        border: "1px solid ".concat(theme.palette.muted.main),
        paddingBottom: theme.spacing['5'],
        paddingLeft: theme.spacing['4'],
        paddingRight: theme.spacing['4'],
        paddingTop: theme.spacing['4'],
        maxWidth: maxWidth,
        width: '100%',
        height: '100%'
      };
    },
    legendWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    legendTitle: {
      textAlign: 'center',
      color: theme.palette.border.hover,
      fontSize: '11px',
      paddingBottom: theme.spacing['2']
    },
    legendLess: {
      flex: 0.2,
      alignSelf: 'center',
      textAlign: 'center',
      paddingLeft: theme.spacing['2'],
      paddingRight: theme.spacing['2'],
      color: theme.palette.border.hover,
      fontSize: '11px'
    },
    legendMore: {
      flex: 0.2,
      paddingLeft: theme.spacing['2'],
      paddingRight: theme.spacing['2'],
      color: theme.palette.border.hover,
      fontSize: '11px'
    },
    legend: {
      flex: 1
    },
    svg: {
      overflow: 'visible !important'
    }
  };
});
defineMessages({
  TITLE: {
    id: 'WordCloudLegend.TITLE',
    defaultMessage: 'Number of mentions',
    description: '[Type: header][Vis: med] - title of the legend'
  },
  FEWER: {
    id: 'WordCloudLegend.FEWER',
    defaultMessage: 'fewer',
    description: '[Type: header][Vis: med] - fewer'
  },
  MORE: {
    id: 'WordCloudLegend.MORE',
    defaultMessage: 'more',
    description: '[Type: header][Vis: med] - more'
  }
});
var useStyles$6 = createUseStyles(function (theme) {
  var _theme$questionBody11, _rowBlock2, _theme$questionBody$f26;
  var _ref179 = (_theme$questionBody11 = theme.questionBody) !== null && _theme$questionBody11 !== void 0 ? _theme$questionBody11 : {},
    _ref179$fontSize = _ref179.fontSize,
    fontSize = _ref179$fontSize === void 0 ? 'inherit' : _ref179$fontSize,
    _ref179$fontFamily = _ref179.fontFamily,
    fontFamily = _ref179$fontFamily === void 0 ? 'inherit' : _ref179$fontFamily,
    _ref179$fontWeight = _ref179.fontWeight,
    fontWeight = _ref179$fontWeight === void 0 ? 'inherit' : _ref179$fontWeight,
    _ref179$color = _ref179.color,
    color = _ref179$color === void 0 ? 'inherit' : _ref179$color;
  return {
    rowBlock: (_rowBlock2 = {}, _defineProperty(_rowBlock2, "@media (min-width: ".concat(theme.breakpoints.sm.max, ")"), {
      width: '33.3% !important'
    }), _defineProperty(_rowBlock2, "flexDirection", 'row'), _defineProperty(_rowBlock2, "float", 'left'), _rowBlock2),
    addressBlock: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 14px 8px 0px',
      width: '100%'
    },
    addressLabel: {
      paddingBottom: '8px',
      fontFamily: (_theme$questionBody$f26 = theme.questionBody.fontFamily) !== null && _theme$questionBody$f26 !== void 0 ? _theme$questionBody$f26 : {},
      fontSize: '16px',
      color: color
    },
    addressContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    },
    selectInput: {
      border: "1px solid ".concat(theme.answerColor, " !important"),
      height: '40px',
      width: '100%',
      marginBottom: '8px',
      padding: '6px',
      backgroundColor: '#fff',
      fontSize: fontSize,
      fontFamily: fontFamily,
      borderRadius: '0px',
      '&:hover, &:focus-within': {
        outline: "2px solid ".concat(theme.primaryAccentColor),
        border: "1px solid ".concat(theme.answerColor)
      },
      // the select tag in the NativeSelect does not take in classNames
      '& > select': {
        width: '100%',
        border: 'none',
        outline: 'none',
        '&:focus-within, &:hover': {
          border: 'none',
          outline: 'none'
        }
      }
    },
    addressInput: {
      border: "1px solid ".concat(theme.answerColor),
      height: '40px',
      width: '100%',
      marginBottom: '8px',
      fontSize: fontSize,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      color: '#000',
      padding: '6px'
    }
  };
});
function AddressField(_ref180) {
  var questionId = _ref180.id,
    required = _ref180.required,
    disabled = _ref180.disabled,
    readOnly = _ref180.readOnly,
    _ref180$responses = _ref180.responses,
    defaultResponses = _ref180$responses === void 0 ? [] : _ref180$responses,
    onChange = _ref180.onChange,
    _ref180$size = _ref180.size,
    size = _ref180$size === void 0 ? 20 : _ref180$size,
    _ref180$answerOptions = _ref180.answerOptions,
    answerOptions = _ref180$answerOptions === void 0 ? [] : _ref180$answerOptions,
    showStatesDropdown = _ref180.showStatesDropdown,
    _ref180$defaultCountr = _ref180.defaultCountry,
    defaultCountry = _ref180$defaultCountr === void 0 ? 'us' : _ref180$defaultCountr,
    fieldProps = _objectWithoutProperties(_ref180, _excluded71);
  var error = fieldProps.error,
    _fieldProps$errorId7 = fieldProps.errorId,
    errorId = _fieldProps$errorId7 === void 0 ? createErrorId(questionId) : _fieldProps$errorId7,
    titleId = fieldProps.title.id;
  var getDefaultValueById = function getDefaultValueById(id) {
    var defaultChoice = defaultResponses.find(function (c) {
      return c.id === id;
    });
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  var handleChange = function handleChange(e) {
    var responses = e.target.value ? [{
      id: e.target.id,
      value: e.target.value
    }] : [];
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var _useStyles$10 = useStyles$6(),
    addressLabel = _useStyles$10.addressLabel,
    addressInput = _useStyles$10.addressInput,
    addressBlock = _useStyles$10.addressBlock,
    rowBlock = _useStyles$10.rowBlock,
    addressContainer = _useStyles$10.addressContainer,
    selectInput = _useStyles$10.selectInput;
  // the following fields are styled different from the street addresses
  var rowSubtypes = ['state', 'zip', 'city', 'country'];
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId
  }, fieldProps), React__default.createElement("div", {
    className: addressContainer
  }, answerOptions.map(function (option) {
    var _option$placeholder3;
    var isStateLabel = option.subtype === 'state_label';
    var isCountryLabel = option.subtype === 'country_label';
    var showDropdown = isStateLabel && showStatesDropdown || isCountryLabel;
    var optionsList = isCountryLabel ? Object.keys(COUNTRIES) : US_STATES;
    var defaultValue = getDefaultValueById(option.id);
    // if there is no value for country set, use the defaultCountry value
    defaultValue = isCountryLabel && defaultValue === undefined ? defaultCountry : defaultValue;
    return (option === null || option === void 0 ? void 0 : option.visible) && React__default.createElement("div", {
      key: option.id,
      className: classNames(rowSubtypes.some(function (el) {
        return option.subtype.includes(el);
      }) ? rowBlock : {}, addressBlock)
    }, showDropdown ? React__default.createElement(React__default.Fragment, null, React__default.createElement("label", {
      className: addressLabel,
      htmlFor: "".concat(questionId, "_").concat(option.id)
    }, React__default.createElement(RichText, {
      element: "span",
      text: option.label
    })), React__default.createElement(NativeSelect, {
      id: "".concat(questionId, "_").concat(option.id),
      name: "".concat(questionId, "_").concat(option.id),
      disabled: option.disabled && disabled,
      onChange: handleChange,
      className: selectInput
    }, React__default.createElement(SelectAnswerOption, {
      selected: true,
      label: isCountryLabel ? 'Select country' : 'Select state',
      value: ""
    }), ' ', optionsList === null || optionsList === void 0 ? void 0 : optionsList.map(function (choice) {
      return React__default.createElement(SelectAnswerOption, {
        key: "".concat(option.id, "_").concat(choice),
        value: choice,
        selected: choice === defaultValue,
        label: isCountryLabel ? COUNTRIES[choice] : choice
      });
    }))) : React__default.createElement(React__default.Fragment, null, React__default.createElement("label", {
      className: addressLabel,
      htmlFor: "".concat(questionId, "_").concat(option.id)
    }, option.required && React__default.createElement("span", {
      "aria-hidden": true
    }, "* "), React__default.createElement(RichText, {
      element: "span",
      text: option.label
    })), React__default.createElement(TextInput$1, {
      id: "".concat(questionId, "_").concat(option.id),
      name: "".concat(questionId, "_").concat(option.id),
      className: addressInput,
      defaultValue: defaultValue,
      required: (option === null || option === void 0 ? void 0 : option.required) && required,
      disabled: (option === null || option === void 0 ? void 0 : option.disabled) && disabled,
      readOnly: (option === null || option === void 0 ? void 0 : option.readOnly) && readOnly,
      placeholder: (_option$placeholder3 = option.placeholder) !== null && _option$placeholder3 !== void 0 ? _option$placeholder3 : '',
      size: size,
      onChange: handleChange,
      "aria-invalid": !!error,
      "aria-describedby": error && errorId,
      "aria-labelledby": titleId,
      maxLength: TEXT_INPUT_MAX_CHARS
    })));
  })));
}
var AddressField$1 = withErrorBoundary(AddressField);
var useStyles$5 = createUseStyles(function (theme) {
  return {
    clearableTextInputContainer: {
      display: 'flex',
      position: 'relative',
      '&:hover $textInput': {
        outline: "2px solid ".concat(theme.primaryAccentColor)
      }
    },
    textInput: function textInput(_ref181) {
      var isRTL = _ref181.isRTL,
        maxLength = _ref181.maxLength;
      return {
        width: "calc(".concat(maxLength + 1, "ch + 25px)"),
        height: 30,
        fontSize: 16,
        textAlign: isRTL ? 'right' : 'left',
        borderRadius: 3,
        padding: isRTL ? [0, 10, 0, 25] : [0, 25, 0, 10],
        margin: [10, 0, 0, 5]
      };
    },
    clearButton: function clearButton(_ref182) {
      var isRTL = _ref182.isRTL;
      return {
        position: 'absolute',
        right: isRTL ? 'auto' : 5,
        left: isRTL ? 10 : 'auto',
        top: 15,
        backgroundColor: theme.secondaryAccentColor,
        borderRadius: 20,
        border: 'none',
        color: theme.primaryAccentColor,
        cursor: 'pointer',
        height: 20,
        width: 20,
        '&:hover': {
          color: theme.secondaryAccentColor,
          backgroundColor: theme.primaryAccentColor
        }
      };
    },
    clearButtonIcon: {
      width: 'inherit',
      height: 'inherit'
    },
    visuallyHidden: visuallyHidden
  };
});
function ClearableTextInput(_ref183) {
  var id = _ref183.id,
    className = _ref183.className,
    _ref183$value = _ref183.value,
    value = _ref183$value === void 0 ? '' : _ref183$value,
    onClear = _ref183.onClear,
    clearVisible = _ref183.clearVisible,
    clearButtonLabelText = _ref183.clearButtonLabelText,
    _ref183$maxLength = _ref183.maxLength,
    maxLength = _ref183$maxLength === void 0 ? 8 : _ref183$maxLength,
    props = _objectWithoutProperties(_ref183, _excluded72);
  var _useContext5 = useContext(L10NContext),
    isRTL = _useContext5.isRTL;
  var _useStyles$11 = useStyles$5({
      isRTL: isRTL,
      maxLength: maxLength
    }),
    clearableTextInputContainer = _useStyles$11.clearableTextInputContainer,
    textInput = _useStyles$11.textInput,
    clearButton = _useStyles$11.clearButton,
    clearButtonIcon = _useStyles$11.clearButtonIcon,
    visuallyHidden = _useStyles$11.visuallyHidden;
  var textBoxRef = useRef(null);
  var clearButtonClick = function clearButtonClick() {
    var _textBoxRef$current;
    onClear === null || onClear === void 0 ? void 0 : onClear();
    (_textBoxRef$current = textBoxRef.current) === null || _textBoxRef$current === void 0 ? void 0 : _textBoxRef$current.focus();
  };
  return React__default.createElement("div", {
    className: classNames(clearableTextInputContainer, className)
  }, React__default.createElement(TextInput$1, _objectSpread({
    id: id,
    className: classNames(textInput),
    maxLength: maxLength,
    size: maxLength,
    ref: textBoxRef,
    value: value
  }, props)), clearVisible && React__default.createElement("button", {
    type: "button",
    tabIndex: -1,
    onClick: clearButtonClick,
    className: clearButton
  }, React__default.createElement(CloseOutlineIcon$1, {
    className: clearButtonIcon
  }), React__default.createElement("span", {
    className: visuallyHidden
  }, clearButtonLabelText)));
}
var useStyles$4 = createUseStyles(function (theme) {
  var fontWeightOptions = getFontWeights(theme.questionBody.fontFamily);
  return {
    slider: {
      '-webkit-appearance': 'none',
      appearance: 'none',
      background: 'transparent',
      cursor: 'pointer',
      width: '100%',
      '&:focus': {
        outline: 'none',
        // Chrome, Safari, Opera, Edge focus style
        '&::-webkit-slider-thumb': {
          border: ['1px', 'solid', theme.answerColor],
          outline: [3, 'solid', theme.answerColor],
          outlineOffset: '0.2rem'
        },
        // Firefox focus style
        '&::-moz-range-thumb': {
          border: ['1px', 'solid', theme.answerColor],
          outline: [3, 'solid', theme.answerColor],
          outlineOffset: '0.2rem'
        }
      },
      // Chrome, Safari, Opera and Edge Chromium styles
      // slider track
      '&::-webkit-slider-runnable-track': {
        backgroundColor: '#ddd',
        border: [1, 'solid', theme.answerColor],
        borderRadius: '0.5rem',
        height: '0.75rem'
      },
      // slider thumb
      '&::-webkit-slider-thumb': {
        '-webkit-appearance': 'none',
        appearance: 'none',
        marginTop: '-6px',
        borderRadius: '3rem',
        border: ['1px', 'solid', theme.answerColor],
        backgroundColor: theme.primaryAccentColor,
        height: '1.5rem',
        width: '1.5rem'
      },
      // Firefox styles
      // slider track
      '&::-moz-range-track': {
        backgroundColor: '#ddd',
        border: [1, 'solid', theme.answerColor],
        borderRadius: '0.5rem',
        height: '0.75rem'
      },
      // slider thumb
      '&::-moz-range-thumb': {
        borderRadius: '3rem',
        border: [1, 'solid', theme.answerColor],
        backgroundColor: theme.primaryAccentColor,
        height: '1.25rem',
        width: '1.25rem'
      }
    },
    labelContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: 10
    },
    labelItem: {
      color: theme.questionColor,
      fontFamily: theme.questionBody.fontFamily,
      fontSize: '14px !important',
      fontWeight: theme.questionBody.fontWeight
    },
    container: {
      display: 'flex',
      gap: '0 25px',
      flexFlow: 'row wrap',
      justifyContent: 'space-between'
    },
    textInputContainer: {
      margin: 0
    },
    sliderContainer: {
      flexGrow: 4
    },
    alertMessageContainer: {
      width: '100%'
    },
    alertMessage: {
      display: 'flex',
      width: '100%',
      alignSelf: 'flex-end',
      alignItems: 'center',
      color: theme.questionColor,
      marginTop: 20,
      fontFamily: theme.questionBody.fontFamily,
      fontSize: 16,
      fontWeight: fontWeightOptions.light
    },
    alertMessageIcon: {
      margin: [1, 3, 0, 0]
    }
  };
});
function RangeSlider(_ref184) {
  var className = _ref184.className,
    minValue = _ref184.minValue,
    maxValue = _ref184.maxValue,
    stepSize = _ref184.stepSize,
    labels = _ref184.labels,
    hideTextBox = _ref184.hideTextBox,
    startPosition = _ref184.startPosition,
    defaultValue = _ref184.defaultValue,
    clearButtonLabelText = _ref184.clearButtonLabelText,
    stepMessage = _ref184.stepMessage,
    errorMessage = _ref184.errorMessage,
    onChange = _ref184.onChange;
  var _useStyles$12 = useStyles$4(),
    slider = _useStyles$12.slider,
    labelContainer = _useStyles$12.labelContainer,
    labelItem = _useStyles$12.labelItem,
    container = _useStyles$12.container,
    sliderContainer = _useStyles$12.sliderContainer,
    textInputContainer = _useStyles$12.textInputContainer,
    alertMessage = _useStyles$12.alertMessage,
    alertMessageIcon = _useStyles$12.alertMessageIcon,
    alertMessageContainer = _useStyles$12.alertMessageContainer;
  var startValue = defaultValue || startPosition;
  var _useState67 = useState(''),
    _useState68 = _slicedToArray(_useState67, 2),
    responseValue = _useState68[0],
    setResponseValue = _useState68[1];
  var _useState69 = useState(startValue.toString()),
    _useState70 = _slicedToArray(_useState69, 2),
    rangeValue = _useState70[0],
    setRangeValue = _useState70[1];
  var _useState71 = useState(defaultValue || ''),
    _useState72 = _slicedToArray(_useState71, 2),
    textValue = _useState72[0],
    setTextValue = _useState72[1];
  var _useState73 = useState(false),
    _useState74 = _slicedToArray(_useState73, 2),
    showStepMessage = _useState74[0],
    setShowStepMessage = _useState74[1];
  var _useState75 = useState(false),
    _useState76 = _slicedToArray(_useState75, 2),
    showInvalidEntryMessage = _useState76[0],
    setShowInvalidEntryMessage = _useState76[1];
  var minLabelText = labels.left,
    middleLabelText = labels.middle,
    maxLabelText = labels.right;
  var changeValue = function changeValue(value) {
    var intVal = parseInt(value, 10);
    var responseVal = '';
    var textBoxVal = '';
    var displayStepMessage = false;
    var displayInvalidMessage = false;
    if (intVal < minValue) {
      textBoxVal = value;
      displayInvalidMessage = true;
    } else if (intVal > maxValue) {
      textBoxVal = value;
      displayInvalidMessage = true;
    } else if (value === '' || (intVal - minValue) % stepSize === 0) {
      responseVal = value;
      textBoxVal = value;
    } else if (Number.isNaN(intVal)) {
      displayInvalidMessage = true;
      textBoxVal = value;
    } else {
      // The value lies between two step points.
      // Determine the closest step point and make that the current value.
      responseVal = (Math.round((intVal - minValue) / stepSize) * stepSize + minValue).toString();
      textBoxVal = responseVal;
      displayStepMessage = true;
    }
    setRangeValue(responseVal || startPosition.toString());
    setResponseValue(responseVal);
    setTextValue(textBoxVal);
    onChange === null || onChange === void 0 ? void 0 : onChange(responseVal);
    setShowStepMessage(displayStepMessage);
    setShowInvalidEntryMessage(displayInvalidMessage);
  };
  var valueChangeHandler = function valueChangeHandler(answerValue) {
    if (answerValue !== responseValue) {
      changeValue(answerValue);
    }
  };
  var clearText = function clearText() {
    changeValue('');
  };
  var getAccessibleValueText = function getAccessibleValueText(rValue) {
    var value = parseInt(rValue, 10);
    if (value === minValue) {
      return "".concat(value, ", ").concat(minLabelText);
    }
    if (value === Math.round(maxValue / 2)) {
      return "".concat(value, ", ").concat(middleLabelText);
    }
    if (value === maxValue) {
      return "".concat(value, ", ").concat(maxLabelText);
    }
    return rValue;
  };
  var invalidEntryMessage = errorMessage.replace(/\{0}/, minValue.toString()).replace(/\{1}/, maxValue.toString());
  return React__default.createElement("div", {
    className: classNames(className, container)
  }, React__default.createElement("div", {
    className: sliderContainer
  }, React__default.createElement("div", {
    className: labelContainer
  }, React__default.createElement("div", {
    className: labelItem
  }, minLabelText), React__default.createElement("div", {
    className: labelItem
  }, middleLabelText), React__default.createElement("div", {
    className: labelItem
  }, maxLabelText)), React__default.createElement("input", {
    type: "range",
    "aria-valuetext": getAccessibleValueText(rangeValue),
    value: rangeValue,
    className: slider,
    min: minValue,
    max: maxValue,
    step: stepSize,
    onChange: function onChange(e) {
      valueChangeHandler(e.target.value);
    }
  })), !hideTextBox && React__default.createElement(ClearableTextInput, {
    className: textInputContainer,
    onChange: function onChange(e) {
      setTextValue(e.target.value);
    },
    onBlur: function onBlur(e) {
      valueChangeHandler(e.target.value);
    },
    onClear: clearText,
    value: textValue,
    maxLength: 8,
    clearVisible: !!textValue,
    inputMode: "numeric",
    pattern: "[0-9]*",
    clearButtonLabelText: clearButtonLabelText
  }), React__default.createElement("div", {
    "aria-live": "assertive",
    className: alertMessageContainer
  }, (showStepMessage || showInvalidEntryMessage) && React__default.createElement("div", {
    className: alertMessage
  }, React__default.createElement(InfoIcon$1, {
    className: alertMessageIcon
  }), showStepMessage && React__default.createElement("span", null, stepMessage), showInvalidEntryMessage && React__default.createElement("span", null, invalidEntryMessage))));
}
var COPY$2 = defineMessages({
  SLIDER_CLEAR_BUTTON_LABEL: {
    id: 'Slider.CLEAR_BUTTON_LABEL',
    defaultMessage: 'Clear',
    description: '[Type: label][Vis: low] - screen reader only label for clear button'
  },
  SLIDER_STEP_MESSAGE: {
    id: 'Slider.STEP_MESSAGE',
    defaultMessage: "We adjusted the number you entered based on the slider's scale.",
    description: '[Type: message][Vis: medium] - Message displayed when the entered value needs to be moved to the next closest step'
  }
});
function Slider(_ref185) {
  var questionId = _ref185.id,
    _ref185$responses = _ref185.responses,
    defaultResponses = _ref185$responses === void 0 ? [] : _ref185$responses,
    onChange = _ref185.onChange,
    scaleOptions = _ref185.scaleOptions,
    hideNumericalInput = _ref185.hideNumericalInput,
    _dis = _ref185.disabled,
    _req = _ref185.required,
    _ro = _ref185.readOnly,
    fieldProps = _objectWithoutProperties(_ref185, _excluded73);
  var defaultValue = useMemo(function () {
    var _defaultResponses$fin14, _defaultResponses$fin15;
    return (_defaultResponses$fin14 = (_defaultResponses$fin15 = defaultResponses.find(function (r) {
      return !!r.value;
    })) === null || _defaultResponses$fin15 === void 0 ? void 0 : _defaultResponses$fin15.value) !== null && _defaultResponses$fin14 !== void 0 ? _defaultResponses$fin14 : '';
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var _useState77 = useState(defaultResponses),
    _useState78 = _slicedToArray(_useState77, 2),
    setResponseValue = _useState78[1];
  var clearButtonLabelText = t(COPY$2.SLIDER_CLEAR_BUTTON_LABEL);
  var stepMessage = t(COPY$2.SLIDER_STEP_MESSAGE);
  var valueChanged = function valueChanged(selectedValue) {
    var responses = selectedValue ? [{
      id: questionId,
      value: selectedValue
    }] : [];
    setResponseValue(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var errorId = createErrorId(questionId);
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    errorId: errorId,
    "data-testid": "SliderQuestionType"
  }, fieldProps), React__default.createElement(RangeSlider, _objectSpread({
    defaultValue: parseInt(defaultValue, 10),
    hideTextBox: hideNumericalInput,
    stepMessage: stepMessage,
    clearButtonLabelText: clearButtonLabelText,
    onChange: valueChanged
  }, scaleOptions)));
}
var useStyles$3 = createUseStyles({
  radioIconInput: {
    /* needed to override styles in BaseInput which effects opacity of icons */
    '& svg': {
      opacity: 1
    }
  }
});
function RadioIconInput(_ref186, forwardedRef) {
  var className = _ref186.className,
    icon = _ref186.icon,
    props = _objectWithoutProperties(_ref186, _excluded74);
  var _useInputStyles6 = useInputStyles(props),
    inputProps = _useInputStyles6.inputProps;
  var _useStyles$13 = useStyles$3(),
    radioIconInput = _useStyles$13.radioIconInput;
  return React__default.createElement(BaseInput$1, _objectSpread({
    type: "radio",
    className: classNames(radioIconInput, className),
    icon: icon,
    ref: forwardedRef
  }, inputProps));
}
var RadioIconInput$1 = forwardRef(RadioIconInput);
var useStyles$2 = createUseStyles(function (theme) {
  var _theme$breakpoints20, _inputStyles;
  return {
    visuallyHidden: visuallyHidden,
    inputStyles: (_inputStyles = {
      textAlign: 'center',
      margin: 'auto',
      marginTop: '4px'
    }, _defineProperty(_inputStyles, "@media (max-width: ".concat((_theme$breakpoints20 = theme.breakpoints) === null || _theme$breakpoints20 === void 0 ? void 0 : _theme$breakpoints20.xs.max, ")"), {
      margin: '5px',
      marginTop: '4px'
    }), _defineProperty(_inputStyles, '&:hover', {
      outline: "1px dashed ".concat(theme.questionColor),
      marginTop: '5px'
    }), _defineProperty(_inputStyles, '&:focus-within', {
      outline: "1px solid ".concat(theme.questionColor),
      marginTop: '5px'
    }), _defineProperty(_inputStyles, "color", function color(_ref187) {
      var _ref187$selected = _ref187.selected,
        selected = _ref187$selected === void 0 ? false : _ref187$selected,
        _ref187$symbolColor = _ref187.symbolColor,
        symbolColor = _ref187$symbolColor === void 0 ? '#F5A623' : _ref187$symbolColor;
      if (selected) {
        return symbolColor;
      }
      return '#fff';
    }), _inputStyles)
  };
});
function StarRatingItem(_ref188) {
  var onChange = _ref188.onChange,
    selected = _ref188.selected,
    checkedProp = _ref188.checked,
    nameProp = _ref188.name,
    symbolColor = _ref188.symbolColor,
    props = _objectWithoutProperties(_ref188, _excluded75);
  var checked = checkedProp;
  var name = nameProp;
  var radioGroup = useRadioGroup();
  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }
    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }
  var _useStyles$14 = useStyles$2({
      checked: checked,
      selected: selected,
      symbolColor: symbolColor !== null && symbolColor !== void 0 ? symbolColor : ''
    }),
    visuallyHidden = _useStyles$14.visuallyHidden,
    inputStyles = _useStyles$14.inputStyles;
  var handleChange = function handleChange(e) {
    var _e$target3 = e.target,
      id = _e$target3.id,
      isChecked = _e$target3.checked,
      value = _e$target3.value;
    radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.onChange({
      id: id,
      checked: isChecked,
      value: value
    });
    onChange === null || onChange === void 0 ? void 0 : onChange({
      id: id,
      checked: isChecked,
      value: value
    });
  };
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(RadioIconInput$1, _objectSpread({
    name: name,
    className: inputStyles,
    onChange: handleChange,
    checked: checked
  }, props)), React__default.createElement("label", {
    className: visuallyHidden,
    htmlFor: props.id
  }, props.label));
}
var useStyles$1 = createUseStyles(function (theme) {
  var _theme$breakpoints21, _theme$breakpoints22, _theme$breakpoints23, _theme$breakpoints24, _theme$breakpoints25, _theme$breakpoints26;
  var listItemBackground = theme.input.bgColor;
  return {
    visuallyHidden: visuallyHidden,
    ratingGroupStyle: _defineProperty({
      display: 'flex',
      width: '100%',
      justifyContent: 'space-evenly'
    }, "@media (max-width: ".concat((_theme$breakpoints21 = theme.breakpoints) === null || _theme$breakpoints21 === void 0 ? void 0 : _theme$breakpoints21.xs.max, ")"), {
      flexDirection: 'column'
    }),
    starContainer: _defineProperty({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      width: '100%',
      textAlign: 'center'
    }, "@media (max-width: ".concat((_theme$breakpoints22 = theme.breakpoints) === null || _theme$breakpoints22 === void 0 ? void 0 : _theme$breakpoints22.xs.max, ")"), {
      backgroundColor: isDark(theme.questionBody.color || '#fff') ? listItemBackground : 'rgba(255, 255, 255, 0.15)',
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
      marginBottom: '5px'
    }),
    starLabel: _defineProperty({
      color: theme.questionColor,
      fontFamily: theme.questionBody.fontFamily,
      fontSize: 14,
      fontWeight: theme.questionBody.fontWeight,
      lineHeight: 1.25
    }, "@media (max-width: ".concat((_theme$breakpoints23 = theme.breakpoints) === null || _theme$breakpoints23 === void 0 ? void 0 : _theme$breakpoints23.xs.max, ")"), {
      // overwrite TextInput styles
      fontSize: theme.questionBody.fontSize,
      marginTop: '8px'
    }),
    naLabel: _defineProperty({
      color: theme.questionColor,
      fontFamily: theme.questionBody.fontFamily,
      fontSize: 14,
      fontWeight: theme.questionBody.fontWeight,
      lineHeight: 1.25
    }, "@media (max-width: ".concat((_theme$breakpoints24 = theme.breakpoints) === null || _theme$breakpoints24 === void 0 ? void 0 : _theme$breakpoints24.xs.max, ")"), {
      // overwrite TextInput styles
      display: 'none'
    }),
    starRow: _defineProperty({
      height: '42px',
      fontSize: '2em'
    }, "@media (min-width: ".concat((_theme$breakpoints25 = theme.breakpoints) === null || _theme$breakpoints25 === void 0 ? void 0 : _theme$breakpoints25.sm.min, ")"), {
      backgroundColor: isDark(theme.questionBody.color || '#fff') ? listItemBackground : 'rgba(255, 255, 255, 0.15)'
    }),
    naRow: _defineProperty({
      height: '42px',
      width: '100%'
    }, "@media (min-width: ".concat((_theme$breakpoints26 = theme.breakpoints) === null || _theme$breakpoints26 === void 0 ? void 0 : _theme$breakpoints26.sm.min, ")"), {
      backgroundColor: isDark(theme.questionBody.color || '#fff') ? listItemBackground : 'rgba(255, 255, 255, 0.15)',
      '& label': {
        display: 'block',
        height: '42px'
      },
      '& span[class^="smqr-richTextContent"]': {
        display: 'none'
      }
    })
  };
});
var COPY$1 = defineMessages({
  STAR: {
    id: 'StarRating.STAR',
    defaultMessage: '{count} {count, plural, one {star} other {stars}}',
    description: 'Star Symbol Rating Label'
  },
  SMILEY: {
    id: 'StarRating.Smiley',
    defaultMessage: '{count} {count, plural, one {smiley} other {smileys}}',
    description: 'Smiley Symbol Rating Label'
  },
  HEART: {
    id: 'StarRating.Heart',
    defaultMessage: '{count} {count, plural, one {heart} other {hearts}}',
    description: 'Heart Symbol Rating Label'
  },
  THUMB: {
    id: 'StarRating.Thumb',
    defaultMessage: '{count} {count, plural, one {thumb} other {thumbs}}',
    description: 'Thumb Symbol Rating Label'
  }
});
function StarRating(_ref189) {
  var _ref189$choices = _ref189.choices,
    choices = _ref189$choices === void 0 ? [] : _ref189$choices,
    choiceNoneOfTheAbove = _ref189.choiceNoneOfTheAbove,
    choiceComment = _ref189.choiceComment,
    disabled = _ref189.disabled,
    required = _ref189.required,
    questionId = _ref189.id,
    rowId = _ref189.rowId,
    _ro = _ref189.readOnly,
    onChange = _ref189.onChange,
    _ref189$responses = _ref189.responses,
    defaultResponses = _ref189$responses === void 0 ? [] : _ref189$responses,
    symbolOptions = _ref189.symbolOptions,
    fieldProps = _objectWithoutProperties(_ref189, _excluded76);
  var errorId = createErrorId(questionId);
  var _useState79 = useState(defaultResponses),
    _useState80 = _slicedToArray(_useState79, 2),
    response = _useState80[0],
    setResponse = _useState80[1];
  /** Filter choices that exist and are visible  */
  var _useQuestionChoices6 = useQuestionChoices([].concat(_toConsumableArray(choices), [choiceNoneOfTheAbove, choiceComment])),
    options = _useQuestionChoices6.options,
    ratingOptions = _useQuestionChoices6.sortableOptions,
    notaOption = _useQuestionChoices6.notaOption,
    commentOption = _useQuestionChoices6.commentOption;
  var isSelected = function isSelected(index) {
    var selectedResponse = response.find(function (c) {
      return c.type !== 'COMMENT';
    });
    var selectedIndex = ratingOptions.findIndex(function (option) {
      return option.id === (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.value);
    });
    return selectedIndex >= index;
  };
  var isChecked = function isChecked(ratingId) {
    var selectedResponse = response.find(function (c) {
      return c.type !== 'COMMENT';
    });
    return ratingId === (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.value);
  };
  /**
   * Default value for the group
   */
  var defaultValue = useMemo(function () {
    var _defaultResponses$fin16;
    return (_defaultResponses$fin16 = defaultResponses.find(function (c) {
      return c.type !== 'COMMENT';
    })) === null || _defaultResponses$fin16 === void 0 ? void 0 : _defaultResponses$fin16.value;
  },
  // defaultValues should not be changed post render (breaks rules of controlled components)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  /**
   * deselect choice if the question is not required
   */
  var unCheckOption = function unCheckOption() {
    if (required) {
      return;
    }
    var responses = response.filter(function (c) {
      return c.type === 'COMMENT';
    });
    setResponse(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  /**
   * Default value by id
   * used for text-input based choices
   */
  var getDefaultValueById = function getDefaultValueById(id) {
    var defaultChoice = defaultResponses.find(function (c) {
      return c.id === id;
    });
    return defaultChoice === null || defaultChoice === void 0 ? void 0 : defaultChoice.value;
  };
  var handleClick = function handleClick(e) {
    var input = e.target;
    var selectedResponse = response.find(function (c) {
      return c.type !== 'COMMENT';
    });
    var isCheckedID = (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.value) === input.id;
    if (isCheckedID && input.checked) {
      e.preventDefault();
      unCheckOption();
    }
  };
  var handleKeyboard = function handleKeyboard(e) {
    var selectedResponse = response.find(function (c) {
      return c.type !== 'COMMENT';
    });
    var isCheckedID = (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.value) === e.target.id;
    if (isCheckedID && e.code === 'Space' || /* unCheck when ArrowLeft is pressed while on the first option */
    (selectedResponse === null || selectedResponse === void 0 ? void 0 : selectedResponse.value) === options[0].id && e.code === 'ArrowLeft') {
      e.preventDefault();
      unCheckOption();
    }
  };
  var handleRadioChange = function handleRadioChange(e) {
    var choiceData = ratingOptions.find(function (c) {
      return e.id === c.id;
    });
    var responses = response.filter(function (c) {
      return c.type === 'COMMENT';
    });
    if (choiceData) {
      var type = choiceData.type;
      responses.push({
        id: rowId,
        type: type,
        value: e.value
      });
      setResponse(responses);
      onChange === null || onChange === void 0 ? void 0 : onChange(responses);
    } else if (e.id === (notaOption === null || notaOption === void 0 ? void 0 : notaOption.id)) {
      responses.push({
        id: rowId,
        type: 'NOTA',
        value: e.value
      });
      setResponse(responses);
      onChange === null || onChange === void 0 ? void 0 : onChange(responses);
    }
  };
  var handleCommentChange = function handleCommentChange(e) {
    var choiceData = options.find(function (c) {
      return c.id === e.target.id;
    });
    var responses = response.filter(function (c) {
      return c.type !== 'COMMENT';
    });
    if (choiceData && !!e.target.value) {
      var id = choiceData.id,
        type = choiceData.type;
      responses.push({
        id: id,
        type: type,
        value: e.target.value
      });
    }
    setResponse(responses);
    onChange === null || onChange === void 0 ? void 0 : onChange(responses);
  };
  var radioGroupProps = {
    disabled: disabled,
    name: questionId,
    defaultValue: defaultValue,
    onChange: handleRadioChange
  };
  var _useStyles$15 = useStyles$1(),
    starLabel = _useStyles$15.starLabel,
    naLabel = _useStyles$15.naLabel,
    ratingGroupStyle = _useStyles$15.ratingGroupStyle,
    starContainer = _useStyles$15.starContainer,
    naRow = _useStyles$15.naRow,
    starRow = _useStyles$15.starRow;
  var radioEvents = {
    onClick: handleClick,
    onKeyDown: handleKeyboard
  };
  var getHiddenLabel = function getHiddenLabel(index) {
    var count = index + 1;
    switch (symbolOptions === null || symbolOptions === void 0 ? void 0 : symbolOptions.symbol) {
      case 'HEART':
        return t(COPY$1.HEART, {
          count: count
        });
      case 'SMILEY':
        return t(COPY$1.SMILEY, {
          count: count
        });
      case 'THUMB':
        return t(COPY$1.THUMB, {
          count: count
        });
      default:
        return t(COPY$1.STAR, {
          count: count
        });
    }
  };
  var getIcon = function getIcon() {
    switch (symbolOptions === null || symbolOptions === void 0 ? void 0 : symbolOptions.symbol) {
      case 'HEART':
        return React__default.createElement(HeartIcon$1, null);
      case 'SMILEY':
        return React__default.createElement(SmileyIcon$1, null);
      case 'THUMB':
        return React__default.createElement(ThumbsUpIcon$1, null);
      default:
        return React__default.createElement(StarIcon$1, null);
    }
  };
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    "data-testid": "StarRatingQuestionType",
    errorId: errorId
  }, fieldProps), React__default.createElement(RadioGroup, _objectSpread({}, radioGroupProps), React__default.createElement("div", {
    className: ratingGroupStyle
  }, ratingOptions.map(function (ratingOption, index) {
    return React__default.createElement("div", {
      className: starContainer,
      key: ratingOption.id
    }, React__default.createElement("div", {
      className: starLabel,
      id: "".concat(ratingOption.id, "-desc")
    }, ratingOption.label), React__default.createElement("div", {
      className: starRow
    }, React__default.createElement(StarRatingItem, _objectSpread(_objectSpread({
      icon: getIcon(),
      id: ratingOption.id,
      label: getHiddenLabel(index),
      checked: isChecked(ratingOption.id),
      selected: isSelected(index),
      value: ratingOption.id
    }, radioEvents), {}, {
      "aria-describedby": ratingOption.label ? "".concat(ratingOption.id, "-desc") : undefined,
      symbolColor: symbolOptions === null || symbolOptions === void 0 ? void 0 : symbolOptions.color
    }))));
  }), notaOption && React__default.createElement("div", {
    className: starContainer,
    key: notaOption.id
  }, React__default.createElement("div", {
    className: naLabel,
    id: "".concat(notaOption.id, "-desc")
  }, notaOption.label), React__default.createElement("div", {
    className: naRow
  }, React__default.createElement(Radio$1, _objectSpread({
    id: notaOption.id,
    key: notaOption.id,
    value: notaOption.id,
    checked: isChecked(notaOption.id),
    "aria-describedby": fieldProps.error && errorId,
    inputSize: 20
  }, radioEvents), notaOption.label)))), commentOption && React__default.createElement(CommentChoice, {
    id: commentOption.id,
    label: commentOption.label,
    onChange: handleCommentChange,
    defaultValue: getDefaultValueById(commentOption.id),
    lineCount: commentOption.linesCount,
    charCount: commentOption.charsCount,
    maxLength: TEXT_INPUT_MAX_CHARS
  })));
}
var useStyles = createUseStyles(function (theme) {
  var _theme$questionBody12 = theme.questionBody,
    fontSize = _theme$questionBody12.fontSize,
    fontFamily = _theme$questionBody12.fontFamily,
    fontWeight = _theme$questionBody12.fontWeight;
  var iconSize = '40px';
  return {
    srOnly: _objectSpread({}, visuallyHidden),
    container: {
      display: 'flex',
      flexDirection: 'column'
    },
    label: {
      fontSize: fontSize,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      color: theme.questionColor,
      marginBottom: '14px'
    },
    instructionsContainer: {
      paddingBottom: '15px'
    },
    fileDragArea: _defineProperty({
      maxWidth: '600px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: '#404040',
      transition: 'all .2s linear',
      opacity: function opacity(_ref190) {
        var disabled = _ref190.disabled;
        return disabled ? 0.5 : 1;
      }
    }, "@media (min-width: ".concat(theme.breakpoints.sm.min, ")"), {
      padding: '20px',
      gap: '10px',
      backgroundColor: function backgroundColor(_ref191) {
        var disabled = _ref191.disabled,
          dragActive = _ref191.dragActive;
        return !disabled && dragActive ? '#ABABAB' : '#EFEFEF';
      },
      border: function border(_ref192) {
        var disabled = _ref192.disabled,
          dragActive = _ref192.dragActive;
        return !disabled && dragActive ? '1px dashed #ABABAB' : '1px dashed #404040';
      },
      outline: function outline(_ref193) {
        var disabled = _ref193.disabled,
          dragActive = _ref193.dragActive;
        return !disabled && dragActive ? '3px solid #404040' : 'none';
      }
    }),
    draggingActive: _defineProperty({
      background: 'blue'
    }, "@media (min-width: ".concat(theme.breakpoints.sm.min, ")"), {
      borderColor: '#ABABAB',
      backgroundColor: '#ABABAB',
      outline: '3px solid #404040'
    }),
    fileUploadDragDesktop: _defineProperty({
      display: 'none'
    }, "@media (min-width: ".concat(theme.breakpoints.sm.min, ")"), {
      display: 'inline-block'
    }),
    stateArea: _defineProperty({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px'
    }, "@media (min-width: ".concat(theme.breakpoints.sm.min, ")"), {
      minHeight: '90px'
    }),
    stateIcon: {
      fontSize: iconSize
    },
    stateText: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    removeFileButton: {
      height: '20px',
      borderRadius: '50%',
      padding: '0',
      border: 'none',
      background: 'transparent',
      fontSize: '20px',
      transition: 'all .2s linear',
      color: '#404040',
      cursor: 'pointer',
      '&:hover, &:focus': {
        outline: '1px solid rgba(64,64,64,1)',
        boxShadow: '0 0 4px transparent',
        outlineOffset: '5px'
      }
    },
    fileUploadText: {
      padding: '15px 0'
    },
    fileUploadLabel: {
      position: 'relative',
      marginRight: '5px',
      transition: 'all .2s linear',
      '&:has(input:focus)': {
        outline: '1px solid #0A7CC1',
        boxShadow: '0 0 4px transparent',
        outlineOffset: '5px'
      }
    },
    fileUploadInput: {
      cursor: 'pointer',
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      opacity: 0,
      fontSize: '.1px'
    },
    linkStyle: {
      color: '#0A7CC1',
      background: 'transparent',
      border: 'none',
      textDecoration: 'underline',
      padding: '0',
      fontSize: '1em',
      display: 'inline-block'
    },
    fileTypeListParagraph: {
      margin: 0
    },
    fileTypeListItem: {
      background: '#404040',
      borderRadius: '3px',
      padding: '5px',
      textTransform: 'uppercase',
      color: '#FFFFFF',
      fontWeight: '700',
      fontSize: '12px',
      margin: '0 5px'
    },
    loading: {
      width: iconSize,
      height: iconSize,
      border: '5px solid rgba(0,0,0,0.25)',
      borderBottomColor: '#008323',
      borderRadius: '50%',
      display: 'inline-block',
      boxSizing: 'border-box',
      animation: '$rotation 1s linear infinite'
    },
    '@keyframes rotation': {
      '0%': {
        transform: 'rotate(0deg)'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    }
  };
});
var COPY = defineMessages({
  CHOOSE_OR_DRAG: {
    id: 'FileUpload.chooseDragFile',
    defaultMessage: '<div class={chooseClass}>Choose a file</div> <div class={dragClass}>or drag it here</div>',
    description: '[Type: label][Vis: high] - label for file input when a file has not been uploaded'
  },
  REPLACE_OR_DRAG: {
    id: 'FileUpload.replaceDragFile',
    defaultMessage: '<div class={chooseClass}>Replace file</div> <div class={dragClass}>or drag it here</div>',
    description: '[Type: label][Vis: high] - label for file input when a file has been uploaded'
  },
  SUPPORTED_FILES: {
    id: 'FileUpload.supportedFiles',
    defaultMessage: 'Supported Files',
    description: '[Type: label][Vis: high] - Prefix to the supported files list'
  },
  FILE_UPLOADING: {
    id: 'FileUpload.fileUploading',
    defaultMessage: 'File uploading',
    description: '[Type: label][Vis: high] - Label for when a file is uploading'
  },
  REMOVE_FILE: {
    id: 'FileUpload.removeFile',
    defaultMessage: 'Remove file',
    description: '[Type: label][Vis: high] - Label for the remove currently selected file button'
  },
  FILE_UPLOADED: {
    id: 'FileUpload.fileUploaded',
    defaultMessage: 'File uploaded successfully',
    description: '[Type: label][Vis: high] - Announcement message for when a file is uploaded successfully'
  }
});
var UPLOAD_STATE = {
  default: 'default',
  uploading: 'uploading',
  error: 'error',
  success: 'success'
};
function FileUpload(_ref194) {
  var questionId = _ref194.id,
    _ro = _ref194.readOnly,
    disabled = _ref194.disabled,
    _ref194$responses = _ref194.responses,
    defaultResponses = _ref194$responses === void 0 ? [] : _ref194$responses,
    _ref194$instructions = _ref194.instructions,
    instructions = _ref194$instructions === void 0 ? 'Optional Instructions' : _ref194$instructions,
    validation = _ref194.validation,
    onChange = _ref194.onChange,
    uploadFile = _ref194.uploadFile,
    questionFieldProps = _objectWithoutProperties(_ref194, _excluded77);
  /** possible states are default, uploading, error, success */
  var _useState81 = useState(defaultResponses[0] ? UPLOAD_STATE.success : UPLOAD_STATE.default),
    _useState82 = _slicedToArray(_useState81, 2),
    state = _useState82[0],
    setState = _useState82[1];
  var _useState83 = useState(false),
    _useState84 = _slicedToArray(_useState83, 2),
    dragActive = _useState84[0],
    setDragActive = _useState84[1];
  /** response is the main state data object from tier 1. Example: {id, value: https://s3.aws.com/filename.jpg} */
  var _useState85 = useState(defaultResponses),
    _useState86 = _slicedToArray(_useState85, 2),
    response = _useState86[0],
    setResponse = _useState86[1];
  var errorId = createErrorId(questionId);
  var _useState87 = useState(''),
    _useState88 = _slicedToArray(_useState87, 2),
    announcement = _useState88[0],
    setAnnouncement = _useState88[1];
  var _useState89 = useState(''),
    _useState90 = _slicedToArray(_useState89, 2),
    errorMessage = _useState90[0],
    setErrorMessage = _useState90[1];
  var fileInputRef = useRef(null);
  var _ref195 = validation || {},
    _ref195$formats = _ref195.formats,
    fileTypes = _ref195$formats === void 0 ? [] : _ref195$formats,
    _ref195$errorMessage = _ref195.errorMessage,
    fileTypesError = _ref195$errorMessage === void 0 ? '' : _ref195$errorMessage;
  var handleDragOver = function handleDragOver(e) {
    e.preventDefault();
    if (!disabled) {
      setDragActive(true);
    }
  };
  var handleDragLeave = function handleDragLeave(e) {
    e.preventDefault();
    if (!disabled) {
      setDragActive(false);
    }
  };
  var setAnnouncementString = function setAnnouncementString(str) {
    setTimeout(function () {
      setAnnouncement(str);
    }, 5000);
    setAnnouncement('');
  };
  var handleSetError = function handleSetError(errorString) {
    setState(UPLOAD_STATE.error);
    setResponse([]);
    setAnnouncementString(errorString);
    setErrorMessage(errorString);
  };
  var handleFileUpload = /*#__PURE__*/function () {
    var _ref196 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(f) {
      var fileResponse, newResponse;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(f && fileTypes.includes("".concat(f.type.split('/')[1])))) {
                _context.next = 9;
                break;
              }
              setState(UPLOAD_STATE.uploading);
              setAnnouncementString(t(COPY.FILE_UPLOADING));
              _context.next = 5;
              return uploadFile === null || uploadFile === void 0 ? void 0 : uploadFile(f);
            case 5:
              fileResponse = _context.sent;
              if (fileResponse) {
                if (fileResponse.error) {
                  handleSetError(fileResponse.error);
                } else {
                  setState(UPLOAD_STATE.success);
                  newResponse = [{
                    id: questionId,
                    value: fileResponse.url
                  }];
                  setResponse(newResponse);
                  /** value will be an s3.awe.com url */
                  onChange === null || onChange === void 0 ? void 0 : onChange(newResponse);
                  setAnnouncementString(t(COPY.FILE_UPLOADED));
                }
              }
              /** not sure what to do if there is no file response */
              _context.next = 10;
              break;
            case 9:
              handleSetError(fileTypesError);
            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleFileUpload(_x) {
      return _ref196.apply(this, arguments);
    };
  }();
  var handleDrop = function handleDrop(e) {
    e.preventDefault();
    if (!disabled) {
      setDragActive(false);
      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        handleFileUpload(e.dataTransfer.files[0]);
      }
    }
  };
  var handleFileInput = function handleFileInput(e) {
    if (!disabled && e.target.files && e.target.files.length > 0) {
      handleFileUpload(e.target.files[0]);
    }
  };
  var handleClearFile = function handleClearFile() {
    var _fileInputRef$current;
    setState(UPLOAD_STATE.default);
    setAnnouncementString('');
    (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.focus();
  };
  var _useStyles = useStyles({
      dragActive: dragActive,
      disabled: disabled
    }),
    srOnly = _useStyles.srOnly,
    container = _useStyles.container,
    instructionsContainer = _useStyles.instructionsContainer,
    fileDragArea = _useStyles.fileDragArea,
    stateArea = _useStyles.stateArea,
    stateIcon = _useStyles.stateIcon,
    stateText = _useStyles.stateText,
    fileUploadText = _useStyles.fileUploadText,
    fileTypeListItem = _useStyles.fileTypeListItem,
    loading = _useStyles.loading,
    linkStyle = _useStyles.linkStyle,
    fileUploadDragDesktop = _useStyles.fileUploadDragDesktop,
    removeFileButton = _useStyles.removeFileButton,
    fileUploadLabel = _useStyles.fileUploadLabel,
    fileUploadInput = _useStyles.fileUploadInput,
    fileTypeListParagraph = _useStyles.fileTypeListParagraph;
  /** using <div> because sm-intl doesn't allow the use of <span> */
  var chooseFileLabel = t(COPY.CHOOSE_OR_DRAG, {
    chooseClass: linkStyle,
    dragClass: fileUploadDragDesktop
  }, {
    html: true
  });
  var replaceFileLabel = t(COPY.REPLACE_OR_DRAG, {
    chooseClass: linkStyle,
    dragClass: fileUploadDragDesktop
  }, {
    html: true
  });
  return React__default.createElement(QuestionField, _objectSpread({
    id: questionId,
    "data-testid": "FileUpload",
    errorId: errorId
  }, questionFieldProps), React__default.createElement("div", {
    role: "status",
    "aria-live": "assertive",
    "aria-atomic": "true",
    className: srOnly
  }, announcement), React__default.createElement("div", {
    className: container
  }, instructions !== undefined && React__default.createElement("p", {
    className: instructionsContainer
  }, instructions), React__default.createElement("div", {
    className: classNames(fileDragArea),
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
    "data-testid": "FileUpload__DropArea"
  }, React__default.createElement("div", {
    className: stateArea
  }, React__default.createElement("div", {
    className: stateIcon
  }, state === 'default' && React__default.createElement(CloudArrowUpIcon$1, {
    color: "#404040"
  }), state === 'uploading' && React__default.createElement("span", {
    className: loading
  }), state === 'error' && React__default.createElement(WarningIcon$1, {
    color: "#CC0000 "
  }), state === 'success' && React__default.createElement(CheckOutlineIcon$1, null)), React__default.createElement("div", {
    className: stateText
  }, state === 'uploading' && React__default.createElement(T, {
    desc: COPY.FILE_UPLOADING
  }), state === 'error' && errorMessage, state === 'success' && response[0] && React__default.createElement(React__default.Fragment, null, response[0].value.split('/').pop(), React__default.createElement("button", {
    type: "button",
    onClick: handleClearFile,
    "aria-label": t(COPY.REMOVE_FILE),
    className: removeFileButton
  }, React__default.createElement(CloseOutlineIcon$1, null))))), React__default.createElement("div", {
    className: fileUploadText
  }, !disabled && React__default.createElement("label", {
    htmlFor: "".concat(questionId, "-fileInput"),
    className: fileUploadLabel
  }, state === 'success' || state === 'uploading' ? replaceFileLabel : chooseFileLabel, React__default.createElement("input", {
    type: "file",
    id: "".concat(questionId, "-fileInput"),
    ref: fileInputRef,
    accept: fileTypes.join(),
    onChange: handleFileInput,
    "aria-describedby": "fileTypeList",
    className: fileUploadInput
  }))), React__default.createElement("p", {
    id: "".concat(questionId, "-fileTypeList"),
    className: fileTypeListParagraph
  }, React__default.createElement("span", {
    className: srOnly
  }, React__default.createElement(T, {
    desc: COPY.SUPPORTED_FILES
  })), ' ', fileTypes.map(function (type) {
    var typeNoDot = type.replace('.', '');
    return React__default.createElement("span", {
      key: typeNoDot,
      className: fileTypeListItem
    }, typeNoDot);
  })))));
}
export { AddressField$1 as AddressField, BestWorst$1 as BestWorst, CaretDownIcon, CaretDownOutlineIcon, Checkbox$1 as Checkbox, CommentBox$1 as CommentBox, DateTime$1 as DateTime, Dropdown$1 as Dropdown, EmailField$1 as EmailField, FileUpload, ImageChoice$1 as ImageChoice, ImagePresentational$1 as ImagePresentational, MatrixDropdown, MatrixRating, MultipleChoice, MultipleTextbox, NameField$1 as NameField, NativeSelect, SelectAnswerOption as NativeSelectOption, Nps, PhoneField$1 as PhoneField, Ranking, SingleTextbox$1 as SingleTextbox, Slider, StarRating, TextPresentational$1 as TextPresentational };